import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { supabase } from "./supabaseClient";

// ═══════════════════════════════════════════════
// ROGERS FAMILY MEAL PLANNER — Full Data + App
// ═══════════════════════════════════════════════

// ── Meal Database ──────────────────────────────
const MEALS_DATA = [
  { id:"B001", name:"Steel Cut Oatmeal", time:["Breakfast"], prep:"Bulk Cook", servings:12, cook:"40 min", cuisine:"American", notes:"Alton Brown-style. Scaled to 6.", needsSide:false },
  { id:"B002", name:"Dutch Baby", time:["Breakfast"], prep:"Bulk Cook", servings:12, cook:"20 min", cuisine:"American", notes:"Dutch oven version @ 425F.", needsSide:false },
  { id:"B003", name:"Shakshuka", time:["Breakfast","Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"30 min", cuisine:"Mediterranean", notes:"Doubled to main course (12 eggs). Mushrooms, feta.", needsSide:false },
  { id:"B004", name:"Huevos de Abuelita", time:["Breakfast"], prep:"Bulk Cook", servings:12, cook:"20 min", cuisine:"Latin", notes:"Toasted bread + sliced hard-boiled eggs + béchamel.", needsSide:false },
  { id:"B005", name:"Eggs", time:["Breakfast"], prep:"Cook Fresh", servings:12, cook:"15 min", cuisine:"American", notes:"Family staple — 3+ times per week. Pair with sides.", needsSide:true },
  { id:"B007", name:"Kodiak Pancakes", time:["Breakfast"], prep:"Bulk Cook", servings:12, cook:"20 min", cuisine:"American", notes:"Kodiak mix + eggs + milk.", needsSide:false },
  { id:"B008", name:"Maple Brown Sugar Cream of Wheat", time:["Breakfast"], prep:"Bulk Cook", servings:20, cook:"7-9 hrs (slow cooker)", cuisine:"American", notes:"Slow cooker 6qt. Every other week.", needsSide:false },
  { id:"B009", name:"Parfait", time:["Breakfast","Dinner"], prep:"Bulk Cook", servings:12, cook:"10 min", cuisine:"American", notes:"Bananas, blueberries, strawberries, Greek yogurt, granola, honey.", needsSide:false },
  { id:"D001", name:"Spicy Shrimp & Andouille over Charleston Grits", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1 hr", cuisine:"Southern/Cajun", notes:"Emeril-style. Grits from scratch.", needsSide:false },
  { id:"D002", name:"Meatloaf (Alton Brown Mod)", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1 hr 15 min", cuisine:"American", notes:"Chipotle-cacao sauce. 2x batch.", needsSide:true },
  { id:"D003", name:"Greek Moussaka", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"2 hrs", cuisine:"Greek/Mediterranean", notes:"Sweet potatoes instead of regular.", needsSide:false },
  { id:"D004", name:"Turkish Chicken", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"30 min", cuisine:"Turkish/Mediterranean", notes:"Milder version for kids. Serve with hummus + pita.", needsSide:true },
  { id:"D005", name:"Lentil Stew", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:20, cook:"5.5 hrs", cuisine:"American/Latin", notes:"4.5 lbs ground beef, oven method @ 350F.", needsSide:false },
  { id:"D006", name:"Hearty Kid-Friendly Turkey Chili", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:18, cook:"4.5-6 hrs", cuisine:"American", notes:"Dutch oven. Kid-approved mild.", needsSide:false },
  { id:"D007", name:"Pot Roast", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:8, cook:"6+ hrs", cuisine:"American", notes:"Crockpot/slow cooker. Chuck roast + sweet potatoes.", needsSide:false },
  { id:"D008", name:"Birria de Res (Quesatacos)", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:10, cook:"3+ hrs", cuisine:"Mexican", notes:"6+ lbs chuck. Ancho + guajillo chiles.", needsSide:true },
  { id:"D009", name:"Tacos Al Pastor", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"Overnight + 2-3 hrs", cuisine:"Mexican", notes:"4-5 lb pork shoulder. Achiote paste.", needsSide:false },
  { id:"D010", name:"Kirkland Cauliflower Supreme Pizza", time:["Dinner"], prep:"Frozen Meal", servings:12, cook:"Per package", cuisine:"American/Italian", notes:"Costco frozen pizza.", needsSide:true },
  { id:"D011", name:"Frozen Gyoza", time:["Dinner"], prep:"Frozen Meal", servings:12, cook:"15 min", cuisine:"Japanese", notes:"Can combine with udon noodles.", needsSide:true },
  { id:"D012", name:"Frozen Udon Noodles", time:["Dinner"], prep:"Frozen Meal", servings:12, cook:"10 min", cuisine:"Japanese", notes:"Can combine with gyoza.", needsSide:true },
  { id:"D013", name:"Gyoza & Udon Combo", time:["Dinner"], prep:"Frozen Meal", servings:12, cook:"20 min", cuisine:"Japanese", notes:"Gyoza + udon together.", needsSide:false },
  { id:"D014", name:"Cañón de Cerdo Entomatado", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1.5 hrs", cuisine:"Honduran/Latin", notes:"Pork tenderloin w/ sweet tomato sauce.", needsSide:true },
  { id:"D015", name:"Chuletas de Diario", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1 hr", cuisine:"Mexican/Latin", notes:"Everyday pork chops.", needsSide:true },
  { id:"D016", name:"Carbonada Criolla", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"3+ hrs", cuisine:"Chilean/Latin", notes:"Goat & vegetable stew. Used beef.", needsSide:false },
  { id:"D017", name:"Carne Asada a la Plancha", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"30-40 min", cuisine:"Central American/Latin", notes:"Sour orange + onion marinade.", needsSide:true },
  { id:"D018", name:"Vaca Frita", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"2.5 hrs", cuisine:"Cuban/Latin", notes:"Shredded beef w/ onions & sour orange.", needsSide:true },
  { id:"D019", name:"Carne Guisada", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"3-4 hrs", cuisine:"Guatemalan/Latin", notes:"Stewed beef w/ carrots & potatoes.", needsSide:false },
  { id:"D020", name:"Pollo en Loroco", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1 hr", cuisine:"Guatemalan/Latin", notes:"Creamy chicken w/ loroco buds.", needsSide:true },
  { id:"D021", name:"Pollo en Cerveza", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"45 min", cuisine:"Central American/Latin", notes:"Chicken with beer.", needsSide:true },
  { id:"D022", name:"Pollo para Tacos", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:6, cook:"30 min", cuisine:"Mexican/Latin", notes:"Chicken for tacos.", needsSide:true },
  { id:"D023", name:"Sopa de Fideos o Sopa Aguada", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"30 min", cuisine:"Mexican/Latin", notes:"Chicken noodle soup, orzo, zucchini.", needsSide:false },
  { id:"D024", name:"Camarones Veracruzanos", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"25 min", cuisine:"Mexican/Latin", notes:"Veracruz-style shrimp.", needsSide:true },
  { id:"D025", name:"Sopa de Quinoa", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"2-3 hrs", cuisine:"Bolivian/Latin", notes:"Quinoa soup. Short ribs, Dutch oven.", needsSide:false },
  { id:"D026", name:"Arroz con Pollo", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"40 min", cuisine:"Latin/Various", notes:"Chicken & rice, my way.", needsSide:false },
  { id:"D027", name:"Pastelón de Plátano Maduro y Carne", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"1 hr", cuisine:"Dominican/Latin", notes:"Plantain & beef casserole.", needsSide:true },
  { id:"D028", name:"Sopa Juliana", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"30 min", cuisine:"Central American/Latin", notes:"Julienned veggie soup + ground beef.", needsSide:false },
  { id:"D029", name:"Sopa de Riendas", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"45 min", cuisine:"Chilean/Latin", notes:"Cranberry bean & pasta soup.", needsSide:false },
  { id:"D030", name:"Sopa de Tortilla de Todos los Días", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"50 min", cuisine:"Mexican/Latin", notes:"Quick tortilla soup.", needsSide:false },
  { id:"D031", name:"Pozole Rojo de Pollo", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"2+ hrs", cuisine:"Mexican/Latin", notes:"Red chicken pozole.", needsSide:false },
  { id:"D032", name:"Pollo Guisado", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1 hr", cuisine:"Panamanian/Latin", notes:"Stewed chicken w/ tortillas.", needsSide:true },
  { id:"D033", name:"Sancocho de Domingo", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"5+ hrs", cuisine:"Panamanian/Latin", notes:"Chicken & root veg soup.", needsSide:false },
  { id:"D034", name:"Cochinita Pibil", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"24+ hrs", cuisine:"Mexican/Yucatan", notes:"Slow-cooked pulled pork.", needsSide:true },
  { id:"L001", name:"Chicken Salad", time:["Lunch"], prep:"Bulk Cook", servings:12, cook:"15 min", cuisine:"American", notes:"Joy of Cooking. Celery, grapes, nuts, mayo.", needsSide:true },
  { id:"L003", name:"Tuna Salad", time:["Lunch"], prep:"Bulk Cook", servings:12, cook:"10 min", cuisine:"American", notes:"Canned tuna, celery, lemon.", needsSide:true },
  { id:"L004", name:"Lentil Soup", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:20, cook:"45 min", cuisine:"American", notes:"Joy of Cooking. ~15 cups.", needsSide:false },
  { id:"L005", name:"Shepherd's Pie", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1 hr", cuisine:"British", notes:"3 lbs ground lamb. Mashed potato top.", needsSide:true },
  { id:"L006", name:"Country Captain", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"40 min", cuisine:"Indian-American", notes:"Added cloves, turmeric + cinnamon, dates.", needsSide:true },
  { id:"L007", name:"Cincinnati Chili", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"3 hrs", cuisine:"American", notes:"5-way with spaghetti.", needsSide:false },
  { id:"L008", name:"Sloppy Joe", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"30 min", cuisine:"American", notes:"Don't double veggies when doubling.", needsSide:true },
  { id:"D035", name:"Steak", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"15 min", cuisine:"American", notes:"Grilled or pan-seared.", needsSide:true },
  { id:"D036", name:"Hamburgers", time:["Dinner"], prep:"Bulk Cook", servings:12, cook:"20 min", cuisine:"American", notes:"Buns, pickles, cheese.", needsSide:true, easyPrep:true },
  { id:"D037", name:"Hot Dogs", time:["Dinner"], prep:"Bulk Cook", servings:12, cook:"15 min", cuisine:"American", notes:"Buns, relish, ketchup, mustard.", needsSide:false, easyPrep:true },
  { id:"D038", name:"Mixtas", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"15 min", cuisine:"Guatemalan", notes:"Hot dogs wrapped in corn tortillas with guacamol.", needsSide:true },
  { id:"D039", name:"Spaghetti", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"30 min", cuisine:"American", notes:"Ground beef, pasta sauce, palm heart noodles.", needsSide:true },
  { id:"D040", name:"Pulled Pork", time:["Lunch","Dinner"], prep:"Frozen Meal", servings:12, cook:"Reheat", cuisine:"American", notes:"Frozen pulled pork with hamburger buns and baked beans.", needsSide:false },
  { id:"L009", name:"Caesar Salad", time:["Dinner"], prep:"Bulk Cook", servings:12, cook:"5 min", cuisine:"American", notes:"Bagged prepacked Caesar salad kit.", needsSide:false, easyPrep:true },
  { id:"B010", name:"Breakfast Burrito", time:["Breakfast"], prep:"Bulk Cook", servings:12, cook:"20 min", cuisine:"Mexican/Latin", notes:"Tortilla, eggs, beans, cheese, rice.", needsSide:false },
  { id:"D041", name:"Burrito (Pollo or Carne Asada)", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"25 min", cuisine:"Mexican/Latin", notes:"Use frozen pollo para tacos or carne asada if available. Flour tortilla, rice, beans, cheese. 2x batch.", needsSide:false },
  { id:"D042", name:"Fish Sticks & Fish Filets", time:["Dinner"], prep:"Frozen Meal", servings:12, cook:"Per package", cuisine:"American", notes:"Frozen fish sticks and filets. Easy weeknight dinner.", needsSide:true },
  { id:"D043", name:"Tomato Red Pepper Soup", time:["Dinner"], prep:"Bulk Cook", servings:12, cook:"45 min", cuisine:"American", notes:"Roasted tomato and red pepper soup. Great with grilled cheese.", needsSide:true, easyPrep:true },
  { id:"B012", name:"Muffins", time:["Breakfast"], prep:"Cook Fresh", servings:12, cook:"25 min", cuisine:"American", notes:"Simple muffins from mix.", needsSide:true },
  { id:"D044", name:"Pollo Guisado con Achiote", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:12, cook:"1.5 hrs", cuisine:"Belizean/Latin", notes:"Chicken & achiote stew from Belize. Marinate 3+ hrs. Potatoes. Used \u00bd avocado oil, added zucchini.", needsSide:true },
  { id:"D045", name:"Puerco en Chile Verde", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"2.5 hrs", cuisine:"Mexican/Latin", notes:"Pork chile verde. Tomatillos, jalape\u00f1os, pork shoulder. Mild version.", needsSide:true },
  { id:"D046", name:"Chicken Gumbo", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:16, cook:"1.5 hrs", cuisine:"Southern/Cajun", notes:"Joy of Cooking. Dutch oven. Andouille sausage, okra, roux. Serve over rice.", needsSide:false },
  { id:"D047", name:"Lemon Garlic Shrimp Pasta", time:["Lunch","Dinner"], prep:"Bulk Cook", servings:8, cook:"25 min", cuisine:"American/Italian", notes:"Sunkist Growers recipe. Linguine, shrimp, lemon, butter, white wine.", needsSide:false },
  { id:"D048", name:"Gyro Meat", time:["Lunch","Dinner"], prep:"Frozen Meal", servings:6, cook:"Per package", cuisine:"Greek/Mediterranean", notes:"Frozen gyro meat (Kronos or similar). Serve with pita, tzatziki, veggies.", needsSide:true },
  { id:"D049", name:"Sandwiches", time:["Dinner"], prep:"Bulk Cook", servings:6, cook:"10 min", cuisine:"American", notes:"Ham + cheese on bread with mayo & mustard. 6 sandwiches for family of 6.", needsSide:false, easyPrep:true },
  { id:"D050", name:"Canned/Box Soup", time:["Dinner"], prep:"Bulk Cook", servings:6, cook:"10 min", cuisine:"American", notes:"Generic heat-up soup from can or box. Keep 2 on hand.", needsSide:false, easyPrep:true },
  { id:"D051", name:"Chicken and Waffles", time:["Dinner"], prep:"Bulk Cook", servings:6, cook:"25 min", cuisine:"American", notes:"Frozen chicken tenders + Kodiak Cake waffles. Maple syrup.", needsSide:false, easyPrep:true },
  { id:"D052", name:"Chicken Nuggets / Tenders", time:["Lunch","Dinner"], prep:"Frozen Meal", servings:8, cook:"Per package", cuisine:"American", notes:"Frozen chicken nuggets, tenders, or filets (Tyson, Kirkland, Just Bare). Easy weeknight win.", needsSide:true, easyPrep:true },
  { id:"D053", name:"Frozen Pizza (Generic)", time:["Lunch","Dinner"], prep:"Frozen Meal", servings:8, cook:"Per package", cuisine:"American/Italian", notes:"Any frozen pizza on hand (DiGiorno, Tombstone, etc.). Backup option to Kirkland Cauliflower Supreme.", needsSide:true, easyPrep:true },
  { id:"D054", name:"Frozen Burritos", time:["Lunch","Dinner"], prep:"Frozen Meal", servings:6, cook:"Per package", cuisine:"Mexican/Latin", notes:"Frozen bean & cheese or pollo burritos.", needsSide:false, easyPrep:true },
  { id:"D055", name:"Frozen Taquitos", time:["Lunch","Dinner"], prep:"Frozen Meal", servings:6, cook:"Per package", cuisine:"Mexican/Latin", notes:"Frozen beef or chicken taquitos. Bake or air fry.", needsSide:true, easyPrep:true },
];

const INGREDIENTS_DATA = {
  B001:[{n:"Butter",q:3,u:"tbsp",c:"Dairy"},{n:"Steel Cut Oats",q:3,u:"cups",c:"Pantry"},{n:"Kosher Salt",q:0.75,u:"tsp",c:"Spices"},{n:"Water",q:9,u:"cups",c:"Pantry"},{n:"Whole Milk",q:1.5,u:"cup",c:"Dairy"},{n:"Buttermilk",q:1.5,u:"cup",c:"Dairy"}],
  B002:[{n:"Flour",q:496,u:"g",c:"Pantry"},{n:"Sugar",q:300,u:"g",c:"Pantry"},{n:"Salt",q:6.6,u:"g",c:"Spices"},{n:"Milk",q:804,u:"g",c:"Dairy"},{n:"Eggs",q:18,u:"large",c:"Dairy"},{n:"Butter",q:186,u:"g",c:"Dairy"}],
  B003:[{n:"Olive Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Onion",q:2,u:"large diced",c:"Produce"},{n:"Mushrooms",q:2,u:"large handful sliced",c:"Produce"},{n:"Red Bell Pepper",q:2,u:"cup diced",c:"Produce"},{n:"Jalapeno",q:2,u:"seeded and sliced",c:"Produce"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Cumin",q:2,u:"tsp",c:"Spices"},{n:"Paprika",q:1,u:"tsp",c:"Spices"},{n:"Turmeric",q:1,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Cayenne",q:0.5,u:"tsp",c:"Spices"},{n:"Crushed San Marzano Tomatoes",q:56,u:"oz can",c:"Canned"},{n:"Water or Broth",q:1,u:"cup",c:"Pantry"},{n:"Eggs",q:24,u:"large",c:"Dairy"},{n:"Feta Cheese",q:1,u:"cup crumbled",c:"Dairy"},{n:"Fresh Parsley",q:2,u:"bunch",c:"Produce"}],
  B004:[{n:"Bread",q:12,u:"slices",c:"Bakery"},{n:"Eggs",q:12,u:"large",c:"Dairy"},{n:"Butter",q:4,u:"tbsp",c:"Dairy"},{n:"All-Purpose Flour",q:4,u:"tbsp",c:"Pantry"},{n:"Whole Milk",q:2,u:"cup",c:"Dairy"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Nutmeg",q:2,u:"pinch",c:"Spices"}],
  B005:[{n:"Eggs",q:24,u:"large",c:"Dairy"},{n:"Butter",q:4,u:"tbsp",c:"Dairy"}],
  B007:[{n:"Kodiak Pancake Mix",q:6,u:"cups",c:"Pantry"},{n:"Eggs",q:6,u:"large",c:"Dairy"},{n:"Milk",q:4,u:"cups",c:"Dairy"},{n:"Maple Syrup",q:2,u:"bottle",c:"Pantry"}],
  B008:[{n:"Cream of Wheat",q:784,u:"g",c:"Pantry"},{n:"Water",q:10,u:"cups",c:"Pantry"},{n:"Whole Milk",q:8,u:"cups",c:"Dairy"},{n:"Butter",q:4,u:"tbsp",c:"Dairy"},{n:"Brown Sugar",q:152,u:"g",c:"Pantry"},{n:"Maple Syrup",q:200,u:"g",c:"Pantry"},{n:"Salt",q:12,u:"g",c:"Spices"},{n:"Cinnamon",q:6,u:"g",c:"Spices"},{n:"Vanilla Extract",q:10,u:"g",c:"Pantry"}],
  B009:[{n:"Greek Yogurt",q:8,u:"cups",c:"Dairy"},{n:"Bananas",q:6,u:"each",c:"Produce"},{n:"Blueberries",q:2,u:"cup",c:"Produce"},{n:"Strawberries",q:2,u:"cup",c:"Produce"},{n:"Granola",q:4,u:"cups",c:"Pantry"},{n:"Honey",q:6,u:"tbsp",c:"Pantry"}],
  D001:[{n:"Shrimp (peeled)",q:4,u:"lbs",c:"Seafood"},{n:"Original Essence",q:16,u:"tsp",c:"Spices"},{n:"Cayenne",q:2,u:"tsp",c:"Spices"},{n:"Andouille Sausage",q:16,u:"oz",c:"Meat"},{n:"Vegetable Oil",q:0.5,u:"cup",c:"Pantry"},{n:"Yellow Onion",q:2,u:"cup chopped",c:"Produce"},{n:"Red Bell Pepper",q:1,u:"cup chopped",c:"Produce"},{n:"Green Bell Pepper",q:1,u:"cup chopped",c:"Produce"},{n:"Garlic",q:2,u:"tsp minced",c:"Produce"},{n:"Chicken Broth",q:3,u:"cups",c:"Pantry"},{n:"Heavy Cream",q:0.5,u:"cup",c:"Dairy"},{n:"Green Onions",q:4,u:"tbsp",c:"Produce"},{n:"Parsley",q:4,u:"tbsp",c:"Produce"},{n:"Quick Grits",q:3,u:"cups",c:"Pantry"},{n:"Whole Milk",q:4,u:"cups",c:"Dairy"},{n:"Heavy Cream (grits)",q:2,u:"cup",c:"Dairy"},{n:"Butter",q:16,u:"tbsp",c:"Dairy"}],
  D002:[{n:"Ground Beef",q:132,u:"oz",c:"Meat"},{n:"Garlic Croutons",q:9,u:"cups",c:"Pantry"},{n:"Paprika",q:3,u:"tbsp",c:"Spices"},{n:"Dried Thyme",q:3,u:"tsp",c:"Spices"},{n:"Onion",q:3,u:"medium diced",c:"Produce"},{n:"Red Bell Pepper",q:3,u:"medium diced",c:"Produce"},{n:"Carrot",q:3,u:"medium grated",c:"Produce"},{n:"Garlic",q:9,u:"cloves",c:"Produce"},{n:"Egg",q:3,u:"large",c:"Dairy"},{n:"Ketchup",q:1,u:"cup",c:"Condiments"},{n:"Tomato Paste",q:3,u:"tbsp",c:"Canned"},{n:"Chipotle in Adobo",q:6,u:"each",c:"Canned"},{n:"Cacao Powder",q:4.5,u:"tsp",c:"Pantry"},{n:"Brown Sugar",q:6,u:"tbsp",c:"Pantry"},{n:"Honey",q:3,u:"tbsp",c:"Pantry"},{n:"Cumin",q:3,u:"tsp",c:"Spices"},{n:"Worcestershire",q:6,u:"tsp",c:"Condiments"}],
  D005:[{n:"Ground Beef",q:9,u:"lbs",c:"Meat"},{n:"Onions (medium dice)",q:6,u:"each",c:"Produce"},{n:"Zucchini/Yellow Squash (half coins)",q:6,u:"each",c:"Produce"},{n:"Bell Peppers",q:6,u:"each",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Baby Carrots",q:4,u:"lbs",c:"Produce"},{n:"San Marzano Peeled Tomatoes",q:56,u:"oz can",c:"Canned"},{n:"Lentils",q:6,u:"cups",c:"Pantry"},{n:"Beef Better Than Bouillon",q:6,u:"tbsp",c:"Pantry"},{n:"Water",q:8,u:"quarts",c:"Pantry"},{n:"Oregano",q:3,u:"tbsp",c:"Spices"},{n:"Umami Spice",q:2,u:"tbsp",c:"Spices"},{n:"Paprika",q:3,u:"tbsp",c:"Spices"},{n:"Cinnamon",q:2,u:"tsp",c:"Spices"},{n:"Lemon Pepper",q:2,u:"tbsp",c:"Spices"},{n:"Salt",q:2,u:"tbsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"},{n:"Apple Cider Vinegar",q:6,u:"tbsp",c:"Pantry"},{n:"Spinach",q:2,u:"lb",c:"Produce"}],
  D006:[{n:"Olive Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Onions",q:4,u:"large chopped",c:"Produce"},{n:"Garlic",q:8,u:"cloves minced",c:"Produce"},{n:"Bell Peppers",q:4,u:"each diced",c:"Produce"},{n:"Ground Turkey (or Chicken)",q:8,u:"lbs",c:"Meat"},{n:"San Marzano Tomatoes (crushed)",q:112,u:"oz (2 cans)",c:"Canned"},{n:"Chicken Broth",q:8,u:"cups",c:"Pantry"},{n:"Cannellini Beans",q:4,u:"15oz cans",c:"Canned"},{n:"Corn",q:4,u:"15oz cans",c:"Canned"},{n:"Green Chiles",q:4,u:"4.5oz cans",c:"Canned"},{n:"Tomato Paste",q:12,u:"oz can",c:"Canned"},{n:"Celery",q:10,u:"stalks diced",c:"Produce"},{n:"Baby Carrots (diced)",q:2,u:"lb",c:"Produce"},{n:"Ground Cumin",q:4,u:"tbsp",c:"Spices"},{n:"Paprika",q:10,u:"tbsp",c:"Spices"},{n:"Dried Oregano",q:8,u:"tbsp",c:"Spices"},{n:"Cinnamon",q:2,u:"tsp",c:"Spices"},{n:"Umami Spice",q:2,u:"tbsp",c:"Spices"},{n:"Salt",q:2,u:"tbsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tbsp",c:"Spices"},{n:"Balsamic Vinegar",q:8,u:"heavy dashes",c:"Pantry"},{n:"Sour Cream",q:2,u:"cup",c:"Dairy"},{n:"Shredded Cheese (for serving)",q:2,u:"bag",c:"Dairy"}],
  D007:[{n:"Boneless Chuck/Pot Roast",q:6,u:"lbs",c:"Meat"},{n:"Onions",q:2,u:"chopped",c:"Produce"},{n:"Baby Carrots",q:2,u:"lbs",c:"Produce"},{n:"Sweet Potatoes (peeled, cubed)",q:4,u:"each",c:"Produce"},{n:"Beef Better Than Bouillon",q:3,u:"tbsp (or ~3L stock)",c:"Pantry"},{n:"Beef Stock",q:12,u:"cups",c:"Pantry"},{n:"Paprika",q:2,u:"tbsp",c:"Spices"},{n:"Oregano",q:1,u:"tbsp",c:"Spices"},{n:"Balsamic Vinegar",q:3,u:"tbsp",c:"Pantry"},{n:"Salt",q:1,u:"tbsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"}],
  D008:[{n:"Boneless Chuck Roast",q:6.5,u:"lbs",c:"Meat"},{n:"Ancho Chiles",q:5,u:"each",c:"Produce"},{n:"Guajillo Chiles",q:5,u:"each",c:"Produce"},{n:"Chiles de Arbol",q:2,u:"each",c:"Produce"},{n:"Rich Beef Stock",q:2.5,u:"quarts",c:"Pantry"},{n:"Cinnamon Stick",q:1,u:"each",c:"Spices"},{n:"Bay Leaves",q:6,u:"each",c:"Spices"},{n:"Toasted Coriander",q:1,u:"tbsp",c:"Spices"},{n:"Black Peppercorns",q:1,u:"tbsp",c:"Spices"},{n:"Dried Oregano",q:2,u:"tsp",c:"Spices"},{n:"Tomato Paste",q:1,u:"tbsp",c:"Canned"},{n:"Yellow Onion",q:1,u:"each",c:"Produce"},{n:"Garlic",q:8,u:"cloves",c:"Produce"},{n:"Salt",q:1,u:"tbsp",c:"Spices"},{n:"Corn Tortillas",q:1,u:"large pack",c:"Bakery"},{n:"Oaxaca Cheese",q:1,u:"lb",c:"Dairy"},{n:"Cilantro",q:1,u:"bunch",c:"Produce"}],
  D009:[{n:"Ancho Chiles",q:8,u:"each",c:"Produce"},{n:"Guajillo Chiles",q:10,u:"each",c:"Produce"},{n:"White Vinegar",q:1.5,u:"cup",c:"Pantry"},{n:"Pineapple Juice",q:2,u:"cup",c:"Pantry"},{n:"Onion",q:2,u:"each",c:"Produce"},{n:"Achiote Paste",q:7,u:"tbsp",c:"Spices"},{n:"Garlic",q:20,u:"cloves",c:"Produce"},{n:"Brown Sugar",q:4,u:"tbsp",c:"Pantry"},{n:"Mexican Oregano",q:4,u:"tbsp",c:"Spices"},{n:"Ground Cumin",q:4,u:"tsp",c:"Spices"},{n:"Ground Cinnamon",q:4,u:"tsp",c:"Spices"},{n:"Kosher Salt",q:6,u:"tbsp",c:"Spices"},{n:"Boneless Pork Shoulder",q:10,u:"lbs",c:"Meat"},{n:"Cilantro",q:2,u:"bunch",c:"Produce"},{n:"Limes",q:4,u:"each",c:"Produce"},{n:"Corn Tortillas",q:2,u:"pack",c:"Bakery"}],
  D003:[{n:"Onions (thinly sliced, veggie layer)",q:4,u:"each",c:"Produce"},{n:"Sweet Potatoes (thinly sliced)",q:8,u:"medium",c:"Produce"},{n:"Eggplant (thinly sliced)",q:2,u:"large",c:"Produce"},{n:"Zucchini (thinly sliced)",q:4,u:"each",c:"Produce"},{n:"Onion (minced, meat layer)",q:2,u:"each",c:"Produce"},{n:"Garlic",q:2,u:"clove minced",c:"Produce"},{n:"Cinnamon",q:1,u:"tsp",c:"Spices"},{n:"Ground Cloves",q:2,u:"pinch",c:"Spices"},{n:"Tomato Paste",q:2,u:"tbsp",c:"Canned"},{n:"Ground Beef",q:1000,u:"g",c:"Meat"},{n:"Crushed Tomatoes",q:800,u:"g",c:"Canned"},{n:"Butter",q:400,u:"g",c:"Dairy"},{n:"All-Purpose Flour",q:400,u:"g",c:"Pantry"},{n:"Whole Milk",q:1500,u:"ml",c:"Dairy"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Nutmeg",q:2,u:"pinch",c:"Spices"},{n:"Parmesan",q:200,u:"g grated",c:"Dairy"},{n:"Egg Yolks",q:6,u:"each",c:"Dairy"}],
  D035:[{n:"Steaks",q:12,u:"each",c:"Meat"},{n:"Olive Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"}],
  D036:[{n:"Ground Beef",q:5,u:"lbs",c:"Meat"},{n:"Hamburger Buns",q:12,u:"each",c:"Bakery"},{n:"Pickles",q:2,u:"jar",c:"Condiments"},{n:"American Cheese",q:12,u:"slices",c:"Dairy"},{n:"Ketchup",q:2,u:"bottle",c:"Condiments"},{n:"Mustard",q:2,u:"bottle",c:"Condiments"},{n:"Lettuce",q:2,u:"head",c:"Produce"},{n:"Tomato",q:4,u:"each",c:"Produce"}],
  D037:[{n:"Hot Dogs",q:2,u:"pack (8ct)",c:"Meat"},{n:"Hot Dog Buns",q:2,u:"pack (8ct)",c:"Bakery"},{n:"Relish",q:2,u:"jar",c:"Condiments"},{n:"Ketchup",q:2,u:"bottle",c:"Condiments"},{n:"Mustard",q:2,u:"bottle",c:"Condiments"}],
  D038:[{n:"Hot Dogs",q:2,u:"pack (8ct)",c:"Meat"},{n:"Corn Tortillas",q:2,u:"pack",c:"Bakery"}],
  D039:[{n:"Ground Beef",q:5,u:"lbs",c:"Meat"},{n:"Pasta Sauce",q:4,u:"large jars",c:"Canned"},{n:"Palm Heart Noodles",q:4,u:"cans",c:"Canned"}],
  D010:[{n:"Kirkland Cauliflower Supreme Pizza (frozen)",q:2,u:"boxes",c:"Frozen"}],
  D011:[{n:"Frozen Gyoza",q:2,u:"bags",c:"Frozen"}],
  D012:[{n:"Frozen Udon Noodles",q:2,u:"packs",c:"Frozen"}],
  D013:[{n:"Frozen Gyoza",q:2,u:"bags",c:"Frozen"},{n:"Frozen Udon Noodles",q:2,u:"packs",c:"Frozen"}],
  D040:[{n:"Pulled Pork (frozen)",q:4,u:"lbs",c:"Frozen"},{n:"Hamburger Buns",q:2,u:"pack (8ct)",c:"Bakery"},{n:"Baked Beans",q:4,u:"cans",c:"Canned"}],
  L009:[{n:"Bagged Caesar Salad Kit",q:4,u:"bags",c:"Produce"}],
  B010:[{n:"Flour Tortillas",q:2,u:"pack",c:"Bakery"},{n:"Eggs",q:24,u:"large",c:"Dairy"},{n:"Canned Pinto Beans",q:2,u:"can",c:"Canned"},{n:"Shredded Cheese",q:2,u:"bag",c:"Dairy"},{n:"Long Grain White Rice",q:2,u:"cup",c:"Pantry"},{n:"Salt",q:1,u:"tsp",c:"Spices"}],
  D041:[{n:"Flour Tortillas",q:4,u:"packs",c:"Bakery"},{n:"Long Grain White Rice",q:4,u:"cups",c:"Pantry"},{n:"Canned Pinto Beans",q:4,u:"cans",c:"Canned"},{n:"Shredded Cheese",q:2,u:"bag",c:"Dairy"},{n:"Sour Cream",q:2,u:"container",c:"Dairy"},{n:"Chicken Thighs (or frozen pollo/carne asada)",q:4,u:"lbs",c:"Meat"}],
  D042:[{n:"Frozen Fish Sticks",q:2,u:"box",c:"Frozen"},{n:"Frozen Fish Filets",q:2,u:"box",c:"Frozen"}],
  B012:[{n:"Muffin Mix",q:2,u:"box",c:"Pantry"},{n:"Eggs",q:2,u:"large",c:"Dairy"},{n:"Milk",q:2,u:"cup",c:"Dairy"}],
  D043:[{n:"Roma Tomatoes",q:16,u:"each",c:"Produce"},{n:"Red Bell Peppers",q:6,u:"each",c:"Produce"},{n:"Onion",q:2,u:"large",c:"Produce"},{n:"Garlic",q:8,u:"cloves",c:"Produce"},{n:"Olive Oil",q:6,u:"tbsp",c:"Pantry"},{n:"Chicken Broth",q:8,u:"cups",c:"Pantry"},{n:"Heavy Cream",q:1,u:"cup",c:"Dairy"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Dried Basil",q:2,u:"tsp",c:"Spices"}],
  D044:[{n:"Chicken (cut into portions)",q:8,u:"lbs",c:"Meat"},{n:"Sofrito Rojo",q:1.5,u:"cups",c:"Canned"},{n:"Aceite de Achiote",q:1,u:"cup",c:"Spices"},{n:"White Potatoes",q:2,u:"lb",c:"Produce"},{n:"Ground Cumin",q:2,u:"tsp",c:"Spices"},{n:"Garlic Powder",q:2,u:"tsp",c:"Spices"},{n:"Bay Leaves",q:4,u:"each",c:"Spices"},{n:"Fine Sea Salt",q:5,u:"tsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"},{n:"Avocado Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Zucchini",q:2,u:"each",c:"Produce"}],
  D045:[{n:"Boneless Pork Shoulder",q:6,u:"lbs",c:"Meat"},{n:"Tomatillos",q:3,u:"lbs",c:"Produce"},{n:"White Onion",q:2,u:"small",c:"Produce"},{n:"Garlic",q:8,u:"cloves",c:"Produce"},{n:"Jalapeño Peppers",q:4,u:"each",c:"Produce"},{n:"Green Onions",q:4,u:"each",c:"Produce"},{n:"Cilantro",q:2,u:"bunch",c:"Produce"},{n:"Ground Cumin",q:3,u:"tsp",c:"Spices"},{n:"Mexican Oregano",q:2,u:"tsp",c:"Spices"},{n:"Fine Sea Salt",q:4,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Vegetable Oil",q:6,u:"tbsp",c:"Pantry"},{n:"Chicken Broth",q:2,u:"cup",c:"Pantry"}],
  D046:[{n:"Chicken Parts",q:6,u:"lbs",c:"Meat"},{n:"Andouille Sausage",q:24,u:"oz",c:"Meat"},{n:"All-Purpose Flour",q:2,u:"cup",c:"Pantry"},{n:"Vegetable Oil",q:1.5,u:"cup",c:"Pantry"},{n:"Okra",q:2,u:"cup sliced",c:"Produce"},{n:"Celery",q:1,u:"cup chopped",c:"Produce"},{n:"Onion",q:1,u:"cup chopped",c:"Produce"},{n:"Green Bell Pepper",q:1,u:"cup chopped",c:"Produce"},{n:"Garlic",q:2,u:"tbsp chopped",c:"Produce"},{n:"Chicken Broth",q:16,u:"cups",c:"Pantry"},{n:"Scallions",q:1,u:"cup chopped",c:"Produce"},{n:"Filé Powder",q:2,u:"tbsp",c:"Spices"},{n:"Salt",q:3,u:"tsp",c:"Spices"},{n:"Ground Red Pepper",q:4,u:"tsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"},{n:"Garlic Powder",q:2,u:"tsp",c:"Spices"},{n:"Long Grain White Rice",q:4,u:"cups",c:"Pantry"}],
  D047:[{n:"Linguine or Spaghetti",q:16,u:"oz",c:"Pantry"},{n:"Large Shrimp (peeled)",q:2,u:"lb",c:"Seafood"},{n:"Olive Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Garlic",q:8,u:"cloves minced",c:"Produce"},{n:"Shallot",q:2,u:"each diced",c:"Produce"},{n:"White Wine or Chicken Broth",q:1,u:"cup",c:"Pantry"},{n:"Butter",q:6,u:"tbsp",c:"Dairy"},{n:"Lemons",q:4,u:"each",c:"Produce"},{n:"Red Pepper Flakes",q:1,u:"tsp",c:"Spices"},{n:"Fresh Italian Parsley",q:1,u:"cup chopped",c:"Produce"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"}],
  D048:[{n:"Frozen Gyro Meat",q:1,u:"box",c:"Frozen"},{n:"Pita Bread",q:1,u:"pack",c:"Bakery"}],
  D049:[{n:"Sliced Bread",q:12,u:"slices",c:"Bakery"},{n:"Sliced Deli Ham",q:12,u:"slices",c:"Meat"},{n:"Sliced Cheese",q:6,u:"slices",c:"Dairy"},{n:"Mayonnaise",q:1,u:"jar",c:"Condiments"},{n:"Mustard",q:1,u:"bottle",c:"Condiments"}],
  D050:[{n:"Canned or Boxed Soup",q:2,u:"32 oz box/large can",c:"Canned"}],
  D051:[{n:"Frozen Chicken Tenders",q:1,u:"large bag",c:"Frozen"},{n:"Kodiak Cake Mix",q:2,u:"cups",c:"Pantry"},{n:"Eggs",q:2,u:"large",c:"Dairy"},{n:"Milk",q:1.5,u:"cup",c:"Dairy"},{n:"Maple Syrup",q:1,u:"bottle",c:"Pantry"},{n:"Butter",q:4,u:"tbsp",c:"Dairy"}],
  D052:[{n:"Frozen Chicken Nuggets/Tenders/Filets",q:1,u:"large bag",c:"Frozen"}],
  D053:[{n:"Frozen Pizza",q:2,u:"each",c:"Frozen"}],
  D054:[{n:"Frozen Burritos",q:6,u:"each",c:"Frozen"}],
  D055:[{n:"Frozen Taquitos",q:1,u:"large bag",c:"Frozen"}],
  // ── Missing ingredient data (added for grocery list) ──
  D004:[{n:"Boneless Chicken Thighs",q:12,u:"each",c:"Meat"},{n:"Onion (diced)",q:2,u:"medium",c:"Produce"},{n:"Garlic",q:6,u:"cloves minced",c:"Produce"},{n:"Bell Peppers (diced)",q:4,u:"each",c:"Produce"},{n:"Carrot (diced)",q:2,u:"each",c:"Produce"},{n:"Cloves (crushed)",q:10,u:"each",c:"Spices"},{n:"Isot or Smoked Red Pepper",q:2,u:"tbsp",c:"Spices"},{n:"Red Pepper Flakes",q:2,u:"tbsp",c:"Spices"},{n:"Paprika",q:2,u:"tbsp",c:"Spices"},{n:"Red Cayenne Pepper",q:2,u:"tsp",c:"Spices"},{n:"Cumin",q:2,u:"tsp",c:"Spices"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"},{n:"Olive Oil",q:8,u:"tbsp",c:"Pantry"},{n:"Hot Water",q:0.66,u:"cup",c:"Pantry"},{n:"Fresh Parsley",q:1,u:"bunch",c:"Produce"},{n:"Lemon",q:2,u:"each",c:"Produce"},{n:"Lavash Bread",q:4,u:"each",c:"Bakery"}],
  D014:[{n:"Pork Tenderloin",q:5,u:"lbs",c:"Meat"},{n:"Plum Tomatoes",q:2,u:"lb",c:"Produce"},{n:"Bell Pepper (yellow)",q:2,u:"large",c:"Produce"},{n:"Onion",q:2,u:"cup chopped",c:"Produce"},{n:"Garlic",q:4,u:"cloves",c:"Produce"},{n:"Cilantro",q:0.5,u:"cup",c:"Produce"},{n:"Tomato Paste",q:6,u:"tbsp",c:"Canned"},{n:"Brown Sugar (piloncillo)",q:4,u:"tbsp",c:"Pantry"},{n:"Dijon Mustard",q:2,u:"tbsp",c:"Condiments"},{n:"Fine Sea Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"}],
  D015:[{n:"Bone-In Pork Chops",q:12,u:"each (6oz)",c:"Meat"},{n:"Avocado Oil or Vegetable Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Ancho Chile Powder",q:2,u:"tsp",c:"Spices"},{n:"Fine Sea Salt",q:3,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Garlic Powder",q:1,u:"tsp",c:"Spices"},{n:"Cilantro",q:0.5,u:"cup chopped",c:"Produce"}],
  D016:[{n:"Chuck Roast (or goat meat)",q:3,u:"lbs",c:"Meat"},{n:"Onion",q:4,u:"cups chopped",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Sweet Paprika",q:2,u:"tbsp",c:"Spices"},{n:"Dried Oregano",q:4,u:"tsp",c:"Spices"},{n:"Ground Cumin",q:2,u:"tsp",c:"Spices"},{n:"Carrots",q:3.5,u:"cups chopped",c:"Produce"},{n:"Red Bell Peppers",q:2,u:"cup chopped",c:"Produce"},{n:"Celery",q:2,u:"cup chopped",c:"Produce"},{n:"Zucchini",q:4,u:"cups diced",c:"Produce"},{n:"Butternut Squash",q:2,u:"lb cubed",c:"Produce"},{n:"Long Grain White Rice",q:1,u:"cup",c:"Pantry"},{n:"Green Peas (frozen)",q:3,u:"cups",c:"Frozen"},{n:"Fresh Italian Parsley",q:1,u:"cup chopped",c:"Produce"},{n:"Olive Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Fine Sea Salt",q:2,u:"tbsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Beef Broth",q:16,u:"cups",c:"Pantry"}],
  D017:[{n:"Flank Steak (or skirt steak)",q:6,u:"lbs",c:"Meat"},{n:"Sour Orange Juice",q:1,u:"cup",c:"Pantry"},{n:"Onion",q:4,u:"large",c:"Produce"},{n:"Garlic",q:8,u:"cloves",c:"Produce"},{n:"Salt",q:2,u:"tbsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"},{n:"Vegetable Oil",q:4,u:"tbsp",c:"Pantry"}],
  D018:[{n:"Flank Steak",q:6,u:"lbs",c:"Meat"},{n:"Yellow Onions",q:5,u:"cups sliced",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Sour Orange Juice",q:1,u:"cup",c:"Pantry"},{n:"Lard or Vegetable Oil",q:3,u:"tbsp",c:"Pantry"},{n:"Bell Pepper",q:2,u:"each sliced",c:"Produce"},{n:"Fine Sea Salt",q:3,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Limes",q:4,u:"each",c:"Produce"}],
  D019:[{n:"Beef Stew Meat",q:4,u:"lbs",c:"Meat"},{n:"Plum Tomatoes",q:2,u:"lb",c:"Produce"},{n:"Onion",q:2,u:"small",c:"Produce"},{n:"Garlic",q:8,u:"cloves",c:"Produce"},{n:"Red Bell Peppers",q:4,u:"large",c:"Produce"},{n:"Toasted Sesame Seeds",q:6,u:"tbsp",c:"Spices"},{n:"Beef Broth",q:4,u:"cups",c:"Pantry"},{n:"Vegetable Oil",q:6,u:"tbsp",c:"Pantry"},{n:"Mexican Cinnamon (Canela)",q:2,u:"4-inch stick",c:"Spices"},{n:"Fresh Thyme",q:16,u:"sprigs",c:"Produce"},{n:"Ground Cloves",q:1,u:"tsp",c:"Spices"},{n:"Bay Leaves",q:4,u:"each",c:"Spices"},{n:"Fine Sea Salt",q:3,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"White Potatoes",q:3,u:"lbs cubed",c:"Produce"}],
  D020:[{n:"Chicken Thighs (boneless)",q:5,u:"lbs",c:"Meat"},{n:"Loroco (frozen or jarred)",q:2,u:"jar",c:"Canned"},{n:"Heavy Cream",q:2,u:"cup",c:"Dairy"},{n:"Onion",q:2,u:"medium",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Chicken Broth",q:2,u:"cup",c:"Pantry"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Vegetable Oil",q:4,u:"tbsp",c:"Pantry"}],
  D021:[{n:"Chicken (cut into 8 pieces)",q:8,u:"lbs",c:"Meat"},{n:"Light Beer (Coors Light)",q:1.5,u:"cups",c:"Pantry"},{n:"Yellow Onions",q:4,u:"cups sliced",c:"Produce"},{n:"Dried Thyme",q:1,u:"tsp",c:"Spices"},{n:"Bay Leaf",q:2,u:"each",c:"Spices"},{n:"Dijon Mustard",q:2,u:"tbsp",c:"Condiments"},{n:"Yellow Mustard",q:2,u:"tbsp",c:"Condiments"},{n:"Worcestershire Sauce",q:4,u:"tbsp",c:"Condiments"},{n:"Fine Sea Salt",q:2,u:"tsp",c:"Spices"},{n:"White Pepper",q:1,u:"tsp",c:"Spices"},{n:"Flour or Cornstarch",q:2,u:"tbsp",c:"Pantry"},{n:"Fresh Italian Parsley",q:1,u:"cup chopped",c:"Produce"},{n:"Vegetable Oil",q:2,u:"tbsp",c:"Pantry"}],
  D022:[{n:"Chicken Thighs (boneless)",q:3,u:"lbs",c:"Meat"},{n:"Onion",q:1,u:"medium",c:"Produce"},{n:"Garlic",q:4,u:"cloves",c:"Produce"},{n:"Cumin",q:1,u:"tsp",c:"Spices"},{n:"Chili Powder",q:1,u:"tsp",c:"Spices"},{n:"Paprika",q:1,u:"tsp",c:"Spices"},{n:"Oregano",q:0.5,u:"tsp",c:"Spices"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Lime Juice",q:2,u:"tbsp",c:"Produce"},{n:"Vegetable Oil",q:2,u:"tbsp",c:"Pantry"},{n:"Corn Tortillas",q:1,u:"pack",c:"Bakery"}],
  D023:[{n:"Rotisserie Chicken (shredded)",q:2,u:"whole",c:"Meat"},{n:"Orzo Pasta",q:2,u:"cup",c:"Pantry"},{n:"Zucchini",q:4,u:"each chopped",c:"Produce"},{n:"Diced Tomatoes (canned with juices)",q:29,u:"oz can",c:"Canned"},{n:"Onion",q:2,u:"cup chopped",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Ancho Chile Powder",q:2,u:"tsp",c:"Spices"},{n:"Ground Cumin",q:1,u:"tsp",c:"Spices"},{n:"Vegetable Oil",q:8,u:"tbsp",c:"Pantry"},{n:"Chicken Broth",q:16,u:"cups",c:"Pantry"},{n:"Fine Sea Salt",q:4,u:"tsp",c:"Spices"},{n:"Avocado",q:2,u:"each",c:"Produce"},{n:"Queso Fresco or Queso Duro",q:2,u:"cup crumbled",c:"Dairy"},{n:"Lime",q:4,u:"each",c:"Produce"}],
  D024:[{n:"Shrimp (peeled, 25-30ct)",q:2,u:"lb",c:"Seafood"},{n:"Onion",q:2,u:"cup chopped",c:"Produce"},{n:"Garlic",q:4,u:"cloves",c:"Produce"},{n:"Diced Tomatoes (canned with juices)",q:29,u:"oz can",c:"Canned"},{n:"Green Olives",q:3,u:"cups",c:"Condiments"},{n:"Capers",q:1.5,u:"cup",c:"Condiments"},{n:"Pimiento Peppers (jarred)",q:2,u:"small jar",c:"Condiments"},{n:"Dried Oregano (Mexican)",q:3,u:"tsp",c:"Spices"},{n:"Bay Leaf",q:2,u:"each",c:"Spices"},{n:"Olive Oil",q:3,u:"tbsp",c:"Pantry"},{n:"Fine Sea Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"}],
  D025:[{n:"Bone-In Short Ribs",q:4,u:"lbs",c:"Meat"},{n:"Quinoa",q:3,u:"cups",c:"Pantry"},{n:"Yellow Potatoes (Yukon Gold)",q:6,u:"cups diced",c:"Produce"},{n:"Onion",q:4,u:"cups chopped",c:"Produce"},{n:"Carrots",q:4,u:"cups chopped",c:"Produce"},{n:"Celery",q:5,u:"cups sliced",c:"Produce"},{n:"Butternut Squash",q:5,u:"cups diced",c:"Produce"},{n:"Green Peas (frozen)",q:3,u:"cups",c:"Frozen"},{n:"Vegetable Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Fine Sea Salt",q:5,u:"tsp",c:"Spices"},{n:"Ground Cumin",q:4,u:"tsp",c:"Spices"},{n:"Dried Oregano",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"}],
  D026:[{n:"Chicken Thighs (boneless, skinless)",q:8,u:"lbs",c:"Meat"},{n:"Spanish Chorizo",q:2,u:"cup chopped",c:"Meat"},{n:"Long Grain White Rice",q:4.5,u:"cups",c:"Pantry"},{n:"Onion",q:2,u:"cup chopped",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Pimientos or Roasted Red Peppers",q:8,u:"oz jar",c:"Canned"},{n:"Plum Tomatoes",q:2,u:"cup chopped",c:"Produce"},{n:"Carrots",q:2,u:"cup chopped",c:"Produce"},{n:"Chicken Broth",q:10,u:"cups",c:"Pantry"},{n:"Bay Leaves",q:4,u:"each",c:"Spices"},{n:"Dried Thyme",q:4,u:"tsp",c:"Spices"},{n:"Aceite de Achiote or Sazón",q:0.5,u:"cup",c:"Spices"},{n:"Green Peas (frozen)",q:2,u:"cup",c:"Frozen"},{n:"Green Olives (pitted)",q:1,u:"cup sliced",c:"Condiments"},{n:"Hard-Boiled Eggs",q:4,u:"each",c:"Dairy"},{n:"Queso Seco or Pecorino",q:0.5,u:"cup grated",c:"Dairy"},{n:"Fresh Italian Parsley",q:0.5,u:"cup chopped",c:"Produce"},{n:"Fine Sea Salt",q:2,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Vegetable Oil",q:2,u:"tbsp",c:"Pantry"}],
  D027:[{n:"Ground Beef",q:2,u:"lb",c:"Meat"},{n:"Ripe Plantains",q:12,u:"large",c:"Produce"},{n:"Onion",q:3,u:"cups chopped",c:"Produce"},{n:"Green Bell Peppers",q:2,u:"cup chopped",c:"Produce"},{n:"Red Bell Peppers",q:2,u:"cup chopped",c:"Produce"},{n:"Plum Tomatoes",q:4,u:"cups chopped",c:"Produce"},{n:"Cilantro",q:1,u:"cup chopped",c:"Produce"},{n:"Garlic",q:4,u:"large cloves",c:"Produce"},{n:"Tomato Paste",q:1,u:"cup",c:"Canned"},{n:"White Wine",q:1,u:"cup",c:"Pantry"},{n:"White Pepper",q:0.5,u:"tsp",c:"Spices"},{n:"Fine Sea Salt",q:2,u:"tbsp",c:"Spices"},{n:"Unsalted Butter",q:8,u:"tbsp",c:"Dairy"},{n:"Mozzarella or Queso Blanco",q:6,u:"cups shredded",c:"Dairy"},{n:"Vegetable Oil",q:4,u:"tbsp",c:"Pantry"}],
  D028:[{n:"Ground Beef",q:3,u:"lbs",c:"Meat"},{n:"Zucchini",q:4,u:"each",c:"Produce"},{n:"Carrots",q:4,u:"each",c:"Produce"},{n:"Chayote Squash",q:2,u:"each",c:"Produce"},{n:"Green Beans",q:2,u:"cup",c:"Produce"},{n:"Onion",q:2,u:"medium",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Chicken Broth",q:12,u:"cups",c:"Pantry"},{n:"Salt",q:2,u:"tsp",c:"Spices"}],
  D029:[{n:"Cannellini Beans (canned)",q:4,u:"15oz cans",c:"Canned"},{n:"Penne Pasta",q:2,u:"lb",c:"Pantry"},{n:"Pancetta or Bacon",q:8,u:"oz",c:"Meat"},{n:"Shallots",q:1,u:"cup chopped",c:"Produce"},{n:"Carrots",q:5,u:"cups chopped",c:"Produce"},{n:"Celery",q:1,u:"cup chopped",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Red Wine (Merlot)",q:2,u:"cup",c:"Pantry"},{n:"Red Bell Peppers",q:4,u:"cups julienned",c:"Produce"},{n:"Russet Potatoes",q:4,u:"cups julienned",c:"Produce"},{n:"Butternut Squash",q:2,u:"cup diced",c:"Produce"},{n:"Diced Tomatoes (canned with juices)",q:29,u:"oz can",c:"Canned"},{n:"Chicken Broth",q:16,u:"cups",c:"Pantry"},{n:"Dried Oregano",q:3,u:"tsp",c:"Spices"},{n:"Dried Thyme",q:2,u:"tsp",c:"Spices"},{n:"Ground Cumin",q:2,u:"tsp",c:"Spices"},{n:"Smoked Paprika",q:1,u:"tsp",c:"Spices"},{n:"Fine Sea Salt",q:3,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Fresh Italian Parsley",q:1,u:"cup chopped",c:"Produce"},{n:"Parmesan Cheese",q:1,u:"cup grated",c:"Dairy"}],
  D030:[{n:"Chicken Broth",q:12,u:"cups",c:"Pantry"},{n:"Corn Tortillas (stale or toasted)",q:16,u:"each",c:"Bakery"},{n:"Roma Tomatoes",q:8,u:"each",c:"Produce"},{n:"Onion",q:2,u:"medium",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Chipotle in Adobo",q:2,u:"each",c:"Canned"},{n:"Avocado",q:4,u:"each",c:"Produce"},{n:"Sour Cream",q:1,u:"cup",c:"Dairy"},{n:"Queso Fresco",q:1,u:"cup",c:"Dairy"},{n:"Cilantro",q:1,u:"bunch",c:"Produce"},{n:"Lime",q:4,u:"each",c:"Produce"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"Vegetable Oil",q:4,u:"tbsp",c:"Pantry"}],
  D031:[{n:"Chicken Thighs (bone-in)",q:6,u:"lbs",c:"Meat"},{n:"Hominy (canned)",q:4,u:"large cans",c:"Canned"},{n:"Ancho Chiles",q:6,u:"each",c:"Produce"},{n:"Guajillo Chiles",q:6,u:"each",c:"Produce"},{n:"Onion",q:2,u:"large",c:"Produce"},{n:"Garlic",q:12,u:"cloves",c:"Produce"},{n:"Chicken Broth",q:12,u:"cups",c:"Pantry"},{n:"Oregano",q:2,u:"tbsp",c:"Spices"},{n:"Cumin",q:2,u:"tsp",c:"Spices"},{n:"Radishes",q:2,u:"bunch",c:"Produce"},{n:"Cabbage",q:0.5,u:"head",c:"Produce"},{n:"Lime",q:6,u:"each",c:"Produce"},{n:"Tostadas",q:2,u:"pack",c:"Bakery"}],
  D032:[{n:"Chicken Thighs (bone-in)",q:9,u:"lbs",c:"Meat"},{n:"Aceite de Achiote",q:1,u:"cup",c:"Spices"},{n:"Onion",q:1,u:"cup chopped",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Ají Criollo or Sweet Pepper",q:2,u:"cup chopped",c:"Produce"},{n:"Tomato Paste",q:1,u:"cup",c:"Canned"},{n:"Puréed Tomatoes",q:2,u:"cup",c:"Canned"},{n:"Chicken Broth",q:6,u:"cups",c:"Pantry"},{n:"Cilantro",q:1,u:"cup chopped",c:"Produce"},{n:"Fine Sea Salt",q:4,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Corn Tortillas",q:2,u:"pack",c:"Bakery"}],
  D033:[{n:"Whole Chicken",q:2,u:"each (4-5 lbs)",c:"Meat"},{n:"Yuca",q:2,u:"lb",c:"Produce"},{n:"Ñame/Yam",q:2,u:"lb",c:"Produce"},{n:"Corn on the Cob",q:6,u:"ears",c:"Produce"},{n:"Plantains (green)",q:4,u:"each",c:"Produce"},{n:"Onion",q:2,u:"large",c:"Produce"},{n:"Garlic",q:12,u:"cloves",c:"Produce"},{n:"Cilantro",q:2,u:"bunch",c:"Produce"},{n:"Dried Oregano (Mexican)",q:1,u:"tsp",c:"Spices"},{n:"Fine Sea Salt",q:2,u:"tbsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Vegetable Oil",q:4,u:"tbsp",c:"Pantry"},{n:"Lime",q:4,u:"each",c:"Produce"}],
  D034:[{n:"Bone-In Pork Butt or Shoulder",q:10,u:"lbs",c:"Meat"},{n:"Achiote Paste",q:6,u:"oz",c:"Spices"},{n:"Sour Orange Juice",q:5,u:"cups",c:"Pantry"},{n:"White Vinegar",q:1,u:"cup",c:"Pantry"},{n:"Garlic",q:16,u:"cloves",c:"Produce"},{n:"Habanero Pepper",q:2,u:"each",c:"Produce"},{n:"Banana Leaves (frozen)",q:2,u:"pack",c:"Frozen"},{n:"Ground Cumin",q:3,u:"tsp",c:"Spices"},{n:"Mexican Oregano",q:2,u:"tsp",c:"Spices"},{n:"Ground Cloves",q:1,u:"tsp",c:"Spices"},{n:"Whole Allspice Berries",q:8,u:"each",c:"Spices"},{n:"Mexican Cinnamon (Canela)",q:2,u:"stick",c:"Spices"},{n:"Vegetable Oil or Lard",q:1,u:"cup",c:"Pantry"},{n:"Fine Sea Salt",q:5,u:"tsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"},{n:"Onion (pickled red)",q:2,u:"large",c:"Produce"},{n:"Corn Tortillas",q:2,u:"pack",c:"Bakery"}],
  L001:[{n:"Rotisserie Chicken (or cooked chicken)",q:6,u:"cups shredded",c:"Meat"},{n:"Celery",q:6,u:"stalks",c:"Produce"},{n:"Grapes (red)",q:2,u:"cup halved",c:"Produce"},{n:"Pecans",q:1,u:"cup",c:"Pantry"},{n:"Mayonnaise",q:1,u:"cup",c:"Condiments"},{n:"Lemon Juice",q:4,u:"tbsp",c:"Produce"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Black Pepper",q:0.5,u:"tsp",c:"Spices"},{n:"Bread",q:24,u:"slices",c:"Bakery"}],
  L003:[{n:"Canned Tuna",q:8,u:"cans",c:"Canned"},{n:"Celery",q:4,u:"stalks",c:"Produce"},{n:"Lemon Juice",q:4,u:"tbsp",c:"Produce"},{n:"Mayonnaise",q:0.66,u:"cup",c:"Condiments"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Black Pepper",q:0.5,u:"tsp",c:"Spices"},{n:"Bread",q:24,u:"slices",c:"Bakery"}],
  L004:[{n:"Lentils (green or brown)",q:4,u:"cups",c:"Pantry"},{n:"Onion",q:2,u:"large",c:"Produce"},{n:"Carrots",q:6,u:"each",c:"Produce"},{n:"Celery",q:6,u:"stalks",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Diced Tomatoes (canned, drained)",q:29,u:"oz can",c:"Canned"},{n:"Dried Thyme",q:2,u:"tsp",c:"Spices"},{n:"Water or Chicken Broth",q:16,u:"cups",c:"Pantry"},{n:"Balsamic Vinegar",q:3,u:"tsp",c:"Pantry"},{n:"Olive Oil",q:2,u:"tbsp",c:"Pantry"},{n:"Salt",q:4,u:"tsp",c:"Spices"},{n:"Black Pepper",q:2,u:"tsp",c:"Spices"},{n:"Spinach",q:8,u:"cups",c:"Produce"},{n:"Lemon Juice",q:4,u:"tbsp",c:"Produce"},{n:"Cumin",q:2,u:"tsp",c:"Spices"},{n:"Bay Leaves",q:4,u:"each",c:"Spices"}],
  L005:[{n:"Ground Lamb",q:6,u:"lbs",c:"Meat"},{n:"All-Purpose Potatoes",q:3,u:"lbs",c:"Produce"},{n:"Onion",q:2,u:"medium",c:"Produce"},{n:"Carrot",q:2,u:"each",c:"Produce"},{n:"Celery Rib",q:2,u:"each",c:"Produce"},{n:"Peas (frozen)",q:2,u:"cup",c:"Frozen"},{n:"Corn (frozen)",q:2,u:"cup",c:"Frozen"},{n:"Tomato Paste",q:4,u:"tbsp",c:"Canned"},{n:"All-Purpose Flour",q:2,u:"tbsp",c:"Pantry"},{n:"Beef or Chicken Broth",q:0.5,u:"cup",c:"Pantry"},{n:"Worcestershire",q:4,u:"tbsp",c:"Condiments"},{n:"Dried Thyme",q:1,u:"tsp",c:"Spices"},{n:"Dried Rosemary",q:1,u:"tsp",c:"Spices"},{n:"Nutmeg",q:2,u:"pinch",c:"Spices"},{n:"Butter",q:10,u:"tbsp",c:"Dairy"},{n:"Whole Milk",q:1,u:"cup",c:"Dairy"},{n:"Vegetable Oil",q:6,u:"tbsp",c:"Pantry"},{n:"Salt",q:2,u:"tsp",c:"Spices"},{n:"White Pepper",q:0.5,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Garlic",q:6,u:"cloves",c:"Produce"}],
  L006:[{n:"Chicken Parts",q:8,u:"lbs",c:"Meat"},{n:"All-Purpose Flour (seasoned, for dredging)",q:1,u:"cup",c:"Pantry"},{n:"Butter",q:0.5,u:"cup",c:"Dairy"},{n:"Onion",q:0.5,u:"cup diced",c:"Produce"},{n:"Green Bell Pepper",q:1,u:"cup diced",c:"Produce"},{n:"Garlic",q:2,u:"clove minced",c:"Produce"},{n:"Curry Powder",q:4,u:"tbsp",c:"Spices"},{n:"Dried Thyme",q:1,u:"tsp",c:"Spices"},{n:"Turmeric",q:2,u:"tsp",c:"Spices"},{n:"Cinnamon",q:1,u:"tsp",c:"Spices"},{n:"Cloves (ground)",q:0.5,u:"tsp",c:"Spices"},{n:"Stewed or Canned Tomatoes",q:4,u:"cups",c:"Canned"},{n:"Dates (quartered)",q:30,u:"each",c:"Pantry"},{n:"Currants",q:6,u:"tbsp",c:"Pantry"},{n:"Toasted Slivered Almonds",q:1,u:"cup",c:"Pantry"},{n:"Long Grain White Rice",q:4,u:"cups",c:"Pantry"},{n:"Salt",q:2,u:"tsp",c:"Spices"}],
  L007:[{n:"Ground Beef",q:4,u:"lbs",c:"Meat"},{n:"Onion",q:4,u:"large",c:"Produce"},{n:"Garlic",q:8,u:"cloves",c:"Produce"},{n:"Chili Powder",q:6,u:"tbsp",c:"Spices"},{n:"Cumin",q:2,u:"tsp",c:"Spices"},{n:"Cinnamon",q:2,u:"tsp",c:"Spices"},{n:"Allspice",q:1,u:"tsp",c:"Spices"},{n:"Cocoa Powder",q:2,u:"tbsp",c:"Pantry"},{n:"Tomato Paste",q:4,u:"tbsp",c:"Canned"},{n:"Crushed Tomatoes",q:2,u:"can (14oz)",c:"Canned"},{n:"Spaghetti",q:2,u:"lb",c:"Pantry"},{n:"Kidney Beans",q:2,u:"can",c:"Canned"},{n:"Shredded Cheese",q:2,u:"bag",c:"Dairy"},{n:"Onion (diced, for topping)",q:2,u:"small",c:"Produce"},{n:"Salt",q:2,u:"tsp",c:"Spices"}],
  L008:[{n:"Ground Beef",q:4,u:"lbs",c:"Meat"},{n:"Onion",q:2,u:"large",c:"Produce"},{n:"Garlic",q:6,u:"cloves",c:"Produce"},{n:"Bell Pepper",q:2,u:"each",c:"Produce"},{n:"Ketchup",q:1,u:"cup",c:"Condiments"},{n:"Tomato Paste",q:4,u:"tbsp",c:"Canned"},{n:"Worcestershire",q:2,u:"tbsp",c:"Condiments"},{n:"Brown Sugar",q:4,u:"tbsp",c:"Pantry"},{n:"Mustard",q:2,u:"tbsp",c:"Condiments"},{n:"Hamburger Buns",q:12,u:"each",c:"Bakery"},{n:"Salt",q:2,u:"tsp",c:"Spices"}],
};

const SIDES_DATA = [
  { id:"S001", name:"Drop Biscuits (ATK)", cuisine:"American", cat:"American", ingredients:[{n:"All-Purpose Flour",q:3,u:"cups",c:"Pantry"},{n:"Sugar",q:4,u:"tsp",c:"Pantry"},{n:"Baking Powder",q:1,u:"tbsp",c:"Pantry"},{n:"Baking Soda",q:0.25,u:"tsp",c:"Pantry"},{n:"Salt",q:1.25,u:"tsp",c:"Spices"},{n:"Heavy Whipping Cream",q:2,u:"cups",c:"Dairy"},{n:"Butter (melted)",q:2,u:"tbsp",c:"Dairy"}] },
  { id:"S002", name:"Mexican Rice", cuisine:"Mexican/Latin", cat:"Latin/Mexican", ingredients:[{n:"Long Grain White Rice",q:2,u:"cups",c:"Pantry"},{n:"Oil",q:2,u:"tbsp",c:"Pantry"},{n:"Garlic",q:3,u:"cloves",c:"Produce"},{n:"Onion",q:0.5,u:"each",c:"Produce"},{n:"Tomato Sauce",q:1,u:"can",c:"Canned"},{n:"Tomato Bouillon",q:2,u:"cubes",c:"Pantry"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Carrot",q:1,u:"diced",c:"Produce"},{n:"Peas",q:0.5,u:"cup",c:"Frozen"}] },
  { id:"S003", name:"Hummus", cuisine:"Mediterranean", cat:"Mediterranean", ingredients:[{n:"Canned Chickpeas",q:14,u:"oz",c:"Canned"},{n:"Tahini",q:1.5,u:"tbsp",c:"Pantry"},{n:"Lemon",q:1,u:"each",c:"Produce"},{n:"Garlic",q:2,u:"cloves",c:"Produce"},{n:"Extra Virgin Olive Oil",q:2,u:"tbsp",c:"Pantry"},{n:"Salt",q:0.5,u:"tsp",c:"Spices"}] },
  { id:"S004", name:"Chickpea Mediterranean Salad", cuisine:"Mediterranean", cat:"Mediterranean", ingredients:[{n:"Dried Chickpeas",q:2,u:"cups",c:"Pantry"},{n:"Red Onions",q:3,u:"small diced",c:"Produce"},{n:"Tomatoes",q:4,u:"small cubed",c:"Produce"},{n:"Cucumber",q:1,u:"each cubed",c:"Produce"},{n:"Red Bell Pepper",q:1,u:"each cubed",c:"Produce"},{n:"Olive Oil",q:0.5,u:"cup",c:"Pantry"},{n:"Lemon Juice",q:6,u:"tbsp",c:"Produce"},{n:"Garlic (minced)",q:3,u:"tsp",c:"Produce"},{n:"Dill",q:1,u:"tsp",c:"Spices"},{n:"Sweet Paprika",q:0.5,u:"tsp",c:"Spices"},{n:"Cumin Powder",q:0.5,u:"tsp",c:"Spices"},{n:"Cayenne",q:0.25,u:"tsp",c:"Spices"},{n:"Black Pepper",q:1,u:"tsp",c:"Spices"},{n:"Salt",q:2,u:"tbsp",c:"Spices"}] },
  { id:"S005", name:"Quinoa con Limón", cuisine:"Latin/Bolivian", cat:"Latin/Mexican", ingredients:[{n:"Quinoa",q:1,u:"cup",c:"Pantry"},{n:"Chicken Broth or Water",q:2,u:"cups",c:"Pantry"},{n:"Queso Fresco or Goat Cheese",q:0.25,u:"cup crumbled",c:"Dairy"},{n:"Plum Tomatoes",q:0.25,u:"cup chopped",c:"Produce"},{n:"Red Onion",q:0.25,u:"cup chopped",c:"Produce"},{n:"Red Bell Pepper",q:0.25,u:"cup chopped",c:"Produce"},{n:"Garlic",q:1,u:"clove",c:"Produce"},{n:"Fresh Italian Parsley",q:0.25,u:"cup chopped",c:"Produce"},{n:"Lime Juice",q:0.33,u:"cup",c:"Produce"},{n:"Fine Sea Salt",q:1,u:"tsp",c:"Spices"},{n:"Ground Cumin",q:0.25,u:"tsp",c:"Spices"},{n:"Black Pepper",q:0.5,u:"tsp",c:"Spices"},{n:"Extra-Virgin Olive Oil",q:2,u:"tbsp",c:"Pantry"}] },
  { id:"S006", name:"Papas Doradas al Sartén", cuisine:"Latin", cat:"Latin/Mexican", ingredients:[{n:"Yukon Gold Potatoes",q:1.5,u:"lbs cubed",c:"Produce"},{n:"Vegetable Oil",q:0.125,u:"cup",c:"Pantry"},{n:"Butter",q:1,u:"tbsp",c:"Dairy"},{n:"Fine Sea Salt",q:1,u:"tsp",c:"Spices"},{n:"Garlic Powder",q:0.25,u:"tsp",c:"Spices"},{n:"Smoked Paprika (Pimentón)",q:0.25,u:"tsp",c:"Spices"}] },
  { id:"S007", name:"Salsa de Tomate Preparada", cuisine:"Latin/Mexican", cat:"Latin/Mexican", ingredients:[{n:"Canned Diced Tomatoes",q:28,u:"oz",c:"Canned"},{n:"Green Onions",q:2,u:"large",c:"Produce"},{n:"Chipotle in Adobo",q:1,u:"each",c:"Canned"},{n:"Dried Thyme",q:0.5,u:"tsp",c:"Spices"},{n:"Garlic",q:1,u:"clove",c:"Produce"},{n:"Vegetable Oil",q:0.25,u:"cup",c:"Pantry"}] },
  { id:"S008", name:"Calabacitas", cuisine:"Mexican/Latin", cat:"Latin/Mexican", ingredients:[{n:"Vegetable Oil or Lard",q:2,u:"tbsp",c:"Pantry"},{n:"Onion",q:1,u:"cup chopped",c:"Produce"},{n:"Garlic",q:1,u:"clove",c:"Produce"},{n:"Zucchini",q:2.5,u:"cups chopped",c:"Produce"},{n:"Yellow Squash",q:2.5,u:"cups chopped",c:"Produce"},{n:"Plum Tomatoes",q:1,u:"cup chopped",c:"Produce"},{n:"Poblano Pepper",q:1,u:"roasted",c:"Produce"},{n:"Corn Kernels",q:1,u:"cup",c:"Produce"},{n:"Dried Oregano (Mexican)",q:0.5,u:"tsp",c:"Spices"},{n:"Fine Sea Salt",q:0.5,u:"tsp",c:"Spices"},{n:"Black Pepper",q:0.25,u:"tsp",c:"Spices"},{n:"Cotija Cheese",q:1,u:"cup",c:"Dairy"}] },

  { id:"S010", name:"Frozen Broccoli", cuisine:"Universal", cat:"American", ingredients:[{n:"Frozen Broccoli",q:2,u:"lbs",c:"Frozen"}] },
  { id:"S011", name:"Frozen Green Beans", cuisine:"Universal", cat:"American", ingredients:[{n:"Frozen Green Beans",q:2,u:"lbs",c:"Frozen"}] },
  { id:"S012", name:"Frozen Medley Mix", cuisine:"Universal", cat:"American", ingredients:[{n:"Frozen Vegetable Medley",q:2,u:"lbs",c:"Frozen"}] },
  { id:"S013", name:"Frozen Sweet Potato Fries", cuisine:"American", cat:"American", ingredients:[{n:"Frozen Sweet Potato Fries",q:2,u:"lbs",c:"Frozen"}] },
  { id:"S014", name:"Frozen Normandy Veggie Mix", cuisine:"Universal", cat:"American", ingredients:[{n:"Frozen Normandy Vegetables",q:2,u:"lbs",c:"Frozen"}] },
  { id:"S015", name:"Frozen Mediterranean Veggie Mix", cuisine:"Mediterranean", cat:"Mediterranean", ingredients:[{n:"Frozen Mediterranean Vegetables",q:2,u:"lbs",c:"Frozen"}] },
  { id:"S016", name:"Mashed Potatoes (Instant)", cuisine:"American", cat:"American", ingredients:[{n:"Instant Mashed Potatoes",q:1,u:"box",c:"Pantry"},{n:"Butter",q:3,u:"tbsp",c:"Dairy"},{n:"Milk",q:1,u:"cup",c:"Dairy"}] },
  { id:"S017", name:"Steamed Rice", cuisine:"Universal", cat:"American", ingredients:[{n:"Long Grain White Rice",q:3,u:"cups",c:"Pantry"},{n:"Salt",q:1,u:"tsp",c:"Spices"}] },
  { id:"S018", name:"Toast", cuisine:"American", cat:"Breakfast Side", ingredients:[{n:"Bread",q:12,u:"slices",c:"Bakery"},{n:"Butter",q:2,u:"tbsp",c:"Dairy"}] },
  { id:"S019", name:"Beans (Breakfast)", cuisine:"Latin", cat:"Breakfast Side", ingredients:[{n:"Canned Beans",q:2,u:"cans",c:"Canned"},{n:"Butter",q:1,u:"tbsp",c:"Dairy"}] },
  { id:"S020", name:"English Muffins", cuisine:"American", cat:"Breakfast Side", ingredients:[{n:"English Muffins",q:6,u:"each",c:"Bakery"},{n:"Butter",q:2,u:"tbsp",c:"Dairy"}] },
  { id:"S021", name:"Mexican Rice & Beans", cuisine:"Mexican/Latin", cat:"Latin/Mexican", ingredients:[{n:"Long Grain White Rice",q:2,u:"cups",c:"Pantry"},{n:"Oil",q:2,u:"tbsp",c:"Pantry"},{n:"Garlic",q:3,u:"cloves",c:"Produce"},{n:"Onion",q:0.5,u:"each",c:"Produce"},{n:"Tomato Sauce",q:1,u:"can",c:"Canned"},{n:"Tomato Bouillon",q:2,u:"cubes",c:"Pantry"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Canned Pinto Beans",q:2,u:"cans",c:"Canned"},{n:"Butter",q:1,u:"tbsp",c:"Dairy"}] },
  { id:"S023", name:"Mexican Rice, Beans & Tortillas", cuisine:"Mexican/Latin", cat:"Latin/Mexican", ingredients:[{n:"Long Grain White Rice",q:2,u:"cups",c:"Pantry"},{n:"Oil",q:2,u:"tbsp",c:"Pantry"},{n:"Garlic",q:3,u:"cloves",c:"Produce"},{n:"Onion",q:0.5,u:"each",c:"Produce"},{n:"Tomato Sauce",q:1,u:"can",c:"Canned"},{n:"Tomato Bouillon",q:2,u:"cubes",c:"Pantry"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Canned Pinto Beans",q:2,u:"cans",c:"Canned"},{n:"Butter",q:1,u:"tbsp",c:"Dairy"},{n:"Flour Tortillas",q:2,u:"packs",c:"Bakery"}] },
  { id:"S024", name:"Guacamol (Guatemalan)", cuisine:"Guatemalan", cat:"Latin/Mexican", ingredients:[{n:"Hass Avocados",q:3,u:"each",c:"Produce"},{n:"Lime Juice",q:3,u:"tbsp",c:"Produce"},{n:"White Onion (finely chopped)",q:2,u:"tbsp",c:"Produce"},{n:"Dried Mexican Oregano",q:0.5,u:"tsp",c:"Spices"},{n:"Fine Sea Salt",q:0.5,u:"tsp",c:"Spices"},{n:"White Pepper",q:0.25,u:"tsp",c:"Spices"},{n:"Queso Seco (or Feta)",q:2,u:"tbsp",c:"Dairy"}] },
  { id:"S025", name:"Corn Tortillas", cuisine:"Latin", cat:"Latin/Mexican", ingredients:[{n:"Corn Tortillas",q:2,u:"packs",c:"Bakery"}] },
  { id:"S026", name:"Artisan Garlic Bread", cuisine:"American", cat:"American", ingredients:[{n:"Artisan Garlic Bread",q:1,u:"loaf",c:"Bakery"}] },
  { id:"S027", name:"Beans", cuisine:"Mexican/Latin", cat:"Latin/Mexican", ingredients:[{n:"Canned Pinto Beans",q:2,u:"cans",c:"Canned"},{n:"Butter",q:1,u:"tbsp",c:"Dairy"}] },
  { id:"S028", name:"Flour Tortillas", cuisine:"Latin", cat:"Latin/Mexican", ingredients:[{n:"Flour Tortillas",q:2,u:"packs",c:"Bakery"}] },
  { id:"S029", name:"Sausage", cuisine:"American", cat:"Breakfast Protein", ingredients:[{n:"Breakfast Sausage Links",q:1,u:"pack",c:"Meat"}] },
  { id:"S030", name:"Bacon", cuisine:"American", cat:"Breakfast Protein", ingredients:[{n:"Bacon",q:1,u:"pack",c:"Meat"}] },
  { id:"S031", name:"Maduros", cuisine:"Latin", cat:"Breakfast Side", ingredients:[{n:"Ripe Plantains",q:3,u:"each",c:"Produce"},{n:"Vegetable Oil",q:0.5,u:"cup",c:"Pantry"},{n:"Salt",q:0.5,u:"tsp",c:"Spices"}] },
  { id:"S032", name:"Grilled Cheese", cuisine:"American", cat:"American", ingredients:[{n:"Bread",q:12,u:"slices",c:"Bakery"},{n:"American Cheese",q:6,u:"slices",c:"Dairy"},{n:"Butter",q:3,u:"tbsp",c:"Dairy"}] },
  { id:"S033", name:"Leftover Pancakes", cuisine:"American", cat:"Breakfast Side", ingredients:[] },
  { id:"S034", name:"Ensalada de Coditos", cuisine:"Latin/Various", cat:"Latin/Mexican", ingredients:[{n:"Elbow Pasta",q:1,u:"lb",c:"Pantry"},{n:"Mayonnaise",q:1,u:"cup",c:"Condiments"},{n:"Crema or Sour Cream",q:0.25,u:"cup",c:"Dairy"},{n:"Lime Juice",q:0.25,u:"cup",c:"Produce"},{n:"Salt",q:1,u:"tsp",c:"Spices"},{n:"Black Pepper",q:0.5,u:"tsp",c:"Spices"},{n:"Garlic",q:1,u:"clove",c:"Produce"},{n:"Bell Peppers (mixed colors)",q:0.75,u:"cup",c:"Produce"},{n:"Celery",q:0.75,u:"cup",c:"Produce"},{n:"Fresh Italian Parsley",q:0.25,u:"cup",c:"Produce"}] },
  { id:"S035", name:"Pita Bread", cuisine:"Mediterranean", cat:"Mediterranean", ingredients:[{n:"Pita Bread",q:1,u:"pack",c:"Bakery"}] },
];

// Curtido is only for Pupusas eat-out, not in the general sides picker
const CURTIDO_DATA = {n:"Curtido", ingredients:[{n:"Green Cabbage",q:0.5,u:"head",c:"Produce"},{n:"Carrots",q:2,u:"each",c:"Produce"},{n:"White Onion",q:1,u:"each",c:"Produce"},{n:"White Vinegar",q:0.5,u:"cup",c:"Pantry"},{n:"Dried Oregano",q:1,u:"tsp",c:"Spices"},{n:"Salt",q:1,u:"tsp",c:"Spices"}]};

// ── Snapshot of the catalog at module load.
//    customMeals state is the single source of truth for user-added meals;
//    these snapshots let us fully reset the mutable arrays on every change
//    so deleted/updated customs can never leave stale entries behind.
const ORIGINAL_MEALS_LENGTH = MEALS_DATA.length;
const ORIGINAL_SIDES_LENGTH = SIDES_DATA.length;
const ORIGINAL_INGREDIENTS_KEYS = new Set(Object.keys(INGREDIENTS_DATA));

// Rebuild MEALS_DATA / SIDES_DATA / INGREDIENTS_DATA from scratch using
// customMeals state. Idempotent: safe to call after any customMeals
// mutation. Skips soft-deleted entries (deletedAt set).
//
// Built-in meal "shadowing": when a user edits a built-in meal we add a
// shadow entry to customMeals with `_shadowOf: <originalId>`. Resync removes
// the original from MEALS_DATA so lookups by name go to the user's edited
// version, not the factory copy. Preserves the original's id on the shadow's
// alias so old plan slots still resolve.
const resyncCustomData = (customMeals) => {
  MEALS_DATA.length = ORIGINAL_MEALS_LENGTH;
  SIDES_DATA.length = ORIGINAL_SIDES_LENGTH;
  Object.keys(INGREDIENTS_DATA).forEach(k => {
    if (!ORIGINAL_INGREDIENTS_KEYS.has(k)) delete INGREDIENTS_DATA[k];
  });

  // Collect ids that are shadowed so we hide the originals.
  const shadowedIds = new Set();
  (customMeals || []).forEach(cm => {
    if (!cm.deletedAt && cm._shadowOf) shadowedIds.add(cm._shadowOf);
  });
  if (shadowedIds.size > 0) {
    for (let i = MEALS_DATA.length - 1; i >= 0; i--) {
      if (shadowedIds.has(MEALS_DATA[i].id)) MEALS_DATA.splice(i, 1);
    }
    for (let i = SIDES_DATA.length - 1; i >= 0; i--) {
      if (shadowedIds.has(SIDES_DATA[i].id)) SIDES_DATA.splice(i, 1);
    }
  }

  (customMeals || []).forEach(cm => {
    if (cm.deletedAt) return;
    if (cm._isSide) {
      SIDES_DATA.push(cm);
    } else {
      MEALS_DATA.push(cm);
      if (cm.ingredients && cm.ingredients.length > 0) {
        INGREDIENTS_DATA[cm.id] = cm.ingredients;
      }
    }
  });
};

// Protein add-on options for certain meals (like Caesar Salad)
const PROTEIN_OPTIONS = {
  L009: [ // Caesar Salad
    { id:"chicken_patties", name:"Chicken Patties/Nuggets", ingredients:[{n:"Frozen Chicken Patties/Nuggets",q:1,u:"bag",c:"Frozen"}] },
    { id:"rotisserie", name:"Rotisserie Chicken", ingredients:[{n:"Rotisserie Chicken",q:1,u:"each",c:"Deli"}] },
    { id:"none", name:"No Protein", ingredients:[] },
  ],
};

const SIDE_CATEGORIES = ["All Sides","Latin/Mexican","Mediterranean","American","Breakfast Side","Breakfast Protein"];

// ── Prep Type Config ───────────────────────────
const PREP_TYPES = {
  "Auto":        { color:"#9ca3af", bg:"#f3f4f6", label:"Auto (use rule/pattern)" },
  "Cook Fresh":  { color:"#2d6a4f", bg:"#d8f3dc", label:"Cook Fresh" },
  "Bulk Cook":   { color:"#1d3557", bg:"#a8dadc", label:"Bulk Cook" },
  "Defrost":     { color:"#6a0572", bg:"#e8d5ec", label:"Defrost" },
  "Frozen Meal": { color:"#0d7377", bg:"#d0f0f0", label:"Frozen Meal" },
  "Leftover Day":{ color:"#b5179e", bg:"#fde2f3", label:"Leftover Day" },
  "Eat Out":     { color:"#e76f51", bg:"#fef3c7", label:"Eat Out" },
  "Skip":        { color:"#6b7280", bg:"#e5e7eb", label:"Skip" },
};

// ═══════════════════════════════════════════════════════════════════════════
// ═ SEASONAL & PERISHABILITY CONSTANTS & ENGINE
// ═══════════════════════════════════════════════════════════════════════════

// Month-indexed seasonal profiles for SWFL (0=Jan, 11=Dec)
// comfort: boost soups/stews/hearty. light: boost salads/grilling/fresh.
// Each value 0-1 representing how much to favor that style.
const SEASONAL_PROFILES = {
  0:  { comfort: 0.6, light: 0.3 },  // Jan - mild cool
  1:  { comfort: 0.5, light: 0.4 },  // Feb
  2:  { comfort: 0.3, light: 0.6 },  // Mar - warming up
  3:  { comfort: 0.2, light: 0.7 },  // Apr - warm
  4:  { comfort: 0.1, light: 0.8 },  // May - hot
  5:  { comfort: 0.1, light: 0.9 },  // Jun - peak heat
  6:  { comfort: 0.1, light: 0.9 },  // Jul - peak heat
  7:  { comfort: 0.1, light: 0.9 },  // Aug - peak heat
  8:  { comfort: 0.2, light: 0.8 },  // Sep - still hot
  9:  { comfort: 0.3, light: 0.6 },  // Oct - cooling
  10: { comfort: 0.5, light: 0.4 },  // Nov - cool season
  11: { comfort: 0.6, light: 0.3 },  // Dec - coolest
};

// Tag meals as comfort or light based on cuisine/ingredients
// These are soft classifications, not hard rules
const COMFORT_MEAL_IDS = new Set(); // will be populated dynamically
const LIGHT_MEAL_IDS = new Set();   // will be populated dynamically

// Perishability tiers: 1 = use within 2 days, 2 = use within 4-5 days, 3 = shelf stable
const PERISHABILITY = {
  'Produce': 1,
  'Dairy': 2,
  'Meat / Seafood': 1,
  'Bakery': 2,
  'Frozen': 3,
  'Pantry': 3,
  'Canned Goods': 3,
  'Condiments': 3,
  'Grains / Pasta': 3,
  'Spices': 3,
  'Other': 3,
};

// ───────────────────────────────────────────────────────────────
// SeasonalGroceryEngine: seasonal scoring, perishability, pantry
// ───────────────────────────────────────────────────────────────

class SeasonalGroceryEngine {
  constructor(mealsData, ingredientsData) {
    this.meals = mealsData;
    this.ingredients = ingredientsData;
    this.mealClassifications = this.classifyMeals(mealsData, ingredientsData);
  }

  // Classify each meal as comfort, light, or neutral
  classifyMeals(mealsData, ingredientsData) {
    const classifications = new Map();
    const comfortKeywords = ['stew', 'soup', 'roast', 'chili', 'oatmeal', 'slow cook', 'braise', 'guisada', 'sancocho', 'carbonada', 'pozole', 'sopa'];
    const lightKeywords = ['salad', 'fresh', 'grill', 'wrap', 'bowl', 'ceviche', 'asada', 'tacos'];

    mealsData.forEach(meal => {
      let classification = 'neutral';
      const nameAndNotes = (meal.name + ' ' + (meal.notes || '')).toLowerCase();

      // Check for comfort indicators
      if (comfortKeywords.some(kw => nameAndNotes.includes(kw))) {
        classification = 'comfort';
      }
      // Check for light indicators (overrides comfort)
      if (lightKeywords.some(kw => nameAndNotes.includes(kw))) {
        classification = 'light';
      }

      classifications.set(meal.id, classification);
    });

    return classifications;
  }

  // Get seasonal score multiplier (0-1) for a meal on a given date
  getSeasonalScore(mealId, planDate) {
    const month = new Date(planDate).getMonth();
    const classification = this.mealClassifications.get(mealId) || 'neutral';

    let baseScore = 0.5;
    if (classification === 'comfort') {
      baseScore = SEASONAL_PROFILES[month].comfort;
    } else if (classification === 'light') {
      baseScore = SEASONAL_PROFILES[month].light;
    } else {
      baseScore = 0.5;
    }

    // Light touch: max ±10% influence
    return baseScore * (1 + 0.2 * (baseScore - 0.5));
  }

  // Get average perishability score for a meal (1-3)
  getMealPerishabilityScore(mealId, ingredientsData) {
    const mealIngs = ingredientsData[mealId] || [];
    if (mealIngs.length === 0) return 2.5; // Default to mid-range

    let totalPerishability = 0;
    let count = 0;

    mealIngs.forEach(ing => {
      const category = ing.c || 'Other';
      const perishScore = PERISHABILITY[category] || PERISHABILITY['Other'];
      totalPerishability += perishScore;
      count++;
    });

    return count > 0 ? totalPerishability / count : 2.5;
  }

  // Penalty for bad perishable scheduling (lower = more perishable = schedule early)
  getPerishabilityPenalty(plan, openSlotKeys) {
    let totalPenalty = 0;

    openSlotKeys.forEach(k => {
      const slot = plan[k];
      if (!slot || !slot.mealId) return;

      const dayOfWeek = new Date(slot.date).getDay(); // 0=Sun, 6=Sat
      const perishScore = this.getMealPerishabilityScore(slot.mealId, this.ingredients);

      // Penalize perishable meals (score < 2) scheduled Thu-Sat (days 4-6)
      if (perishScore < 2 && dayOfWeek >= 4) {
        totalPenalty += 0.3;
      }
      // Slight bonus for shelf-stable meals (score > 2.5) scheduled late week
      if (perishScore > 2.5 && dayOfWeek >= 4) {
        totalPenalty -= 0.1;
      }
    });

    return Math.max(0, totalPenalty / Math.max(1, openSlotKeys.length));
  }

  // Pantry bonus: how many meal ingredients are already in pantry
  getPantryBonus(mealId, pantryItems, ingredientsData, familySize) {
    const mealIngs = ingredientsData[mealId] || [];
    if (mealIngs.length === 0) return 0;

    let matched = 0;
    mealIngs.forEach(ing => {
      const ingName = (ing.n || '').toLowerCase();
      if (pantryItems && pantryItems.some(p => (p.name || '').toLowerCase().includes(ingName) || ingName.includes((p.name || '').toLowerCase()))) {
        matched++;
      }
    });

    return mealIngs.length > 0 ? matched / mealIngs.length : 0;
  }
}

// ═══════════════════════════════════════════════════════════════════════════
// ═ 1. THOMPSON SAMPLING ENGINE (~250 lines)
// ═══════════════════════════════════════════════════════════════════════════

class ThompsonSampler {
  constructor() {
    this.params = new Map(); // mealId -> {alpha, beta}
    this.servedDates = new Map(); // mealId -> [dates]
  }

  // Marsaglia-Tsang gamma distribution sampling
  _sampleGamma(k, theta = 1) {
    if (k < 1) k = 1;
    const d = k - 1/3;
    const c = 1 / Math.sqrt(9 * d);
    let z, v, u;
    do {
      do {
        z = (Math.random() - 0.5) * 3;
        v = 1 + c * z;
      } while (v <= 0);
      v = v * v * v;
      u = Math.random();
    } while (u > 1 - 0.0331 * z * z * z * z && Math.log(u) > 0.5 * z * z + d * (1 - v + Math.log(v)));
    return d * v * theta;
  }

  // Beta(alpha, beta) sampling via Gamma
  _sampleBeta(alpha, beta) {
    const x = this._sampleGamma(alpha);
    const y = this._sampleGamma(beta);
    return x / (x + y);
  }

  // Initialize or get Beta parameters for a meal
  _getParams(mealId) {
    if (!this.params.has(mealId)) {
      this.params.set(mealId, { alpha: 2, beta: 2 });
    }
    return this.params.get(mealId);
  }

  // Record feedback: updates Beta distribution
  recordFeedback(mealId, signal) {
    const params = this._getParams(mealId);
    switch (signal) {
      case 'cooked':        params.alpha += 1.0; break;
      case 're_added':      params.alpha += 1.0; break;
      case 'accepted':      params.alpha += 0.3; break;
      case 'swapped_away':  params.beta  += 0.7; break;
      case 'skipped':       params.beta  += 0.3; break;
      case 'swapped_to':    break; // No update for swap target yet
      default: break;
    }
  }

  // Track served date for cooldown
  markServed(mealId, dateString) {
    if (!this.servedDates.has(mealId)) {
      this.servedDates.set(mealId, []);
    }
    const dates = this.servedDates.get(mealId);
    if (!dates.includes(dateString)) {
      dates.push(dateString);
    }
  }

  // Filter candidates by cooldown: 14-day hard exclusion
  filterByCooldown(candidates, lastPlanDate) {
    const hardCooldownDays = 14;
    const softCooldownStart = 14;
    const softCooldownEnd = 21;

    return candidates.filter(meal => {
      const dates = this.servedDates.get(meal.id) || [];
      if (dates.length === 0) return true;

      const lastServed = new Date(Math.max(...dates.map(d => new Date(d).getTime())));
      const daysSince = Math.floor((lastPlanDate.getTime() - lastServed.getTime()) / (24 * 60 * 60 * 1000));

      // Hard exclusion: within 14 days
      if (daysSince < hardCooldownDays) return false;

      // Soft transition: 14-21 days → explore probability increases
      if (daysSince >= softCooldownStart && daysSince <= softCooldownEnd) {
        return Math.random() < (daysSince - softCooldownStart) / (softCooldownEnd - softCooldownStart);
      }

      return true;
    });
  }

  // Main selection via Thompson Sampling with temperature scaling
  selectMeal(candidates, context = {}, options = {}) {
    const { temperature = 0.8, explorationBudget = 3 } = options;
    const lastPlanDate = context.lastPlanDate || new Date();

    // 1. Apply hard cooldown filtering
    let filtered = this.filterByCooldown(candidates, lastPlanDate);

    // 2. Safety valve: if pool is too small, relax cooldown progressively
    if (filtered.length < 8) {
      const softCooldownStart = 14;
      const softCooldownEnd = 21;
      let relaxed = candidates.filter(meal => {
        const dates = this.servedDates.get(meal.id) || [];
        if (dates.length === 0) return true;
        const lastServed = new Date(Math.max(...dates.map(d => new Date(d).getTime())));
        const daysSince = Math.floor((lastPlanDate.getTime() - lastServed.getTime()) / (24 * 60 * 60 * 1000));
        // Relax to 10 days hard + 16-28 soft
        return daysSince >= 10;
      });
      if (relaxed.length >= 8) filtered = relaxed;
    }

    if (filtered.length === 0) return candidates[Math.floor(Math.random() * candidates.length)];

    // 3. Thompson Sampling: sample each candidate's belief
    const scores = filtered.map(meal => {
      const params = this._getParams(meal.id);
      const sample = this._sampleBeta(params.alpha, params.beta);
      return { meal, sample };
    });

    // 4. Apply temperature scaling
    const scaledScores = scores.map(({ meal, sample }) => {
      // Temperature scaling: higher T = more entropy
      const scaledSample = Math.pow(sample, 1 / temperature);
      return { meal, score: scaledSample };
    });

    // 5. Select via softmax (weighted random from scores)
    const totalScore = scaledScores.reduce((sum, s) => sum + s.score, 0);
    let rand = Math.random() * totalScore;
    for (const { meal, score } of scaledScores) {
      rand -= score;
      if (rand <= 0) return meal;
    }

    return scaledScores[scaledScores.length - 1].meal;
  }

  // Load Thompson params from Supabase
  async loadFromSupabase(supabase, userId) {
    try {
      const { data, error } = await supabase
        .from("meal_planner_data")
        .select("thompson_params")
        .eq("user_id", userId)
        .single();

      if (error && error.code !== "PGRST116") {
        console.error("Thompson load error:", error);
        return;
      }

      if (data?.thompson_params) {
        const stored = data.thompson_params;
        this.params.clear();
        Object.entries(stored.params || {}).forEach(([mealId, { alpha, beta }]) => {
          this.params.set(mealId, { alpha, beta });
        });
        this.servedDates.clear();
        Object.entries(stored.servedDates || {}).forEach(([mealId, dates]) => {
          this.servedDates.set(mealId, dates);
        });
      }
    } catch (e) {
      console.error("Thompson load exception:", e);
    }
  }

  // Save Thompson params to Supabase (fire-and-forget)
  async saveToSupabase(supabase, userId) {
    const paramsObj = {};
    this.params.forEach((v, k) => { paramsObj[k] = v; });
    const servedDatesObj = {};
    this.servedDates.forEach((v, k) => { servedDatesObj[k] = v; });

    const thompson_params = {
      params: paramsObj,
      servedDates: servedDatesObj,
      version: 1,
      updated_at: new Date().toISOString()
    };

    supabase
      .from("meal_planner_data")
      .update({ thompson_params })
      .eq("user_id", userId)
      .catch(e => console.error("Thompson save error:", e));
  }
}

// ═══════════════════════════════════════════════════════════════════════════
// ═ 2. MEAL EVENT HELPERS (~100 lines)
// ═══════════════════════════════════════════════════════════════════════════

const getSeason = (date) => {
  const d = new Date(date);
  const month = d.getMonth();
  if (month >= 2 && month <= 4) return "Spring";
  if (month >= 5 && month <= 7) return "Summer";
  if (month >= 8 && month <= 10) return "Fall";
  return "Winter";
};

const getWeekNumber = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNum;
};

const buildContext = (slotDate, mealTime, prepType, extra = {}) => {
  const d = new Date(slotDate);
  return {
    slotDate,
    dayOfWeek: DAYS[d.getDay()],
    mealTime,
    prepType,
    season: getSeason(slotDate),
    weekNumber: getWeekNumber(slotDate),
    ...extra
  };
};

const recordMealEvent = async (supabase, userId, event) => {
  const {
    eventType, mealId, slotDate, mealTime, prepType,
    replacedMealId, replacedPrepType, wasViewed, skipReason
  } = event;

  const eventRecord = {
    user_id: userId,
    event_type: eventType,
    meal_id: mealId,
    slot_date: slotDate,
    meal_time: mealTime,
    prep_type: prepType,
    replaced_meal_id: replacedMealId,
    replaced_prep_type: replacedPrepType,
    was_viewed: wasViewed || false,
    skip_reason: skipReason,
    context: buildContext(slotDate, mealTime, prepType),
    created_at: new Date().toISOString()
  };

  // Fire-and-forget
  supabase
    .from("meal_events")
    .insert([eventRecord])
    .catch(e => console.error("Event record error:", e));
};

const recordSwap = async (supabase, userId, swap) => {
  const {
    newMealId, rejectedMealId, slotDate, mealTime,
    newPrepType, rejectedPrepType
  } = swap;

  await recordMealEvent(supabase, userId, {
    eventType: 'swapped_away',
    mealId: rejectedMealId,
    slotDate,
    mealTime,
    prepType: rejectedPrepType,
    replacedMealId: newMealId,
    replacedPrepType: newPrepType,
    wasViewed: true
  });

  // No event for the new meal yet—it will be tracked at finalize
};

const recordWeekAccepted = async (supabase, userId, slots, wasViewed) => {
  const events = [];
  slots.forEach(slot => {
    if (!slot.mealId) return;
    if (slot.prepType === "Skip" || slot.prepType === "Eat Out") return;
    if (slot.isLeftover) return;

    events.push({
      eventType: 'accepted',
      mealId: slot.mealId,
      slotDate: slot.date,
      mealTime: slot.mealTime,
      prepType: slot.prepType,
      wasViewed
    });
  });

  // Batch fire-and-forget
  if (events.length > 0) {
    const records = events.map(e => recordMealEvent(supabase, userId, e));
    await Promise.allSettled(records);
  }
};

// ═══════════════════════════════════════════════════════════════════════════
// ═ 3. MEAL PREFERENCE ENGINE (~300 lines)
// ═══════════════════════════════════════════════════════════════════════════

// Feature weight configuration
const FEATURE_WEIGHTS = {
  proteinType: 0.15,
  cuisineMarkers: 0.15,
  cookingMethod: 0.12,
  carbBase: 0.10,
  vegTypes: 0.12,
  spiceLevel: 0.10,
  texture: 0.12,
  distinctiveIngredients: 0.14
};

const PROTEIN_KEYWORDS = {
  'beef': ['beef', 'steak', 'ground beef', 'chuck', 'sirloin'],
  'chicken': ['chicken', 'poultry', 'rotisserie'],
  'pork': ['pork', 'bacon', 'sausage', 'ham'],
  'seafood': ['fish', 'shrimp', 'salmon', 'cod', 'tuna'],
  'vegetarian': ['tofu', 'tempeh', 'chickpea', 'lentil', 'bean'],
  'egg': ['egg', 'eggs']
};

const CUISINE_SIGNATURES = {
  'mexican': ['salsa', 'cilantro', 'chili', 'cumin', 'lime', 'jalapeño', 'tortilla'],
  'mediterranean': ['olive oil', 'feta', 'lemon', 'oregano', 'garlic', 'tomato'],
  'asian': ['soy', 'ginger', 'sesame', 'sichuan', 'wasabi', 'soy sauce'],
  'american': ['cheddar', 'bacon', 'bbq', 'ranch', 'corn'],
  'italian': ['basil', 'parmesan', 'mozzarella', 'tomato', 'garlic', 'pasta']
};

const CARB_KEYWORDS = ['rice', 'pasta', 'bread', 'potato', 'tortilla', 'quinoa', 'couscous'];
const VEG_KEYWORDS = ['vegetable', 'carrot', 'broccoli', 'spinach', 'kale', 'pepper', 'tomato', 'lettuce'];
const SPICE_KEYWORDS = {
  'mild': ['mild', 'soft', 'tender'],
  'medium': ['medium', 'some spice', 'moderately spicy'],
  'hot': ['hot', 'spicy', 'very spicy', 'jalapeño', 'habanero', 'chili']
};
const TEXTURE_KEYWORDS = ['crispy', 'tender', 'crunchy', 'creamy', 'smooth', 'chewy', 'juicy'];
const STOPWORDS = new Set(['the', 'a', 'an', 'and', 'or', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by']);

class MealPreferenceEngine {
  constructor(mealsData, ingredientsData) {
    this.meals = mealsData || [];
    this.ingredients = ingredientsData || {};
    this.userPreferences = new Map(); // mealId -> score
    this.similarityMatrix = new Map(); // "mealId1_mealId2" -> similarity
    this.lastUpdate = new Date();
    this._computeSimilarityMatrix();
  }

  // Extract feature vector for a meal (8 dimensions)
  _extractFeatures(mealId) {
    const meal = this.meals.find(m => m.id === mealId);
    if (!meal) return null;

    const ingredients = this.ingredients[mealId] || [];
    const ingredientText = (ingredients.map(i => i.n || '').join(' ') + ' ' + (meal.name || '')).toLowerCase();

    // 1. Protein type (one-hot)
    const proteinVector = Array(6).fill(0); // 6 protein types
    Object.entries(PROTEIN_KEYWORDS).forEach(([type, keywords], idx) => {
      if (keywords.some(k => ingredientText.includes(k))) proteinVector[idx] = 1;
    });

    // 2. Cuisine markers (one-hot)
    const cuisineVector = Array(5).fill(0);
    Object.entries(CUISINE_SIGNATURES).forEach(([cuisine, keywords], idx) => {
      if (keywords.some(k => ingredientText.includes(k))) cuisineVector[idx] = 1;
    });

    // 3. Cooking method (infer from prep type + name)
    const cookingVector = Array(4).fill(0); // bake, fry, boil, slow_cook
    const prepLower = (meal.prep || '').toLowerCase();
    if (prepLower.includes('bulk')) cookingVector[3] = 1; // slow_cook
    if (ingredientText.includes('bak')) cookingVector[0] = 1;
    if (ingredientText.includes('fry') || ingredientText.includes('crisp')) cookingVector[1] = 1;

    // 4. Carb base (one-hot)
    const carbVector = Array(7).fill(0);
    CARB_KEYWORDS.forEach((keyword, idx) => {
      if (ingredientText.includes(keyword)) carbVector[idx] = 1;
    });

    // 5. Vegetable types (bag-of-words)
    const vegVector = Array(6).fill(0);
    VEG_KEYWORDS.forEach((keyword, idx) => {
      if (idx < 6 && ingredientText.includes(keyword)) vegVector[idx] = 1;
    });

    // 6. Spice level (ordinal)
    const spiceVector = [0, 0, 0]; // mild, medium, hot
    Object.entries(SPICE_KEYWORDS).forEach(([level, keywords]) => {
      const idx = level === 'mild' ? 0 : level === 'medium' ? 1 : 2;
      if (keywords.some(k => ingredientText.includes(k))) spiceVector[idx] = 1;
    });

    // 7. Texture (bag-of-words)
    const textureVector = Array(7).fill(0);
    TEXTURE_KEYWORDS.forEach((keyword, idx) => {
      if (idx < 7 && ingredientText.includes(keyword)) textureVector[idx] = 1;
    });

    // 8. Distinctive ingredients (rare/uncommon ingredients)
    const distinctiveVector = Array(5).fill(0);
    const distinctiveKeywords = ['coconut', 'miso', 'kimchi', 'tandoori', 'harissa'];
    distinctiveKeywords.forEach((keyword, idx) => {
      if (idx < 5 && ingredientText.includes(keyword)) distinctiveVector[idx] = 1;
    });

    return {
      protein: proteinVector,
      cuisine: cuisineVector,
      cooking: cookingVector,
      carb: carbVector,
      veg: vegVector,
      spice: spiceVector,
      texture: textureVector,
      distinctive: distinctiveVector
    };
  }

  // Compute cosine similarity between two feature vectors
  _cosineSimilarity(feats1, feats2) {
    if (!feats1 || !feats2) return 0;
    const allKeys = Object.keys(feats1);
    let dotProduct = 0, norm1 = 0, norm2 = 0;

    allKeys.forEach(key => {
      const v1 = feats1[key];
      const v2 = feats2[key];
      for (let i = 0; i < v1.length; i++) {
        dotProduct += v1[i] * v2[i];
        norm1 += v1[i] * v1[i];
        norm2 += v2[i] * v2[i];
      }
    });

    if (norm1 === 0 || norm2 === 0) return 0;
    return dotProduct / (Math.sqrt(norm1) * Math.sqrt(norm2));
  }

  // Build 50x50 similarity matrix (upper triangle only)
  _computeSimilarityMatrix() {
    const n = Math.min(this.meals.length, 50);
    for (let i = 0; i < n; i++) {
      for (let j = i + 1; j < n; j++) {
        const m1 = this.meals[i];
        const m2 = this.meals[j];
        const f1 = this._extractFeatures(m1.id);
        const f2 = this._extractFeatures(m2.id);
        const sim = this._cosineSimilarity(f1, f2);
        this.similarityMatrix.set(`${m1.id}_${m2.id}`, sim);
        this.similarityMatrix.set(`${m2.id}_${m1.id}`, sim);
      }
    }
  }

  // Modified Rocchio with IDF-weighted credit assignment
  updatePreferences(events) {
    if (!events || events.length === 0) return;

    const now = new Date();
    const halfLife = 60 * 24 * 60 * 60 * 1000; // 60 days
    const eventScores = new Map();

    events.forEach(event => {
      if (!event.mealId) return;

      // Time decay: 60-day half-life
      const ageMs = now.getTime() - new Date(event.created_at).getTime();
      const decayFactor = Math.pow(0.5, ageMs / halfLife);

      // Event type weight
      let eventWeight = 0;
      switch (event.event_type) {
        case 'cooked':      eventWeight = 1.0; break;
        case 'accepted':    eventWeight = 0.5; break;
        case 'swapped_away': eventWeight = -0.3; break;
        case 'skipped':     eventWeight = -0.2; break;
        default: eventWeight = 0;
      }

      const score = eventWeight * decayFactor;
      const current = eventScores.get(event.mealId) || 0;
      eventScores.set(event.mealId, current + score);
    });

    // Commit to userPreferences
    eventScores.forEach((score, mealId) => {
      const current = this.userPreferences.get(mealId) || 0;
      this.userPreferences.set(mealId, Math.max(0, current + score));
    });

    this.lastUpdate = now;
  }

  // Score a meal: returns {score, confidence, breakdown}
  scoreMeal(mealId) {
    const baseScore = this.userPreferences.get(mealId) || 0;
    const prefCount = this.userPreferences.size;
    const confidence = Math.min(0.95, prefCount > 0 ? Math.sqrt(prefCount) / 10 : 0);

    return {
      score: Math.min(1, Math.max(0, baseScore / 5)),
      confidence,
      breakdown: { baseScore, prefCount, confidence }
    };
  }

  // Get similar meals for a given meal
  getSimilarMeals(mealId, topN = 5) {
    const similar = [];
    this.meals.forEach(meal => {
      if (meal.id === mealId) return;
      const key = `${mealId}_${meal.id}`;
      const similarity = this.similarityMatrix.get(key) || 0;
      if (similarity > 0.3) {
        similar.push({ meal, similarity });
      }
    });
    return similar.sort((a, b) => b.similarity - a.similarity).slice(0, topN);
  }

  // Cold-start prediction for new meals
  estimateColdStart(newMeal, newIngredients) {
    if (this.userPreferences.size === 0) return 0.5;

    const newFeatures = this._extractFeatures(newMeal.id);
    if (!newFeatures) return 0.5;

    let similarScore = 0;
    let totalSimilarity = 0;

    this.meals.forEach(meal => {
      const mealScore = this.userPreferences.get(meal.id);
      if (mealScore === undefined) return;

      const key = `${newMeal.id}_${meal.id}`;
      const similarity = this.similarityMatrix.get(key) || this._cosineSimilarity(
        newFeatures,
        this._extractFeatures(meal.id)
      );

      if (similarity > 0.2) {
        similarScore += mealScore * similarity;
        totalSimilarity += similarity;
      }
    });

    if (totalSimilarity === 0) return 0.5;
    return Math.min(1, Math.max(0, similarScore / totalSimilarity / 5));
  }
}

const MEAL_TIMES = ["Breakfast","Lunch","Dinner"];
const DAYS = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

// ── Helper: date formatting ────────────────────
const fmt = (d) => d.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});
const fmtShort = (d) => d.toLocaleDateString("en-US",{month:"numeric",day:"numeric"});
const addDays = (d,n) => { const r=new Date(d); r.setDate(r.getDate()+n); return r; };

// ── Unit normalization ─────────────────────────
// Normalizes plural / variant forms so pantry "cup" matches grocery "cups".
// Add aliases here whenever a new variant slips through.
const UNIT_ALIASES = {
  "cup": "cup", "cups": "cup", "c": "cup",
  "tbsp": "tbsp", "tbsps": "tbsp", "tablespoon": "tbsp", "tablespoons": "tbsp", "tbs": "tbsp", "tb": "tbsp",
  "tsp": "tsp", "tsps": "tsp", "teaspoon": "tsp", "teaspoons": "tsp", "t": "tsp",
  "oz": "oz", "ounce": "oz", "ounces": "oz",
  "lb": "lb", "lbs": "lb", "pound": "lb", "pounds": "lb",
  "g": "g", "gram": "g", "grams": "g",
  "kg": "kg", "kilogram": "kg", "kilograms": "kg",
  "ml": "ml", "milliliter": "ml", "milliliters": "ml",
  "l": "l", "liter": "l", "liters": "l",
  "each": "each", "ea": "each",
  "can": "can", "cans": "can",
  "bottle": "bottle", "bottles": "bottle",
  "jar": "jar", "jars": "jar",
  "bag": "bag", "bags": "bag",
  "box": "box", "boxes": "box",
  "pack": "pack", "packs": "pack", "package": "pack", "packages": "pack",
  "pkg": "pack",
  "bunch": "bunch", "bunches": "bunch",
  "head": "head", "heads": "head",
  "clove": "clove", "cloves": "clove",
  "slice": "slice", "slices": "slice",
  "stick": "stick", "sticks": "stick",
  "pinch": "pinch", "pinches": "pinch",
  "dash": "dash", "dashes": "dash",
  "large": "large", "medium": "medium", "small": "small",
};
const normalizeUnit = (u) => {
  if (!u) return "each";
  const k = String(u).trim().toLowerCase().replace(/\.$/, "");
  return UNIT_ALIASES[k] || k;
};

// ── Recipe ingredient line parser ──────────────
// Replaces the brittle one-shot regex with a proper tokenizer:
//   1. Strip leading bullet/dash markers.
//   2. Pull out a leading quantity (mixed number, fraction, decimal, or
//      unicode fraction). Returns 1 if no number present.
//   3. Pull out a unit IF it matches UNIT_ALIASES with word boundaries
//      (so "lbs" doesn't leak its "s" into the name and "g" doesn't
//      hijack "garlic").
//   4. Strip a "(15 oz)" style package size if present and use it as the
//      unit when no other unit was found.
//   5. Whatever remains (after stripping a leading comma) is the name.
//   6. Returns null if the resulting name is empty.
const UNICODE_FRACTIONS = { "½":0.5, "¼":0.25, "¾":0.75, "⅓":0.333, "⅔":0.667, "⅛":0.125, "⅜":0.375, "⅝":0.625, "⅞":0.875, "⅕":0.2, "⅖":0.4, "⅗":0.6, "⅘":0.8 };
const parseIngredientLine = (raw) => {
  if (!raw) return null;
  let line = String(raw).trim()
    // strip leading bullet/dash/number-bullet markers
    .replace(/^[-*•·▪]+\s*/, "")
    .replace(/^\d+[.)]\s+/, ""); // "1. " or "2) "
  if (!line) return null;

  let qty = null;
  let unit = null;

  // Step 1: leading quantity. Order matters — check most specific first
  // (mixed > unicode-combined > fraction > unicode-bare > decimal) so a
  // bare "1" doesn't gobble the integer part of "1½".
  const mixedMatch = line.match(/^(\d+)\s+(\d+)\/(\d+)\b/);
  const uniCombined = !mixedMatch && line.match(/^(\d+)([½¼¾⅓⅔⅛⅜⅝⅞⅕⅖⅗⅘])/);
  const fracMatch = !mixedMatch && !uniCombined && line.match(/^(\d+)\/(\d+)\b/);
  const uniBare = !mixedMatch && !uniCombined && !fracMatch && line.match(/^([½¼¾⅓⅔⅛⅜⅝⅞⅕⅖⅗⅘])/);
  const decMatch = !mixedMatch && !uniCombined && !fracMatch && !uniBare && line.match(/^(\d+(?:\.\d+)?)/);

  if (mixedMatch) {
    qty = parseInt(mixedMatch[1], 10) + (parseInt(mixedMatch[2], 10) / parseInt(mixedMatch[3], 10));
    line = line.slice(mixedMatch[0].length).trim();
  } else if (uniCombined) {
    qty = parseInt(uniCombined[1], 10) + UNICODE_FRACTIONS[uniCombined[2]];
    line = line.slice(uniCombined[0].length).trim();
  } else if (fracMatch) {
    qty = parseInt(fracMatch[1], 10) / parseInt(fracMatch[2], 10);
    line = line.slice(fracMatch[0].length).trim();
  } else if (uniBare) {
    qty = UNICODE_FRACTIONS[uniBare[1]];
    line = line.slice(uniBare[0].length).trim();
  } else if (decMatch) {
    qty = parseFloat(decMatch[1]);
    line = line.slice(decMatch[0].length).trim();
  }

  // Step 2: parenthetical package size — "(15 oz) can ...".
  // - If we DON'T have a qty/unit yet, adopt the parenthetical as our qty+unit.
  // - If we DO already have qty+unit (e.g., "2 cups"), the parenthetical is
  //   informational; just strip it. "2 cups (16 oz) broth" → 2 cups broth.
  const parenAtStart = line.match(/^\(\s*(\d+(?:\.\d+)?)\s*([a-z]+)\s*\)\s*/i);
  if (parenAtStart) {
    if (qty == null && !unit) {
      const innerUnit = parenAtStart[2].toLowerCase();
      if (UNIT_ALIASES[innerUnit]) {
        qty = parseFloat(parenAtStart[1]);
        unit = UNIT_ALIASES[innerUnit];
      }
    }
    line = line.slice(parenAtStart[0].length).trim();
  }

  // Step 3: unit token with word boundary.
  if (!unit) {
    const unitMatch = line.match(/^([a-zA-Z]+)\b/);
    if (unitMatch) {
      const candidate = unitMatch[1].toLowerCase();
      if (UNIT_ALIASES[candidate]) {
        unit = UNIT_ALIASES[candidate];
        line = line.slice(unitMatch[0].length).trim();
      }
    }
  }

  // Step 3b: AFTER unit is stripped, also strip a trailing parenthetical
  // package size (e.g., "2 cups (16 oz) chicken broth" → "chicken broth").
  const parenAfter = line.match(/^\(\s*[^)]+\)\s*/);
  if (parenAfter) line = line.slice(parenAfter[0].length).trim();

  // Step 4: strip a leading comma or dash separator
  line = line.replace(/^[,;:\-—]\s*/, "").trim();

  // Step 5: handle "to taste" and similar at end of line — strip from name
  //         but keep the ingredient
  const toTasteMatch = line.match(/^(.+?)[,\s]+to\s+taste\s*$/i);
  if (toTasteMatch) {
    line = toTasteMatch[1].trim();
    if (qty == null) qty = 0;          // 0 = "to taste"
    if (!unit) unit = "to taste";
  }

  // Defaults
  if (qty == null) qty = 1;
  if (!unit) unit = "each";

  // Step 6: empty name = drop
  if (!line || line.length < 2) return null;

  return { n: line, q: qty, u: unit };
};

// ── Helper: get meals for a meal time (sorted alphabetically) ──────────
const mealsForTime = (mealTime, prepType, isManual = false) => {
  return MEALS_DATA.filter(m => {
    // Strict separation: only show meals that match the specific meal time
    let timeMatch;
    if (isManual) {
      // Manual selection: allow cross-picking between lunch/dinner, and always allow frozen meals
      if (mealTime === "Breakfast") {
        timeMatch = m.time.includes("Breakfast");
      } else if (mealTime === "Lunch" || mealTime === "Dinner") {
        timeMatch = m.time.includes(mealTime) || m.time.includes("Lunch") || m.time.includes("Dinner");
      } else {
        timeMatch = m.time.includes(mealTime);
      }
    } else {
      // Auto-fill mode: strict separation
      timeMatch = m.time.includes(mealTime);
    }

    // In manual selection mode, show ALL meals matching the time regardless of
    // prep-type filter. Previously a slot with prepType "Cook Fresh" or "Bulk
    // Cook" hid Frozen Meal items (Fish Sticks, Frozen Pizza, etc.), making
    // them effectively unselectable unless the user first switched the prep
    // dropdown — which was non-obvious. updateSlot() now auto-corrects the
    // slot's prepType to match the chosen meal's recommended `prep`, so this
    // is safe.
    if (isManual) return timeMatch;

    if (prepType === "Bulk Cook") return m.prep === "Bulk Cook" && timeMatch;
    if (prepType === "Frozen Meal") return m.prep === "Frozen Meal" && timeMatch;
    if (prepType === "Cook Fresh") return (m.prep === "Cook Fresh" || m.prep === "Bulk Cook") && timeMatch;
    return timeMatch;
  }).sort((a,b) => a.name.localeCompare(b.name));
};

// Maps a meal's cuisine string to the best-matching side category
const cuisineToSideCat = (cuisine) => {
  if (!cuisine) return "American";
  const c = cuisine.toLowerCase();
  if (c.includes("mexican") || c.includes("latin") || c.includes("salvadoran") || c.includes("cuban") || c.includes("guatemalan") || c.includes("yucatan") || c.includes("central american") || c.includes("bolivian")) return "Latin/Mexican";
  if (c.includes("mediterranean") || c.includes("greek") || c.includes("lebanese") || c.includes("middle eastern")) return "Mediterranean";
  return "American";
};

// Returns ordered side categories with best-match first
const orderedSideCats = (cuisine) => {
  const best = cuisineToSideCat(cuisine);
  const cats = SIDE_CATEGORIES.filter(c => c !== "Breakfast Side" && c !== "Breakfast Protein");
  return [best, ...cats.filter(c => c !== best && c !== "All Sides"), "All Sides"];
};

// ═══════════════════════════════════════════════
// ═ SIMULATED ANNEALING OPTIMIZER
// ═══════════════════════════════════════════════

class SimulatedAnnealingOptimizer {
  constructor(mealsData, ingredientsData) {
    this.meals = mealsData;
    this.ingredients = ingredientsData;
    this.mealMap = new Map(mealsData.map(m => [m.id, m]));

    // Tunable weights for energy function
    this.weights = {
      preference: 0.25,      // Thompson/preference score contribution
      variety: 0.22,          // Cuisine entropy + protein rotation
      repetition: 1.0,        // Penalize recently-served and in-plan repeats (hard for Dinner)
      ingredientOverlap: 0.08, // Reward shared ingredients
      ruleCompliance: 0.08,   // Penalize constraint violations
      seasonal: 0.08,         // NEW: Seasonal fit
      perishable: 0.04,       // NEW: Perishability scheduling
      pantry: 0.03,           // NEW: Pantry utilization bonus
    };

    // SA parameters
    this.T0 = 1.0;
    this.alpha = 0.995;
    this.maxIterations = 4000;
    this.reheats = 1;  // Allow one reheat if stuck
  }

  // Compute total energy for a plan (lower = better)
  _energy(plan, openSlotKeys, context) {
    let totalEnergy = 0;

    // Extract preference scores for filled slots
    const prefScores = [];
    openSlotKeys.forEach(k => {
      const slot = plan[k];
      if (slot && slot.mealId) {
        let score = 0;
        if (context.thompsonSampler && context.thompsonSampler.params && context.thompsonSampler.params.size > 0) {
          const meal = this.mealMap.get(slot.mealId);
          if (meal) {
            const prefEst = context.thompsonSampler.selectMeal([meal], context, { temperature: 0.0 });
            score = prefEst ? 1.0 : 0.5;
          }
        } else if (context.prefEngine) {
          const scored = context.prefEngine.scoreMeal(slot.mealId);
          score = scored.score || 0.5;
        } else {
          score = 0.5;
        }
        prefScores.push(score);
      }
    });
    const avgPrefScore = prefScores.length > 0 ? prefScores.reduce((a, b) => a + b) / prefScores.length : 0.5;
    totalEnergy += this.weights.preference * (1 - avgPrefScore);

    // Variety score: cuisine entropy + protein rotation
    const varietyPenalty = this._computeVarietyPenalty(plan, openSlotKeys);
    totalEnergy += this.weights.variety * varietyPenalty;

    // Repetition penalty: within plan + recent history
    const repetitionPenalty = this._computeRepetitionPenalty(plan, openSlotKeys, context);
    totalEnergy += this.weights.repetition * repetitionPenalty;

    // Ingredient overlap bonus (negative penalty = reward)
    const ingredientBonus = this._computeIngredientOverlapBonus(plan, openSlotKeys);
    totalEnergy -= this.weights.ingredientOverlap * ingredientBonus;

    // Rule compliance penalty
    const rulePenalty = this._computeRulePenalty(plan, openSlotKeys, context);
    totalEnergy += this.weights.ruleCompliance * rulePenalty;

    // Seasonal fit
    if (context.seasonalEngine) {
      let seasonalPenalty = 0;
      openSlotKeys.forEach(k => {
        const slot = plan[k];
        if (slot && slot.mealId) {
          const score = context.seasonalEngine.getSeasonalScore(slot.mealId, slot.date);
          seasonalPenalty += (1 - score);
        }
      });
      seasonalPenalty = openSlotKeys.length > 0 ? seasonalPenalty / openSlotKeys.length : 0;
      totalEnergy += this.weights.seasonal * seasonalPenalty;
    }

    // Perishable scheduling
    if (context.seasonalEngine) {
      const perishPenalty = context.seasonalEngine.getPerishabilityPenalty(plan, openSlotKeys);
      totalEnergy += this.weights.perishable * perishPenalty;
    }

    // Pantry utilization bonus
    if (context.seasonalEngine && context.pantryItems) {
      let pantryBonus = 0;
      openSlotKeys.forEach(k => {
        const slot = plan[k];
        if (slot && slot.mealId) {
          pantryBonus += context.seasonalEngine.getPantryBonus(
            slot.mealId, context.pantryItems, this.ingredients, context.familySize
          );
        }
      });
      pantryBonus = openSlotKeys.length > 0 ? pantryBonus / openSlotKeys.length : 0;
      totalEnergy -= this.weights.pantry * pantryBonus;
    }

    return totalEnergy;
  }

  // Compute variety penalty (lower = more variety)
  _computeVarietyPenalty(plan, openSlotKeys) {
    let cuisineCounts = {};
    let proteinPenalty = 0;
    let lastProtein = null;
    let sameProteinDays = 0;

    openSlotKeys.forEach(k => {
      const slot = plan[k];
      if (slot && slot.mealId && slot.mealTime === "Dinner") {
        const meal = this.mealMap.get(slot.mealId);
        if (meal) {
          // Track cuisine entropy
          const cuisine = meal.cuisine || "unknown";
          cuisineCounts[cuisine] = (cuisineCounts[cuisine] || 0) + 1;

          // Track protein rotation
          const mealText = (meal.name + ' ' + (this.ingredients[slot.mealId] || []).map(i => i.n).join(' ')).toLowerCase();
          let protein = "unknown";
          for (const [proteinType, keywords] of Object.entries(PROTEIN_KEYWORDS)) {
            if (keywords.some(k => mealText.includes(k))) {
              protein = proteinType;
              break;
            }
          }

          if (protein === lastProtein && lastProtein !== "unknown") {
            sameProteinDays++;
          }
          lastProtein = protein;
        }
      }
    });

    // Shannon entropy of cuisines (higher = more variety)
    let H = 0;
    const totalCount = Object.values(cuisineCounts).reduce((a, b) => a + b, 0);
    if (totalCount > 0) {
      Object.values(cuisineCounts).forEach(count => {
        const p = count / totalCount;
        if (p > 0) H -= p * Math.log2(p);
      });
      // Normalize by max entropy
      const maxH = Math.log2(Math.max(2, Object.keys(cuisineCounts).length));
      H = maxH > 0 ? (1 - H / maxH) : 0.5; // Lower H value = penalty
    } else {
      H = 0.5;
    }

    // Combine with protein penalty
    const proteinPenaltyTerm = sameProteinDays * 0.1;
    return H + proteinPenaltyTerm;
  }

  // Compute repetition penalty (penalize meals repeated within plan or recently)
  _computeRepetitionPenalty(plan, openSlotKeys, context) {
    // Count within-plan repeats PER MEAL TIME so Dinner duplicates don't cancel
    // out with Lunch ones, and so we can hard-enforce the 14-day dinner rule.
    const dinnerCounts = {};
    const otherCounts = {};

    openSlotKeys.forEach(k => {
      const slot = plan[k];
      if (slot && slot.mealId) {
        if (slot.mealTime === "Dinner") {
          dinnerCounts[slot.mealId] = (dinnerCounts[slot.mealId] || 0) + 1;
        } else {
          otherCounts[slot.mealId] = (otherCounts[slot.mealId] || 0) + 1;
        }
      }
    });

    let penalty = 0;

    // HARD Dinner repeat penalty: David wants max 1 dinner of any meal per
    // 14-day window (== 2x/month). Any within-plan Dinner duplicate gets a
    // massive penalty so SA effectively rejects it.
    Object.entries(dinnerCounts).forEach(([mealId, count]) => {
      if (count > 1) penalty += Math.pow(count - 1, 2) * 5.0;
    });
    // Softer penalty for non-Dinner within-plan repeats
    Object.entries(otherCounts).forEach(([mealId, count]) => {
      if (count > 1) penalty += Math.pow(count - 1, 2) * 0.2;
    });

    // Recent history check — also hard for Dinner within 14 days
    if (context.history && context.history.length > 0) {
      const dinner14History = new Set();   // dinners served in last 14 days
      const lunchDinner3wHistory = new Set(); // lunches/dinners in last 3 weeks (soft)
      const planDates = openSlotKeys.map(k => new Date(plan[k].date).getTime()).sort();
      const oldestPlanDay = planDates[0] || Date.now();
      const cutoff14 = oldestPlanDay - (14 * 24 * 60 * 60 * 1000);
      const cutoff21 = oldestPlanDay - (21 * 24 * 60 * 60 * 1000);

      context.history.forEach(h => {
        const historyTime = new Date(h.date).getTime();
        Object.values(h.plan).forEach(slot => {
          if (!slot.mealId) return;
          if (slot.mealTime === "Dinner" && historyTime >= cutoff14) {
            dinner14History.add(slot.mealId);
          }
          if ((slot.mealTime === "Lunch" || slot.mealTime === "Dinner") && historyTime >= cutoff21) {
            lunchDinner3wHistory.add(slot.mealId);
          }
        });
      });

      openSlotKeys.forEach(k => {
        const slot = plan[k];
        if (!slot || !slot.mealId) return;
        // HARD: Dinner meal repeated within 14 days of history
        if (slot.mealTime === "Dinner" && dinner14History.has(slot.mealId)) {
          penalty += 3.0;
        }
        // Soft: any lunch/dinner repeated from 3-week history
        if (lunchDinner3wHistory.has(slot.mealId)) {
          penalty += 0.15;
        }
      });
    }

    // Cap for numerical stability but keep dinner-hard-penalties dominant
    return Math.min(penalty, 50.0);
  }

  // Compute ingredient overlap bonus (reward shared ingredients)
  _computeIngredientOverlapBonus(plan, openSlotKeys) {
    const mealIds = [];
    openSlotKeys.forEach(k => {
      const slot = plan[k];
      if (slot && slot.mealId) {
        mealIds.push(slot.mealId);
      }
    });

    if (mealIds.length < 2) return 0;

    let totalJaccard = 0;
    let pairCount = 0;

    for (let i = 0; i < mealIds.length; i++) {
      for (let j = i + 1; j < mealIds.length; j++) {
        const ing1 = new Set((this.ingredients[mealIds[i]] || []).map(x => x.n.toLowerCase()));
        const ing2 = new Set((this.ingredients[mealIds[j]] || []).map(x => x.n.toLowerCase()));

        const intersection = new Set([...ing1].filter(x => ing2.has(x)));
        const union = new Set([...ing1, ...ing2]);

        const jaccard = union.size > 0 ? intersection.size / union.size : 0;
        totalJaccard += jaccard;
        pairCount++;
      }
    }

    return pairCount > 0 ? totalJaccard / pairCount : 0;
  }

  // Compute rule compliance penalty
  _computeRulePenalty(plan, openSlotKeys, context) {
    let penalty = 0;

    if (!context.rules) return penalty;

    // Check never_on rules
    if (context.blocked) {
      openSlotKeys.forEach(k => {
        const slot = plan[k];
        if (slot && slot.mealId && context.blocked[k]) {
          const prepTypes = Object.keys(context.blocked[k]);
          if (prepTypes.includes(slot.prepType)) {
            penalty += 0.5;
          }
        }
      });
    }

    // Check max_per_week rules
    const maxRules = context.rules.filter(r => r.kind === "max_per_week");
    if (maxRules.length > 0) {
      const weekGroups = {};
      openSlotKeys.forEach(k => {
        const slot = plan[k];
        if (!slot) return;
        const weekNum = Math.floor(openSlotKeys.indexOf(k) / 21); // 3 meals/day * 7 days
        if (!weekGroups[weekNum]) weekGroups[weekNum] = [];
        weekGroups[weekNum].push(slot);
      });

      Object.entries(weekGroups).forEach(([weekNum, weekSlots]) => {
        maxRules.forEach(rule => {
          const mealCount = weekSlots.filter(s => s.mealId && this.mealMap.get(s.mealId)).length;
          if (mealCount > rule.count) {
            penalty += Math.pow(mealCount - rule.count, 2) * 0.1;
          }
        });
      });
    }

    return Math.min(penalty, 1.0);
  }

  // Generate initial random valid assignment
  _randomAssignment(openSlotKeys, plan, candidatesMap) {
    const newPlan = JSON.parse(JSON.stringify(plan));

    openSlotKeys.forEach(k => {
      const candidates = candidatesMap[k] && candidatesMap[k].candidates;
      if (candidates && candidates.length > 0) {
        const pick = candidates[Math.floor(Math.random() * candidates.length)];
        newPlan[k] = { ...newPlan[k], mealId: pick.id };
      }
    });

    return newPlan;
  }

  // Generate neighbor solution by swapping one meal
  _neighbor(plan, openSlotKeys, candidatesMap) {
    const newPlan = JSON.parse(JSON.stringify(plan));

    if (openSlotKeys.length === 0) return newPlan;

    const slotToSwap = openSlotKeys[Math.floor(Math.random() * openSlotKeys.length)];
    const candidates = candidatesMap[slotToSwap] && candidatesMap[slotToSwap].candidates;

    if (candidates && candidates.length > 0) {
      const pick = candidates[Math.floor(Math.random() * candidates.length)];
      newPlan[slotToSwap] = { ...newPlan[slotToSwap], mealId: pick.id };
    }

    return newPlan;
  }

  // Main simulated annealing optimization loop
  optimize(plan, openSlotKeys, candidatesMap, context) {
    if (openSlotKeys.length === 0) return plan;

    let bestPlan = this._randomAssignment(openSlotKeys, plan, candidatesMap);
    let bestEnergy = this._energy(bestPlan, openSlotKeys, context);

    let current = JSON.parse(JSON.stringify(bestPlan));
    let currentEnergy = bestEnergy;

    let T = this.T0;

    for (let i = 0; i < this.maxIterations; i++) {
      const candidate = this._neighbor(current, openSlotKeys, candidatesMap);
      const candidateEnergy = this._energy(candidate, openSlotKeys, context);
      const delta = candidateEnergy - currentEnergy;

      // Accept if better, or probabilistically if worse
      if (delta < 0 || Math.random() < Math.exp(-delta / Math.max(T, 0.01))) {
        current = candidate;
        currentEnergy = candidateEnergy;

        // Update best if we found a better solution
        if (currentEnergy < bestEnergy) {
          bestPlan = JSON.parse(JSON.stringify(current));
          bestEnergy = currentEnergy;
        }
      }

      T *= this.alpha;

      // Reheat if stuck
      if (i === Math.floor(this.maxIterations * 0.6) && this.reheats > 0) {
        T = this.T0 * 0.3;
        this.reheats--;
      }
    }

    return bestPlan;
  }
}

// ═══════════════════════════════════════════════
// ═ HISTORY BACKFILL FUNCTION
// ═══════════════════════════════════════════════

const backfillHistoryToEvents = async (supabase, userId, history, hasBackfilled) => {
  // Only run once per session — check flag in JSONB
  if (hasBackfilled) return;

  if (!history || history.length === 0) return;

  const batchSize = 50;
  const events = [];

  history.forEach((plan_record, idx) => {
    const planDate = new Date(plan_record.date);

    Object.values(plan_record.plan || {}).forEach(slot => {
      if (!slot.mealId) return;
      if (slot.prepType === "Skip" || slot.prepType === "Eat Out") return;
      if (slot.isLeftover) return;

      // Create synthetic 'cooked' event from historical data
      events.push({
        user_id: userId,
        event_type: 'cooked',
        meal_id: slot.mealId,
        slot_date: slot.date,
        meal_time: slot.mealTime,
        prep_type: slot.prepType,
        context: buildContext(slot.date, slot.mealTime, slot.prepType, { source: 'backfill' }),
        created_at: planDate.toISOString(),
        source: 'backfill',
        confidence: 0.4 // Lower confidence for backfilled events
      });
    });
  });

  // Batch insert (fire-and-forget)
  if (events.length > 0) {
    for (let i = 0; i < events.length; i += batchSize) {
      const batch = events.slice(i, i + batchSize);
      supabase
        .from("meal_events")
        .insert(batch)
        .catch(e => console.error("Backfill batch error:", e));
    }
  }
};

// ═══════════════════════════════════════════════
//  MAIN APP COMPONENT
// ═══════════════════════════════════════════════
export default function RogersFamilyMealPlanner({ session, onSignOut, linkedCalendarAccounts = [], onLinkCalendarAccount, onUnlinkCalendarAccount, fetchCalendarEvents }) {
  // ── Supabase cloud sync helpers ──────────────────────────
  // Both allowed logins share the SAME meal plan data.
  // We always read/write using the primary account's UUID
  // (david@providenceswfl.com) so there is one single shared row.
  const SHARED_USER_ID = "0fc6ea4c-79fe-4f51-a74c-702af6e232e6";
  const userId = SHARED_USER_ID;
  const userEmail = session?.user?.email || "";
  const saveTimerRef = useRef(null);
  // Holds the LATEST queued payload so we can flush it on tab close even if
  // the debounce timer hasn't fired yet. This is the bug that kept eating
  // custom meals: user added Tostadas, closed the tab within 1.5s, the
  // setTimeout never fired, the save was lost.
  const pendingPayloadRef = useRef(null);

  // ── Local persistence (write-through cache) ─────────────────────────
  // Supabase save is async + debounced. Two redundant local backups so
  // nothing is lost regardless of what the browser does on unload:
  //   (a) localStorage — synchronous, simple, survives tab close. ~5MB cap.
  //   (b) IndexedDB    — async, survives tab close, much higher cap (hundreds
  //       of MB), survives localStorage being cleared by site-data tools.
  // On load (lower in the file), if Supabase is unreachable we hydrate from
  // these caches instead of starting blank.
  const persistLocal = useCallback((payload) => {
    try {
      localStorage.setItem("rogers_meal_planner_v1", JSON.stringify({ payload, savedAt: Date.now() }));
    } catch (e) { /* localStorage might be full or disabled */ }
    // IndexedDB write — fire and forget, errors logged.
    try {
      const req = indexedDB.open("rogers_meal_planner", 1);
      req.onupgradeneeded = (ev) => {
        const db = ev.target.result;
        if (!db.objectStoreNames.contains("kv")) db.createObjectStore("kv");
      };
      req.onsuccess = (ev) => {
        const db = ev.target.result;
        try {
          const tx = db.transaction("kv", "readwrite");
          tx.objectStore("kv").put({ payload, savedAt: Date.now() }, "state");
          tx.oncomplete = () => db.close();
          tx.onerror = () => db.close();
        } catch (e) { /* ignore */ }
      };
    } catch (e) { /* IndexedDB unavailable, localStorage is enough */ }
  }, []);

  // Read the latest IndexedDB snapshot (used as a fallback when Supabase is
  // unreachable on load).
  const readIDBSnapshot = useCallback(() => new Promise((resolve) => {
    try {
      const req = indexedDB.open("rogers_meal_planner", 1);
      req.onupgradeneeded = (ev) => {
        const db = ev.target.result;
        if (!db.objectStoreNames.contains("kv")) db.createObjectStore("kv");
      };
      req.onsuccess = (ev) => {
        const db = ev.target.result;
        try {
          const tx = db.transaction("kv", "readonly");
          const get = tx.objectStore("kv").get("state");
          get.onsuccess = () => { resolve(get.result || null); db.close(); };
          get.onerror = () => { resolve(null); db.close(); };
        } catch (e) { resolve(null); }
      };
      req.onerror = () => resolve(null);
    } catch (e) { resolve(null); }
  }), []);

  // Debounced save to Supabase — 800ms after last change.
  const saveToCloud = useCallback((dataObj, onComplete) => {
    if (!userId) return;
    persistLocal(dataObj);
    pendingPayloadRef.current = dataObj;
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(async () => {
      const payload = pendingPayloadRef.current;
      pendingPayloadRef.current = null;
      saveTimerRef.current = null;
      if (!payload) return;
      try {
        const { error } = await supabase.from("meal_planner_data").upsert({
          user_id: userId,
          ...payload,
          updated_at: new Date().toISOString()
        }, { onConflict: "user_id" });
        if (error) {
          console.error("Save error:", error);
          if (onComplete) onComplete("error");
        } else {
          if (onComplete) onComplete("saved");
        }
      } catch (e) {
        console.error("Save error:", e);
        if (onComplete) onComplete("error");
      }
    }, 800);
  }, [userId, persistLocal]);

  // Flush pending save synchronously on tab close using navigator.sendBeacon.
  // sendBeacon survives unload (regular fetch/upsert does not). We POST
  // straight to the Supabase REST endpoint with the anon key.
  const flushPendingSave = useCallback(() => {
    if (!userId || !pendingPayloadRef.current) return;
    if (saveTimerRef.current) {
      clearTimeout(saveTimerRef.current);
      saveTimerRef.current = null;
    }
    const payload = pendingPayloadRef.current;
    pendingPayloadRef.current = null;

    // Always also push to localStorage as a redundant safety net.
    persistLocal(payload);

    try {
      const url = "https://nuixrqyzzwkpdwzzkjsg.supabase.co/rest/v1/meal_planner_data?on_conflict=user_id";
      const body = JSON.stringify({
        user_id: userId,
        ...payload,
        updated_at: new Date().toISOString()
      });
      // Build a Blob with the apikey + Authorization headers embedded as
      // form-data — Supabase REST requires the auth headers, but sendBeacon
      // can only set Content-Type via Blob. So we fall back to fetch with
      // keepalive:true which is the only other reliable option for unload.
      if (typeof fetch === "function") {
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "apikey": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im51aXhycXl6endrcGR3enpranNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NzUzODUsImV4cCI6MjA4OTU1MTM4NX0.41hCtjD8ZgMbYYg2pSWDcVxUXwO3xB4zBKY7KiLPW84",
            "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im51aXhycXl6endrcGR3enpranNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NzUzODUsImV4cCI6MjA4OTU1MTM4NX0.41hCtjD8ZgMbYYg2pSWDcVxUXwO3xB4zBKY7KiLPW84",
            "Prefer": "resolution=merge-duplicates,return=minimal",
          },
          body,
          keepalive: true, // critical: lets the request survive unload
        }).catch(() => {});
      }
    } catch (e) {
      console.error("Flush save error:", e);
    }
  }, [userId, persistLocal]);

  useEffect(() => {
    const handler = () => flushPendingSave();
    window.addEventListener("beforeunload", handler);
    window.addEventListener("pagehide", handler);
    const visHandler = () => {
      if (document.visibilityState === "hidden") flushPendingSave();
    };
    document.addEventListener("visibilitychange", visHandler);
    return () => {
      window.removeEventListener("beforeunload", handler);
      window.removeEventListener("pagehide", handler);
      document.removeEventListener("visibilitychange", visHandler);
    };
  }, [flushPendingSave]);

  const DEFAULT_RULES = [
    { kind:"always_pair", meal:"D034", side:"S002", side2:"S027", side3:"" },
    { kind:"always_pair", meal:"D008", side:"S002", side2:"S027", side3:"S025" },
    { kind:"always_pair", meal:"D022", side:"S002", side2:"S027", side3:"S025" },
    { kind:"always_pair", meal:"D038", side:"S024", side2:"S025", side3:"" },
    { kind:"always_pair", meal:"D039", side:"S026", side2:"", side3:"" },
    { kind:"always_pair", meal:"D032", side:"S002", side2:"S027", side3:"S025" },
    { kind:"always_pair", meal:"D036", side:"S013", side2:"", side3:"" },
    { kind:"always_pair", meal:"L008", side:"S013", side2:"", side3:"" },
    { kind:"always_pair", meal:"L003", side:"S018", side2:"", side3:"" },
    { kind:"always_pair", meal:"L001", side:"S018", side2:"", side3:"" },
    { kind:"always_pair", meal:"D043", side:"S032", side2:"", side3:"" },
    // Turkish Chicken Wraps — default to Hummus + Pita Bread
    { kind:"always_pair", meal:"D004", side:"S003", side2:"S035", side3:"" },
  ];
  const defaultDayModes = () => {
    const modes = {};
    DAYS.forEach(d => { modes[d] = { Breakfast: "Any", Lunch: "Any", Dinner: "Any" }; });
    return modes;
  };
  const defaultStartDate = () => {
    const d = new Date(); d.setDate(d.getDate() - d.getDay()); return d.toISOString().slice(0,10);
  };

  // ── App State (initialized with defaults, then overwritten by cloud load) ──
  const [dataLoaded, setDataLoaded] = useState(false);
  const [syncStatus, setSyncStatus] = useState("loading"); // "loading" | "saved" | "saving" | "error"
  const [tab, setTab] = useState("planner");
  const [familySize, setFamilySize] = useState(6);
  const [dbSearch, setDbSearch] = useState("");
  const [dbFilter, setDbFilter] = useState("All");

  // ── Planner State ──────────────────────────
  const [weeks, setWeeks] = useState(1);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [plan, setPlan] = useState({});
  const [finalized, setFinalized] = useState(false);

  // ── Self-heal: if startDate ever becomes empty/invalid (bad save, stale
  //    state, etc.), reset to the default so the app can't go blank. ──
  useEffect(() => {
    const bad = !startDate
      || typeof startDate !== "string"
      || isNaN(new Date(startDate + "T00:00:00").getTime());
    if (bad) {
      const d = new Date();
      d.setDate(d.getDate() - d.getDay());
      setStartDate(d.toISOString().slice(0,10));
    }
  }, [startDate]);

  // ── Day Modes: Cook vs Defrost/Prepackaged per day ──
  // Keys are date strings ("2026-03-22") or day names ("Sun") for backward compat
  const [dayModes, setDayModes] = useState(defaultDayModes);
  const updateDayMode = (day, mt, mode) => {
    setDayModes(prev => ({ ...prev, [day]: { ...prev[day], [mt]: mode } }));
  };
  // Helper: look up day mode — checks date key first, then day-name key, then "Any"
  const getDayMode = (dateStr, dayName, mt) => {
    if (dayModes[dateStr]?.[mt]) return dayModes[dateStr][mt];
    if (dayModes[dayName]?.[mt]) return dayModes[dayName][mt];
    return "Any";
  };

  // ── Pantry State ───────────────────────────
  const [freezerMeals, setFreezerMeals] = useState([]);
  const [pantryItems, setPantryItems] = useState([]);
  const [pantrySearch, setPantrySearch] = useState("");
  const [pantryLocFilter, setPantryLocFilter] = useState("All");
  const [pantryTab, setPantryTab] = useState("freezer");

  // ── Rhythms State ──────────────────────────
  const [rules, setRules] = useState(DEFAULT_RULES);
  const [history, setHistory] = useState([]);
  const [ruleKind, setRuleKind] = useState("day_meal");
  const [newRule, setNewRule] = useState({});

  // ── Thompson Sampling & Preference Engine State ────────
  const [thompsonSampler] = useState(() => new ThompsonSampler());
  const [prefEngine] = useState(() => new MealPreferenceEngine(MEALS_DATA, INGREDIENTS_DATA));

  // ── Grocery State ──────────────────────────
  const [groceryChecked, setGroceryChecked] = useState({});
  const [groceryWeekTab, setGroceryWeekTab] = useState(0);
  const [dismissedPatterns, setDismissedPatterns] = useState([]);

  // ── Print / PDF State ─────────────────────
  const [showPrintView, setShowPrintView] = useState(false);

  // ── Recipe Scanner State ──────────────────
  const [recipeText, setRecipeText] = useState("");
  const [parsedRecipe, setParsedRecipe] = useState(null);
  const [customMeals, setCustomMeals] = useState([]); // includes custom sides with _isSide:true

  // Whenever customMeals state changes, fully rebuild the global
  // MEALS_DATA / SIDES_DATA / INGREDIENTS_DATA arrays. This is the only
  // place those arrays should be touched from now on. Eliminates a whole
  // class of stale-data bugs where a deleted custom meal kept showing up
  // in the planner because the splice was missed somewhere.
  useEffect(() => {
    resyncCustomData(customMeals);
  }, [customMeals]);
  const [showScanner, setShowScanner] = useState(false);
  const [scannerMode, setScannerMode] = useState("meal"); // "meal" or "side"

  // ── Special Occasion Meals ──────────────────
  // IDs of meals that are "Special Occasion" — excluded from auto-gen but manually selectable
  const DEFAULT_SPECIAL_OCCASION = ["D001", "D008", "D034"];
  const [specialOccasionMeals, setSpecialOccasionMeals] = useState(DEFAULT_SPECIAL_OCCASION);

  // ── History Backfill Flag ──────────────────
  const [hasBackfilled, setHasBackfilled] = useState(false);

  // ── Meal Management State ──────────────────
  const [showManageMeals, setShowManageMeals] = useState(false);
  const [editingMeal, setEditingMeal] = useState(null); // meal object being edited, or null
  const [showAddForm, setShowAddForm] = useState(false);
  const [manageMealSearch, setManageMealSearch] = useState("");
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  // ── Side Management State ──────────────────
  const [editingSide, setEditingSide] = useState(null);
  const [showAddSideForm, setShowAddSideForm] = useState(false);
  const [confirmDeleteSideId, setConfirmDeleteSideId] = useState(null);

  // ── AI Assistant State ────────────────────
  const [aiQuery, setAiQuery] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiResult, setAiResult] = useState(null);
  const [aiError, setAiError] = useState(null);
  const [aiTaskType, setAiTaskType] = useState("suggest_from_pantry");
  const [scanMode, setScanMode] = useState("pantry"); // "pantry" or "freezer"

  // ── Claude-as-Primary-Planner State ──
  const [aiPlanLoading, setAiPlanLoading] = useState(false);
  const [aiPlanDraft, setAiPlanDraft] = useState(null); // Raw AI plan result
  const [aiPlanError, setAiPlanError] = useState(null);
  const [aiPlanReasoning, setAiPlanReasoning] = useState({}); // {slotKey: "reasoning text"}
  const [showAiReasoning, setShowAiReasoning] = useState(false);
  const [refineQuery, setRefineQuery] = useState("");
  const [refineLoading, setRefineLoading] = useState(false);
  const [refineHistory, setRefineHistory] = useState([]); // conversation turns
  const [mealFeedback, setMealFeedback] = useState({}); // {slotKey: {rating, tags, comment}}

  // ── AI Helper: call Supabase Edge Function ──
  const MEAL_AI_URL = "https://nuixrqyzzwkpdwzzkjsg.supabase.co/functions/v1/meal-ai";
  // Supabase anon key — sent as `apikey` header so the Edge Function gateway
  // accepts the request even if the user's access token is stale/expired.
  const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im51aXhycXl6endrcGR3enpranNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NzUzODUsImV4cCI6MjA4OTU1MTM4NX0.41hCtjD8ZgMbYYg2pSWDcVxUXwO3xB4zBKY7KiLPW84";

  // Always use the anon key for Edge Function auth.
  //
  // We previously tried `session?.access_token || ANON_KEY`. The problem:
  // Supabase access tokens expire every 1 hour; an expired token is still a
  // non-empty string, so the `||` fallback never fired and the gateway
  // returned 401 with body `{code, message}`. We then tried refreshSession(),
  // but signInWithIdToken (Google OAuth) doesn't always return a refresh
  // token, so the refresh itself fails — back to 401.
  //
  // The Edge Function doesn't need to identify the user via JWT for these
  // tasks (everything it needs is in the request body). The anon key is a
  // long-lived JWT that the gateway always accepts, so use it unconditionally.
  // If we ever need user identity inside the function, we can add a userId
  // field to the body.
  const getEdgeFnToken = async () => SUPABASE_ANON_KEY;

  const callMealAI = useCallback(async (taskType, userMessage, extraData = {}) => {
    setAiLoading(true);
    setAiError(null);
    setAiResult(null);

    // Build the meal catalog with ingredients
    const allMeals = [...MEALS_DATA, ...customMeals.filter(m => !m._isSide)];
    const catalog = allMeals.map(m => ({
      ...m,
      ingredients: INGREDIENTS_DATA[m.id] || m.ingredients || [],
    }));

    // Build recent history (last 4 weeks)
    const recentHistory = (history || []).slice(-28);

    // Build preference scores from Thompson Sampler
    const topRated = [];
    const bottomRated = [];
    if (thompsonSampler.params.size > 0) {
      const scores = [];
      thompsonSampler.params.forEach((params, mealId) => {
        const score = params.alpha / (params.alpha + params.beta);
        scores.push({ mealId, score });
      });
      scores.sort((a, b) => b.score - a.score);
      scores.slice(0, 10).forEach(s => topRated.push(s.mealId));
      scores.slice(-5).forEach(s => bottomRated.push(s.mealId));
    }

    // Build extra context for specific task types
    const extraContext = {};
    if (["use_first", "nutrition_score", "costco_optimize"].includes(taskType)) {
      extraContext.freezerMeals = freezerMeals || [];
    }
    if (["nutrition_score", "costco_optimize"].includes(taskType)) {
      // Send current plan as context
      extraContext.currentPlan = Object.entries(plan)
        .filter(([_, s]) => s.mealId && s.date)
        .map(([_, s]) => ({ date: s.date, mealTime: s.mealTime, mealId: s.mealId, prepType: s.prepType, side: s.side || "", isLeftover: s.isLeftover || false }));
    }

    const body = {
      taskType,
      mealCatalog: catalog,
      mealHistory: recentHistory,
      pantryInventory: pantryItems || [],
      preferenceScores: { topRated, bottomRated },
      userMessage: userMessage || `Run ${taskType} analysis`,
      ...extraContext,
      ...extraData,
    };

    try {
      const res = await fetch(MEAL_AI_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${await getEdgeFnToken()}`,
          "apikey": SUPABASE_ANON_KEY,
        },
        body: JSON.stringify(body),
      });

      const json = await res.json();

      if (json.fallback || json.error) {
        setAiError(json.error || "AI unavailable — using algorithmic planner");
        setAiLoading(false);
        return null;
      }

      setAiResult({ data: json.data, taskType, model: json.model, usage: json.usage });
      setAiLoading(false);
      return json.data;
    } catch (err) {
      console.error("AI call failed:", err);
      setAiError("Connection error — falling back to algorithmic planner");
      setAiLoading(false);
      return null;
    }
  }, [history, pantryItems, customMeals, thompsonSampler, freezerMeals, plan]);

  // ── Claude-as-Primary-Planner: Generate full plan ──
  const generateAIPlan = useCallback(async () => {
    setAiPlanLoading(true);
    setAiPlanError(null);
    setAiPlanDraft(null);
    setAiPlanReasoning({});
    setRefineHistory([]);

    // Build meal catalog with all needed fields
    const allMeals = [...MEALS_DATA, ...customMeals.filter(m => !m._isSide)];
    const catalog = allMeals.map(m => ({
      ...m,
      ingredients: INGREDIENTS_DATA[m.id] || m.ingredients || [],
    }));

    // Tally how many ready-to-cook frozen meal options exist so the prompt
    // can give the AI an explicit floor (e.g. "include at least 2 of the
    // 7 frozen meal options per week").
    const frozenMealCatalog = catalog.filter(m =>
      m.prep === "Frozen Meal" && (m.time || []).some(t => ["Lunch","Dinner"].includes(t))
    );
    const frozenMealList = frozenMealCatalog.map(m => `${m.id} (${m.name}, ${m.time.join("/")})`).join("; ");

    // Build sides catalog
    const allSides = [...SIDES_DATA, ...customMeals.filter(m => m._isSide)];
    const sidesCatalog = allSides.map(s => ({ id: s.id, name: s.name, cuisine: s.cuisine, cat: s.cat }));

    // Build date range
    const sd = new Date(startDate + "T00:00:00");
    const totalDays = weeks * 7;
    const endDate = new Date(sd);
    endDate.setDate(endDate.getDate() + totalDays - 1);

    // Build preference scores from Thompson Sampler
    const topRated = [];
    const bottomRated = [];
    if (thompsonSampler.params.size > 0) {
      const scores = [];
      thompsonSampler.params.forEach((params, mealId) => {
        const score = params.alpha / (params.alpha + params.beta);
        scores.push({ mealId, score });
      });
      scores.sort((a, b) => b.score - a.score);
      scores.slice(0, 10).forEach(s => topRated.push(s.mealId));
      scores.slice(-5).forEach(s => bottomRated.push(s.mealId));
    }

    // Build recent history (last 4 weeks)
    const recentHistory = (history || []).slice(-28);

    // Determine current season
    const month = sd.getMonth();
    const season = month >= 4 && month <= 9 ? "summer (hot, prefer grill/no-cook/air-fryer, avoid sustained oven)" :
                   month >= 10 || month <= 1 ? "winter (comfort food, slow-cooker, hearty meals)" :
                   "spring/fall (moderate, all cooking methods fine)";

    // Fetch calendar events for the plan date range
    let calendarEvents = [];
    if (fetchCalendarEvents) {
      try {
        const events = await fetchCalendarEvents(startDate, endDate.toISOString().slice(0, 10));
        if (events && events.length > 0) {
          calendarEvents = events;
        }
        // events === null means no token / expired — we'll proceed without calendar data
      } catch (err) {
        console.warn('Calendar fetch failed, proceeding without:', err);
      }
    }

    const body = {
      taskType: "generate_plan",
      mealCatalog: catalog,
      sidesCatalog,
      mealHistory: recentHistory,
      pantryInventory: pantryItems || [],
      freezerMeals: freezerMeals || [],
      preferenceScores: { topRated, bottomRated },
      dateRange: {
        startDate: startDate,
        endDate: endDate.toISOString().slice(0, 10),
        totalDays,
      },
      constraints: {
        season,
        familySize,
        totalMealSlots: totalDays * 3,
        dinnerCooldownDays: 14,
        dinnerCooldownNote: "No dinner meal should repeat within 14 days (max 2x/month). Check mealHistory and do not reuse any Dinner mealId that appears within the last 14 days.",
        prepTypes: {
          allowed: ["Cook Fresh", "Bulk Cook", "Defrost", "Frozen Meal", "Leftover Day", "Eat Out", "Skip"],
          definitions: {
            "Cook Fresh":  "Cook from scratch the day-of, no leftovers planned.",
            "Bulk Cook":   "Cook a large batch that yields leftovers for later slots (count leftovers separately as Leftover Day).",
            "Defrost":     "Pull a previously cooked meal from the freezer (only valid when the mealId appears in freezerMeals[]).",
            "Frozen Meal": "Heat a ready-to-cook frozen item from the store (e.g., fish sticks, frozen pizza, gyoza). NOT a defrosted leftover. Use any meal whose catalog `prep` field is 'Frozen Meal'.",
            "Leftover Day":"Eat leftovers from an earlier Bulk Cook in the same plan; mealId should reference the original.",
            "Eat Out":     "Restaurant or social meal. Default Sunday Lunch only.",
            "Skip":        "No meal scheduled (rare).",
          },
          honorMealPrep: "Each meal in mealCatalog has a `prep` field that is the RECOMMENDED prepType for that meal. Always use the meal's `prep` value as the slot's prepType unless one of these specific overrides applies: (a) the meal is in freezerMeals[] and you want a Defrost day, (b) you are scheduling a Leftover Day from a prior Bulk Cook in this same plan.",
        },
        frozenMealUsage: {
          available: frozenMealCatalog.length,
          list: frozenMealList,
          minPerWeek: Math.min(2, frozenMealCatalog.length),
          note: `David has ${frozenMealCatalog.length} ready-to-cook frozen meal options in his catalog: ${frozenMealList || "(none)"}. These are easy weeknight wins. Include AT LEAST 2 frozen-meal slots per 7-day window (use prepType "Frozen Meal"), distributed across the plan — do not lump them all into one week. Pick busy/Cook-Easy weeknights when possible.`,
        },
        defrostUsage: freezerMeals && freezerMeals.length > 0
          ? `freezerMeals[] contains ${freezerMeals.length} cooked meal(s) David already has stored. Schedule at least 1 Defrost slot per week using one of these mealIds (deduct from portions as you go). Defrost is the easiest weeknight option — use it.`
          : "No cooked freezer meals stored. Skip Defrost prep type for this plan.",
      },
      userMessage: `Generate a ${totalDays}-day meal plan from ${startDate} to ${endDate.toISOString().slice(0, 10)}. Season: ${season}. Family of ${familySize}.${calendarEvents.length > 0 ? ` Calendar events are included for scheduling awareness.` : ''}

CRITICAL RULES:
1. No dinner meal may repeat within 14 days — each dinner mealId used in this plan must be unique AND must not appear in the last 14 days of mealHistory.
2. Honor each meal's catalog \`prep\` field as the slot's prepType. If a meal is tagged \`prep:"Frozen Meal"\` (like Fish Sticks D042, Frozen Pizza D010, Gyoza D011, Pulled Pork D040, Gyro Meat D048), schedule it with prepType "Frozen Meal" — do NOT convert it to Bulk Cook or Cook Fresh.
3. Include at least 2 "Frozen Meal" slots per week to keep weeknights easy. There are ${frozenMealCatalog.length} frozen meal options available — use them.
4. If freezerMeals[] is non-empty, schedule at least 1 Defrost slot per week from those stored meals.
5. Variety > novelty: rotate across Cook Fresh, Bulk Cook, Defrost, and Frozen Meal prep types across the week. A plan that's 100% Cook Fresh / Bulk Cook is wrong.`,
      calendarEvents,
    };

    // try/finally guarantees the loading spinner stops even if any branch
    // throws or returns early. The previous version had ~5 separate
    // setAiPlanLoading(false) calls and missing one left the button stuck.
    try {
      const res = await fetch(MEAL_AI_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${await getEdgeFnToken()}`,
          "apikey": SUPABASE_ANON_KEY,
        },
        body: JSON.stringify(body),
      });

      const rawText = await res.text();
      let json;
      try { json = JSON.parse(rawText); } catch { json = null; }
      console.log("AI plan HTTP status:", res.status, "raw response:", rawText?.slice(0, 2000));

      if (!json) {
        setAiPlanError(`AI returned non-JSON (status ${res.status}): ${(rawText || "").slice(0, 160)}`);
        return;
      }

      if (json.fallback || json.error) {
        setAiPlanError(json.error || "AI unavailable — use Auto Meal Plan instead");
        return;
      }

      // Response shape can be { data: { weekPlan, weekSummary } } OR { weekPlan, weekSummary }
      const aiPlan = json.data || json;
      if (!aiPlan || !Array.isArray(aiPlan.weekPlan) || aiPlan.weekPlan.length === 0) {
        console.error("AI plan response missing weekPlan:", json);
        const keys = Object.keys(json || {}).join(", ") || "(none)";
        setAiPlanError(`AI response missing weekPlan (status ${res.status}). Top-level keys: ${keys}. Check console for full response.`);
        return;
      }
      setAiPlanDraft(aiPlan);

      // Apply AI plan to the plan state
      const reasoningMap = {};
      setPlan(prev => {
        const next = { ...prev };
        if (aiPlan.weekPlan) {
          aiPlan.weekPlan.forEach(slot => {
            const k = `${slot.date}_${slot.mealTime}`;
            if (next[k]) {
              next[k] = {
                ...next[k],
                prepType: slot.prepType || "Bulk Cook",
                mealId: slot.mealId || "",
                side: slot.sideId || "",
                side2: slot.side2Id || "",
                isLeftover: slot.isLeftover || false,
                reason: slot.reasoning || "",
                lockedType: true,
                lockedMeal: false,
                notes: "",
                sideType: slot.sideId ? "specific" : "",
                side2Type: slot.side2Id ? "specific" : "",
                side3Type: "", side3: "",
                eatOutType: slot.prepType === "Eat Out" ? "Life Groups" : "",
                makeSalsa: false, makeCurtido: false,
                proteinAdd: "",
              };
              reasoningMap[k] = slot.reasoning || "";
            }
          });
        }
        return next;
      });
      setAiPlanReasoning(reasoningMap);
      setShowAiReasoning(true);
      setRefineHistory([{ role: "claude", content: (aiPlan && aiPlan.weekSummary) || "Plan generated successfully." }]);
    } catch (err) {
      console.error("AI plan generation failed:", err);
      setAiPlanError("Connection error — use Auto Meal Plan as fallback");
    } finally {
      setAiPlanLoading(false);
    }
  }, [startDate, weeks, history, pantryItems, freezerMeals, customMeals, thompsonSampler, familySize, fetchCalendarEvents]);

  // ── Claude-as-Primary-Planner: Refine existing plan ──
  const refineAIPlan = useCallback(async (userMsg) => {
    if (!userMsg?.trim()) return;
    setRefineLoading(true);

    // Build current draft plan from plan state
    const currentSlots = Object.entries(plan)
      .filter(([_, s]) => s.date && s.mealTime)
      .map(([k, s]) => ({
        date: s.date,
        mealTime: s.mealTime,
        mealId: s.mealId || "",
        prepType: s.prepType || "Auto",
        sideId: s.side || "",
        side2Id: s.side2 || "",
        isLeftover: s.isLeftover || false,
        locked: s.lockedMeal || false,
      }))
      .sort((a, b) => a.date.localeCompare(b.date) || MEAL_TIMES.indexOf(a.mealTime) - MEAL_TIMES.indexOf(b.mealTime));

    const allMeals = [...MEALS_DATA, ...customMeals.filter(m => !m._isSide)];
    const catalog = allMeals.map(m => ({ id: m.id, name: m.name, time: m.time, cuisine: m.cuisine, prep: m.prep, cook: m.cook, servings: m.servings, needsSide: m.needsSide, notes: m.notes }));
    const allSides = [...SIDES_DATA, ...customMeals.filter(m => m._isSide)];
    const sidesCatalog = allSides.map(s => ({ id: s.id, name: s.name, cuisine: s.cuisine, cat: s.cat }));

    const sd = new Date(startDate + "T00:00:00");
    const totalDays = weeks * 7;
    const endDate = new Date(sd);
    endDate.setDate(endDate.getDate() + totalDays - 1);

    const body = {
      taskType: "refine_plan",
      mealCatalog: catalog,
      sidesCatalog,
      currentDraftPlan: currentSlots,
      dateRange: {
        startDate,
        endDate: endDate.toISOString().slice(0, 10),
        totalDays,
      },
      userMessage: userMsg,
    };

    try {
      const res = await fetch(MEAL_AI_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${await getEdgeFnToken()}`,
          "apikey": SUPABASE_ANON_KEY,
        },
        body: JSON.stringify(body),
      });

      const json = await res.json();

      if (json.fallback || json.error) {
        setRefineHistory(prev => [...prev, { role: "user", content: userMsg }, { role: "claude", content: `Error: ${json.error || "AI unavailable"}` }]);
        setRefineLoading(false);
        return;
      }

      const changes = json.data || json || {};

      // Apply changes to plan
      if (changes.changes?.length) {
        setPlan(prev => {
          const next = { ...prev };
          changes.changes.forEach(ch => {
            const k = `${ch.date}_${ch.mealTime}`;
            if (next[k]) {
              next[k] = {
                ...next[k],
                mealId: ch.newMealId || "",
                prepType: ch.newPrepType || next[k].prepType,
                side: ch.newSideId || "",
                side2: ch.newSide2Id || "",
                isLeftover: ch.isLeftover || false,
                reason: ch.reasoning || "",
                lockedType: true,
                sideType: ch.newSideId ? "specific" : "",
                side2Type: ch.newSide2Id ? "specific" : "",
              };
              // Update reasoning map
              setAiPlanReasoning(prev => ({ ...prev, [k]: ch.reasoning || "" }));
            }
          });
          return next;
        });
      }

      setRefineHistory(prev => [
        ...prev,
        { role: "user", content: userMsg },
        { role: "claude", content: (changes && changes.summary) || `Made ${(changes && changes.changes?.length) || 0} changes.` },
      ]);
      setRefineLoading(false);
    } catch (err) {
      console.error("Refine plan failed:", err);
      setRefineHistory(prev => [...prev, { role: "user", content: userMsg }, { role: "claude", content: "Connection error. Try again." }]);
      setRefineLoading(false);
    }
  }, [plan, startDate, weeks, customMeals]);

  // ── Record meal feedback to Supabase ──
  const recordFeedback = useCallback(async (slotKey, feedbackData) => {
    const slot = plan[slotKey];
    if (!slot?.mealId) return;

    setMealFeedback(prev => ({ ...prev, [slotKey]: feedbackData }));

    try {
      await supabase.from("meal_feedback").insert({
        user_id: userId,
        meal_id: slot.mealId,
        event_type: feedbackData.rating >= 4 ? "thumbs_up" : feedbackData.rating <= 2 ? "thumbs_down" : "rating",
        // Symmetric mapping: 5★→+1, 4★→+0.5, 3★→0, 2★→-0.5, 1★→-1.
        // Old asymmetric mapping (5/4★→+1.0, 1/2★→-0.5, 3★→+0.3) skewed
        // preferences toward the positive even when the user was neutral.
        signal_strength: ({ 5: 1.0, 4: 0.5, 3: 0, 2: -0.5, 1: -1.0 })[feedbackData.rating] ?? 0,
        rating: feedbackData.rating,
        comment: feedbackData.comment || null,
        tags: feedbackData.tags || [],
        slot_date: slot.date,
        meal_time: slot.mealTime,
        source: "explicit",
      });
    } catch (err) {
      console.error("Failed to record feedback:", err);
    }
  }, [plan, userId]);

  // ── Load data from Supabase on mount ──
  useEffect(() => {
    if (!userId) return;
    const load = async () => {
      let data = null;
      let error = null;
      try {
        const res = await supabase
          .from("meal_planner_data")
          .select("*")
          .eq("user_id", userId)
          .single();
        data = res.data;
        error = res.error;
      } catch (netErr) {
        error = { message: String(netErr) };
      }
      // Supabase unreachable or returned an error other than "no rows":
      // hydrate from IndexedDB / localStorage so the user sees their data
      // instead of a blank app. Cloud save will retry once back online.
      let hydratedFromCache = false;
      if ((error && error.code !== "PGRST116") || (error && !data)) {
        if (error) console.warn("Supabase load failed, trying local cache:", error.message);
        const idbSnap = await readIDBSnapshot();
        const lsRaw = (() => { try { return localStorage.getItem("rogers_meal_planner_v1"); } catch { return null; } })();
        const lsSnap = lsRaw ? (() => { try { return JSON.parse(lsRaw); } catch { return null; } })() : null;
        const pick = (idbSnap && lsSnap)
          ? (idbSnap.savedAt > lsSnap.savedAt ? idbSnap : lsSnap)
          : (idbSnap || lsSnap);
        if (pick && pick.payload) {
          console.warn("Hydrating from local cache, saved", new Date(pick.savedAt).toLocaleString());
          data = pick.payload;
          hydratedFromCache = true;
        } else if (error && error.code !== "PGRST116") {
          setSyncStatus("error");
        }
      }
      try {
        if (data) {
          // Helper: is this a parseable YYYY-MM-DD date?
          const isGoodDate = (v) => {
            if (typeof v !== "string" || !v) return false;
            const d = new Date(v + "T00:00:00");
            return !isNaN(d.getTime()) && d.getFullYear() >= 1970;
          };
          if (data.family_size != null) setFamilySize(data.family_size);
          if (data.weeks != null) setWeeks(data.weeks);
          // Scrub bad start_date so it can't crash the planner on render
          if (isGoodDate(data.start_date)) setStartDate(data.start_date);
          // Scrub plan slots whose `date` is missing or unparseable
          if (data.plan && typeof data.plan === "object") {
            const cleanPlan = {};
            Object.entries(data.plan).forEach(([k, slot]) => {
              if (slot && typeof slot === "object" && isGoodDate(slot.date)) {
                cleanPlan[k] = slot;
              }
            });
            setPlan(cleanPlan);
          }
          if (data.day_modes) setDayModes(data.day_modes);
          if (data.freezer_meals) setFreezerMeals(data.freezer_meals.filter(fm => fm && fm.mealId && (fm.portions || 0) > 0));
          if (data.pantry_items) setPantryItems(data.pantry_items.filter(pi => pi && pi.name && (pi.qty || 0) > 0));
          if (data.rules) setRules(data.rules);
          if (data.history) {
            // Scrub history: drop any slot in any past plan whose mealId is
            // empty or whose date is bad. Corrupted slots poison pattern
            // detection (treats "no meal" as a meal preference signal).
            const cleanHistory = data.history.map(h => {
              if (!h || !h.plan) return h;
              const cleanedPlan = {};
              Object.entries(h.plan).forEach(([k, slot]) => {
                if (slot && typeof slot === "object" && isGoodDate(slot.date) && slot.mealId) {
                  cleanedPlan[k] = slot;
                }
              });
              return { ...h, plan: cleanedPlan };
            }).filter(h => h && h.plan && Object.keys(h.plan).length > 0);
            setHistory(cleanHistory);
          }
          if (data.grocery_checked) {
            setGroceryChecked(data.grocery_checked);
            // dismissed_patterns stored inside grocery_checked to avoid adding a DB column
            if (data.grocery_checked._dismissed_patterns) setDismissedPatterns(data.grocery_checked._dismissed_patterns);
          }
          if (data.custom_meals) {
            setCustomMeals(data.custom_meals);
            // Single source of truth: rebuild MEALS_DATA/SIDES_DATA/
            // INGREDIENTS_DATA from customMeals. Skips soft-deleted entries.
            // Replaces the previous "push if not present" pattern that
            // accumulated stale entries across hot reloads.
            resyncCustomData(data.custom_meals);
          }
          if (data.special_occasion_meals) setSpecialOccasionMeals(data.special_occasion_meals);

          // Load Thompson Sampler params
          if (thompsonSampler) {
            await thompsonSampler.loadFromSupabase(supabase, userId);
          }

          // Mark as "error" if we're showing cached data; "saved" if from cloud.
          // Auto-save will set "saving" -> "saved" again as soon as state changes.
          setSyncStatus(hydratedFromCache ? "error" : "saved");

          // Backfill historical data to meal_events (once per load) — skip
          // when hydrating from cache because we may be offline.
          if (!hydratedFromCache && !hasBackfilled && data.history && data.history.length > 0) {
            await backfillHistoryToEvents(supabase, userId, data.history, false);
            setHasBackfilled(true);
          }
        } else {
          setSyncStatus("saved"); // new user, no data yet — that's fine
        }
      } catch (e) {
        console.error("Load error:", e);
        setSyncStatus("error");
      }
      setDataLoaded(true);
    };
    load();
  }, [userId, thompsonSampler, hasBackfilled]);

  // ── Auto-save to Supabase whenever key state changes ──
  // Honest sync status: sets "saving" immediately, then "saved" or "error"
  // based on the actual Supabase response (the previous version blindly
  // flipped to "saved" after 2s regardless of whether the write succeeded).
  useEffect(() => {
    if (!dataLoaded) return; // Don't save during initial load
    setSyncStatus("saving");
    saveToCloud({
      family_size: familySize,
      weeks,
      start_date: startDate,
      plan,
      day_modes: dayModes,
      freezer_meals: freezerMeals,
      pantry_items: pantryItems,
      rules,
      history,
      grocery_checked: { ...groceryChecked, _dismissed_patterns: dismissedPatterns },
      custom_meals: customMeals,
      special_occasion_meals: specialOccasionMeals,
    }, (result) => setSyncStatus(result));
  }, [dataLoaded, familySize, weeks, startDate, plan, dayModes, freezerMeals, pantryItems, rules, history, groceryChecked, customMeals, specialOccasionMeals, dismissedPatterns, saveToCloud]);

  // ── Helper: what would a rule/pattern suggest for this slot? ──
  const getAutoHint = (dayName, mt) => {
    // Check day_meal rules
    const dayRule = rules.find(r => r.kind === "day_meal" && r.day === dayName && r.mealTime === mt);
    if (dayRule) {
      const mealName = dayRule.meal ? MEALS_DATA.find(m => m.id === dayRule.meal)?.name : "";
      return { type: dayRule.type, meal: dayRule.meal || "", label: `Rule: ${dayRule.type}${mealName ? " — " + mealName : ""}` };
    }
    // Check every_other rules (show hint but note it alternates)
    const eoRule = rules.find(r => r.kind === "every_other" && r.day === dayName && r.mealTime === mt);
    if (eoRule) {
      const mealName = eoRule.meal ? MEALS_DATA.find(m => m.id === eoRule.meal)?.name : "";
      return { type: eoRule.type, meal: eoRule.meal || "", label: `Every other: ${eoRule.type}${mealName ? " — " + mealName : ""}` };
    }
    // Check never_on rules
    const neverRule = rules.find(r => r.kind === "never_on" && r.day === dayName && (!r.mealTime || r.mealTime === mt));
    if (neverRule) {
      return { type: "", meal: "", label: `Never ${neverRule.type} on ${dayName}` };
    }
    // Check frequency rules
    const freqRule = rules.find(r => r.kind === "frequency" && r.mealTime === mt);
    if (freqRule) {
      const mealName = MEALS_DATA.find(m => m.id === freqRule.meal)?.name || "";
      const dayHint = (freqRule.preferDays || []).includes(dayName) ? " (preferred day)" : "";
      return { type: "Bulk Cook", meal: freqRule.meal, label: `Freq: ${mealName} ${freqRule.count}x/wk${dayHint}` };
    }
    // Check rotate rules
    const rotRule = rules.find(r => r.kind === "rotate" && r.mealTime === mt && (r.rotateDays || []).includes(dayName));
    if (rotRule) {
      const names = (rotRule.rotateMeals || []).map(id => MEALS_DATA.find(m => m.id === id)?.name || id);
      return { type: "Bulk Cook", meal: "", label: `Rotate: ${names.join(", ")}` };
    }
    // Then learned patterns (only day_type patterns have a .pattern string)
    if (history.length >= 2) {
      const patKey = `${dayName}_${mt}`;
      const match = patterns.find(p => p.kind === "day_type" && typeof p.pattern === "string" && p.pattern.startsWith(patKey) && p.confidence >= 60);
      if (match) {
        const type = match.pattern.split("_")[2];
        return { type, meal: "", label: `Pattern: ${type} (${match.confidence}%)` };
      }
    }
    return null;
  };

  // ── Initialize plan when weeks/startDate/rules change ─
  useEffect(() => {
    // Guard: skip if startDate is empty/invalid (e.g. user clearing the date picker)
    if (!startDate) return;
    const sd = new Date(startDate + "T00:00:00");
    if (isNaN(sd.getTime())) return;
    const totalDays = weeks * 7;
    const newPlan = {};
    for (let i = 0; i < totalDays; i++) {
      const d = addDays(sd, i);
      const key = d.toISOString().slice(0,10);
      MEAL_TIMES.forEach(mt => {
        const k = `${key}_${mt}`;
        if (!plan[k]) {
          // All new slots default to "Auto" — rules/patterns apply when Auto Meal Plan runs
          newPlan[k] = { date:key, mealTime:mt, prepType:"Auto", mealId:"", bulkCount:4, sideType:"", side:"", side2Type:"", side2:"", side3Type:"", side3:"", notes:"", reason:"", lockedType:false, lockedMeal:false, eatOutType:"", makeSalsa:false, makeCurtido:false, proteinAdd:"", isLeftover:false, customItems:[] };
        } else {
          // Ensure existing slots have customItems field
          newPlan[k] = { ...plan[k], customItems: plan[k].customItems || [] };
        }
      });
    }
    setPlan(newPlan);
    setFinalized(false);
  }, [weeks, startDate, rules]);

  // ── Plan helpers ───────────────────────────
  const updateSlot = (key, field, value) => {
    setPlan(p => {
      const updated = {...p};
      const slot = {...updated[key], [field]:value};
      if (field === "prepType") {
        slot.mealId = ""; slot.sideType = ""; slot.side = ""; slot.side2Type = ""; slot.side2 = ""; slot.side3Type = ""; slot.side3 = ""; slot.bulkCount = 4;
        slot.eatOutType = ""; slot.makeSalsa = false; slot.makeCurtido = false; slot.isLeftover = false;
        // If user picks a specific type (not Auto), lock the type
        slot.lockedType = value !== "Auto";
        slot.lockedMeal = false;
        slot.reason = value === "Auto" ? "" : "";
        // Auto-propagate Cook vs Easy dayModes
        if (value !== "Auto") {
          const slotDate = new Date(slot.date + "T00:00:00");
          const dayName = DAYS[slotDate.getDay()];
          const cookTypes = ["Bulk Cook"];
          const easyTypes = ["Frozen Meal","Defrost","Eat Out","Leftover Day"];
          if (cookTypes.includes(value)) {
            updateDayMode(dayName, slot.mealTime, "Cook");
          } else if (easyTypes.includes(value)) {
            updateDayMode(dayName, slot.mealTime, "Easy");
          }
        }
      }
      if (field === "mealId") {
        slot.sideType = ""; slot.side = ""; slot.side2Type = ""; slot.side2 = ""; slot.side3Type = ""; slot.side3 = ""; slot.proteinAdd = ""; slot.servingStyle = "";
        // If user picks a specific meal, lock both type and meal
        slot.lockedMeal = value !== "";
        slot.lockedType = true; // type is always locked if you've picked a meal

        // Auto-correct prepType to match the chosen meal's recommended prep.
        // Previously, picking a Frozen Meal (e.g. Fish Sticks) while the slot
        // was set to Cook Fresh would silently leave the wrong prep type on
        // the slot. Now Fish Sticks → "Frozen Meal", Pulled Pork → "Frozen
        // Meal", etc. The dropdown shows all meals in manual mode, so this
        // keeps the slot in a consistent state.
        if (value) {
          const pickedMeal = MEALS_DATA.find(m => m.id === value)
            || customMeals.find(m => m.id === value);
          if (pickedMeal && pickedMeal.prep) {
            const oldPrep = slot.prepType;
            const newPrep = pickedMeal.prep;
            if (oldPrep !== newPrep && newPrep !== "Auto") {
              slot.prepType = newPrep;
              // Update Cook/Easy day mode too
              const slotDate = new Date(slot.date + "T00:00:00");
              const dayName = DAYS[slotDate.getDay()];
              const cookTypes = ["Bulk Cook"];
              const easyTypes = ["Frozen Meal","Defrost","Eat Out","Leftover Day"];
              if (cookTypes.includes(newPrep)) {
                updateDayMode(dayName, slot.mealTime, "Cook");
              } else if (easyTypes.includes(newPrep)) {
                updateDayMode(dayName, slot.mealTime, "Easy");
              }
              // Reset bulk count if no longer Bulk Cook
              if (newPrep !== "Bulk Cook") slot.bulkCount = 4;
            }
          }
        }

        // ── Thompson feedback: track meal swaps ──
        const oldMealId = updated[key].mealId;
        if (oldMealId && oldMealId !== value && value) {
          // User swapped: record feedback for old meal and new meal
          if (thompsonSampler) {
            thompsonSampler.recordFeedback(oldMealId, 'swapped_away');
            // Record swap event (fire-and-forget)
            recordSwap(supabase, userId, {
              newMealId: value,
              rejectedMealId: oldMealId,
              slotDate: slot.date,
              mealTime: slot.mealTime,
              newPrepType: slot.prepType,
              rejectedPrepType: slot.prepType
            });
          }
        }
      }
      if (field === "sideType") { slot.side = ""; }
      if (field === "side2Type") { slot.side2 = ""; }
      if (field === "side3Type") { slot.side3 = ""; }
      updated[key] = slot;

      // Auto-fill next-day leftover when a Bulk Cook meal is selected
      if (slot.prepType === "Bulk Cook" && slot.mealId && field === "mealId") {
        // Clear any previous auto-leftover from this slot
        Object.keys(updated).forEach(dk => {
          if (dk !== key && updated[dk].reason === `leftover from ${slot.date} ${slot.mealTime}`) {
            updated[dk] = {...updated[dk], prepType:"Auto", mealId:"", isLeftover:false, reason:"", lockedType:false, lockedMeal:false,
              sideType:"", side:"", side2Type:"", side2:"", side3Type:"", side3:"", servingStyle:""};
          }
        });
        // Place leftover on next day, same meal time, if the slot is empty/Auto
        if (slot.mealId) {
          const nextDay = addDays(new Date(slot.date + "T00:00:00"), 1);
          const nextKey = `${nextDay.toISOString().slice(0,10)}_${slot.mealTime}`;
          if (updated[nextKey] && (!updated[nextKey].mealId || updated[nextKey].prepType === "Auto")) {
            updated[nextKey] = {...updated[nextKey], prepType:slot.prepType, mealId:slot.mealId, isLeftover:true,
              reason:`leftover from ${slot.date} ${slot.mealTime}`, lockedType:true, lockedMeal:true,
              sideType:slot.sideType||"", side:slot.side||"", side2Type:slot.side2Type||"", side2:slot.side2||"",
              side3Type:slot.side3Type||"", side3:slot.side3||"", servingStyle:slot.servingStyle||""};
          }
        }
      }

      // Auto-fill defrost when a Bulk Cook meal is selected or bulk count changes
      if (slot.prepType === "Bulk Cook" && slot.mealId && (field === "mealId" || field === "bulkCount")) {
        // First clear any existing auto-defrosts for this slot's old meal
        Object.keys(updated).forEach(dk => {
          if (dk !== key && updated[dk].reason && updated[dk].reason.includes(`bulk cook on ${slot.date}`)) {
            updated[dk] = {...updated[dk], prepType:"Bulk Cook", mealId:"", reason:""};
          }
        });
        // Now place defrosts spaced out
        const extra = slot.bulkCount - 1;
        let placed = 0;
        const keys = Object.keys(updated).sort();
        const startIdx = keys.indexOf(key);
        for (let gap = 2; gap <= 4 && placed < extra; gap++) {
          for (let i = 1; placed < extra; i++) {
            const d = addDays(new Date(slot.date + "T00:00:00"), i * gap);
            const dk = `${d.toISOString().slice(0,10)}_${slot.mealTime}`;
            if (updated[dk] && !updated[dk].mealId && (updated[dk].prepType === "Cook Fresh" || updated[dk].prepType === "Bulk Cook")) {
              updated[dk] = {...updated[dk], prepType:"Defrost", mealId:slot.mealId, reason:`Defrost from bulk cook on ${slot.date}`};
              placed++;
            }
            if (i > 14) break;
          }
        }
      }

      // ── Defrost auto-chain DISABLED.
      //
      // Previously, picking a Defrost meal auto-scheduled additional defrost
      // slots based on the freezer's portion count — but it didn't subtract
      // ALREADY-SCHEDULED defrosts of the same meal in the current plan. So
      // a freezer with 4 portions would chain 3 more defrosts every time you
      // touched the slot, leading to over-scheduling and freezer math errors
      // on finalize. David also said the app overestimates freezer leftovers.
      //
      // New behavior: place exactly one defrost when the user picks one.
      // If they want more days defrosted, they can do it manually — which is
      // both more predictable and matches how a normal person plans.
      //
      // Leftover-toggle behavior: just clear sides; no auto-chain to manage.
      if (field === "isLeftover" && slot.prepType === "Defrost" && value === true) {
        slot.sideType = ""; slot.side = ""; slot.side2Type = ""; slot.side2 = ""; slot.side3Type = ""; slot.side3 = "";
        updated[key] = slot;
      }

      return updated;
    });
  };

  const repeatTomorrow = (key) => {
    const slot = plan[key];
    if (!slot) return;
    const d = new Date(slot.date + "T00:00:00");
    const next = addDays(d, 1);
    const nextKey = `${next.toISOString().slice(0,10)}_${slot.mealTime}`;
    if (plan[nextKey]) {
      setPlan(p => ({...p, [nextKey]:{...p[nextKey], prepType:slot.prepType, mealId:slot.mealId, sideType:slot.sideType, side:slot.side}}));
    }
  };

  // Holds a list of "could not place all defrosts" warnings so the UI can
  // surface them after a Bulk Cook fill instead of silently swallowing
  // unplaced portions.
  const [bulkWarnings, setBulkWarnings] = useState([]);
  // Tracks whether autoMealPlan is currently running. The optimizer can take
  // 1-2s for long plans and freezes the UI; the button disables + shows a
  // spinner so the user doesn't double-click thinking nothing happened.
  const [autoPlanLoading, setAutoPlanLoading] = useState(false);

  // ── Auto-fill bulk cook defrost ────────────
  const autofillBulkDefrost = useCallback(() => {
    const warnings = [];
    setPlan(prev => {
      const next = {...prev};
      const keys = Object.keys(next).sort();
      keys.forEach(k => {
        const slot = next[k];
        if (slot.prepType === "Bulk Cook" && slot.mealId) {
          const extra = slot.bulkCount - 1;
          let placed = 0;
          for (let gap = 2; gap <= 4 && placed < extra; gap++) {
            for (let i = 1; placed < extra; i++) {
              const d = addDays(new Date(slot.date + "T00:00:00"), i * gap);
              const dk = `${d.toISOString().slice(0,10)}_${slot.mealTime}`;
              if (next[dk] && !next[dk].mealId && (next[dk].prepType === "Cook Fresh" || next[dk].prepType === "Bulk Cook")) {
                next[dk] = {...next[dk], prepType:"Defrost", mealId:slot.mealId, reason:`Defrost from bulk cook on ${slot.date}`};
                placed++;
              }
              if (i > 14) break;
            }
          }
          // Warn when fewer defrosts were placed than the bulkCount asked for —
          // previously this was silent and the user lost portions to nowhere.
          if (placed < extra) {
            const meal = MEALS_DATA.find(m => m.id === slot.mealId);
            warnings.push({
              key: k,
              date: slot.date,
              mealName: meal ? meal.name : slot.mealId,
              requested: extra + 1,
              placed: placed + 1,
              shortBy: extra - placed,
            });
          }
        }
      });
      return next;
    });
    setBulkWarnings(warnings);
  }, []);

  // ── AUTO MEAL PLAN ────────────────────────
  // ONLY fills slots that are still "Auto". Anything you manually changed is left alone.
  const autoMealPlan = () => {
    setPlan(prev => {
      const next = {...prev};
      const keys = Object.keys(next).sort();
      const used = { Breakfast: [], Lunch: [], Dinner: [] };

      // Reset non-locked slots back to Auto so they get re-filled with fresh randomization
      keys.forEach(k => {
        const slot = next[k];
        if (!slot.lockedType && !slot.lockedMeal) {
          next[k] = { ...slot, prepType: "Auto", mealId: "", sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "", reason: "" };
        }
      });

      // Track what's manually locked so we don't repeat those meals
      keys.forEach(k => {
        if (next[k].prepType !== "Auto" && next[k].mealId) {
          used[next[k].mealTime]?.push(next[k].mealId);
        }
      });

      // Helper: pick a meal using learned preferences, avoiding recent repeats and same-day duplicates
      const pickMeal = (candidates, recentIds, currentDayMeals = [], dayName = "", mealTime = "") => {
        // Filter out meals used in the last 3-4 weeks (from history) for lunch/dinner/bulk
        const recentFromHistory = new Set();
        // Hard 14-day Dinner cooldown set (separate)
        const dinner14DayCooldown = new Set();
        if (history.length > 0) {
          const weeksToCheck = 4;
          const daysToCheck = weeksToCheck * 7;
          const planDays = Object.values(plan).map(s => new Date(s.date + "T00:00:00").getTime()).sort();
          const oldestPlanDay = planDays[0] || Date.now();
          const cutoffTime = oldestPlanDay - (daysToCheck * 24 * 60 * 60 * 1000);
          const cutoff14 = oldestPlanDay - (14 * 24 * 60 * 60 * 1000);
          history.forEach(h => {
            const historyTime = new Date(h.date).getTime();
            if (historyTime >= cutoffTime) {
              Object.values(h.plan).forEach(slot => {
                if (slot.mealId && (slot.mealTime === "Lunch" || slot.mealTime === "Dinner")) {
                  recentFromHistory.add(slot.mealId);
                }
              });
            }
            if (historyTime >= cutoff14) {
              Object.values(h.plan).forEach(slot => {
                if (slot.mealId && slot.mealTime === "Dinner") dinner14DayCooldown.add(slot.mealId);
              });
            }
          });
        }
        // Eggs (B005) and Toast (S018) are exempt from frequency limits
        const exempt = ["B005", "S018"];
        // HARD dinner cooldown filter — applied BEFORE the soft 3-week filter
        // so the 14-day rule is enforced even if the pool ends up small.
        const preFiltered = (mealTime === "Dinner")
          ? candidates.filter(m => !dinner14DayCooldown.has(m.id))
          : candidates;
        const fresh = preFiltered.filter(m =>
          !recentIds.includes(m.id) &&
          !currentDayMeals.includes(m.id) &&
          (exempt.includes(m.id) || !recentFromHistory.has(m.id))
        );
        // Fallback chain respects the hard dinner cooldown
        const pool = fresh.length > 0
          ? fresh
          : (preFiltered.filter(m => !currentDayMeals.includes(m.id)).length > 0
              ? preFiltered.filter(m => !currentDayMeals.includes(m.id))
              : candidates.filter(m => !currentDayMeals.includes(m.id)));
        if (pool.length === 0) return null;

        // ── Thompson Sampling Integration ──
        // If we have Thompson data, use it; otherwise fall back to pattern-based weighting
        let selected = null;
        if (thompsonSampler && thompsonSampler.params.size > 0) {
          const context = { lastPlanDate: new Date(startDate || new Date()) };
          selected = thompsonSampler.selectMeal(pool, context, { temperature: 0.8 });
          if (selected) {
            // Fire-and-forget event: record this suggestion
            recordMealEvent(supabase, userId, {
              eventType: 'suggested',
              mealId: selected.id,
              slotDate: new Date().toISOString().slice(0,10),
              mealTime,
              prepType: "Auto"
            });
            return selected;
          }
        }

        // ── Fallback: Use learned preferences to weight selection ──
        // Check if we have day+meal preference patterns for this slot
        if (dayName && mealTime && patterns.length > 0) {
          const dayMealPrefs = patterns.filter(p =>
            p.kind === "day_meal_pref" && p.day === dayName && p.mealTime === mealTime
          ).sort((a,b) => b.confidence - a.confidence);

          // Also check general meal frequency patterns
          const freqPrefs = patterns.filter(p =>
            p.kind === "meal_freq" && p.mealTime === mealTime
          ).sort((a,b) => b.avgPerPlan - a.avgPerPlan);

          // Build a weighted pool: preferred meals get more weight
          const weights = new Map();
          pool.forEach(m => weights.set(m.id, 1)); // base weight = 1

          dayMealPrefs.forEach(p => {
            if (weights.has(p.mealId)) {
              weights.set(p.mealId, weights.get(p.mealId) + Math.round(p.confidence / 20)); // high confidence = more weight
            }
          });
          freqPrefs.forEach(p => {
            if (weights.has(p.mealId)) {
              weights.set(p.mealId, weights.get(p.mealId) + Math.round(p.avgPerPlan)); // frequent meals get boosted
            }
          });

          // Weighted random selection
          const totalWeight = [...weights.values()].reduce((a,b) => a+b, 0);
          let rand = Math.random() * totalWeight;
          for (const m of pool) {
            rand -= weights.get(m.id) || 1;
            if (rand <= 0) return m;
          }
        }

        return pool[Math.floor(Math.random() * pool.length)];
      };

      // Helper: pick a side for a meal (respects always_pair rules with multi-side)
      const pickSide = (meal, mt) => {
        if (!meal.needsSide) return { sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "" };
        // Check always_pair rule first
        const pairRule = rules.find(r => r.kind === "always_pair" && r.meal === meal.id);
        if (pairRule) {
          const pairedSide = SIDES_DATA.find(s => s.id === pairRule.side);
          if (pairedSide) {
            const result = { sideType: pairedSide.cat, side: pairedSide.id, side2Type: "", side2: "", side3Type: "", side3: "" };
            if (pairRule.side2) { const s2 = SIDES_DATA.find(s => s.id === pairRule.side2); if (s2) { result.side2Type = s2.cat; result.side2 = s2.id; } }
            if (pairRule.side3) { const s3 = SIDES_DATA.find(s => s.id === pairRule.side3); if (s3) { result.side3Type = s3.cat; result.side3 = s3.id; } }
            return result;
          }
        }
        if (mt === "Breakfast") {
          // Always pick one breakfast side (toast, beans, english muffins, maduros)
          const bfSides = SIDES_DATA.filter(s => s.cat === "Breakfast Side");
          const pick = bfSides[Math.floor(Math.random() * bfSides.length)];
          const result = pick ? { sideType: "Breakfast Side", side: pick.id, side2Type: "", side2: "", side3Type: "", side3: "" } : { sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "" };
          // ~15% chance to add bacon or sausage as a second side (roughly once a week)
          if (pick && Math.random() < 0.15) {
            const proteins = SIDES_DATA.filter(s => s.cat === "Breakfast Protein");
            const proteinPick = proteins[Math.floor(Math.random() * proteins.length)];
            if (proteinPick) { result.side2Type = "Breakfast Protein"; result.side2 = proteinPick.id; }
          }
          return result;
        }
        // Check learned side pairing patterns from history
        const learnedPair = patterns.find(p => p.kind === "side_pair" && p.mealId === meal.id && p.confidence >= 50);
        if (learnedPair) {
          const learnedSide = SIDES_DATA.find(s => s.id === learnedPair.sideId);
          if (learnedSide) {
            return { sideType: learnedSide.cat, side: learnedSide.id, side2Type: "", side2: "", side3Type: "", side3: "" };
          }
        }
        // Cuisine-aware side picking — uses the cuisine matcher, picks from best-match category
        const bestCat = cuisineToSideCat(meal.cuisine);
        const options = SIDES_DATA.filter(s => s.cat === bestCat);
        const pick = options.length > 0 ? options[Math.floor(Math.random() * options.length)] : null;
        return pick ? { sideType: bestCat, side: pick.id, side2Type: "", side2: "", side3Type: "", side3: "" } : { sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "" };
      };

      // Helper: is this slot available for auto-fill?
      const isAuto = (k) => next[k] && next[k].prepType === "Auto" && !next[k].lockedType;
      const needsMealOnly = (k) => next[k] && next[k].lockedType && !next[k].lockedMeal && !next[k].mealId && !["Leftover Day","Eat Out","Skip"].includes(next[k].prepType);

      const totalDays = keys.length / 3;
      const weeksCount = Math.ceil(totalDays / 7);

      // Helper: get week number for a slot key (0-indexed from plan start)
      const getWeekNum = (k) => {
        const idx = keys.indexOf(k);
        return Math.floor(Math.floor(idx / 3) / 7);
      };

      // Helper: get all keys in the same week as the given key
      const getWeekKeys = (weekNum) => keys.filter(k => getWeekNum(k) === weekNum);

      // Helper: count how many slots in a week have a given prep type (for already-set slots)
      const countTypeInWeek = (weekNum, type, mealTimeFilter) => {
        return getWeekKeys(weekNum).filter(k => {
          const s = next[k];
          return s.prepType === type && (!mealTimeFilter || s.mealTime === mealTimeFilter);
        }).length;
      };

      // ── PASS 0a: Sunday Lunch = Eat Out (Life Groups) ──
      keys.forEach(k => {
        if (!isAuto(k)) return;
        const slot = next[k];
        const d = new Date(slot.date + "T00:00:00");
        const dayName = DAYS[d.getDay()];
        if (dayName === "Sun" && slot.mealTime === "Lunch") {
          next[k] = { ...slot, prepType: "Eat Out", mealId: "", eatOutType: "Life Groups", reason: "Auto: Sunday Lunch — Life Groups", lockedType: true };
        }
      });

      // ── PASS 0b: One bulk breakfast per week — rotate Oatmeal (B001) / Cream of Wheat (B008) ──
      // Only place on a breakfast day the user marked as "Cook" — otherwise, don't auto-bulk-cook breakfast.
      const bulkBreakfastRotation = ["B001", "B008"];
      for (let w = 0; w < weeksCount; w++) {
        const cookBreakfastKeys = getWeekKeys(w).filter(k => {
          if (next[k].mealTime !== "Breakfast" || !isAuto(k)) return false;
          const dd = new Date(next[k].date + "T00:00:00");
          const dn = DAYS[dd.getDay()];
          return getDayMode(next[k].date, dn, "Breakfast") === "Cook";
        });
        if (cookBreakfastKeys.length > 0) {
          // Pick a day (prefer mid-week like Wed or Thu)
          const preferred = cookBreakfastKeys.find(k => {
            const dd = new Date(next[k].date + "T00:00:00");
            return dd.getDay() === 3 || dd.getDay() === 4; // Wed or Thu
          }) || cookBreakfastKeys[0];
          // Alternate B001 and B008 by week number
          const bulkId = bulkBreakfastRotation[w % bulkBreakfastRotation.length];
          const meal = MEALS_DATA.find(m => m.id === bulkId);
          if (meal && preferred) {
            // No auto-sides — David picks sides himself.
            next[preferred] = { ...next[preferred], prepType: "Bulk Cook", mealId: bulkId, sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "", reason: `Auto: weekly bulk breakfast — ${meal.name}`, lockedType: true };
            used.Breakfast.push(bulkId);
          }
        }
      }

      // ── PASS 1a: Apply "day_meal" rules (every week) ──
      keys.forEach(k => {
        if (!isAuto(k)) return;
        const slot = next[k];
        const d = new Date(slot.date + "T00:00:00");
        const dayName = DAYS[d.getDay()];
        const rule = rules.find(r => r.kind === "day_meal" && r.day === dayName && r.mealTime === slot.mealTime);
        if (rule) {
          next[k] = { ...slot, prepType: rule.type, mealId: rule.meal || "", reason: `Rule: ${dayName} ${slot.mealTime} = ${rule.type}` };
          if (rule.meal) used[slot.mealTime]?.push(rule.meal);
        }
      });

      // ── PASS 1b: Apply "every_other" rules (alternating weeks) ──
      keys.forEach(k => {
        if (!isAuto(k)) return;
        const slot = next[k];
        const d = new Date(slot.date + "T00:00:00");
        const dayName = DAYS[d.getDay()];
        const weekNum = getWeekNum(k);
        const rule = rules.find(r => r.kind === "every_other" && r.day === dayName && r.mealTime === slot.mealTime);
        if (rule) {
          const isOddWeek = weekNum % 2 === 0; // 0-indexed, so week 0 = "this week" = odd
          const shouldApply = (rule.startWeek === "odd") ? isOddWeek : !isOddWeek;
          if (shouldApply) {
            next[k] = { ...slot, prepType: rule.type, mealId: rule.meal || "", reason: `Every other ${dayName}: ${rule.type}` };
            if (rule.meal) used[slot.mealTime]?.push(rule.meal);
          }
        }
      });

      // ── PASS 1c: Apply "never_on" rules — mark slots that must NOT get a certain type ──
      // We store blocked types per slot key for later passes to check
      const blocked = {}; // key -> Set of blocked prep types
      rules.filter(r => r.kind === "never_on").forEach(rule => {
        keys.forEach(k => {
          const slot = next[k];
          const d = new Date(slot.date + "T00:00:00");
          const dayName = DAYS[d.getDay()];
          if (dayName === rule.day && (!rule.mealTime || rule.mealTime === slot.mealTime)) {
            if (!blocked[k]) blocked[k] = new Set();
            blocked[k].add(rule.type);
          }
        });
      });

      // ── PASS 1d: Apply "rotate" rules — cycle through meal list on specified days ──
      rules.filter(r => r.kind === "rotate").forEach(rule => {
        const meals = rule.rotateMeals || [];
        if (meals.length === 0) return;
        let rotIdx = 0;
        keys.forEach(k => {
          if (!isAuto(k)) return;
          const slot = next[k];
          if (slot.mealTime !== rule.mealTime) return;
          const d = new Date(slot.date + "T00:00:00");
          const dayName = DAYS[d.getDay()];
          if (!(rule.rotateDays || []).includes(dayName)) return;
          const mealId = meals[rotIdx % meals.length];
          const meal = MEALS_DATA.find(m => m.id === mealId);
          next[k] = { ...slot, prepType: meal?.prep || "Bulk Cook", mealId, reason: `Rotate: ${meal?.name || mealId}` };
          if (used[slot.mealTime]) used[slot.mealTime].push(mealId);
          rotIdx++;
        });
      });

      // ── PASS 1e: Apply "frequency" rules — place meal X times per week ──
      rules.filter(r => r.kind === "frequency").forEach(rule => {
        const count = rule.count || 3;
        const mealId = rule.meal;
        const mt = rule.mealTime;
        const meal = MEALS_DATA.find(m => m.id === mealId);
        if (!meal) return;
        const preferDays = rule.preferDays || [];

        for (let w = 0; w < weeksCount; w++) {
          const weekSlots = getWeekKeys(w).filter(k => next[k].mealTime === mt && isAuto(k));
          // Already placed this meal this week?
          const alreadyPlaced = getWeekKeys(w).filter(k => next[k].mealId === mealId && next[k].mealTime === mt).length;
          const needed = count - alreadyPlaced;
          if (needed <= 0) continue;

          // Sort: preferred days first, then others
          const sorted = weekSlots.sort((a, b) => {
            const dayA = DAYS[new Date(next[a].date + "T00:00:00").getDay()];
            const dayB = DAYS[new Date(next[b].date + "T00:00:00").getDay()];
            const prefA = preferDays.includes(dayA) ? 0 : 1;
            const prefB = preferDays.includes(dayB) ? 0 : 1;
            return prefA - prefB;
          });

          let placed = 0;
          for (const k of sorted) {
            if (placed >= needed) break;
            // Respect never_on
            if (blocked[k] && blocked[k].has(meal.prep)) continue;
            // No auto-sides — David picks sides himself.
            next[k] = { ...next[k], prepType: meal.prep || "Bulk Cook", mealId, sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "", reason: `Freq: ${meal.name} ${count}x/wk` };
            if (used[mt]) used[mt].push(mealId);
            placed++;
          }
        }
      });

      // ── PASS 2: Apply learned patterns to remaining Auto slots ──
      if (history.length >= 2) {
        keys.forEach(k => {
          if (!isAuto(k)) return;
          const slot = next[k];
          const d = new Date(slot.date + "T00:00:00");
          const dayName = DAYS[d.getDay()];
          const patKey = `${dayName}_${slot.mealTime}`;
          const match = patterns.find(p => p.kind === "day_type" && typeof p.pattern === "string" && p.pattern.startsWith(patKey) && p.confidence >= 60);
          if (match) {
            const type = match.pattern.split("_")[2];
            if (type && PREP_TYPES[type] && type !== "Auto") {
              // Respect never_on
              if (blocked[k] && blocked[k].has(type)) return;
              next[k] = { ...slot, prepType: type, reason: `Pattern: ${dayName} ${slot.mealTime} (${match.confidence}%)` };
            }
          }
        });
      }

      // ── PASS 3: Place ~1 bulk cook dinner per week on Auto slots ──
      // But first check min_per_week rules — if there's a min for Bulk Cook, respect it
      const minBulkRule = rules.find(r => r.kind === "min_per_week" && r.type === "Bulk Cook");
      for (let w = 0; w < weeksCount; w++) {
        const existingBulk = countTypeInWeek(w, "Bulk Cook", "Dinner");
        const minNeeded = minBulkRule ? Math.max(1, minBulkRule.count) : 1;
        if (existingBulk >= minNeeded) continue;

        const weekKeys = getWeekKeys(w).filter(k => {
          if (!isAuto(k) || next[k].mealTime !== "Dinner") return false;
          const dd2 = new Date(next[k].date + "T00:00:00");
          const dn = DAYS[dd2.getDay()];
          const mode = getDayMode(next[k].date, dn, "Dinner");
          return mode === "Cook"; // Only bulk cook on days the user marked Cook
        });
        const earlySlots = weekKeys.filter(k => {
          const d = new Date(next[k].date + "T00:00:00");
          return d.getDay() <= 2;
        });
        const bulkSlot = earlySlots[0] || weekKeys[0];
        if (bulkSlot) {
          // Respect never_on
          if (blocked[bulkSlot] && blocked[bulkSlot].has("Bulk Cook")) continue;
          const bulkMeals = MEALS_DATA.filter(m => m.prep === "Bulk Cook" && m.time.includes("Dinner"));
          const bulkDayName = DAYS[new Date(next[bulkSlot].date + "T00:00:00").getDay()];
          const pick = pickMeal(bulkMeals, used.Dinner, [], bulkDayName, "Dinner");
          if (pick) {
            const bc = pick.servings >= 8 ? 4 : 3;
            next[bulkSlot] = { ...next[bulkSlot], prepType: "Bulk Cook", mealId: pick.id, bulkCount: bc, reason: "Auto: weekly bulk cook" };
            used.Dinner.push(pick.id);

            // Spread defrosts — prefer "Easy" days first, then any Auto slot
            let placed = 0;
            const extra = bc - 1;
            // First pass: try Easy days
            for (let i = 1; placed < extra && i <= 14; i++) {
              const dd = addDays(new Date(next[bulkSlot].date + "T00:00:00"), i);
              const dk = `${dd.toISOString().slice(0, 10)}_Dinner`;
              const dn = DAYS[dd.getDay()];
              if (next[dk] && isAuto(dk) && (getDayMode(dd.toISOString().slice(0,10), dn, "Dinner") === "Easy")) {
                next[dk] = { ...next[dk], prepType: "Defrost", mealId: pick.id, reason: "Defrost from bulk cook (easy day)" };
                placed++;
              }
            }
            // Second pass: fill remaining on any Auto slots
            for (let gap = 2; gap <= 4 && placed < extra; gap++) {
              for (let i = 1; placed < extra; i++) {
                const dd = addDays(new Date(next[bulkSlot].date + "T00:00:00"), i * gap);
                const dk = `${dd.toISOString().slice(0, 10)}_Dinner`;
                if (next[dk] && (isAuto(dk) || (!next[dk].mealId && (next[dk].prepType === "Cook Fresh" || next[dk].prepType === "Bulk Cook")))) {
                  next[dk] = { ...next[dk], prepType: "Defrost", mealId: pick.id, reason: "Defrost from bulk cook" };
                  placed++;
                }
                if (i > 14) break;
              }
            }
            // Lunch defrost too
            for (let i = 2; i <= 5; i++) {
              const d = addDays(new Date(next[bulkSlot].date + "T00:00:00"), i);
              const lk = `${d.toISOString().slice(0, 10)}_Lunch`;
              if (next[lk] && isAuto(lk) && placed < extra) {
                next[lk] = { ...next[lk], prepType: "Defrost", mealId: pick.id, reason: "Defrost from bulk cook (lunch)" };
                placed++;
                break;
              }
            }
          }
        }
      }

      // ── PASS 3b: Enforce min_per_week for non-Bulk-Cook types ──
      rules.filter(r => r.kind === "min_per_week" && r.type !== "Bulk Cook").forEach(rule => {
        for (let w = 0; w < weeksCount; w++) {
          const existing = countTypeInWeek(w, rule.type, rule.mealTime || null);
          const needed = (rule.count || 1) - existing;
          if (needed <= 0) continue;
          const weekAutoSlots = getWeekKeys(w).filter(k => isAuto(k) && (!rule.mealTime || next[k].mealTime === rule.mealTime));
          let placed = 0;
          for (const k of weekAutoSlots) {
            if (placed >= needed) break;
            if (blocked[k] && blocked[k].has(rule.type)) continue;
            next[k] = { ...next[k], prepType: rule.type, reason: `Min rule: at least ${rule.count} ${rule.type}/wk` };
            placed++;
          }
        }
      });

      // ── PASS 4: Simulated Annealing global optimization ──
      // Collect all open slots that need meal assignments
      const openSlotKeys = [];
      const candidatesMap = {};
      const maxRules = rules.filter(r => r.kind === "max_per_week");

      keys.forEach(k => {
        const slot = next[k];

        // Fully locked (user picked both type + meal) — never touch
        if (slot.lockedMeal) return;
        // Already has a meal from earlier passes — skip
        if (slot.mealId) return;
        // No-meal types — nothing to pick
        if (["Leftover Day", "Eat Out", "Skip"].includes(slot.prepType)) return;
        // Defrost already assigned — skip
        if (slot.prepType === "Defrost") return;

        const mt = slot.mealTime;
        const weekNum = getWeekNum(k);
        const d = new Date(slot.date + "T00:00:00");
        const dayName = DAYS[d.getDay()];
        const dayMode = getDayMode(slot.date, dayName, mt);

        // Determine what type to use for picking — respect day modes.
        // David's rule: only cook meals on days marked "Cook". Otherwise, pick from easy options
        // (Frozen Meals + meals tagged easyPrep like hamburgers, hot dogs, caesar salad, tomato soup).
        let assignType = slot.prepType === "Auto" ? "Bulk Cook" : slot.prepType;
        let easyMode = false;
        if (slot.prepType === "Auto") {
          if (dayMode === "Cook") {
            assignType = (mt === "Breakfast") ? "Cook Fresh" : "Bulk Cook";
          } else {
            // Non-Cook days (Any or Easy): pool = Frozen Meal + easyPrep meals.
            // If no candidates exist for this meal time (e.g. Breakfast), the slot stays empty.
            easyMode = true;
            assignType = "Bulk Cook"; // placeholder for rule checks; final prepType uses meal.prep
          }
        }

        // Check max_per_week — if this type is at cap, fall back to Bulk Cook
        const maxRule = maxRules.find(r => r.type === assignType && (!r.mealTime || r.mealTime === mt));
        if (maxRule) {
          const currentCount = countTypeInWeek(weekNum, assignType, maxRule.mealTime || null);
          if (currentCount >= maxRule.count) {
            if (slot.prepType === "Auto") assignType = "Bulk Cook";
            else return; // locked type at cap — skip
          }
        }

        // Respect never_on
        if (blocked[k] && blocked[k].has(assignType)) {
          if (slot.prepType === "Auto") assignType = "Bulk Cook";
          else return;
        }

        // Get meals already assigned to this day to avoid duplicates
        const dayKey = slot.date;
        const dayMealsForThisDay = Object.values(next).filter(s => s.date === dayKey && s.mealId).map(s => s.mealId);

        let candidates;
        if (easyMode) {
          // Non-Cook days: Frozen Meal OR easyPrep meals for this meal time.
          // (For Breakfast on non-Cook days there are no such meals — candidates will be empty and the slot stays blank.)
          candidates = MEALS_DATA.filter(m => (m.prep === "Frozen Meal" || m.easyPrep === true) && m.time.includes(mt));
        } else if (mt === "Breakfast") {
          // Breakfast: default to Cook Fresh, with bulk cook rotation allowed once per week
          if (assignType === "Cook Fresh") {
            candidates = MEALS_DATA.filter(m => m.time.includes("Breakfast") && m.prep === "Cook Fresh");
            // If not enough Cook Fresh options, also allow Bulk Cook for variety
            if (candidates.length === 0) {
              candidates = MEALS_DATA.filter(m => m.time.includes("Breakfast") && m.prep === "Bulk Cook");
            }
          } else {
            // Bulk Cook breakfast: rotate between B001 and B008 approximately once per week
            const bulkBreakfastIds = ["B001", "B008"];
            candidates = bulkBreakfastIds.map(id => MEALS_DATA.find(m => m.id === id)).filter(m => m);
            if (candidates.length === 0) {
              candidates = MEALS_DATA.filter(m => m.time.includes("Breakfast") && m.prep === "Bulk Cook");
            }
          }
        } else if (assignType === "Frozen Meal") {
          // Strict separation: only show meals that match this meal time
          candidates = MEALS_DATA.filter(m => m.prep === "Frozen Meal" && m.time.includes(mt));
        } else if (assignType === "Bulk Cook") {
          // Strict separation: only show meals that match this meal time
          candidates = MEALS_DATA.filter(m => m.prep === "Bulk Cook" && m.time.includes(mt));
        } else if (assignType === "Cook Fresh") {
          // Cook Fresh: strict separation
          candidates = MEALS_DATA.filter(m => (m.prep === "Cook Fresh" || m.prep === "Bulk Cook") && m.time.includes(mt));
        } else {
          candidates = MEALS_DATA.filter(m => m.prep === "Bulk Cook" && m.time.includes(mt));
        }

        // Exclude special occasion meals from auto-generation
        candidates = candidates.filter(m => !specialOccasionMeals.includes(m.id));

        // ── Hard 14-day Dinner cooldown ──
        // David's rule: no dinner meal should repeat more than 1x per 14 days
        // (max 2x/month). Filter out dinners already served in the last 14
        // days (history). Within-plan repeats are handled by SA penalty.
        if (mt === "Dinner" && history && history.length > 0) {
          const slotTime = new Date(slot.date + "T00:00:00").getTime();
          const cutoff = slotTime - (14 * 24 * 60 * 60 * 1000);
          const recentDinners = new Set();
          history.forEach(h => {
            const ht = new Date(h.date).getTime();
            if (ht >= cutoff) {
              Object.values(h.plan || {}).forEach(s => {
                if (s.mealId && s.mealTime === "Dinner") recentDinners.add(s.mealId);
              });
            }
          });
          const before = candidates.length;
          const filtered = candidates.filter(m => !recentDinners.has(m.id));
          // Safety valve: only apply filter if we still have enough candidates
          if (filtered.length >= 3) candidates = filtered;
          console.log(`[AutoPlan] ${k} 14-day cooldown removed ${before - candidates.length} meals`);
        }

        // DEBUG: log dinner candidate pools so we can see why new meals aren't appearing
        if (mt === "Dinner") {
          const hasNew = candidates.some(m => ["D049","D050","D051"].includes(m.id));
          console.log(`[AutoPlan] ${k} dayMode=${dayMode} easyMode=${easyMode} assignType=${assignType} candidates(${candidates.length})=${candidates.map(m=>m.id).join(",")} hasNew=${hasNew}`);
        }

        // Build candidates list for this slot
        if (candidates.length > 0) {
          candidatesMap[k] = { candidates, assignType, dayName, mt, dayMode, easyMode };
          openSlotKeys.push(k);
        }
      });

      // Run SA optimizer if we have open slots
      if (openSlotKeys.length > 0) {
        const saOptimizer = new SimulatedAnnealingOptimizer(MEALS_DATA, INGREDIENTS_DATA);
        const seasonalEngine = new SeasonalGroceryEngine(MEALS_DATA, INGREDIENTS_DATA);
        const saContext = {
          history, rules, blocked, used, thompsonSampler, prefEngine,
          specialOccasionMeals, getDayMode, familySize, PROTEIN_KEYWORDS,
          seasonalEngine,    // NEW
          pantryItems,       // NEW
        };

        try {
          const optimizedPlan = saOptimizer.optimize(next, openSlotKeys, candidatesMap, saContext);

          // Apply optimized assignments — no auto-sides (David picks sides himself).
          // On non-Cook days (easyMode), store the meal's actual prep so e.g. Hamburgers stays Bulk Cook.
          openSlotKeys.forEach(k => {
            if (optimizedPlan[k] && optimizedPlan[k].mealId) {
              const slot = optimizedPlan[k];
              const pick = MEALS_DATA.find(m => m.id === slot.mealId);
              if (pick) {
                const assignType = candidatesMap[k].assignType;
                const dayMode = candidatesMap[k].dayMode;
                const easyMode = candidatesMap[k].easyMode;
                const finalPrep = easyMode ? (pick.prep || assignType) : assignType;
                const reason = next[k].lockedType ? `You picked ${assignType} — auto-selected meal` : (easyMode ? "Easy night: quick/frozen pick" : (dayMode === "Cook" ? "Cook day: main meal chosen" : (next[k].reason || "Auto: optimized selection")));
                next[k] = { ...next[k], prepType: finalPrep, mealId: slot.mealId, sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "", reason };
                if (used[slot.mealTime]) used[slot.mealTime].push(pick.id);
              }
            }
          });
        } catch (e) {
          console.error('SA optimizer failed, falling back to greedy:', e);
          // GREEDY FALLBACK: Original PASS 4 logic
          openSlotKeys.forEach(k => {
            const slot = next[k];
            const assignType = candidatesMap[k].assignType;
            const dayName = candidatesMap[k].dayName;
            const mt = candidatesMap[k].mt;
            const dayMode = candidatesMap[k].dayMode;
            const candidates = candidatesMap[k].candidates;

            const dayKey = slot.date;
            const dayMealsForThisDay = Object.values(next).filter(s => s.date === dayKey && s.mealId).map(s => s.mealId);
            const pick = pickMeal(candidates, used[mt] || [], dayMealsForThisDay, dayName, mt);

            if (pick) {
              // No auto-sides — David picks sides himself.
              // On non-Cook days (easyMode), use the meal's actual prep type.
              const easyMode = candidatesMap[k].easyMode;
              const finalPrep = easyMode ? (pick.prep || assignType) : assignType;
              const reason = slot.lockedType ? `You picked ${assignType} — auto-selected meal` : (easyMode ? "Easy night: quick/frozen pick" : (dayMode === "Cook" ? "Cook day: main meal chosen" : (slot.reason || "Auto: favorites rotation")));
              next[k] = { ...slot, prepType: finalPrep, mealId: pick.id, sideType: "", side: "", side2Type: "", side2: "", side3Type: "", side3: "", reason };
              if (used[mt]) used[mt].push(pick.id);
            }
          });
        }
      }

      // ── PASS 5 & 6: Auto-side population is DISABLED per David's request ──
      // Auto Meal Plan now only places main meals. David picks sides himself from the UI.
      // (always_pair rules and needsSide auto-fill are intentionally skipped here.)

      return next;
    });
  };

  // ── Finalize plan ──────────────────────────
  // Compute the ingredient and freezer impact of a plan — used so re-finalize
  // can apply ONLY the diff between the previously-saved version and the
  // current version, instead of double-deducting pantry/freezer.
  const computePlanImpact = (planObj, fsize) => {
    const freezerImpact = {}; // mealId -> portions to remove
    const pantryImpact  = {}; // "name||normalizedUnit" -> qty to remove
    Object.values(planObj || {}).forEach(slot => {
      if (!slot) return;
      // Defrost: removes one portion from freezer
      if (slot.prepType === "Defrost" && slot.mealId) {
        freezerImpact[slot.mealId] = (freezerImpact[slot.mealId] || 0) + 1;
      }
      // Pantry deduction — skip no-cook types and leftovers
      if (["Leftover Day","Eat Out","Skip","Defrost","Frozen Meal"].includes(slot.prepType)) return;
      if (slot.isLeftover) return;
      if (slot.mealId) {
        // Fractional scaling: use the meal's recipe.servings against familySize
        // and bulkCount, instead of the old hard-coded "/6" assumption that
        // overestimated for any meal whose recipe yielded != 6.
        const meal = MEALS_DATA.find(m => m.id === slot.mealId) || (customMeals && customMeals.find(m => m.id === slot.mealId));
        const recipeServings = (meal && meal.servings) || 6;
        const meals = (slot.prepType === "Bulk Cook" && slot.bulkCount) ? slot.bulkCount : 1;
        const mealScale = (fsize * meals) / recipeServings;
        const ings = INGREDIENTS_DATA[slot.mealId];
        if (ings) ings.forEach(i => {
          const key = `${i.n}||${normalizeUnit(i.u)}`;
          pantryImpact[key] = (pantryImpact[key] || 0) + i.q * mealScale;
        });
        // Sides scale with the meal — if you bulk-cook tacos x4, you also need
        // x4 of the side ingredients.
        [slot.side, slot.side2, slot.side3].forEach(sideId => {
          if (!sideId) return;
          const side = SIDES_DATA.find(s => s.id === sideId);
          if (side && side.ingredients) {
            side.ingredients.forEach(i => {
              const key = `${i.n}||${normalizeUnit(i.u)}`;
              pantryImpact[key] = (pantryImpact[key] || 0) + i.q * mealScale;
            });
          }
        });
      }
    });
    return { freezerImpact, pantryImpact };
  };

  const finalizePlan = () => {
    // Auto-fill any bulk cook defrosts
    autofillBulkDefrost();

    // ── Re-finalize detection ──
    // If we already finalized a plan whose slot dates match the current plan's
    // slot dates, treat this as a RE-FINALIZE: compute the delta vs the saved
    // version and only apply the net change.
    const currentDates = Object.values(plan).map(s => s.date).sort();
    const currentFirst = currentDates[0];
    const currentLast  = currentDates[currentDates.length - 1];
    const existingIdx = history.findIndex(h => {
      if (!h.plan || Object.keys(h.plan).length === 0) return false;
      const hDates = Object.values(h.plan).map(s => s.date).sort();
      if (hDates.length === 0) return false;
      return hDates[0] === currentFirst && hDates[hDates.length - 1] === currentLast;
    });
    const isRefinalize = existingIdx !== -1;

    // Calculate impacts. On re-finalize, NET delta = current - saved.
    const currentImpact = computePlanImpact(plan, familySize);
    const savedImpact = isRefinalize
      ? computePlanImpact(history[existingIdx].plan, history[existingIdx].familySize || familySize)
      : { freezerImpact: {}, pantryImpact: {} };

    // ── Apply freezer delta ──
    // Positive net = remove more portions from freezer
    // Negative net = add portions BACK to freezer (a Defrost was undone)
    const newFreezer = [...freezerMeals];
    const allFreezerKeys = new Set([...Object.keys(currentImpact.freezerImpact), ...Object.keys(savedImpact.freezerImpact)]);
    allFreezerKeys.forEach(mealId => {
      const net = (currentImpact.freezerImpact[mealId] || 0) - (savedImpact.freezerImpact[mealId] || 0);
      if (net === 0) return;
      const idx = newFreezer.findIndex(f => f.mealId === mealId);
      if (idx !== -1) {
        newFreezer[idx].portions -= net;
        if (newFreezer[idx].portions <= 0) newFreezer.splice(idx, 1);
      } else if (net < 0) {
        // Need to restore a freezer entry that was fully consumed earlier
        const meal = MEALS_DATA.find(m => m.id === mealId) || customMeals.find(m => m.id === mealId);
        if (meal) {
          newFreezer.push({ mealId, name: meal.name, portions: -net, mealTime: meal.time?.includes("Dinner") ? "Dinner" : (meal.time?.[0] || "Dinner") });
        }
      }
    });
    setFreezerMeals(newFreezer);

    // ── Apply pantry delta ──
    const newPantry = [...pantryItems];
    const allPantryKeys = new Set([...Object.keys(currentImpact.pantryImpact), ...Object.keys(savedImpact.pantryImpact)]);
    allPantryKeys.forEach(key => {
      const net = (currentImpact.pantryImpact[key] || 0) - (savedImpact.pantryImpact[key] || 0);
      if (net === 0) return;
      const [name, unit] = key.split("||");
      // Normalize the pantry side too so "cup" matches "cups", etc.
      const idx = newPantry.findIndex(p => p.name === name && normalizeUnit(p.unit) === unit);
      if (idx !== -1) {
        newPantry[idx].qty -= net;
        if (newPantry[idx].qty <= 0) newPantry.splice(idx, 1);
      } else if (net < 0) {
        // Restore pantry item that had been fully consumed
        newPantry.push({ name, unit, qty: -net, category: "Pantry" });
      }
      // If net > 0 and item not in pantry — nothing to deduct (user may have consumed elsewhere); leave alone.
    });
    setPantryItems(newPantry);

    // ── AI-plan implicit feedback (only on first finalize) ──
    if (!isRefinalize && aiPlanDraft) {
      const implicitEvents = [];
      Object.entries(plan).forEach(([k, slot]) => {
        if (!slot.mealId || slot.prepType === "Skip" || slot.prepType === "Eat Out") return;
        const aiSlot = aiPlanDraft?.weekPlan?.find(s => s.date === slot.date && s.mealTime === slot.mealTime);
        if (aiSlot && aiSlot.mealId === slot.mealId) {
          implicitEvents.push({ user_id: userId, meal_id: slot.mealId, event_type: "meal_kept_as_planned", signal_strength: 0.7, slot_date: slot.date, meal_time: slot.mealTime, auto_generated: true, source: "plan_acceptance" });
        } else if (aiSlot && aiSlot.mealId !== slot.mealId) {
          implicitEvents.push({ user_id: userId, meal_id: aiSlot.mealId, event_type: "meal_swapped_away", signal_strength: -0.5, replaced_with: slot.mealId, slot_date: slot.date, meal_time: slot.mealTime, auto_generated: true, source: "plan_edit" });
        }
      });
      if (implicitEvents.length > 0) {
        supabase.from("meal_feedback").insert(implicitEvents).then(() => {}).catch(err => console.error("Implicit feedback error:", err));
      }
    }

    // ── Meal events + Thompson feedback ──
    // On re-finalize, only record feedback for slots whose mealId changed,
    // so preferences don't get counted multiple times.
    const slotsArray = Object.values(plan);
    const savedSlots = isRefinalize ? history[existingIdx].plan : {};
    const newlyCookedSlots = slotsArray.filter(slot => {
      if (!slot.mealId) return false;
      if (slot.prepType === "Skip" || slot.prepType === "Eat Out") return false;
      if (slot.isLeftover) return false;
      const k = `${slot.date}_${slot.mealTime}`;
      const prev = savedSlots[k];
      // First-time finalize: record everything. Re-finalize: only new/changed meals.
      return !isRefinalize || !prev || prev.mealId !== slot.mealId;
    });

    recordWeekAccepted(supabase, userId, newlyCookedSlots, true);

    newlyCookedSlots.forEach(slot => {
      if (thompsonSampler) {
        thompsonSampler.recordFeedback(slot.mealId, 'cooked');
        thompsonSampler.markServed(slot.mealId, slot.date);
      }
    });

    if (thompsonSampler) thompsonSampler.saveToSupabase(supabase, userId);

    // ── Save to history ──
    // On re-finalize: REPLACE the existing entry. On first finalize: APPEND.
    if (isRefinalize) {
      setHistory(h => h.map((entry, i) => i === existingIdx
        ? { ...entry, date: new Date().toISOString(), plan: {...plan}, familySize }
        : entry));
    } else {
      setHistory(h => [...h, { date: new Date().toISOString(), plan: {...plan}, familySize }]);
    }
    setFinalized(true);
    // Auto-show print offer
    setTimeout(() => setShowPrintView(true), 500);
  };

  // ── Reset Meal Plan ONLY — keep freezer, pantry, history, custom meals, rules ──
  // Clears: plan slots, day modes, grocery checkboxes, finalized flag.
  // Preserves: freezerMeals, pantryItems, history, customMeals, rules, patterns.
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  // 30-second undo snapshot so an accidental reset is recoverable.
  const [undoSnapshot, setUndoSnapshot] = useState(null);
  const totalReset = () => {
    const snap = {
      plan: JSON.parse(JSON.stringify(plan)),
      dayModes: JSON.parse(JSON.stringify(dayModes)),
      groceryChecked: JSON.parse(JSON.stringify(groceryChecked)),
      finalized,
      takenAt: Date.now(),
    };
    setUndoSnapshot(snap);
    setTimeout(() => setUndoSnapshot(s => (s && s.takenAt === snap.takenAt) ? null : s), 30000);

    setPlan(p => {
      const fresh = {};
      Object.keys(p).forEach(k => {
        const old = p[k];
        fresh[k] = { date:old.date, mealTime:old.mealTime, prepType:"Auto", mealId:"", bulkCount:4, sideType:"", side:"", side2Type:"", side2:"", side3Type:"", side3:"", notes:"", reason:"", lockedType:false, lockedMeal:false, eatOutType:"", makeSalsa:false, makeCurtido:false, proteinAdd:"", isLeftover:false, customItems:[] };
      });
      return fresh;
    });
    setDayModes(defaultDayModes());
    setGroceryChecked({});
    setFinalized(false);
    setShowResetConfirm(false);
  };

  const undoReset = () => {
    if (!undoSnapshot) return;
    setPlan(undoSnapshot.plan);
    setDayModes(undoSnapshot.dayModes);
    setGroceryChecked(undoSnapshot.groceryChecked);
    setFinalized(undoSnapshot.finalized);
    setUndoSnapshot(null);
  };

  // ── Reset single slot back to Auto ──
  const resetSlotToAuto = (key) => {
    setPlan(p => {
      const old = p[key];
      if (!old) return p;
      // Also reset the Cook vs Easy day mode for this slot back to "Any"
      const slotDate = new Date(old.date + "T00:00:00");
      const dayName = DAYS[slotDate.getDay()];
      updateDayMode(dayName, old.mealTime, "Any");
      return { ...p, [key]: { date:old.date, mealTime:old.mealTime, prepType:"Auto", mealId:"", bulkCount:4, sideType:"", side:"", side2Type:"", side2:"", side3Type:"", side3:"", notes:"", reason:"", lockedType:false, lockedMeal:false, eatOutType:"", makeSalsa:false, makeCurtido:false, proteinAdd:"", isLeftover:false, customItems:[] } };
    });
  };

  // ── Print / PDF Export ─────────────────────
  const [printMode, setPrintMode] = useState("both"); // "plan" | "grocery" | "both" | "fridge"
  const handlePrint = (mode = "both") => {
    setPrintMode(mode);
    // ── Auto-fit the meal-plan page to ONE full sheet ──
    // Each row in the table wraps to 2–4 visual lines depending on:
    //   prep type label, meal name, sides (0–3), notes (if present),
    //   custom grocery items. Notes were missing before, so the previous
    //   estimator under-budgeted and the LAST day got clipped off the page
    //   by the section's overflow:hidden.
    //
    // Solve for a font size whose total vertical consumption fits the
    // printable area, with a real margin so a single oversized cell can't
    // push the bottom row off the page.
    const totalDays = weeks * 7;

    // Inspect the actual plan to estimate how many lines each row will need.
    // Base = 1 (meal name). Add lines for prep label, each side, notes,
    // custom items. Take the max across all days so the worst cell sets
    // the floor (otherwise a heavy day at the bottom gets clipped).
    let maxLinesPerCell = 2;
    const sd0 = new Date(startDate + "T00:00:00");
    for (let i = 0; i < totalDays; i++) {
      const day = addDays(sd0, i);
      const dateKey = day.toISOString().slice(0, 10);
      for (const mt of MEAL_TIMES) {
        const slot = plan[`${dateKey}_${mt}`];
        if (!slot) continue;
        let lines = 1;                          // prep label
        if (slot.mealId) lines += 1;            // meal name line
        if (slot.side) lines += 1;
        if (slot.side2) lines += 1;
        if (slot.side3) lines += 1;
        if (slot.notes && slot.notes.trim()) {
          // 1 line per ~32 chars (column is narrow on portrait)
          lines += Math.max(1, Math.ceil(slot.notes.length / 32));
        }
        if (Array.isArray(slot.customItems) && slot.customItems.length > 0) {
          lines += 1;
        }
        if (lines > maxLinesPerCell) maxLinesPerCell = lines;
      }
    }
    const linesPerRow = Math.max(2.5, Math.min(6, maxLinesPerCell));

    const headerRows  = 1;
    const lineHeight  = 1.22;
    const padVh       = 1.0;
    // Reserve more vertical space for header + safety margin so the last
    // row never gets clipped by overflow:hidden on the section.
    const usableVh    = 84;
    const rows        = totalDays + headerRows;
    const fontVh = Math.max(1.0, Math.min(2.6,
      (usableVh / rows - padVh) / (lineHeight * linesPerRow)
    ));
    const headerVh = Math.min(2.8, fontVh * 1.15);
    // Force every body row to take an equal slice of the table height so
    // a heavy row can't squeeze the others off the page.
    const rowVh = (usableVh - padVh) / rows;
    document.documentElement.style.setProperty("--print-font", `${fontVh.toFixed(2)}vh`);
    document.documentElement.style.setProperty("--print-font-header", `${headerVh.toFixed(2)}vh`);
    document.documentElement.style.setProperty("--print-row-vh", `${rowVh.toFixed(2)}vh`);
    // Give React a frame to update printMode, then print
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.print();
      });
    });
  };

  // ── Recipe Text Parser ─────────────────────
  const parseRecipeText = () => {
    if (!recipeText.trim()) return;
    const lines = recipeText.split("\n").map(l => l.trim()).filter(l => l);
    let name = lines[0] || "New Recipe";
    let ingredients = [];
    let notes = "";
    let inIngredients = false;
    // Track whether we've seen an explicit "Ingredients:" header. If we
    // never see one, treat every line after the title as a candidate
    // ingredient — so a bare list with no header still works.
    let sawHeader = false;

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i];
      const lower = line.toLowerCase();
      if (lower.includes("ingredient") || lower.includes("you'll need") || lower.includes("you will need")) {
        inIngredients = true; sawHeader = true; continue;
      }
      if (lower.includes("instruction") || lower.includes("direction") || lower.includes("method") || lower.startsWith("step ")) {
        inIngredients = false;
        notes += lines.slice(i).join("; ");
        break;
      }
      if (inIngredients || !sawHeader) {
        const parsed = parseIngredientLine(line);
        if (parsed) ingredients.push({ ...parsed, c: "Other" });
      }
    }

    // Auto-detect categories
    const catMap = {
      Produce: ["onion","garlic","tomato","pepper","carrot","celery","lettuce","zucchini","potato","lime","lemon","cilantro","parsley","banana","berry","avocado","corn","squash","eggplant","mushroom","jalapeno","chile"],
      Meat: ["beef","chicken","pork","turkey","lamb","sausage","ground","steak","roast","shrimp"],
      Dairy: ["milk","butter","cheese","cream","yogurt","egg","sour cream","feta"],
      Pantry: ["flour","sugar","oil","rice","pasta","oat","lentil","bean","broth","stock","vinegar","syrup","honey","vanilla"],
      Canned: ["tomato sauce","tomato paste","canned","san marzano","crushed tomato","diced tomato"],
      Spices: ["salt","pepper","cumin","paprika","oregano","cinnamon","thyme","cayenne","turmeric","chili powder"],
      Bakery: ["bread","bun","tortilla","muffin"],
      Frozen: ["frozen"],
    };
    ingredients.forEach(ing => {
      const lower = ing.n.toLowerCase();
      for (const [cat, keywords] of Object.entries(catMap)) {
        if (keywords.some(kw => lower.includes(kw))) { ing.c = cat; break; }
      }
    });

    if (scannerMode === "side") {
      // 6-digit timestamp-based ID matches the meal scanner. 5 digits had
      // a 1-in-100k collision risk on rapid scan/delete cycles.
      const newId = `CS${String(Date.now()).slice(-6)}`;
      setParsedRecipe({
        id: newId,
        name,
        cuisine: "Various",
        sideCat: "American",
        isSide: true,
        ingredients
      });
    } else {
      // Use timestamp-based ID like addNewMeal so deleting then re-scanning
      // can never collide with an existing meal's ID.
      const newId = `C${String(Date.now()).slice(-6)}`;
      setParsedRecipe({
        id: newId,
        name,
        time: ["Dinner","Lunch"],
        prep: "Bulk Cook",
        servings: 6,
        cook: "Unknown",
        cuisine: "Various",
        notes: notes.slice(0, 200) || "Scanned recipe",
        needsSide: false,
        ingredients
      });
    }
  };

  // All meal/side mutations go through customMeals state. A useEffect
  // (defined later) calls resyncCustomData() on every customMeals change so
  // MEALS_DATA / SIDES_DATA / INGREDIENTS_DATA always reflect state. No
  // direct mutations of those arrays anywhere outside resyncCustomData.

  const saveScannedRecipe = () => {
    if (!parsedRecipe) return;
    const ings = parsedRecipe.ingredients || [];
    const meal = { id:parsedRecipe.id, name:parsedRecipe.name, time:parsedRecipe.time, prep:parsedRecipe.prep, servings:parsedRecipe.servings, cook:parsedRecipe.cook, cuisine:parsedRecipe.cuisine, notes:parsedRecipe.notes, needsSide:parsedRecipe.needsSide, ingredients: ings };
    setCustomMeals(c => [...c, meal]);
    setParsedRecipe(null);
    setRecipeText("");
    setShowScanner(false);
  };

  const saveScannedSide = () => {
    if (!parsedRecipe) return;
    const ings = parsedRecipe.ingredients || [];
    const side = {
      id: parsedRecipe.id,
      name: parsedRecipe.name,
      cuisine: parsedRecipe.cuisine || "Various",
      cat: parsedRecipe.sideCat || "American",
      ingredients: ings,
      _isSide: true
    };
    setCustomMeals(c => [...c, side]);
    setParsedRecipe(null);
    setRecipeText("");
    setShowScanner(false);
  };

  // ── Meal Management Functions ─────────────
  const addNewMeal = (meal) => {
    const newId = `C${String(Date.now()).slice(-6)}`;
    const ings = meal.ingredients || [];
    const newMeal = { ...meal, id: newId, ingredients: ings };
    setCustomMeals(c => [...c, newMeal]);
    setShowAddForm(false);
    setEditingMeal(null);
  };

  const updateMeal = (updatedMeal) => {
    const ings = updatedMeal.ingredients || [];
    const mealToSave = { ...updatedMeal, ingredients: ings };
    setCustomMeals(c => {
      const ci = c.findIndex(m => m.id === mealToSave.id);
      if (ci !== -1) {
        const updated = [...c];
        updated[ci] = mealToSave;
        return updated;
      }
      // Editing a built-in meal: shadow it. The shadow gets a new id with
      // an "-edit" suffix so it doesn't collide with the original — the
      // built-in keeps its slot in MEALS_DATA, the shadow appears alongside.
      // Old behavior added the built-in's exact id to customMeals which
      // produced TWO entries with the same id and unstable lookups.
      const shadowId = String(mealToSave.id).startsWith("C") ? mealToSave.id : `${mealToSave.id}-edit`;
      return [...c, { ...mealToSave, id: shadowId, _shadowOf: mealToSave.id }];
    });
    setEditingMeal(null);
  };

  const removeMeal = (mealId) => {
    // Soft delete: mark with deletedAt so the user can restore.
    setCustomMeals(c => c.map(m => m.id === mealId ? { ...m, deletedAt: Date.now() } : m));
    setPlan(p => {
      const updated = { ...p };
      Object.keys(updated).forEach(k => {
        if (updated[k].mealId === mealId) {
          updated[k] = { ...updated[k], mealId: "", prepType: "Auto" };
        }
      });
      return updated;
    });
    setConfirmDeleteId(null);
  };

  // Restore a soft-deleted custom meal. Just clear deletedAt; the
  // resync useEffect re-registers it in MEALS_DATA / SIDES_DATA.
  const restoreMeal = (mealId) => {
    setCustomMeals(c => c.map(m => {
      if (m.id !== mealId) return m;
      const { deletedAt, ...rest } = m;
      return rest;
    }));
  };

  const purgeMeal = (mealId) => {
    setCustomMeals(c => c.filter(m => m.id !== mealId));
  };

  const startEditMeal = (meal) => {
    const existingIngs = INGREDIENTS_DATA[meal.id] || [];
    setEditingMeal({ ...meal, time: [...meal.time], ingredients: existingIngs.map(i => ({...i})) });
    setShowAddForm(false);
  };

  const startAddMeal = () => {
    setEditingMeal({
      id: "",
      name: "",
      time: ["Dinner"],
      prep: "Bulk Cook",
      servings: 6,
      cook: "",
      cuisine: "",
      notes: "",
      needsSide: false,
      ingredients: []
    });
    setShowAddForm(true);
  };

  // ── Side Management Functions ─────────────
  const addNewSide = (side) => {
    const newId = `CS${String(Date.now()).slice(-6)}`;
    const newSide = { id: newId, name: side.name, cuisine: side.cuisine || "Various", cat: side.cat || "American", ingredients: side.ingredients || [], _isSide: true };
    setCustomMeals(c => [...c, newSide]);
    setEditingSide(null);
    setShowAddSideForm(false);
  };

  const updateSide = (updatedSide) => {
    setCustomMeals(c => {
      const ci = c.findIndex(m => m.id === updatedSide.id);
      if (ci !== -1) { const updated = [...c]; updated[ci] = updatedSide; return updated; }
      return [...c, { ...updatedSide, _isSide: true }];
    });
    setEditingSide(null);
  };

  const removeSide = (sideId) => {
    // Soft-delete sides too, for symmetry with meals.
    setCustomMeals(c => c.map(m => m.id === sideId ? { ...m, deletedAt: Date.now() } : m));
    setConfirmDeleteSideId(null);
  };

  const startEditSide = (side) => {
    setEditingSide({ ...side, ingredients: (side.ingredients || []).map(i => ({...i})) });
    setShowAddSideForm(false);
  };

  const startAddSide = () => {
    setEditingSide({ id: "", name: "", cuisine: "", cat: "American", ingredients: [], _isSide: true });
    setShowAddSideForm(true);
  };

  // ── Paste-to-parse ingredient helper ────────
  const [showIngredientPaste, setShowIngredientPaste] = useState(false);
  const [ingredientPasteText, setIngredientPasteText] = useState("");

  const KNOWN_UNITS = {"cups":"cups","cup":"cup","c":"cup","tbsp":"tbsp","tablespoon":"tbsp","tablespoons":"tbsp","tsp":"tsp","teaspoon":"tsp","teaspoons":"tsp","lbs":"lbs","lb":"lb","pound":"lbs","pounds":"lbs","oz":"oz","ounce":"oz","ounces":"oz","g":"g","gram":"g","grams":"g","slices":"slices","slice":"slices","pack":"pack","packs":"pack","package":"pack","packages":"pack","bottle":"bottle","bottles":"bottle","jar":"jar","jars":"jar","can":"can","cans":"can","bunch":"bunch","bunches":"bunch","head":"head","heads":"head","clove":"cloves","cloves":"cloves","pinch":"pinch","each":"each","large":"each","medium":"each","small":"each","whole":"each"};

  const CATEGORY_HINTS = {chicken:"Meat",beef:"Meat",pork:"Meat",steak:"Meat",sausage:"Meat",bacon:"Meat",turkey:"Meat",shrimp:"Meat",fish:"Meat",salmon:"Meat",ground:"Meat",ham:"Meat",lamb:"Meat",meat:"Meat",
    butter:"Dairy",milk:"Dairy",cream:"Dairy",cheese:"Dairy",yogurt:"Dairy",egg:"Dairy",eggs:"Dairy",sour:"Dairy",buttermilk:"Dairy",
    onion:"Produce",garlic:"Produce",tomato:"Produce",lettuce:"Produce",pepper:"Produce",carrot:"Produce",potato:"Produce",celery:"Produce",lime:"Produce",lemon:"Produce",avocado:"Produce",cilantro:"Produce",jalapeño:"Produce",jalapeno:"Produce",spinach:"Produce",broccoli:"Produce",mushroom:"Produce",corn:"Produce",bean:"Produce",zucchini:"Produce",cucumber:"Produce",ginger:"Produce",banana:"Produce",apple:"Produce",berries:"Produce",strawberr:"Produce",blueberr:"Produce",
    salt:"Spices",pepper:"Spices",cumin:"Spices",paprika:"Spices",oregano:"Spices",cinnamon:"Spices",chili:"Spices",nutmeg:"Spices",thyme:"Spices",basil:"Spices",cayenne:"Spices",turmeric:"Spices",
    bread:"Bakery",bun:"Bakery",tortilla:"Bakery",roll:"Bakery",pita:"Bakery",
    ketchup:"Condiments",mustard:"Condiments",mayo:"Condiments",sauce:"Condiments",vinegar:"Condiments",relish:"Condiments",sriracha:"Condiments",
    flour:"Pantry",sugar:"Pantry",rice:"Pantry",pasta:"Pantry",oil:"Pantry",broth:"Pantry",stock:"Pantry",noodle:"Pantry",oats:"Pantry",honey:"Pantry",syrup:"Pantry",vanilla:"Pantry",baking:"Pantry",cocoa:"Pantry",soy:"Pantry"};

  const guessCategory = (name) => {
    const lower = name.toLowerCase();
    for (const [hint, cat] of Object.entries(CATEGORY_HINTS)) {
      if (lower.includes(hint)) return cat;
    }
    return "Pantry";
  };

  const parseIngredientLines = (text) => {
    const lines = text.split(/\n/).map(l => l.trim()).filter(l => l.length > 0);
    return lines.map(line => {
      // Remove leading bullet/dash/number
      let cleaned = line.replace(/^[-•*]\s*/, "").replace(/^\d+\.\s*/, "").trim();
      // Try pattern: "2 cups flour" or "1/2 tsp salt" or "3 large eggs"
      const match = cleaned.match(/^([\d./½¼¾⅓⅔⅛]+)\s*([\w]+)?\s+(.+)$/);
      if (match) {
        let qStr = match[1].replace("½",".5").replace("¼",".25").replace("¾",".75").replace("⅓",".33").replace("⅔",".67").replace("⅛",".125");
        if (qStr.includes("/")) { const [a,b]=qStr.split("/"); qStr = String(parseFloat(a)/parseFloat(b)); }
        const q = parseFloat(qStr) || 1;
        const rawUnit = (match[2] || "").toLowerCase();
        const u = KNOWN_UNITS[rawUnit] || "each";
        let n = match[3].trim();
        // If unit wasn't recognized, it's probably part of the name
        if (!KNOWN_UNITS[rawUnit] && rawUnit) n = rawUnit + " " + n;
        return { n, q, u, c: guessCategory(n) };
      }
      // No quantity match — just treat the whole line as a name
      return { n: cleaned, q: 1, u: "each", c: guessCategory(cleaned) };
    });
  };

  // ── Normalize ingredient names for smarter grocery dedup ──
  const normalizeIngredient = (name) => {
    let n = name.toLowerCase().trim();
    // Plural normalization
    const plurals = {
      'tomatoes': 'tomato', 'potatoes': 'potato', 'onions': 'onion',
      'peppers': 'pepper', 'carrots': 'carrot', 'eggs': 'egg',
      'lemons': 'lemon', 'limes': 'lime', 'avocados': 'avocado',
      'cloves garlic': 'garlic', 'garlic cloves': 'garlic',
      'chicken breasts': 'chicken breast', 'chicken thighs': 'chicken thigh'
    };
    if (plurals[n]) n = plurals[n];
    // Common brand/variant normalization
    n = n.replace(/fresh |organic |large |medium |small |whole |diced |chopped |minced |sliced /g, '');
    return n;
  };

  // ── Generate grocery list (per-week) ──────────────────
  const weeklyGroceryLists = useMemo(() => {
    if (!finalized) return [];
    const scale = familySize / 6;
    const sd = new Date(startDate + "T00:00:00");

    const processSlots = (slots) => {
      const items = {};
      const addItem = (name, qty, unit, category, tag="") => {
        const normalized = normalizeIngredient(name);
        const key = `${normalized}__${unit}`;
        if (!items[key]) items[key] = { name: name, qty: 0, unit, category, tag };
        items[key].qty += qty;
      };
      slots.forEach(slot => {
        if (slot.prepType === "Eat Out" && slot.eatOutType === "Pupusas") {
          if (slot.makeSalsa) {
            const salsa = SIDES_DATA.find(s => s.id === "S007");
            if (salsa) salsa.ingredients.forEach(i => addItem(i.n, i.q * scale, i.u, i.c, "(salsa for pupusas)"));
          }
          if (slot.makeCurtido) {
            CURTIDO_DATA.ingredients.forEach(i => addItem(i.n, i.q * scale, i.u, i.c, "(curtido for pupusas)"));
          }
        }
        if (["Leftover Day","Eat Out","Skip","Defrost"].includes(slot.prepType)) return;
        if (slot.isLeftover) return;
        // Main-meal scaling: recipes already list total ingredients for a batch
        // of `servings` servings. We need (familySize * bulkCount) servings for
        // Bulk Cook slots, and (familySize) servings for single-eat slots.
        // Scale factor buys exactly the right number of batches. Minimum 1 batch.
        const mealData = slot.mealId ? MEALS_DATA.find(m => m.id === slot.mealId) : null;
        const recipeServings = mealData?.servings || 12;
        const meals = slot.prepType === "Bulk Cook" ? Math.max(1, slot.bulkCount || 1) : 1;
        const mealScale = Math.max(1, (familySize * meals) / recipeServings);
        // Sides are made fresh each time, sized per family — not multiplied by bulkCount
        if (slot.mealId) {
          const ings = INGREDIENTS_DATA[slot.mealId];
          if (ings) ings.forEach(i => addItem(i.n, i.q * mealScale, i.u, i.c));
        }
        if (slot.side) { const side = SIDES_DATA.find(s => s.id === slot.side); if (side) side.ingredients.forEach(i => addItem(i.n, i.q * scale, i.u, i.c, "(side)")); }
        if (slot.side2) { const side2 = SIDES_DATA.find(s => s.id === slot.side2); if (side2) side2.ingredients.forEach(i => addItem(i.n, i.q * scale, i.u, i.c, "(side 2)")); }
        if (slot.side3) { const side3 = SIDES_DATA.find(s => s.id === slot.side3); if (side3) side3.ingredients.forEach(i => addItem(i.n, i.q * scale, i.u, i.c, "(side 3)")); }
        if (slot.proteinAdd && slot.mealId && PROTEIN_OPTIONS[slot.mealId]) {
          const protein = PROTEIN_OPTIONS[slot.mealId].find(p => p.id === slot.proteinAdd);
          if (protein) protein.ingredients.forEach(i => addItem(i.n, i.q * mealScale, i.u, i.c, "(protein)"));
        }
        // Add custom items from the slot
        if (slot.customItems && slot.customItems.length > 0) {
          slot.customItems.forEach(itemName => {
            addItem(itemName, 1, "item", "Special Items", "(custom)");
          });
        }
      });
      // Subtract pantry items (split evenly across weeks, or all from week 1)
      return items;
    };

    // Split slots by week
    const weekSlots = [];
    for (let w = 0; w < weeks; w++) {
      const weekStart = addDays(sd, w * 7);
      const weekEnd = addDays(sd, (w + 1) * 7);
      const slots = Object.values(plan).filter(slot => {
        const d = new Date(slot.date + "T00:00:00");
        return d >= weekStart && d < weekEnd;
      });
      weekSlots.push(slots);
    }

    // Generate grocery list per week, with pantry projection that carries
    // over across weeks. Previously week 2+ saw a fresh pantry of zero
    // because the deduction only ran on week 0 — leading to over-buy when
    // pantry surplus would have actually covered week 2 demand.
    const projectedPantry = {};
    pantryItems.forEach(pi => {
      const key = `${pi.name}__${normalizeUnit(pi.unit)}`;
      projectedPantry[key] = (projectedPantry[key] || 0) + pi.qty;
    });
    const result = weekSlots.map((slots) => {
      const items = processSlots(slots);
      // Apply projected pantry to THIS week's needs, then subtract what we
      // used so the remainder carries over to week 2+.
      Object.keys(items).forEach(key => {
        const normKey = (() => {
          const idx = key.lastIndexOf("__");
          if (idx < 0) return key;
          return key.slice(0, idx) + "__" + normalizeUnit(key.slice(idx + 2));
        })();
        const onHand = projectedPantry[normKey] || 0;
        if (onHand > 0) {
          const used = Math.min(onHand, items[key].qty);
          items[key].onHand = onHand;
          items[key].qty = items[key].qty - used;
          projectedPantry[normKey] = onHand - used;
        }
      });
      const grouped = {};
      Object.values(items).forEach(item => {
        const cat = item.category || "Other";
        if (!grouped[cat]) grouped[cat] = [];
        grouped[cat].push(item);
      });
      return grouped;
    });

    return result;
  }, [finalized, plan, familySize, pantryItems, weeks, startDate]);

  // Combined grocery list (for backward compat — merges all weeks)
  const groceryList = useMemo(() => {
    if (weeklyGroceryLists.length === 0) return {};
    if (weeklyGroceryLists.length === 1) return weeklyGroceryLists[0];
    // Merge all weeks
    const merged = {};
    weeklyGroceryLists.forEach(weekList => {
      Object.entries(weekList).forEach(([cat, items]) => {
        if (!merged[cat]) merged[cat] = [];
        items.forEach(item => {
          const existing = merged[cat].find(i => i.name === item.name && i.unit === item.unit);
          if (existing) { existing.qty += item.qty; }
          else { merged[cat].push({...item}); }
        });
      });
    });
    return merged;
  }, [weeklyGroceryLists]);

  // ── Detected patterns from history ─────────
  const patterns = useMemo(() => {
    if (history.length < 2) return [];
    const total = history.length;
    const results = [];

    // 1) Day/MealTime/PrepType patterns (existing)
    const dayCounts = {};
    history.forEach(h => {
      Object.values(h.plan).forEach(slot => {
        const d = new Date(slot.date + "T00:00:00");
        const dayName = DAYS[d.getDay()];
        const key = `${dayName}_${slot.mealTime}_${slot.prepType}`;
        dayCounts[key] = (dayCounts[key] || 0) + 1;
      });
    });
    Object.entries(dayCounts).forEach(([k,v]) => {
      const conf = Math.round(v/total*100);
      if (conf >= 50) results.push({ id:`day_${k}`, kind:"day_type", pattern:k, count:v, confidence:conf });
    });

    // 2) Meal frequency patterns — "You pick X about N times per plan"
    const mealFreq = {};
    history.forEach(h => {
      const planMeals = {};
      Object.values(h.plan).forEach(slot => {
        if (slot.mealId) {
          const fk = `${slot.mealId}_${slot.mealTime}`;
          planMeals[fk] = (planMeals[fk] || 0) + 1;
        }
      });
      Object.entries(planMeals).forEach(([fk, cnt]) => {
        if (!mealFreq[fk]) mealFreq[fk] = [];
        mealFreq[fk].push(cnt);
      });
    });
    Object.entries(mealFreq).forEach(([fk, counts]) => {
      if (counts.length < Math.ceil(total * 0.5)) return; // must appear in at least half the plans
      const [mealId, mt] = fk.split("_");
      const avg = Math.round(counts.reduce((a,b)=>a+b,0) / counts.length * 10) / 10;
      if (avg >= 1.5) {
        const meal = MEALS_DATA.find(m => m.id === mealId);
        if (meal) results.push({ id:`freq_${fk}`, kind:"meal_freq", mealId, mealTime:mt, mealName:meal.name, avgPerPlan:avg, confidence:Math.round(counts.length/total*100) });
      }
    });

    // 3) Side pairing patterns — "When you pick meal X, you usually pair side Y"
    const pairCounts = {}; // key: mealId, value: { sideId: count }
    const mealCounts = {};
    history.forEach(h => {
      Object.values(h.plan).forEach(slot => {
        if (slot.mealId && slot.side) {
          mealCounts[slot.mealId] = (mealCounts[slot.mealId] || 0) + 1;
          const pk = `${slot.mealId}__${slot.side}`;
          pairCounts[pk] = (pairCounts[pk] || 0) + 1;
        }
        if (slot.mealId && slot.side2) {
          const pk2 = `${slot.mealId}__${slot.side2}`;
          pairCounts[pk2] = (pairCounts[pk2] || 0) + 1;
        }
        if (slot.mealId && slot.side3) {
          const pk3 = `${slot.mealId}__${slot.side3}`;
          pairCounts[pk3] = (pairCounts[pk3] || 0) + 1;
        }
      });
    });
    Object.entries(pairCounts).forEach(([pk, cnt]) => {
      const [mealId, sideId] = pk.split("__");
      const mTotal = mealCounts[mealId] || 1;
      const conf = Math.round(cnt / mTotal * 100);
      if (conf >= 50 && cnt >= 2) {
        const meal = MEALS_DATA.find(m => m.id === mealId);
        const side = SIDES_DATA.find(s => s.id === sideId);
        if (meal && side) results.push({ id:`pair_${pk}`, kind:"side_pair", mealId, sideId, mealName:meal.name, sideName:side.name, count:cnt, confidence:conf });
      }
    });

    // 4) Serving style patterns — "You usually serve Birria as Tacos"
    const styleCounts = {};
    const styleTotal = {};
    history.forEach(h => {
      Object.values(h.plan).forEach(slot => {
        if (slot.mealId && slot.servingStyle) {
          const sk = `${slot.mealId}_${slot.servingStyle}`;
          styleCounts[sk] = (styleCounts[sk] || 0) + 1;
          styleTotal[slot.mealId] = (styleTotal[slot.mealId] || 0) + 1;
        }
      });
    });
    Object.entries(styleCounts).forEach(([sk, cnt]) => {
      const [mealId, style] = sk.split("_");
      const mTotal = styleTotal[mealId] || 1;
      const conf = Math.round(cnt / mTotal * 100);
      if (conf >= 50 && cnt >= 2) {
        const meal = MEALS_DATA.find(m => m.id === mealId);
        if (meal) results.push({ id:`style_${sk}`, kind:"serving_style", mealId, style, mealName:meal.name, count:cnt, confidence:conf });
      }
    });

    // 5) Day+MealTime+Specific Meal patterns — "You usually pick Eggs on Mon Breakfast"
    const dayMealCounts = {}; // key: "Mon_Breakfast_B005" => count
    const dayMealTimeTotal = {}; // key: "Mon_Breakfast" => total
    history.forEach(h => {
      Object.values(h.plan).forEach(slot => {
        if (!slot.mealId) return;
        const d = new Date(slot.date + "T00:00:00");
        const dayName = DAYS[d.getDay()];
        const dmKey = `${dayName}_${slot.mealTime}`;
        dayMealTimeTotal[dmKey] = (dayMealTimeTotal[dmKey] || 0) + 1;
        const dmmKey = `${dmKey}_${slot.mealId}`;
        dayMealCounts[dmmKey] = (dayMealCounts[dmmKey] || 0) + 1;
      });
    });
    Object.entries(dayMealCounts).forEach(([dmmKey, cnt]) => {
      const parts = dmmKey.split("_");
      const mealId = parts[2];
      const dmKey = `${parts[0]}_${parts[1]}`;
      const dmTotal = dayMealTimeTotal[dmKey] || 1;
      const conf = Math.round(cnt / dmTotal * 100);
      if (conf >= 40 && cnt >= 2) {
        const meal = MEALS_DATA.find(m => m.id === mealId);
        if (meal) results.push({ id:`daymeal_${dmmKey}`, kind:"day_meal_pref", day:parts[0], mealTime:parts[1], mealId, mealName:meal.name, count:cnt, confidence:conf });
      }
    });

    return results
      .filter(p => !dismissedPatterns.includes(p.id))
      .sort((a,b) => b.confidence - a.confidence);
  }, [history, dismissedPatterns]);

  // ═══════════════════════════════════════════
  //  RENDER
  // ═══════════════════════════════════════════
  const tabStyle = (t) => ({
    padding:"10px 16px", cursor:"pointer", fontWeight:tab===t?"700":"400",
    borderBottom:tab===t?"3px solid #2d6a4f":"3px solid transparent",
    color:tab===t?"#2d6a4f":"#555", background:"none", border:"none",
    fontSize:"14px", whiteSpace:"nowrap"
  });

  // ── Loading screen while data loads from cloud ──
  if (!dataLoaded) {
    return (
      <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100vh",background:"#faf9f6",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
        <div style={{textAlign:"center"}}>
          <div style={{fontSize:"36px",marginBottom:"12px"}}>🍽️</div>
          <div style={{color:"#2d6a4f",fontWeight:"600",fontSize:"16px",marginBottom:"8px"}}>Loading your meal plans...</div>
          <div style={{color:"#999",fontSize:"13px"}}>Syncing from cloud</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{fontFamily:"'Segoe UI',system-ui,sans-serif", background:"#faf9f6", minHeight:"100vh", color:"#1a1a1a"}}>
    <div id="app-content">
      {/* ── NAV BAR ─────────────────────────── */}
      <div style={{background:"#2d6a4f", color:"white", padding:"12px 20px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:"8px"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
          <span style={{fontSize:"20px",fontWeight:"700"}}>Rogers Family Meals</span>
          <span style={{fontSize:"10px",opacity:0.7,padding:"2px 8px",background:"rgba(255,255,255,0.15)",borderRadius:"8px"}}>
            {syncStatus === "saving" ? "Syncing..." : syncStatus === "saved" ? "Synced" : syncStatus === "error" ? "Sync error" : "..."}
          </span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
          <label style={{fontSize:"13px"}}>Family Size:</label>
          <select value={familySize} onChange={e=>setFamilySize(+e.target.value)}
            style={{padding:"4px 8px",borderRadius:"6px",border:"none",fontSize:"14px"}}>
            {[2,3,4,5,6,7,8,9,10].map(n=><option key={n} value={n}>{n}</option>)}
          </select>
          <span style={{fontSize:"11px",opacity:0.7}}>{userEmail}</span>
          <button onClick={onSignOut} style={{padding:"4px 12px",background:"rgba(255,255,255,0.2)",color:"white",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",fontSize:"12px",cursor:"pointer"}}>
            Sign Out
          </button>
        </div>
      </div>

      {/* ── TAB BAR ─────────────────────────── */}
      <div style={{display:"flex", borderBottom:"1px solid #ddd", background:"white", overflowX:"auto", padding:"0 12px"}}>
        {[["database","Meal Database"],["planner","Plan Meals"],["rhythms","Rhythms"],["pantry","Pantry"],["grocery","Grocery List"],["ai","\u2728 AI Assistant"]].map(([k,l])=>
          <button key={k} onClick={()=>setTab(k)} style={tabStyle(k)}>{l}</button>
        )}
      </div>

      <div style={{padding:"16px 20px", maxWidth:"1200px", margin:"0 auto"}}>

        {/* ════════════════════════════════════ */}
        {/*  TAB: MEAL DATABASE                 */}
        {/* ════════════════════════════════════ */}
        {tab === "database" && (
          <div>
            <div style={{display:"flex",gap:"10px",marginBottom:"16px",flexWrap:"wrap",alignItems:"center"}}>
              <input value={dbSearch} onChange={e=>setDbSearch(e.target.value)} placeholder="Search meals..."
                style={{padding:"8px 12px",border:"1px solid #ccc",borderRadius:"8px",flex:"1",minWidth:"200px",fontSize:"14px"}} />
              <select value={dbFilter} onChange={e=>setDbFilter(e.target.value)} style={{padding:"8px 12px",borderRadius:"8px",border:"1px solid #ccc",fontSize:"14px"}}>
                <option value="All">All Types</option>
                {Object.keys(PREP_TYPES).map(t=><option key={t} value={t}>{t}</option>)}
              </select>
              <button onClick={startAddMeal}
                style={{padding:"8px 16px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                + Add Meal
              </button>
            </div>

            {/* ── Add / Edit Meal Form ──────────── */}
            {editingMeal && (showAddForm || !showAddForm) && (
              <div style={{background:"white",borderRadius:"12px",padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,0.12)",marginBottom:"20px",border:"2px solid #2d6a4f"}}>
                <h4 style={{color:"#2d6a4f",margin:"0 0 14px 0",fontSize:"16px"}}>{showAddForm ? "Add New Meal" : `Edit: ${editingMeal.name}`}</h4>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px",marginBottom:"12px"}}>
                  <label style={{fontSize:"13px",fontWeight:"500"}}>
                    Meal Name *
                    <input value={editingMeal.name} onChange={e=>setEditingMeal(m=>({...m,name:e.target.value}))}
                      placeholder="e.g. Chicken Alfredo"
                      style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px",boxSizing:"border-box"}} />
                  </label>
                  <label style={{fontSize:"13px",fontWeight:"500"}}>
                    Cook Time
                    <input value={editingMeal.cook} onChange={e=>setEditingMeal(m=>({...m,cook:e.target.value}))}
                      placeholder="e.g. 45 min"
                      style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px",boxSizing:"border-box"}} />
                  </label>
                  <label style={{fontSize:"13px",fontWeight:"500"}}>
                    Cuisine
                    <input value={editingMeal.cuisine} onChange={e=>setEditingMeal(m=>({...m,cuisine:e.target.value}))}
                      placeholder="e.g. Italian, Mexican"
                      style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px",boxSizing:"border-box"}} />
                  </label>
                  <label style={{fontSize:"13px",fontWeight:"500"}}>
                    Servings
                    <input type="number" value={editingMeal.servings} onChange={e=>setEditingMeal(m=>({...m,servings:+e.target.value}))}
                      style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px",boxSizing:"border-box"}} />
                  </label>
                  <label style={{fontSize:"13px",fontWeight:"500"}}>
                    Prep Type
                    <select value={editingMeal.prep} onChange={e=>setEditingMeal(m=>({...m,prep:e.target.value}))}
                      style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px"}}>
                      {Object.keys(PREP_TYPES).filter(t=>!["Leftover Day","Eat Out","Skip","Defrost"].includes(t)).map(t=>
                        <option key={t} value={t}>{t}</option>
                      )}
                    </select>
                  </label>
                  <label style={{fontSize:"13px",fontWeight:"500"}}>
                    Meal Times
                    <select value={editingMeal.time.join(",")} onChange={e=>setEditingMeal(m=>({...m,time:e.target.value.split(",")}))}
                      style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px"}}>
                      <option value="Breakfast">Breakfast</option>
                      <option value="Lunch">Lunch</option>
                      <option value="Dinner">Dinner</option>
                      <option value="Dinner,Lunch">Dinner & Lunch</option>
                      <option value="Breakfast,Lunch">Breakfast & Lunch</option>
                      <option value="Breakfast,Dinner">Breakfast & Dinner</option>
                    </select>
                  </label>
                </div>
                <label style={{fontSize:"13px",fontWeight:"500",display:"block",marginBottom:"10px"}}>
                  Notes
                  <textarea value={editingMeal.notes||""} onChange={e=>setEditingMeal(m=>({...m,notes:e.target.value}))}
                    placeholder="Recipe notes, tips, variations..."
                    style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px",boxSizing:"border-box",minHeight:"60px",resize:"vertical"}} />
                </label>
                {/* ── Ingredient Editor ──────────── */}
                <div style={{marginBottom:"14px",border:"1px solid #d1d5db",borderRadius:"8px",padding:"12px",background:"#f9fafb"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px",flexWrap:"wrap",gap:"6px"}}>
                    <span style={{fontSize:"13px",fontWeight:"600",color:"#2d6a4f"}}>Ingredients (for grocery list)</span>
                    <div style={{display:"flex",gap:"6px"}}>
                      <button onClick={()=>setShowIngredientPaste(v=>!v)}
                        style={{padding:"4px 10px",background:showIngredientPaste?"#dc2626":"#1e40af",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer",fontWeight:"600"}}>
                        {showIngredientPaste ? "Cancel Paste" : "Paste List"}
                      </button>
                      <button onClick={()=>setEditingMeal(m=>({...m,ingredients:[...(m.ingredients||[]),{n:"",q:1,u:"each",c:"Produce"}]}))}
                        style={{padding:"4px 10px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer",fontWeight:"600"}}>
                        + Add One
                      </button>
                    </div>
                  </div>
                  {showIngredientPaste && (
                    <div style={{marginBottom:"10px",background:"#eff6ff",border:"1px solid #93c5fd",borderRadius:"8px",padding:"10px"}}>
                      <p style={{fontSize:"11px",color:"#1e40af",margin:"0 0 6px 0"}}>Paste your ingredient list (one per line). Formats like "2 cups flour", "1 lb chicken", or just "garlic" all work.</p>
                      <textarea value={ingredientPasteText} onChange={e=>setIngredientPasteText(e.target.value)}
                        placeholder={"2 cups flour\n1 lb chicken breast\n3 cloves garlic\n1 can black beans\nSalt and pepper to taste"}
                        style={{width:"100%",padding:"8px",borderRadius:"6px",border:"1px solid #93c5fd",fontSize:"12px",minHeight:"80px",resize:"vertical",boxSizing:"border-box",fontFamily:"monospace"}} />
                      <button onClick={()=>{
                        if (!ingredientPasteText.trim()) return;
                        const parsed = parseIngredientLines(ingredientPasteText);
                        setEditingMeal(m=>({...m, ingredients:[...(m.ingredients||[]), ...parsed]}));
                        setIngredientPasteText("");
                        setShowIngredientPaste(false);
                      }} style={{marginTop:"6px",padding:"6px 16px",background:"#1e40af",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer",fontWeight:"600"}}>
                        Parse & Add Ingredients
                      </button>
                    </div>
                  )}
                  {(editingMeal.ingredients||[]).length === 0 && !showIngredientPaste && (
                    <p style={{fontSize:"12px",color:"#888",margin:"4px 0",fontStyle:"italic"}}>No ingredients yet. Add ingredients so they appear on your grocery list.</p>
                  )}
                  {(editingMeal.ingredients||[]).map((ing, idx) => (
                    <div key={idx} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr auto",gap:"6px",marginBottom:"6px",alignItems:"center"}}>
                      <input value={ing.n} placeholder="Name" onChange={e=>{
                        const updated = [...editingMeal.ingredients];
                        updated[idx] = {...updated[idx], n: e.target.value};
                        setEditingMeal(m=>({...m, ingredients: updated}));
                      }} style={{padding:"5px 8px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px"}} />
                      <input type="number" value={ing.q} step="0.25" min="0" onChange={e=>{
                        const updated = [...editingMeal.ingredients];
                        updated[idx] = {...updated[idx], q: +e.target.value};
                        setEditingMeal(m=>({...m, ingredients: updated}));
                      }} style={{padding:"5px 8px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px",width:"100%",boxSizing:"border-box"}} />
                      <select value={ing.u} onChange={e=>{
                        const updated = [...editingMeal.ingredients];
                        updated[idx] = {...updated[idx], u: e.target.value};
                        setEditingMeal(m=>({...m, ingredients: updated}));
                      }} style={{padding:"5px 4px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px"}}>
                        {["each","cups","cup","tbsp","tsp","lbs","lb","oz","g","slices","pack","bottle","jar","can","bunch","head","cloves","pinch"].map(u=>
                          <option key={u} value={u}>{u}</option>
                        )}
                      </select>
                      <select value={ing.c} onChange={e=>{
                        const updated = [...editingMeal.ingredients];
                        updated[idx] = {...updated[idx], c: e.target.value};
                        setEditingMeal(m=>({...m, ingredients: updated}));
                      }} style={{padding:"5px 4px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px"}}>
                        {["Produce","Meat","Dairy","Pantry","Spices","Bakery","Condiments","Frozen","Other"].map(c=>
                          <option key={c} value={c}>{c}</option>
                        )}
                      </select>
                      <button onClick={()=>{
                        const updated = editingMeal.ingredients.filter((_,i)=>i!==idx);
                        setEditingMeal(m=>({...m, ingredients: updated}));
                      }} style={{padding:"2px 8px",background:"#ef4444",color:"white",border:"none",borderRadius:"5px",fontSize:"14px",cursor:"pointer",lineHeight:"1.4"}}>×</button>
                    </div>
                  ))}
                  {(editingMeal.ingredients||[]).length > 0 && (
                    <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr auto",gap:"6px",marginBottom:"2px"}}>
                      <span style={{fontSize:"10px",color:"#888"}}>Name</span>
                      <span style={{fontSize:"10px",color:"#888"}}>Qty</span>
                      <span style={{fontSize:"10px",color:"#888"}}>Unit</span>
                      <span style={{fontSize:"10px",color:"#888"}}>Category</span>
                      <span style={{fontSize:"10px",color:"#888"}}></span>
                    </div>
                  )}
                </div>

                <label style={{fontSize:"13px",display:"flex",alignItems:"center",gap:"6px",marginBottom:"14px"}}>
                  <input type="checkbox" checked={editingMeal.needsSide} onChange={e=>setEditingMeal(m=>({...m,needsSide:e.target.checked}))} />
                  Needs Side Dish
                </label>
                <div style={{display:"flex",gap:"8px"}}>
                  <button onClick={()=>{
                    if (!editingMeal.name.trim()) return;
                    if (showAddForm) addNewMeal(editingMeal);
                    else updateMeal(editingMeal);
                  }}
                    style={{padding:"8px 24px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer",opacity:editingMeal.name.trim()?"1":"0.5"}}>
                    {showAddForm ? "Add Meal" : "Save Changes"}
                  </button>
                  <button onClick={()=>{setEditingMeal(null);setShowAddForm(false);}}
                    style={{padding:"8px 20px",background:"#e5e7eb",color:"#555",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:"12px"}}>
              {MEALS_DATA.filter(m => {
                const s = dbSearch.toLowerCase();
                const matchSearch = !s || m.name.toLowerCase().includes(s) || m.cuisine.toLowerCase().includes(s);
                const matchFilter = dbFilter === "All" || m.prep === dbFilter;
                return matchSearch && matchFilter;
              }).sort((a,b) => a.name.localeCompare(b.name)).map(m => {
                const pt = PREP_TYPES[m.prep] || PREP_TYPES["Cook Fresh"];
                const isCustom = customMeals.some(cm => cm.id === m.id);
                return (
                  <div key={m.id} style={{background:"white",borderRadius:"12px",padding:"14px",boxShadow:"0 1px 4px rgba(0,0,0,0.08)",borderLeft:`4px solid ${pt.color}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:"600",fontSize:"15px"}}>
                          {m.name}
                          {isCustom && <span style={{fontSize:"10px",background:"#d8f3dc",color:"#2d6a4f",padding:"1px 6px",borderRadius:"8px",marginLeft:"6px",fontWeight:"500"}}>Custom</span>}
                          {specialOccasionMeals.includes(m.id) && <span style={{fontSize:"10px",background:"#fef9e7",color:"#b8860b",padding:"1px 6px",borderRadius:"8px",marginLeft:"6px",fontWeight:"500"}}>{"\u2B50"} Special</span>}
                        </div>
                        <div style={{fontSize:"12px",color:"#666",marginTop:"2px"}}>{m.time.join(", ")} · {m.cuisine}</div>
                      </div>
                      <div style={{display:"flex",gap:"4px",alignItems:"center"}}>
                        <span style={{background:pt.bg,color:pt.color,padding:"2px 8px",borderRadius:"12px",fontSize:"11px",fontWeight:"600",whiteSpace:"nowrap"}}>{m.prep}</span>
                      </div>
                    </div>
                    <div style={{fontSize:"12px",color:"#888",marginTop:"6px"}}>{m.cook} · Serves {m.servings}{m.needsSide ? " · Needs Side" : ""}</div>
                    {m.notes && <div style={{fontSize:"12px",color:"#555",marginTop:"4px",fontStyle:"italic"}}>{m.notes}</div>}
                    {INGREDIENTS_DATA[m.id] && (
                      <details style={{marginTop:"6px"}}>
                        <summary style={{fontSize:"12px",color:"#2d6a4f",cursor:"pointer",fontWeight:"500"}}>Ingredients ({INGREDIENTS_DATA[m.id].length})</summary>
                        <div style={{fontSize:"11px",color:"#555",marginTop:"4px",lineHeight:"1.6"}}>
                          {INGREDIENTS_DATA[m.id].map((ing,i)=><span key={i}>{ing.q} {ing.u} {ing.n}{i<INGREDIENTS_DATA[m.id].length-1?", ":""}</span>)}
                        </div>
                      </details>
                    )}
                    <div style={{display:"flex",gap:"6px",marginTop:"8px",borderTop:"1px solid #f0f0f0",paddingTop:"8px"}}>
                      <button onClick={()=>startEditMeal(m)}
                        style={{padding:"4px 12px",background:"#e8f5e9",color:"#2d6a4f",border:"1px solid #c8e6c9",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>
                        Edit
                      </button>
                      {confirmDeleteId === m.id ? (
                        <>
                          <span style={{fontSize:"11px",color:"#e76f51",fontWeight:"600",lineHeight:"26px"}}>Delete this meal?</span>
                          <button onClick={()=>removeMeal(m.id)}
                            style={{padding:"4px 10px",background:"#e76f51",color:"white",border:"none",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>
                            Yes
                          </button>
                          <button onClick={()=>setConfirmDeleteId(null)}
                            style={{padding:"4px 10px",background:"#e5e7eb",color:"#555",border:"none",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>
                            No
                          </button>
                        </>
                      ) : (
                        <button onClick={()=>setConfirmDeleteId(m.id)}
                          style={{padding:"4px 12px",background:"#fef2f0",color:"#e76f51",border:"1px solid #fcd5cf",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{marginTop:"24px"}}>
              <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"12px"}}>
                <h3 style={{color:"#2d6a4f",margin:0,fontSize:"16px"}}>Side Dishes</h3>
                <button onClick={startAddSide}
                  style={{padding:"6px 14px",background:"#f4a261",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"12px",cursor:"pointer"}}>
                  + Add Side
                </button>
              </div>

              {/* ── Add / Edit Side Form ──────────── */}
              {editingSide && (
                <div style={{background:"white",borderRadius:"12px",padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,0.12)",marginBottom:"20px",border:"2px solid #f4a261"}}>
                  <h4 style={{color:"#f4a261",margin:"0 0 14px 0",fontSize:"16px"}}>{showAddSideForm ? "Add New Side" : `Edit: ${editingSide.name}`}</h4>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"10px",marginBottom:"12px"}}>
                    <label style={{fontSize:"13px",fontWeight:"500"}}>
                      Side Name *
                      <input value={editingSide.name} onChange={e=>setEditingSide(s=>({...s,name:e.target.value}))}
                        placeholder="e.g. Coleslaw"
                        style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px",boxSizing:"border-box"}} />
                    </label>
                    <label style={{fontSize:"13px",fontWeight:"500"}}>
                      Cuisine
                      <input value={editingSide.cuisine} onChange={e=>setEditingSide(s=>({...s,cuisine:e.target.value}))}
                        placeholder="e.g. American, Latin"
                        style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px",boxSizing:"border-box"}} />
                    </label>
                    <label style={{fontSize:"13px",fontWeight:"500"}}>
                      Category
                      <select value={editingSide.cat} onChange={e=>setEditingSide(s=>({...s,cat:e.target.value}))}
                        style={{width:"100%",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",marginTop:"3px"}}>
                        {SIDE_CATEGORIES.filter(c=>c!=="All Sides").map(c=><option key={c} value={c}>{c}</option>)}
                      </select>
                    </label>
                  </div>

                  {/* ── Ingredient Editor for Side ──────────── */}
                  <div style={{marginBottom:"14px",border:"1px solid #d1d5db",borderRadius:"8px",padding:"12px",background:"#f9fafb"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}}>
                      <span style={{fontSize:"13px",fontWeight:"600",color:"#f4a261"}}>Ingredients (for grocery list)</span>
                      <button onClick={()=>setEditingSide(s=>({...s,ingredients:[...(s.ingredients||[]),{n:"",q:1,u:"each",c:"Produce"}]}))}
                        style={{padding:"4px 10px",background:"#f4a261",color:"white",border:"none",borderRadius:"6px",fontSize:"12px",cursor:"pointer",fontWeight:"600"}}>
                        + Add Ingredient
                      </button>
                    </div>
                    {(editingSide.ingredients||[]).length === 0 && (
                      <p style={{fontSize:"12px",color:"#888",margin:"4px 0",fontStyle:"italic"}}>No ingredients yet. Add ingredients so they appear on your grocery list.</p>
                    )}
                    {(editingSide.ingredients||[]).map((ing, idx) => (
                      <div key={idx} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr auto",gap:"6px",marginBottom:"6px",alignItems:"center"}}>
                        <input value={ing.n} placeholder="Name" onChange={e=>{
                          const updated = [...editingSide.ingredients];
                          updated[idx] = {...updated[idx], n: e.target.value};
                          setEditingSide(s=>({...s, ingredients: updated}));
                        }} style={{padding:"5px 8px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px"}} />
                        <input type="number" value={ing.q} step="0.25" min="0" onChange={e=>{
                          const updated = [...editingSide.ingredients];
                          updated[idx] = {...updated[idx], q: +e.target.value};
                          setEditingSide(s=>({...s, ingredients: updated}));
                        }} style={{padding:"5px 8px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px",width:"100%",boxSizing:"border-box"}} />
                        <select value={ing.u} onChange={e=>{
                          const updated = [...editingSide.ingredients];
                          updated[idx] = {...updated[idx], u: e.target.value};
                          setEditingSide(s=>({...s, ingredients: updated}));
                        }} style={{padding:"5px 4px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px"}}>
                          {["each","cups","cup","tbsp","tsp","lbs","lb","oz","g","slices","pack","bottle","jar","can","bunch","head","cloves","pinch"].map(u=>
                            <option key={u} value={u}>{u}</option>
                          )}
                        </select>
                        <select value={ing.c} onChange={e=>{
                          const updated = [...editingSide.ingredients];
                          updated[idx] = {...updated[idx], c: e.target.value};
                          setEditingSide(s=>({...s, ingredients: updated}));
                        }} style={{padding:"5px 4px",borderRadius:"5px",border:"1px solid #ccc",fontSize:"12px"}}>
                          {["Produce","Meat","Dairy","Pantry","Spices","Bakery","Condiments","Frozen","Other"].map(c=>
                            <option key={c} value={c}>{c}</option>
                          )}
                        </select>
                        <button onClick={()=>{
                          const updated = editingSide.ingredients.filter((_,i)=>i!==idx);
                          setEditingSide(s=>({...s, ingredients: updated}));
                        }} style={{padding:"2px 8px",background:"#ef4444",color:"white",border:"none",borderRadius:"5px",fontSize:"14px",cursor:"pointer",lineHeight:"1.4"}}>{"\u00D7"}</button>
                      </div>
                    ))}
                  </div>

                  <div style={{display:"flex",gap:"8px"}}>
                    <button onClick={()=>{
                      if (!editingSide.name.trim()) return;
                      if (showAddSideForm) addNewSide(editingSide);
                      else updateSide(editingSide);
                    }}
                      style={{padding:"8px 24px",background:"#f4a261",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer",opacity:editingSide.name.trim()?"1":"0.5"}}>
                      {showAddSideForm ? "Add Side" : "Save Changes"}
                    </button>
                    <button onClick={()=>{setEditingSide(null);setShowAddSideForm(false);}}
                      style={{padding:"8px 20px",background:"#e5e7eb",color:"#555",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                      Cancel
                    </button>
                  </div>
                </div>
              )}

              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:"10px"}}>
                {[...SIDES_DATA].sort((a,b) => a.name.localeCompare(b.name)).map(s=>{
                  const isCustom = customMeals.some(cm => cm.id === s.id && cm._isSide);
                  return (
                    <div key={s.id} style={{background:"white",borderRadius:"10px",padding:"12px",boxShadow:"0 1px 3px rgba(0,0,0,0.06)",borderLeft:"3px solid #f4a261"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                        <div>
                          <div style={{fontWeight:"600",fontSize:"14px"}}>
                            {s.name}
                            {isCustom && <span style={{fontSize:"10px",background:"#fef3c7",color:"#f4a261",padding:"1px 6px",borderRadius:"8px",marginLeft:"6px",fontWeight:"500"}}>Custom</span>}
                          </div>
                          <div style={{fontSize:"11px",color:"#666"}}>{s.cat} {s.cuisine ? `\u00B7 ${s.cuisine}` : ""}</div>
                        </div>
                      </div>
                      <div style={{fontSize:"11px",color:"#888",marginTop:"4px"}}>{s.ingredients.map(i=>i.n).join(", ")}</div>
                      <div style={{display:"flex",gap:"6px",marginTop:"8px",borderTop:"1px solid #f0f0f0",paddingTop:"6px"}}>
                        <button onClick={()=>startEditSide(s)}
                          style={{padding:"3px 10px",background:"#fef3c7",color:"#d97706",border:"1px solid #fde68a",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>
                          Edit
                        </button>
                        {confirmDeleteSideId === s.id ? (
                          <>
                            <span style={{fontSize:"11px",color:"#e76f51",fontWeight:"600",lineHeight:"24px"}}>Delete?</span>
                            <button onClick={()=>removeSide(s.id)}
                              style={{padding:"3px 8px",background:"#e76f51",color:"white",border:"none",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>Yes</button>
                            <button onClick={()=>setConfirmDeleteSideId(null)}
                              style={{padding:"3px 8px",background:"#e5e7eb",color:"#555",border:"none",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>No</button>
                          </>
                        ) : (
                          <button onClick={()=>setConfirmDeleteSideId(s.id)}
                            style={{padding:"3px 10px",background:"#fef2f0",color:"#e76f51",border:"1px solid #fcd5cf",borderRadius:"6px",fontSize:"11px",fontWeight:"600",cursor:"pointer"}}>
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── Recipe Scanner ───────────────── */}
            <div style={{marginTop:"24px"}}>
              <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"12px"}}>
                <h3 style={{color:"#2d6a4f",margin:0,fontSize:"16px"}}>Recipe Scanner</h3>
                <button onClick={()=>setShowScanner(!showScanner)}
                  style={{padding:"6px 14px",background:showScanner?"#e5e7eb":"#2d6a4f",color:showScanner?"#555":"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"12px",cursor:"pointer"}}>
                  {showScanner ? "Hide Scanner" : "Scan a Recipe"}
                </button>
              </div>
              {showScanner && (
                <div style={{background:"white",borderRadius:"12px",padding:"16px",boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>
                  <div style={{display:"flex",gap:"6px",marginBottom:"10px"}}>
                    <button onClick={()=>setScannerMode("meal")}
                      style={{padding:"6px 14px",borderRadius:"6px",border:"none",cursor:"pointer",fontWeight:"600",fontSize:"12px",
                        background:scannerMode==="meal"?"#2d6a4f":"#e5e7eb",color:scannerMode==="meal"?"white":"#555"}}>
                      Scan a Meal
                    </button>
                    <button onClick={()=>setScannerMode("side")}
                      style={{padding:"6px 14px",borderRadius:"6px",border:"none",cursor:"pointer",fontWeight:"600",fontSize:"12px",
                        background:scannerMode==="side"?"#2d6a4f":"#e5e7eb",color:scannerMode==="side"?"white":"#555"}}>
                      Scan a Side Dish
                    </button>
                  </div>
                  <p style={{fontSize:"13px",color:"#666",marginBottom:"10px"}}>
                    {scannerMode === "meal"
                      ? "Paste a recipe below. Put the recipe name on the first line, then list ingredients."
                      : "Paste a side dish recipe below. Put the name on the first line, then list ingredients."}
                  </p>
                  <textarea value={recipeText} onChange={e=>setRecipeText(e.target.value)}
                    placeholder={"Arroz con Gandules\n\nIngredients:\n2 cups long grain rice\n1 can gandules (pigeon peas)\n1/4 lb smoked ham, diced\n2 tbsp sofrito\n1 packet sazón\n1 tbsp olive oil\n2 cups water\nSalt to taste\n\nInstructions:\n1. Heat oil in caldero..."}
                    style={{width:"100%",minHeight:"200px",padding:"12px",borderRadius:"8px",border:"1px solid #ccc",fontSize:"13px",fontFamily:"monospace",resize:"vertical",boxSizing:"border-box"}} />
                  <div style={{display:"flex",gap:"8px",marginTop:"10px"}}>
                    <button onClick={parseRecipeText}
                      style={{padding:"8px 20px",background:"#f4a261",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                      Parse Recipe
                    </button>
                    <button onClick={()=>{setRecipeText("");setParsedRecipe(null);}}
                      style={{padding:"8px 20px",background:"#e5e7eb",color:"#555",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                      Clear
                    </button>
                  </div>

                  {/* Parsed result preview */}
                  {parsedRecipe && (
                    <div style={{marginTop:"16px",border:"1px solid #d8f3dc",borderRadius:"10px",padding:"14px",background:"#f0faf4"}}>
                      <h4 style={{color:"#2d6a4f",margin:"0 0 8px 0",fontSize:"15px"}}>Parsed {parsedRecipe.isSide ? "Side" : "Meal"}: {parsedRecipe.name}</h4>

                      {parsedRecipe.isSide ? (
                        /* ── Side Dish Fields ── */
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"10px"}}>
                          <label style={{fontSize:"12px"}}>
                            Side Name:
                            <input value={parsedRecipe.name} onChange={e=>setParsedRecipe(r=>({...r,name:e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px",boxSizing:"border-box"}} />
                          </label>
                          <label style={{fontSize:"12px"}}>
                            Cuisine:
                            <input value={parsedRecipe.cuisine} onChange={e=>setParsedRecipe(r=>({...r,cuisine:e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px",boxSizing:"border-box"}} />
                          </label>
                          <label style={{fontSize:"12px",gridColumn:"1 / -1"}}>
                            Side Category:
                            <select value={parsedRecipe.sideCat} onChange={e=>setParsedRecipe(r=>({...r,sideCat:e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px"}}>
                              {SIDE_CATEGORIES.filter(c=>c!=="All Sides").map(c=><option key={c} value={c}>{c}</option>)}
                            </select>
                          </label>
                        </div>
                      ) : (
                        /* ── Meal Fields ── */
                        <>
                        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"10px"}}>
                          <label style={{fontSize:"12px"}}>
                            Meal Name:
                            <input value={parsedRecipe.name} onChange={e=>setParsedRecipe(r=>({...r,name:e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px",boxSizing:"border-box"}} />
                          </label>
                          <label style={{fontSize:"12px"}}>
                            Cook Time:
                            <input value={parsedRecipe.cook} onChange={e=>setParsedRecipe(r=>({...r,cook:e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px",boxSizing:"border-box"}} />
                          </label>
                          <label style={{fontSize:"12px"}}>
                            Cuisine:
                            <input value={parsedRecipe.cuisine} onChange={e=>setParsedRecipe(r=>({...r,cuisine:e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px",boxSizing:"border-box"}} />
                          </label>
                          <label style={{fontSize:"12px"}}>
                            Servings:
                            <input type="number" value={parsedRecipe.servings} onChange={e=>setParsedRecipe(r=>({...r,servings:+e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px",boxSizing:"border-box"}} />
                          </label>
                          <label style={{fontSize:"12px"}}>
                            Prep Type:
                            <select value={parsedRecipe.prep} onChange={e=>setParsedRecipe(r=>({...r,prep:e.target.value}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px"}}>
                              {Object.keys(PREP_TYPES).filter(t=>!["Leftover Day","Eat Out","Skip","Defrost"].includes(t)).map(t=>
                                <option key={t} value={t}>{t}</option>
                              )}
                            </select>
                          </label>
                          <label style={{fontSize:"12px"}}>
                            Meal Times:
                            <select value={parsedRecipe.time.join(",")} onChange={e=>setParsedRecipe(r=>({...r,time:e.target.value.split(",")}))}
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",marginTop:"2px"}}>
                              <option value="Breakfast">Breakfast</option>
                              <option value="Lunch">Lunch</option>
                              <option value="Dinner">Dinner</option>
                              <option value="Dinner,Lunch">Dinner & Lunch</option>
                              <option value="Breakfast,Lunch">Breakfast & Lunch</option>
                              <option value="Breakfast,Dinner">Breakfast & Dinner</option>
                            </select>
                          </label>
                        </div>
                        <label style={{fontSize:"12px",display:"flex",alignItems:"center",gap:"6px",marginBottom:"10px"}}>
                          <input type="checkbox" checked={parsedRecipe.needsSide} onChange={e=>setParsedRecipe(r=>({...r,needsSide:e.target.checked}))} />
                          Needs Side Dish
                        </label>
                        </>
                      )}

                      {parsedRecipe.ingredients.length > 0 && (
                        <div>
                          <h5 style={{color:"#555",margin:"0 0 6px 0",fontSize:"13px"}}>Ingredients ({parsedRecipe.ingredients.length}):</h5>
                          <div style={{maxHeight:"200px",overflow:"auto",fontSize:"12px"}}>
                            {parsedRecipe.ingredients.map((ing,i) => (
                              <div key={i} style={{display:"flex",gap:"6px",alignItems:"center",marginBottom:"4px",padding:"4px 6px",background:"white",borderRadius:"6px"}}>
                                <input value={ing.q} onChange={e=>{const ings=[...parsedRecipe.ingredients];ings[i]={...ing,q:+e.target.value};setParsedRecipe(r=>({...r,ingredients:ings}));}}
                                  style={{width:"50px",padding:"2px 4px",border:"1px solid #ccc",borderRadius:"3px",fontSize:"11px",textAlign:"center"}} type="number" step="0.25" />
                                <input value={ing.u} onChange={e=>{const ings=[...parsedRecipe.ingredients];ings[i]={...ing,u:e.target.value};setParsedRecipe(r=>({...r,ingredients:ings}));}}
                                  style={{width:"60px",padding:"2px 4px",border:"1px solid #ccc",borderRadius:"3px",fontSize:"11px"}} />
                                <input value={ing.n} onChange={e=>{const ings=[...parsedRecipe.ingredients];ings[i]={...ing,n:e.target.value};setParsedRecipe(r=>({...r,ingredients:ings}));}}
                                  style={{flex:1,padding:"2px 4px",border:"1px solid #ccc",borderRadius:"3px",fontSize:"11px"}} />
                                <span style={{fontSize:"10px",color:"#888",minWidth:"50px"}}>{ing.c}</span>
                                <button onClick={()=>{const ings=parsedRecipe.ingredients.filter((_,j)=>j!==i);setParsedRecipe(r=>({...r,ingredients:ings}));}}
                                  style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"14px"}}>x</button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <div style={{display:"flex",gap:"8px",marginTop:"12px"}}>
                        <button onClick={parsedRecipe.isSide ? saveScannedSide : saveScannedRecipe}
                          style={{padding:"8px 20px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                          {parsedRecipe.isSide ? "Save to Side Dishes" : "Save to Meal Database"}
                        </button>
                        <button onClick={()=>setParsedRecipe(null)}
                          style={{padding:"8px 20px",background:"#e5e7eb",color:"#555",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                          Discard
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Custom meals added */}
                  {customMeals.filter(c=>!c._isSide).length > 0 && (
                    <div style={{marginTop:"12px"}}>
                      <h5 style={{color:"#555",fontSize:"13px",marginBottom:"6px"}}>Your Custom Meals ({customMeals.filter(c=>!c._isSide).length}):</h5>
                      {customMeals.filter(c=>!c._isSide).map((m,i) => (
                        <div key={i} style={{fontSize:"12px",color:"#2d6a4f",padding:"4px 8px",display:"flex",justifyContent:"space-between",alignItems:"center",background:"#f0faf4",borderRadius:"6px",marginBottom:"3px"}}>
                          <span>{m.name} ({m.prep}, {m.time.join("/")})</span>
                          <div style={{display:"flex",gap:"6px"}}>
                            <button onClick={()=>{setShowScanner(false);startEditMeal(m);window.scrollTo({top:0,behavior:"smooth"});}}
                              style={{background:"none",border:"none",color:"#2d6a4f",cursor:"pointer",fontSize:"11px",fontWeight:"600",textDecoration:"underline"}}>Edit</button>
                            <button onClick={()=>removeMeal(m.id)}
                              style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"11px",fontWeight:"600",textDecoration:"underline"}}>Remove</button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {/* Custom sides added */}
                  {customMeals.filter(c=>c._isSide).length > 0 && (
                    <div style={{marginTop:"12px"}}>
                      <h5 style={{color:"#555",fontSize:"13px",marginBottom:"6px"}}>Your Custom Sides ({customMeals.filter(c=>c._isSide).length}):</h5>
                      {customMeals.filter(c=>c._isSide).map((s,i) => (
                        <div key={i} style={{fontSize:"12px",color:"#0d7377",padding:"4px 8px",display:"flex",justifyContent:"space-between",alignItems:"center",background:"#e0f7fa",borderRadius:"6px",marginBottom:"3px"}}>
                          <span>{s.name} ({s.cat}) — {(s.ingredients||[]).length} ingredients</span>
                          <button onClick={()=>removeSide(s.id)} style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"11px",fontWeight:"600",textDecoration:"underline"}}>Remove</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ── Special Occasion Meals Manager ── */}
            <div style={{background:"white",borderRadius:"12px",padding:"18px",boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginTop:"20px",border:"2px solid #d4a017"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px"}}>
                <h4 style={{margin:0,color:"#b8860b",fontSize:"15px"}}>{"\u2B50"} Special Occasion Meals</h4>
                <span style={{fontSize:"11px",color:"#999"}}>Not included in Auto Meal Plan — select manually</span>
              </div>
              <p style={{fontSize:"12px",color:"#666",marginTop:0,marginBottom:"12px"}}>
                These meals won't appear when you hit "Auto Meal Plan" but you can still pick them from the dropdown in any slot. Great for holidays, birthdays, or when you just feel like making something special.
              </p>

              {/* Current special occasion meals */}
              {specialOccasionMeals.length > 0 ? (
                <div style={{display:"flex",flexWrap:"wrap",gap:"8px",marginBottom:"14px"}}>
                  {specialOccasionMeals.map(id => {
                    const m = MEALS_DATA.find(x => x.id === id);
                    if (!m) return null;
                    return (
                      <div key={id} style={{display:"flex",alignItems:"center",gap:"6px",background:"#fef9e7",border:"1px solid #f0d668",borderRadius:"20px",padding:"5px 12px"}}>
                        <span style={{fontSize:"13px",fontWeight:"500",color:"#7d6608"}}>{m.name}</span>
                        <button onClick={() => setSpecialOccasionMeals(prev => prev.filter(x => x !== id))}
                          title="Remove from Special Occasion"
                          style={{background:"none",border:"none",color:"#c0392b",cursor:"pointer",fontSize:"15px",fontWeight:"bold",padding:"0 2px",lineHeight:1}}>&times;</button>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p style={{fontSize:"12px",color:"#999",fontStyle:"italic",marginBottom:"14px"}}>No special occasion meals yet — add some below.</p>
              )}

              {/* Add to special occasion list */}
              <div style={{display:"flex",gap:"8px",alignItems:"center"}}>
                <select id="addSpecialOccasion" style={{flex:1,padding:"7px 10px",borderRadius:"8px",border:"1px solid #ccc",fontSize:"13px"}}>
                  <option value="">— Add a meal to Special Occasion —</option>
                  {MEALS_DATA.filter(m => !specialOccasionMeals.includes(m.id)).sort((a,b) => a.name.localeCompare(b.name)).map(m =>
                    <option key={m.id} value={m.id}>{m.name} ({m.prep})</option>
                  )}
                </select>
                <button onClick={() => {
                  const sel = document.getElementById("addSpecialOccasion");
                  if (sel && sel.value) {
                    setSpecialOccasionMeals(prev => [...prev, sel.value]);
                    sel.value = "";
                  }
                }}
                  style={{padding:"7px 16px",background:"#d4a017",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer",whiteSpace:"nowrap"}}>
                  + Add
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ════════════════════════════════════ */}
        {/*  TAB: PLAN MEALS                    */}
        {/* ════════════════════════════════════ */}
        {tab === "planner" && (
          <div>
            <div style={{display:"flex",gap:"12px",marginBottom:"16px",flexWrap:"wrap",alignItems:"center"}}>
              <label style={{fontSize:"13px",fontWeight:"500"}}>Start Date:
                <input type="date" value={startDate} onChange={e=>{
                  const v = e.target.value;
                  // Ignore empty / invalid values from the date picker (prevents blank-screen crash)
                  if (!v) return;
                  const d = new Date(v + "T00:00:00");
                  if (isNaN(d.getTime())) return;
                  // Reject dates with year < 1970 (date picker typing artifact)
                  if (d.getFullYear() < 1970) return;
                  setStartDate(v);
                }}
                  style={{marginLeft:"6px",padding:"6px 10px",borderRadius:"8px",border:"1px solid #ccc",fontSize:"13px"}} />
              </label>
              <label style={{fontSize:"13px",fontWeight:"500"}}>Weeks:
                <select value={weeks} onChange={e=>setWeeks(+e.target.value)} style={{marginLeft:"6px",padding:"6px 10px",borderRadius:"8px",border:"1px solid #ccc",fontSize:"13px"}}>
                  <option value={1}>1 Week</option><option value={2}>2 Weeks</option>
                </select>
              </label>
              <button
                onClick={() => {
                  // Set loading flag, let React paint, then run the synchronous
                  // optimizer. Otherwise the button never visually changes
                  // because we block the main thread immediately on click.
                  setAutoPlanLoading(true);
                  setTimeout(() => {
                    try { autoMealPlan(); } finally { setAutoPlanLoading(false); }
                  }, 50);
                }}
                disabled={autoPlanLoading}
                style={{padding:"8px 16px",background:autoPlanLoading?"#fcd5b5":"#f4a261",color:"white",border:"none",borderRadius:"8px",fontWeight:"700",fontSize:"13px",cursor:autoPlanLoading?"wait":"pointer",boxShadow:"0 2px 6px rgba(244,162,97,0.3)"}}>
                {autoPlanLoading ? "Optimizing..." : "Auto Meal Plan"}
              </button>
              <button onClick={generateAIPlan} disabled={aiPlanLoading}
                style={{padding:"8px 16px",background:aiPlanLoading?"#93c5fd":"#3b82f6",color:"white",border:"none",borderRadius:"8px",fontWeight:"700",fontSize:"13px",cursor:aiPlanLoading?"wait":"pointer",boxShadow:"0 2px 6px rgba(59,130,246,0.3)",display:"flex",alignItems:"center",gap:"6px"}}>
                {aiPlanLoading ? "Generating..." : "\u2728 AI Plan"}
              </button>
              <button onClick={finalizePlan} style={{padding:"8px 16px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                Finalize Plan
              </button>
              {/* Calendar connection indicator — multi-account */}
              <div style={{display:"flex",alignItems:"center",gap:"6px",flexWrap:"wrap"}}>
                {linkedCalendarAccounts.map(a => (
                  <span key={a.email} style={{fontSize:"11px",color:"#059669",fontWeight:"500",display:"flex",alignItems:"center",gap:"3px",background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:"6px",padding:"3px 8px"}}
                    title={`Calendars: ${a.calendars.map(c=>c.name).join(', ')}`}>
                    📅 {a.email.split('@')[0]}
                    <button onClick={()=>onUnlinkCalendarAccount(a.email)} style={{background:"none",border:"none",color:"#dc2626",cursor:"pointer",fontSize:"13px",padding:"0 0 0 4px",lineHeight:"1"}} title="Unlink this calendar">&times;</button>
                  </span>
                ))}
                {onLinkCalendarAccount && (
                  <button onClick={onLinkCalendarAccount}
                    style={{padding:"4px 10px",background:linkedCalendarAccounts.length > 0 ? "#f0fdf4" : "#eff6ff",color:linkedCalendarAccounts.length > 0 ? "#059669" : "#3b82f6",border:`1px solid ${linkedCalendarAccounts.length > 0 ? "#bbf7d0" : "#bfdbfe"}`,borderRadius:"6px",fontWeight:"500",fontSize:"11px",cursor:"pointer",display:"flex",alignItems:"center",gap:"3px"}}
                    title="Link a Google account's calendar for AI-aware scheduling">
                    📅 {linkedCalendarAccounts.length > 0 ? "+" : "Link Calendar"}
                  </button>
                )}
              </div>
              {finalized && (
                <>
                  <span style={{color:"#2d6a4f",fontWeight:"600",fontSize:"13px"}}>Plan finalized!</span>
                  <button onClick={()=>setShowPrintView(true)}
                    style={{padding:"8px 14px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer",display:"flex",alignItems:"center",gap:"5px"}}
                    title="Open print view — plan, grocery list, or fridge calendar">
                    🖨️ Print Plan
                  </button>
                </>
              )}
              {!showResetConfirm ? (
                <button onClick={()=>setShowResetConfirm(true)} title="Clears the meal plan only — freezer, pantry, and history are preserved" style={{marginLeft:"auto",padding:"8px 16px",background:"#dc2626",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer",boxShadow:"0 2px 6px rgba(220,38,38,0.2)"}}>
                  Reset Meal Plan
                </button>
              ) : (
                <span style={{marginLeft:"auto",display:"flex",gap:"6px",alignItems:"center",fontSize:"12px",color:"#dc2626",fontWeight:"600"}}>
                  Clear meal plan? (Freezer & pantry kept)
                  <button onClick={totalReset} style={{padding:"6px 12px",background:"#dc2626",color:"white",border:"none",borderRadius:"6px",fontWeight:"700",fontSize:"12px",cursor:"pointer"}}>Yes, Reset Plan</button>
                  <button onClick={()=>setShowResetConfirm(false)} style={{padding:"6px 12px",background:"#e5e7eb",color:"#333",border:"none",borderRadius:"6px",fontWeight:"600",fontSize:"12px",cursor:"pointer"}}>Cancel</button>
                </span>
              )}
            </div>

            {/* ── Undo banner: appears for 30s after a Reset Plan click ── */}
            {undoSnapshot && (
              <div style={{padding:"10px 14px",background:"#ecfdf5",border:"1px solid #6ee7b7",borderRadius:"8px",marginBottom:"12px",fontSize:"13px",color:"#065f46",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span>Plan reset. <strong>Undo available for 30 seconds.</strong></span>
                <span style={{display:"flex",gap:"6px"}}>
                  <button onClick={undoReset} style={{padding:"6px 14px",background:"#059669",color:"white",border:"none",borderRadius:"6px",fontWeight:"700",fontSize:"12px",cursor:"pointer"}}>Undo Reset</button>
                  <button onClick={()=>setUndoSnapshot(null)} style={{padding:"6px 10px",background:"transparent",color:"#065f46",border:"none",cursor:"pointer",fontSize:"16px"}}>×</button>
                </span>
              </div>
            )}

            {/* ── AI Plan Controls: Error, Reasoning Toggle, Refine Chat ── */}
            {aiPlanError && (
              <div style={{padding:"10px 14px",background:"#fef2f2",border:"1px solid #fca5a5",borderRadius:"8px",marginBottom:"12px",fontSize:"13px",color:"#991b1b"}}>
                {aiPlanError}
              </div>
            )}
            {bulkWarnings.length > 0 && (
              <div style={{padding:"10px 14px",background:"#fffbeb",border:"1px solid #fcd34d",borderRadius:"8px",marginBottom:"12px",fontSize:"13px",color:"#92400e"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
                  <strong>Bulk cook didn't fit all portions</strong>
                  <button onClick={()=>setBulkWarnings([])} style={{background:"none",border:"none",cursor:"pointer",color:"#92400e",fontSize:"16px"}}>×</button>
                </div>
                {bulkWarnings.map((w, i) => (
                  <div key={i} style={{fontSize:"12px",lineHeight:"1.4"}}>
                    {w.mealName} on {w.date}: requested {w.requested} portions, only placed {w.placed}. {w.shortBy} portion{w.shortBy === 1 ? "" : "s"} unplaced — extend the plan or reduce bulk count.
                  </div>
                ))}
              </div>
            )}
            {(showAiReasoning || refineHistory.length > 0) && (
              <div style={{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:"10px",padding:"14px",marginBottom:"14px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}}>
                  <span style={{fontWeight:"700",fontSize:"14px",color:"#1e40af"}}>{"\u2728"} AI Planner</span>
                  <button onClick={() => setShowAiReasoning(r => !r)}
                    style={{padding:"4px 10px",background:"#dbeafe",border:"1px solid #93c5fd",borderRadius:"6px",fontSize:"12px",cursor:"pointer",color:"#1e40af"}}>
                    {showAiReasoning ? "Hide Reasoning" : "Show Reasoning"}
                  </button>
                </div>
                {/* Conversation history */}
                {refineHistory.length > 0 && (
                  <div style={{maxHeight:"200px",overflowY:"auto",marginBottom:"10px",fontSize:"13px"}}>
                    {refineHistory.map((turn, i) => (
                      <div key={i} style={{padding:"6px 10px",marginBottom:"4px",borderRadius:"6px",
                        background: turn.role === "user" ? "#e0e7ff" : "#f0fdf4",
                        textAlign: turn.role === "user" ? "right" : "left",
                        color: turn.role === "user" ? "#3730a3" : "#166534"}}>
                        <span style={{fontWeight:"600",fontSize:"11px"}}>{turn.role === "user" ? "You" : "Claude"}:</span>{" "}
                        {turn.content}
                      </div>
                    ))}
                  </div>
                )}
                {/* Refine input */}
                <div style={{display:"flex",gap:"8px"}}>
                  <input
                    type="text"
                    placeholder="Refine plan... (e.g. 'Make Wednesday easier', 'More Mexican')"
                    value={refineQuery}
                    onChange={e => setRefineQuery(e.target.value)}
                    onKeyDown={e => { if (e.key === "Enter" && refineQuery.trim() && !refineLoading) { refineAIPlan(refineQuery.trim()); setRefineQuery(""); } }}
                    style={{flex:1,padding:"8px 12px",borderRadius:"8px",border:"1px solid #93c5fd",fontSize:"13px"}}
                  />
                  <button onClick={() => { if (refineQuery.trim() && !refineLoading) { refineAIPlan(refineQuery.trim()); setRefineQuery(""); } }}
                    disabled={refineLoading || !refineQuery.trim()}
                    style={{padding:"8px 14px",background:refineLoading?"#93c5fd":"#3b82f6",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:refineLoading?"wait":"pointer"}}>
                    {refineLoading ? "..." : "Refine"}
                  </button>
                </div>
              </div>
            )}

            {/* ── Day Mode Selector: Cook vs Easy (Defrost/Prepackaged) ── */}
            {(() => {
              const sd = new Date(startDate + "T00:00:00");
              const weekBlocks = [];
              for (let w = 0; w < weeks; w++) {
                const weekDays = Array.from({length: 7}, (_, i) => {
                  const d = addDays(sd, w * 7 + i);
                  const dateKey = d.toISOString().slice(0, 10);
                  const dayName = DAYS[d.getDay()];
                  // For week 1 use day-name keys (backward compat), for week 2+ use date keys
                  // Always use date keys so weeks are independent
                  const modeKey = dateKey;
                  return { date: d, dateKey, dayName, modeKey };
                });
                weekBlocks.push({ weekNum: w, days: weekDays });
              }
              return weekBlocks.map(wb => (
                <div key={wb.weekNum} style={{marginBottom:"16px",background:"white",borderRadius:"10px",padding:"12px 16px",boxShadow:"0 1px 3px rgba(0,0,0,0.06)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}}>
                    <span style={{fontSize:"13px",fontWeight:"600",color:"#2d6a4f"}}>
                      Cook vs Easy Days{weeks > 1 ? ` — Week ${wb.weekNum + 1}` : ""}
                    </span>
                    <span style={{fontSize:"10px",color:"#999"}}>Cook = fresh meals · Easy = defrost/frozen/eat out · Any = auto decides</span>
                  </div>
                  <div style={{overflowX:"auto"}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:"11px"}}>
                      <thead>
                        <tr>
                          <th style={{padding:"4px 8px",textAlign:"left",color:"#666"}}></th>
                          {wb.days.map(d => (
                            <th key={d.modeKey} style={{padding:"4px 6px",textAlign:"center",color:"#2d6a4f",fontWeight:"600"}}>
                              <div>{d.dayName.slice(0,3)}</div>
                              {weeks > 1 && <div style={{fontSize:"9px",fontWeight:"400",color:"#888"}}>{fmtShort(d.date)}</div>}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {MEAL_TIMES.map(mt => (
                          <tr key={mt}>
                            <td style={{padding:"3px 8px",fontWeight:"500",color:"#555"}}>{mt}</td>
                            {wb.days.map(d => {
                              const val = getDayMode(d.dateKey, d.dayName, mt);
                              return (
                                <td key={d.modeKey} style={{padding:"2px 4px",textAlign:"center"}}>
                                  <select value={val} onChange={e=>updateDayMode(d.modeKey,mt,e.target.value)}
                                    style={{padding:"3px 2px",borderRadius:"4px",fontSize:"10px",border:"1px solid #ddd",cursor:"pointer",width:"100%",
                                      background: val==="Cook" ? "#d8f3dc" : val==="Easy" ? "#fef3c7" : "#f9fafb",
                                      color: val==="Cook" ? "#2d6a4f" : val==="Easy" ? "#92400e" : "#999",
                                      fontWeight: val==="Any" ? "400" : "600"}}>
                                    <option value="Any">Any</option>
                                    <option value="Cook">Cook</option>
                                    <option value="Easy">Easy</option>
                                  </select>
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ));
            })()}

            {/* ── Planner Grid ──────────────── */}
            {(() => {
              const totalDays = weeks * 7;
              const sd = new Date(startDate + "T00:00:00");
              const days = Array.from({length:totalDays}, (_,i) => addDays(sd,i));
              return days.map(day => {
                const dateKey = day.toISOString().slice(0,10);
                const dayName = DAYS[day.getDay()];
                return (
                  <div key={dateKey} style={{marginBottom:"16px",background:"white",borderRadius:"12px",boxShadow:"0 1px 4px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                    <div style={{background:"#2d6a4f",color:"white",padding:"8px 14px",fontWeight:"600",fontSize:"14px"}}>
                      {dayName} — {fmt(day)}
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(min(100%,260px),1fr))",gap:"1px",background:"#eee"}}>
                      {MEAL_TIMES.map(mt => {
                        const k = `${dateKey}_${mt}`;
                        const slot = plan[k];
                        if (!slot) return null;
                        const pt = PREP_TYPES[slot.prepType] || PREP_TYPES["Auto"];
                        const isAutoSlot = slot.prepType === "Auto";
                        const noMealPicker = ["Leftover Day","Eat Out","Skip","Auto"].includes(slot.prepType);
                        const isDefrost = slot.prepType === "Defrost";
                        const selectedMeal = MEALS_DATA.find(m => m.id === slot.mealId);
                        // Let the user add a side to any meal they've selected — even breakfast,
                        // even if the meal's default needsSide flag is false.
                        const showSide = !!selectedMeal;
                        const availableMeals = noMealPicker ? [] : isDefrost ? [] : mealsForTime(mt, slot.prepType, true);
                        // For Defrost: only show meals in the freezer pantry
                        const freezerOptions = isDefrost ? freezerMeals.filter(fm => {
                          if (fm.mealTime === "Both") return true;
                          return fm.mealTime === mt;
                        }) : [];
                        // Get hint for what rule/pattern would fill this Auto slot
                        const autoHint = isAutoSlot ? getAutoHint(dayName, mt) : null;

                        return (
                          <div key={k} style={{background:pt.bg,padding:"12px",minHeight:"120px",position:"relative"}}>
                            {/* Lock indicator — "Type set" is clickable to reset to Auto */}
                            {(slot.lockedMeal || slot.lockedType) && !isAutoSlot && (
                              slot.lockedMeal ? (
                                <div style={{position:"absolute",top:"6px",right:"8px",fontSize:"10px",color:"#2d6a4f"}} title="Meal locked — won't change">
                                  Locked
                                </div>
                              ) : (
                                <button onClick={()=>updateSlot(k,"prepType","Auto")} style={{position:"absolute",top:"4px",right:"6px",fontSize:"10px",color:"#9ca3af",background:"none",border:"1px solid #ddd",borderRadius:"4px",padding:"1px 6px",cursor:"pointer",lineHeight:"1.4"}} title="Click to reset to Auto">
                                  Type set ✕
                                </button>
                              )
                            )}
                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}}>
                              <span style={{fontWeight:"600",fontSize:"13px",color:pt.color}}>{mt}</span>
                              <div style={{display:"flex",alignItems:"center",gap:"4px"}}>
                                {/* Feedback buttons */}
                                {!isAutoSlot && slot.mealId && (
                                  <span style={{display:"flex",gap:"2px"}}>
                                    <button onClick={() => recordFeedback(k, { rating: 5, tags: ["make_again"] })}
                                      title="Thumbs up"
                                      style={{background:"none",border:"none",cursor:"pointer",fontSize:"14px",padding:"1px 3px",
                                        opacity: mealFeedback[k]?.rating === 5 ? 1 : 0.4}}>
                                      {"\uD83D\uDC4D"}
                                    </button>
                                    <button onClick={() => recordFeedback(k, { rating: 1, tags: ["skip_next_time"] })}
                                      title="Thumbs down"
                                      style={{background:"none",border:"none",cursor:"pointer",fontSize:"14px",padding:"1px 3px",
                                        opacity: mealFeedback[k]?.rating === 1 ? 1 : 0.4}}>
                                      {"\uD83D\uDC4E"}
                                    </button>
                                  </span>
                                )}
                                {!isAutoSlot && (
                                  <button onClick={()=>resetSlotToAuto(k)} title="Reset to Auto"
                                    style={{background:"none",border:"none",cursor:"pointer",fontSize:"16px",padding:"2px 6px",borderRadius:"4px",color:pt.color}}>
                                    &#8635;
                                  </button>
                                )}
                              </div>
                            </div>
                            {/* AI reasoning tooltip */}
                            {showAiReasoning && aiPlanReasoning[k] && (
                              <div style={{padding:"4px 8px",marginBottom:"6px",background:"rgba(59,130,246,0.08)",borderRadius:"6px",fontSize:"11px",color:"#1e40af",lineHeight:"1.4",borderLeft:"3px solid #3b82f6"}}>
                                {aiPlanReasoning[k]}
                              </div>
                            )}

                            {/* Prep Type */}
                            <select value={slot.prepType} onChange={e=>updateSlot(k,"prepType",e.target.value)}
                              style={{width:"100%",padding:"6px 8px",borderRadius:"6px",border:isAutoSlot?`2px dashed #bbb`:`1px solid ${pt.color}40`,fontSize:"12px",marginBottom:"6px",background:isAutoSlot?"#fafafa":"white",color:isAutoSlot?"#999":"inherit"}}>
                              {Object.keys(PREP_TYPES).map(t=><option key={t} value={t}>{PREP_TYPES[t].label}</option>)}
                            </select>

                            {/* Auto hint — shows what rule/pattern would apply */}
                            {isAutoSlot && (
                              <div style={{padding:"8px",background:"#f9fafb",borderRadius:"6px",border:"1px dashed #d1d5db",marginBottom:"6px",textAlign:"center"}}>
                                {autoHint ? (
                                  <div style={{fontSize:"11px",color:"#6b7280"}}>
                                    <span style={{fontWeight:"600",color:PREP_TYPES[autoHint.type]?.color || "#666"}}>{autoHint.label}</span>
                                    <div style={{marginTop:"2px",fontSize:"10px",color:"#9ca3af"}}>will apply when you hit Auto Meal Plan</div>
                                  </div>
                                ) : (
                                  <div style={{fontSize:"11px",color:"#9ca3af"}}>
                                    Auto Meal Plan will pick a meal for this slot
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Bulk count */}
                            {slot.prepType === "Bulk Cook" && (
                              <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"6px"}}>
                                <span style={{fontSize:"11px",color:pt.color}}>Makes</span>
                                <input type="number" min={2} max={12} value={slot.bulkCount} onChange={e=>updateSlot(k,"bulkCount",+e.target.value)}
                                  style={{width:"50px",padding:"4px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px",textAlign:"center"}} />
                                <span style={{fontSize:"11px",color:pt.color}}>meals</span>
                              </div>
                            )}

                            {/* Meal picker: grouped by a meal's DEFAULT meal time
                                (Breakfast, Lunch, or Dinner). We infer the default
                                bucket from the ID prefix (B-, L-, D-) with a
                                fallback to m.time[0]. The slot's own meal time
                                bucket is shown first; the other two are listed
                                below so you can pull breakfast-for-dinner, a big
                                lunch dish for dinner, and so on. This deliberately
                                ignores the Bulk / Fresh prep type so every
                                eligible meal is always visible. */}
                            {!noMealPicker && (() => {
                              const defaultTime = (m) => {
                                const id = m.id || "";
                                if (id.startsWith("B")) return "Breakfast";
                                if (id.startsWith("L")) return "Lunch";
                                if (id.startsWith("D")) return "Dinner";
                                return (m.time && m.time[0]) || "Dinner";
                              };
                              // Show ALL meals including Frozen Meal items (Fish Sticks, Udon,
                              // Gyoza, Chicken Nuggets, Frozen Pizza, etc.). Previously these
                              // were filtered out here on the assumption the user would change
                              // the prep type to "Frozen Meal" first — non-obvious. updateSlot()
                              // auto-corrects the slot's prepType when a frozen meal is picked.
                              const pickable = MEALS_DATA;
                              const byTime = (t) => pickable
                                .filter(m => defaultTime(m) === t && !specialOccasionMeals.includes(m.id) && m.prep !== "Frozen Meal")
                                .sort((a,b) => a.name.localeCompare(b.name));
                              const frozenMealOpts = pickable
                                .filter(m => m.prep === "Frozen Meal" && !specialOccasionMeals.includes(m.id) && (m.time || []).some(t => t === mt || t === "Lunch" || t === "Dinner"))
                                .sort((a,b) => a.name.localeCompare(b.name));
                              const primary = byTime(mt);
                              const otherTimes = ["Breakfast","Lunch","Dinner"].filter(t => t !== mt);
                              const specials = pickable
                                .filter(m => specialOccasionMeals.includes(m.id))
                                .sort((a,b) => a.name.localeCompare(b.name));
                              return (
                                <select value={slot.mealId} onChange={e=>updateSlot(k,"mealId",e.target.value)}
                                  style={{width:"100%",padding:"6px 8px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"12px",marginBottom:"6px",background:"white"}}>
                                  <option value="">— Select Meal —</option>
                                  <optgroup label={`${mt} Meals`}>
                                    {primary.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                                  </optgroup>
                                  {frozenMealOpts.length > 0 && (
                                    <optgroup label={"❄️ Frozen / Ready-to-Cook"}>
                                      {frozenMealOpts.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                                    </optgroup>
                                  )}
                                  {otherTimes.map(t => {
                                    const list = byTime(t);
                                    if (!list.length) return null;
                                    return (
                                      <optgroup key={t} label={`${t} — pull for ${mt}`}>
                                        {list.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                                      </optgroup>
                                    );
                                  })}
                                  {specials.length > 0 && (
                                    <optgroup label="Special Occasion">
                                      {specials.map(m=><option key={m.id} value={m.id}>{"\u2B50 "}{m.name}</option>)}
                                    </optgroup>
                                  )}
                                </select>
                              );
                            })()}

                            {/* Defrost meal picker — only freezer pantry items */}
                            {isDefrost && (
                              <div>
                                {freezerOptions.length > 0 ? (
                                  <select value={slot.mealId} onChange={e=>updateSlot(k,"mealId",e.target.value)}
                                    style={{width:"100%",padding:"6px 8px",borderRadius:"6px",border:"1px solid #6a0572",fontSize:"12px",marginBottom:"6px",background:"#f5f0f6",color:"#6a0572"}}>
                                    <option value="">— Select from Freezer —</option>
                                    {[...freezerOptions].sort((a,b)=>a.name.localeCompare(b.name)).map((fm,i)=><option key={`${fm.mealId}-${i}`} value={fm.mealId}>{fm.name} ({fm.portions} portions)</option>)}
                                  </select>
                                ) : (
                                  <div style={{fontSize:"11px",color:"#6a0572",fontStyle:"italic",padding:"6px 0",background:"#f5f0f6",borderRadius:"6px",textAlign:"center",marginBottom:"6px"}}>
                                    No meals in freezer yet. Add them in the Pantry tab.
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Protein add-on (e.g., Caesar Salad → chicken patties/rotisserie) */}
                            {slot.mealId && PROTEIN_OPTIONS[slot.mealId] && (
                              <select value={slot.proteinAdd||""} onChange={e=>updateSlot(k,"proteinAdd",e.target.value)}
                                style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #8b5cf6",fontSize:"11px",marginBottom:"6px",background:"#f5f3ff",color:"#6d28d9"}}>
                                <option value="">— Add Protein? (optional) —</option>
                                {PROTEIN_OPTIONS[slot.mealId].map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                              </select>
                            )}

                            {/* Serving style picker for versatile meats (Birria, Pollo para Tacos, Cochinita Pibil, Carne Asada) */}
                            {slot.mealId && ["D008","D022","D034","D017"].includes(slot.mealId) && (
                              <div style={{marginBottom:"6px"}}>
                                <div style={{fontSize:"10px",color:"#b45309",fontWeight:"600",marginBottom:"2px"}}>Serving Style</div>
                                <select value={slot.servingStyle||""} onChange={e=>updateSlot(k,"servingStyle",e.target.value)}
                                  style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #d97706",fontSize:"12px",background:"#fffbeb",color:"#92400e"}}>
                                  <option value="">{"Main Entr\u00e9e (as-is)"}</option>
                                  <option value="Tacos">As Tacos</option>
                                  <option value="Burritos">As Burritos</option>
                                  <option value="Nachos">As Nachos</option>
                                </select>
                                {slot.servingStyle && (
                                  <div style={{fontSize:"11px",color:"#b45309",fontStyle:"italic",padding:"2px 0",marginTop:"2px"}}>
                                    Serving as {slot.servingStyle}
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Leftover toggle — mark this slot as leftovers so ingredients aren't double-counted */}
                            {slot.mealId && !isAutoSlot && !["Leftover Day","Eat Out","Skip","Defrost"].includes(slot.prepType) && (
                              <label style={{display:"flex",alignItems:"center",gap:"5px",fontSize:"11px",color:slot.isLeftover?"#b5179e":"#888",marginBottom:"6px",cursor:"pointer",padding:"3px 0"}}>
                                <input type="checkbox" checked={!!slot.isLeftover} onChange={e=>updateSlot(k,"isLeftover",e.target.checked)} style={{accentColor:"#b5179e"}} />
                                {slot.isLeftover ? "🍽️ Leftovers — not on grocery list" : "Leftovers? (skip grocery list)"}
                              </label>
                            )}

                            {!isAutoSlot && ["Leftover Day","Skip"].includes(slot.prepType) && (
                              <div style={{fontSize:"12px",color:pt.color,fontStyle:"italic",padding:"4px 0"}}>
                                {slot.prepType === "Leftover Day" ? "Clean out the fridge" : "Skipped"}
                              </div>
                            )}

                            {/* Eat Out sub-menu with Pupusas option */}
                            {!isAutoSlot && slot.prepType === "Eat Out" && (
                              <div style={{marginBottom:"6px"}}>
                                <select value={slot.eatOutType||""} onChange={e=>updateSlot(k,"eatOutType",e.target.value)}
                                  style={{width:"100%",padding:"6px 8px",borderRadius:"6px",border:"1px solid #e76f51",fontSize:"12px",marginBottom:"4px",background:"#fef3c7",color:"#92400e"}}>
                                  <option value="">What are we getting? (optional)</option>
                                  <option value="Pupusas">Pupusas</option>
                                  <option value="Other">Other</option>
                                </select>
                                {slot.eatOutType === "Other" && (
                                  <div style={{fontSize:"11px",color:"#e76f51",fontStyle:"italic",padding:"2px 0"}}>Restaurant / takeout</div>
                                )}
                                {slot.eatOutType === "Pupusas" && (
                                  <div style={{background:"#fff7ed",border:"1px solid #fed7aa",borderRadius:"8px",padding:"8px 10px",marginTop:"4px"}}>
                                    <div style={{fontSize:"12px",fontWeight:"600",color:"#c2410c",marginBottom:"6px"}}>Make at home to go with pupusas?</div>
                                    <label style={{display:"flex",alignItems:"center",gap:"6px",fontSize:"12px",color:"#333",marginBottom:"4px",cursor:"pointer"}}>
                                      <input type="checkbox" checked={slot.makeSalsa||false} onChange={e=>updateSlot(k,"makeSalsa",e.target.checked)}
                                        style={{accentColor:"#e76f51"}} />
                                      Salsa de Tomate Preparada
                                    </label>
                                    <label style={{display:"flex",alignItems:"center",gap:"6px",fontSize:"12px",color:"#333",cursor:"pointer"}}>
                                      <input type="checkbox" checked={slot.makeCurtido||false} onChange={e=>updateSlot(k,"makeCurtido",e.target.checked)}
                                        style={{accentColor:"#e76f51"}} />
                                      Curtido
                                    </label>
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Side dishes — up to 3 sides per slot, cuisine-aware */}
                            {selectedMeal && !noMealPicker && ["Lunch","Dinner"].includes(mt) && (
                              showSide ? (
                                (() => { const mealCuisine = selectedMeal.cuisine || ""; const sideCats = orderedSideCats(mealCuisine); const bestCat = cuisineToSideCat(mealCuisine); return (
                                <div>
                                  {/* Side 1 */}
                                  <div style={{fontSize:"10px",color:"#92400e",fontWeight:"600",marginBottom:"2px"}}>Side 1 <span style={{fontWeight:"400",color:"#999"}}>({bestCat} match)</span></div>
                                  <select value={slot.sideType||""} onChange={e=>updateSlot(k,"sideType",e.target.value)}
                                    style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #e09f3e",fontSize:"12px",marginBottom:"3px",background:"#fff8ee",fontWeight:"500",color:"#92400e"}}>
                                    <option value="">— What kind of side? —</option>
                                    {sideCats.map(c=><option key={c} value={c}>{c === bestCat ? `★ ${c}` : c}</option>)}
                                  </select>
                                  {slot.sideType && (
                                    <select value={slot.side} onChange={e=>updateSlot(k,"side",e.target.value)}
                                      style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #f4a261",fontSize:"12px",marginBottom:"4px",background:"#fffaf0"}}>
                                      <option value="">— Pick a Side —</option>
                                      {SIDES_DATA.filter(s => slot.sideType === "All Sides" ? s.cat !== "Breakfast Side" && s.cat !== "Breakfast Protein" : s.cat === slot.sideType).sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                                    </select>
                                  )}
                                  {/* Side 2 — optional */}
                                  {slot.side && (
                                    <div>
                                      <div style={{fontSize:"10px",color:"#0d7377",fontWeight:"600",marginBottom:"2px",marginTop:"2px"}}>Side 2 <span style={{fontWeight:"400",color:"#999"}}>(optional)</span></div>
                                      <select value={slot.side2Type||""} onChange={e=>updateSlot(k,"side2Type",e.target.value)}
                                        style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #0d7377",fontSize:"11px",marginBottom:"3px",background:"#f0fdfa",color:"#0d7377"}}>
                                        <option value="">— Add another side? —</option>
                                        {sideCats.map(c=><option key={c} value={c}>{c === bestCat ? `★ ${c}` : c}</option>)}
                                      </select>
                                      {slot.side2Type && (
                                        <select value={slot.side2} onChange={e=>updateSlot(k,"side2",e.target.value)}
                                          style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #0d7377",fontSize:"11px",marginBottom:"4px",background:"#f0fdfa"}}>
                                          <option value="">— Pick Side 2 —</option>
                                          {SIDES_DATA.filter(s => slot.side2Type === "All Sides" ? s.cat !== "Breakfast Side" && s.cat !== "Breakfast Protein" : s.cat === slot.side2Type).sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                                        </select>
                                      )}
                                    </div>
                                  )}
                                  {/* Side 3 — optional */}
                                  {slot.side2 && (
                                    <div>
                                      <div style={{fontSize:"10px",color:"#6a0572",fontWeight:"600",marginBottom:"2px",marginTop:"2px"}}>Side 3 <span style={{fontWeight:"400",color:"#999"}}>(optional)</span></div>
                                      <select value={slot.side3Type||""} onChange={e=>updateSlot(k,"side3Type",e.target.value)}
                                        style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #6a0572",fontSize:"11px",marginBottom:"3px",background:"#fdf4ff",color:"#6a0572"}}>
                                        <option value="">— Add a third side? —</option>
                                        {sideCats.map(c=><option key={c} value={c}>{c === bestCat ? `★ ${c}` : c}</option>)}
                                      </select>
                                      {slot.side3Type && (
                                        <select value={slot.side3} onChange={e=>updateSlot(k,"side3",e.target.value)}
                                          style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #6a0572",fontSize:"11px",marginBottom:"4px",background:"#fdf4ff"}}>
                                          <option value="">— Pick Side 3 —</option>
                                          {SIDES_DATA.filter(s => slot.side3Type === "All Sides" ? s.cat !== "Breakfast Side" && s.cat !== "Breakfast Protein" : s.cat === slot.side3Type).sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                                        </select>
                                      )}
                                    </div>
                                  )}
                                </div>
                                ); })()
                              ) : (
                                <div style={{fontSize:"11px",color:"#888",fontStyle:"italic",marginBottom:"4px"}}>Complete meal — no side needed</div>
                              )
                            )}
                            {mt === "Breakfast" && selectedMeal?.needsSide && (
                              <div>
                                {/* Breakfast Protein selector */}
                                <div style={{fontSize:"10px",color:"#92400e",fontWeight:"600",marginBottom:"2px"}}>Protein</div>
                                <select value={slot.sideType||""} onChange={e=>updateSlot(k,"sideType",e.target.value)}
                                  style={{width:"100%",padding:"6px 8px",borderRadius:"6px",border:"1px solid #e09f3e",fontSize:"12px",marginBottom:"3px",background:"#fff8ee",fontWeight:"500",color:"#92400e"}}>
                                  <option value="">— Add protein? —</option>
                                  <option value="Breakfast Protein">Breakfast Protein</option>
                                </select>
                                {slot.sideType === "Breakfast Protein" && (
                                  <select value={slot.side} onChange={e=>updateSlot(k,"side",e.target.value)}
                                    style={{width:"100%",padding:"6px 8px",borderRadius:"6px",border:"1px solid #f4a261",fontSize:"12px",marginBottom:"4px",background:"#fffaf0"}}>
                                    <option value="">— Pick Protein —</option>
                                    {SIDES_DATA.filter(s => s.cat === "Breakfast Protein").sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                                  </select>
                                )}
                                {/* Breakfast Side selector — always available */}
                                <div style={{fontSize:"10px",color:"#0d7377",fontWeight:"600",marginBottom:"2px",marginTop:"4px"}}>Side <span style={{fontWeight:"400",color:"#999"}}>(optional)</span></div>
                                <select value={slot.side2Type||""} onChange={e=>updateSlot(k,"side2Type",e.target.value)}
                                  style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #0d7377",fontSize:"12px",marginBottom:"3px",background:"#f0fdfa",color:"#0d7377"}}>
                                  <option value="">— Add breakfast side? —</option>
                                  <option value="Breakfast Side">Breakfast Side</option>
                                  <option value="All Sides">All Sides</option>
                                </select>
                                {slot.side2Type && (
                                  <select value={slot.side2||""} onChange={e=>updateSlot(k,"side2",e.target.value)}
                                    style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #0d7377",fontSize:"12px",marginBottom:"4px",background:"#f0fdfa"}}>
                                    <option value="">— Pick a Side —</option>
                                    {SIDES_DATA.filter(s => slot.side2Type === "All Sides" ? true : s.cat === slot.side2Type).sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                                  </select>
                                )}
                                {/* Third optional side */}
                                {slot.side2 && (
                                  <div>
                                    <div style={{fontSize:"10px",color:"#6a0572",fontWeight:"600",marginBottom:"2px",marginTop:"2px"}}>Side 2 <span style={{fontWeight:"400",color:"#999"}}>(optional)</span></div>
                                    <select value={slot.side3Type||""} onChange={e=>updateSlot(k,"side3Type",e.target.value)}
                                      style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #6a0572",fontSize:"11px",marginBottom:"3px",background:"#fdf4ff",color:"#6a0572"}}>
                                      <option value="">— Another side? —</option>
                                      <option value="Breakfast Side">Breakfast Side</option>
                                      <option value="All Sides">All Sides</option>
                                    </select>
                                    {slot.side3Type && (
                                      <select value={slot.side3||""} onChange={e=>updateSlot(k,"side3",e.target.value)}
                                        style={{width:"100%",padding:"5px 8px",borderRadius:"6px",border:"1px solid #6a0572",fontSize:"11px",marginBottom:"4px",background:"#fdf4ff"}}>
                                        <option value="">— Pick Side 2 —</option>
                                        {SIDES_DATA.filter(s => slot.side3Type === "All Sides" ? true : s.cat === slot.side3Type).sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                                      </select>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}

                            {/* Notes */}
                            <input value={slot.notes||""} onChange={e=>updateSlot(k,"notes",e.target.value)} placeholder="Notes..."
                              style={{width:"100%",padding:"4px 8px",borderRadius:"4px",border:"1px solid #ddd",fontSize:"11px",background:"white",boxSizing:"border-box"}} />

                            {/* Reason badge */}
                            {slot.reason && <div style={{marginTop:"4px",fontSize:"10px",color:"#666",background:"#f0f0f0",padding:"2px 6px",borderRadius:"8px",display:"inline-block"}}>{slot.reason}</div>}

                            {/* Custom items */}
                            <div style={{marginTop:"8px",paddingTop:"8px",borderTop:"1px solid #eee"}}>
                              <div style={{fontSize:"11px",fontWeight:"600",color:"#2d6a4f",marginBottom:"4px"}}>Special Items</div>
                              {(slot.customItems || []).map((item, idx) => (
                                <div key={idx} style={{fontSize:"10px",color:"#555",background:"#f9f9f9",padding:"4px 6px",borderRadius:"4px",marginBottom:"2px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                                  <span>{item}</span>
                                  <button onClick={() => {
                                    const newItems = [...(slot.customItems || [])];
                                    newItems.splice(idx, 1);
                                    updateSlot(k, "customItems", newItems);
                                  }} style={{background:"none",border:"none",cursor:"pointer",color:"#999",fontSize:"14px",padding:"0",marginLeft:"4px"}}>×</button>
                                </div>
                              ))}
                              <input type="text" placeholder="Add special item..." 
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" && e.target.value.trim()) {
                                    const newItems = [...(slot.customItems || []), e.target.value.trim()];
                                    updateSlot(k, "customItems", newItems);
                                    e.target.value = "";
                                  }
                                }}
                                style={{width:"100%",padding:"4px 6px",borderRadius:"4px",border:"1px solid #ddd",fontSize:"10px",marginTop:"2px",boxSizing:"border-box"}}/>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              });
            })()}
          </div>
        )}

        {/* ════════════════════════════════════ */}
        {/*  TAB: RHYTHMS                       */}
        {/* ════════════════════════════════════ */}
        {tab === "rhythms" && (
          <div>
            <h3 style={{color:"#2d6a4f",marginBottom:"4px",fontSize:"16px"}}>Meal Rules</h3>
            <p style={{fontSize:"13px",color:"#666",marginBottom:"16px"}}>Rules control how Auto Meal Plan fills your week. Pick a rule type, configure it, and add it.</p>

            {/* ── Rule Kind Picker ──────────── */}
            <div style={{background:"white",borderRadius:"12px",padding:"16px",boxShadow:"0 1px 4px rgba(0,0,0,0.08)",marginBottom:"20px"}}>
              <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginBottom:"14px"}}>
                {[
                  ["day_meal","Every Week"],
                  ["every_other","Every Other Week"],
                  ["frequency","X Times/Week"],
                  ["max_per_week","Max Per Week"],
                  ["min_per_week","Min Per Week"],
                  ["never_on","Never On"],
                  ["always_pair","Always Pair Side"],
                  ["rotate","Rotate Meals"],
                ].map(([k,label]) => (
                  <button key={k} onClick={()=>{setRuleKind(k);setNewRule({});}}
                    style={{padding:"6px 12px",borderRadius:"16px",border:"none",cursor:"pointer",fontSize:"12px",fontWeight:ruleKind===k?"700":"400",
                      background:ruleKind===k?"#2d6a4f":"#e5e7eb",color:ruleKind===k?"white":"#555"}}>
                    {label}
                  </button>
                ))}
              </div>

              {/* ── EVERY WEEK ──────────────── */}
              {ruleKind === "day_meal" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Example: "Friday Dinner = Eat Out" — applies every single week.</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center"}}>
                    <select value={newRule.day||""} onChange={e=>setNewRule(r=>({...r,day:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Day...</option>{DAYS.map(d=><option key={d} value={d}>{d}</option>)}
                    </select>
                    <select value={newRule.mealTime||""} onChange={e=>setNewRule(r=>({...r,mealTime:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Meal Time...</option>{MEAL_TIMES.map(m=><option key={m} value={m}>{m}</option>)}
                    </select>
                    <span style={{fontSize:"13px",color:"#666"}}>=</span>
                    <select value={newRule.type||""} onChange={e=>setNewRule(r=>({...r,type:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Type...</option>{Object.keys(PREP_TYPES).filter(t=>t!=="Auto").map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                    <select value={newRule.meal||""} onChange={e=>setNewRule(r=>({...r,meal:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Specific meal (optional)...</option>{MEALS_DATA.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                  </div>
                </div>
              )}

              {/* ── EVERY OTHER WEEK ───────── */}
              {ruleKind === "every_other" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Example: "Cream of Wheat every other Saturday Breakfast" — alternates weeks.</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center"}}>
                    <select value={newRule.day||""} onChange={e=>setNewRule(r=>({...r,day:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Day...</option>{DAYS.map(d=><option key={d} value={d}>{d}</option>)}
                    </select>
                    <select value={newRule.mealTime||""} onChange={e=>setNewRule(r=>({...r,mealTime:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Meal Time...</option>{MEAL_TIMES.map(m=><option key={m} value={m}>{m}</option>)}
                    </select>
                    <span style={{fontSize:"13px",color:"#666"}}>=</span>
                    <select value={newRule.type||""} onChange={e=>setNewRule(r=>({...r,type:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Type...</option>{Object.keys(PREP_TYPES).filter(t=>t!=="Auto").map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                    <select value={newRule.meal||""} onChange={e=>setNewRule(r=>({...r,meal:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Specific meal...</option>{MEALS_DATA.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                    <label style={{fontSize:"12px",display:"flex",alignItems:"center",gap:"4px"}}>
                      <span>Start week:</span>
                      <select value={newRule.startWeek||"odd"} onChange={e=>setNewRule(r=>({...r,startWeek:e.target.value}))} style={{padding:"4px 8px",borderRadius:"4px",border:"1px solid #ccc",fontSize:"12px"}}>
                        <option value="odd">This week (odd)</option><option value="even">Next week (even)</option>
                      </select>
                    </label>
                  </div>
                </div>
              )}

              {/* ── X TIMES PER WEEK ──────── */}
              {ruleKind === "frequency" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Example: "Eggs 3x/week for Breakfast, vary the sides" — picks different days each week.</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center"}}>
                    <select value={newRule.meal||""} onChange={e=>setNewRule(r=>({...r,meal:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Meal...</option>{MEALS_DATA.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                    <input type="number" min={1} max={7} value={newRule.count||3} onChange={e=>setNewRule(r=>({...r,count:+e.target.value}))}
                      style={{width:"50px",padding:"6px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",textAlign:"center"}} />
                    <span style={{fontSize:"13px",color:"#666"}}>times/week for</span>
                    <select value={newRule.mealTime||""} onChange={e=>setNewRule(r=>({...r,mealTime:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Meal Time...</option>{MEAL_TIMES.map(m=><option key={m} value={m}>{m}</option>)}
                    </select>
                    <label style={{fontSize:"12px",display:"flex",alignItems:"center",gap:"4px"}}>
                      <input type="checkbox" checked={newRule.varySides||false} onChange={e=>setNewRule(r=>({...r,varySides:e.target.checked}))} />
                      Vary sides each time
                    </label>
                  </div>
                  <div style={{marginTop:"8px",display:"flex",gap:"6px",flexWrap:"wrap",alignItems:"center"}}>
                    <span style={{fontSize:"12px",color:"#666"}}>Preferred days (optional):</span>
                    {DAYS.map(d => (
                      <label key={d} style={{fontSize:"12px",display:"flex",alignItems:"center",gap:"2px"}}>
                        <input type="checkbox" checked={(newRule.preferDays||[]).includes(d)}
                          onChange={e => { const days = newRule.preferDays||[]; setNewRule(r=>({...r,preferDays:e.target.checked?[...days,d]:days.filter(x=>x!==d)})); }} />
                        {d}
                      </label>
                    ))}
                  </div>
                </div>
              )}

              {/* ── MAX PER WEEK ──────────── */}
              {ruleKind === "max_per_week" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Example: "Max 2 Eat Out meals per week" — limits how often a type appears.</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center"}}>
                    <span style={{fontSize:"13px",color:"#666"}}>Max</span>
                    <input type="number" min={0} max={14} value={newRule.count||2} onChange={e=>setNewRule(r=>({...r,count:+e.target.value}))}
                      style={{width:"50px",padding:"6px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",textAlign:"center"}} />
                    <select value={newRule.type||""} onChange={e=>setNewRule(r=>({...r,type:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Type...</option>{Object.keys(PREP_TYPES).filter(t=>t!=="Auto").map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                    <span style={{fontSize:"13px",color:"#666"}}>per week</span>
                    <select value={newRule.mealTime||""} onChange={e=>setNewRule(r=>({...r,mealTime:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Any meal time</option>{MEAL_TIMES.map(m=><option key={m} value={m}>{m} only</option>)}
                    </select>
                  </div>
                </div>
              )}

              {/* ── MIN PER WEEK ──────────── */}
              {ruleKind === "min_per_week" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Example: "At least 1 Bulk Cook per week" — ensures a type appears enough.</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center"}}>
                    <span style={{fontSize:"13px",color:"#666"}}>At least</span>
                    <input type="number" min={1} max={14} value={newRule.count||1} onChange={e=>setNewRule(r=>({...r,count:+e.target.value}))}
                      style={{width:"50px",padding:"6px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",textAlign:"center"}} />
                    <select value={newRule.type||""} onChange={e=>setNewRule(r=>({...r,type:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Type...</option>{Object.keys(PREP_TYPES).filter(t=>t!=="Auto").map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                    <span style={{fontSize:"13px",color:"#666"}}>per week</span>
                    <select value={newRule.mealTime||""} onChange={e=>setNewRule(r=>({...r,mealTime:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Any meal time</option>{MEAL_TIMES.map(m=><option key={m} value={m}>{m} only</option>)}
                    </select>
                  </div>
                </div>
              )}

              {/* ── NEVER ON ─────────────── */}
              {ruleKind === "never_on" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Example: "Never Bulk Cook on Friday" — blocks a type on certain days.</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center"}}>
                    <span style={{fontSize:"13px",color:"#666"}}>Never</span>
                    <select value={newRule.type||""} onChange={e=>setNewRule(r=>({...r,type:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Type...</option>{Object.keys(PREP_TYPES).filter(t=>t!=="Auto").map(t=><option key={t} value={t}>{t}</option>)}
                    </select>
                    <span style={{fontSize:"13px",color:"#666"}}>on</span>
                    <select value={newRule.day||""} onChange={e=>setNewRule(r=>({...r,day:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Day...</option>{DAYS.map(d=><option key={d} value={d}>{d}</option>)}
                    </select>
                    <select value={newRule.mealTime||""} onChange={e=>setNewRule(r=>({...r,mealTime:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Any meal time</option>{MEAL_TIMES.map(m=><option key={m} value={m}>{m}</option>)}
                    </select>
                  </div>
                </div>
              )}

              {/* ── ALWAYS PAIR SIDE (up to 3) ─────── */}
              {ruleKind === "always_pair" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Lock sides to a meal. Side 1 is required; Sides 2 & 3 are optional (e.g., Birria → Rice + Beans + Tortillas).</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center",marginBottom:"6px"}}>
                    <span style={{fontSize:"13px",color:"#666"}}>If</span>
                    <select value={newRule.meal||""} onChange={e=>setNewRule(r=>({...r,meal:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Meal...</option>{MEALS_DATA.filter(m=>m.needsSide).map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                    <span style={{fontSize:"13px",color:"#666"}}>→ Side 1:</span>
                    <select value={newRule.side||""} onChange={e=>setNewRule(r=>({...r,side:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Side 1...</option>{SIDES_DATA.filter(s=>s.cat!=="Breakfast Side"&&s.cat!=="Breakfast Protein").sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                    </select>
                  </div>
                  {newRule.side && (
                    <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center",marginBottom:"6px"}}>
                      <span style={{fontSize:"12px",color:"#0d7377"}}>+ Side 2 (optional):</span>
                      <select value={newRule.side2||""} onChange={e=>setNewRule(r=>({...r,side2:e.target.value}))} style={{padding:"5px 10px",borderRadius:"6px",border:"1px solid #0d7377",fontSize:"12px",background:"#f0fdfa"}}>
                        <option value="">None</option>{SIDES_DATA.filter(s=>s.cat!=="Breakfast Side" && s.id!==newRule.side).sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                      </select>
                    </div>
                  )}
                  {newRule.side2 && (
                    <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center"}}>
                      <span style={{fontSize:"12px",color:"#6a0572"}}>+ Side 3 (optional):</span>
                      <select value={newRule.side3||""} onChange={e=>setNewRule(r=>({...r,side3:e.target.value}))} style={{padding:"5px 10px",borderRadius:"6px",border:"1px solid #6a0572",fontSize:"12px",background:"#fdf4ff"}}>
                        <option value="">None</option>{SIDES_DATA.filter(s=>s.cat!=="Breakfast Side" && s.id!==newRule.side && s.id!==newRule.side2).sort((a,b)=>a.name.localeCompare(b.name)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}
                      </select>
                    </div>
                  )}
                </div>
              )}

              {/* ── ROTATE MEALS ──────────── */}
              {ruleKind === "rotate" && (
                <div>
                  <p style={{fontSize:"12px",color:"#888",marginBottom:"8px"}}>Example: "Rotate Eggs, Pancakes, Oatmeal for weekday Breakfasts" — cycles through a list.</p>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap",alignItems:"center",marginBottom:"8px"}}>
                    <span style={{fontSize:"13px",color:"#666"}}>Rotate for</span>
                    <select value={newRule.mealTime||""} onChange={e=>setNewRule(r=>({...r,mealTime:e.target.value}))} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                      <option value="">Meal Time...</option>{MEAL_TIMES.map(m=><option key={m} value={m}>{m}</option>)}
                    </select>
                    <span style={{fontSize:"13px",color:"#666"}}>on:</span>
                    {DAYS.map(d => (
                      <label key={d} style={{fontSize:"12px",display:"flex",alignItems:"center",gap:"2px"}}>
                        <input type="checkbox" checked={(newRule.rotateDays||[]).includes(d)}
                          onChange={e => { const days = newRule.rotateDays||[]; setNewRule(r=>({...r,rotateDays:e.target.checked?[...days,d]:days.filter(x=>x!==d)})); }} />
                        {d}
                      </label>
                    ))}
                  </div>
                  <div style={{display:"flex",gap:"6px",flexWrap:"wrap",alignItems:"center"}}>
                    <span style={{fontSize:"12px",color:"#666"}}>Meals to rotate:</span>
                    <select onChange={e => { if(e.target.value) setNewRule(r=>({...r,rotateMeals:[...(r.rotateMeals||[]),e.target.value]})); e.target.value=""; }}
                      style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"12px"}}>
                      <option value="">Add a meal...</option>{MEALS_DATA.filter(m=>!(newRule.rotateMeals||[]).includes(m.id)).map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                  </div>
                  {(newRule.rotateMeals||[]).length > 0 && (
                    <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginTop:"6px"}}>
                      {(newRule.rotateMeals||[]).map((mId,i) => {
                        const meal = MEALS_DATA.find(m=>m.id===mId);
                        return (
                          <span key={i} style={{background:"#d8f3dc",color:"#2d6a4f",padding:"4px 10px",borderRadius:"12px",fontSize:"12px",display:"flex",alignItems:"center",gap:"4px"}}>
                            {meal?.name||mId}
                            <button onClick={()=>setNewRule(r=>({...r,rotateMeals:(r.rotateMeals||[]).filter(x=>x!==mId)}))}
                              style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"14px",padding:0}}>x</button>
                          </span>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}

              {/* ── ADD RULE BUTTON ──────── */}
              <div style={{marginTop:"12px"}}>
                <button onClick={()=>{
                  const r = {...newRule, kind:ruleKind};
                  // Validate based on kind
                  let valid = false;
                  if (ruleKind==="day_meal" && r.day && r.mealTime && r.type) valid=true;
                  if (ruleKind==="every_other" && r.day && r.mealTime && r.type) valid=true;
                  if (ruleKind==="frequency" && r.meal && r.mealTime && (r.count||3)>0) valid=true;
                  if (ruleKind==="max_per_week" && r.type && (r.count||2)>=0) valid=true;
                  if (ruleKind==="min_per_week" && r.type && (r.count||1)>0) valid=true;
                  if (ruleKind==="never_on" && r.type && r.day) valid=true;
                  if (ruleKind==="always_pair" && r.meal && r.side) valid=true;
                  if (ruleKind==="rotate" && r.mealTime && (r.rotateMeals||[]).length>=2 && (r.rotateDays||[]).length>=1) valid=true;
                  if (valid) { setRules(rs=>[...rs,r]); setNewRule({}); }
                }}
                  style={{padding:"8px 20px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                  Add Rule
                </button>
              </div>
            </div>

            {/* ── Active Rules List ──────────── */}
            {rules.length > 0 && (
              <div style={{marginBottom:"24px"}}>
                <h4 style={{color:"#555",fontSize:"14px",marginBottom:"8px"}}>Active Rules ({rules.length})</h4>
                {rules.map((r,i) => {
                  const mealName = r.meal ? MEALS_DATA.find(m=>m.id===r.meal)?.name : "";
                  const sideName = r.side ? SIDES_DATA.find(s=>s.id===r.side)?.name : "";
                  let desc = "";
                  if (r.kind==="day_meal") desc = `Every ${r.day} ${r.mealTime} = ${r.type}${mealName?" — "+mealName:""}`;
                  if (r.kind==="every_other") desc = `Every other ${r.day} ${r.mealTime} = ${r.type}${mealName?" — "+mealName:""} (${r.startWeek||"odd"} weeks)`;
                  if (r.kind==="frequency") desc = `${mealName} ${r.count||3}x/week for ${r.mealTime}${r.varySides?" (vary sides)":""}${(r.preferDays||[]).length>0?" on "+r.preferDays.join(", "):""}`;
                  if (r.kind==="max_per_week") desc = `Max ${r.count||2} ${r.type} per week${r.mealTime?" ("+r.mealTime+" only)":""}`;
                  if (r.kind==="min_per_week") desc = `At least ${r.count||1} ${r.type} per week${r.mealTime?" ("+r.mealTime+" only)":""}`;
                  if (r.kind==="never_on") desc = `Never ${r.type} on ${r.day}${r.mealTime?" "+r.mealTime:""}`;
                  if (r.kind==="always_pair") { const s2Name = r.side2 ? SIDES_DATA.find(s=>s.id===r.side2)?.name : ""; const s3Name = r.side3 ? SIDES_DATA.find(s=>s.id===r.side3)?.name : ""; desc = `If ${mealName} → ${sideName}${s2Name?" + "+s2Name:""}${s3Name?" + "+s3Name:""}`; }
                  if (r.kind==="rotate") { const names=(r.rotateMeals||[]).map(id=>MEALS_DATA.find(m=>m.id===id)?.name||id); desc=`Rotate [${names.join(", ")}] for ${r.mealTime} on ${(r.rotateDays||[]).join(", ")}`; }

                  const kindLabels = {day_meal:"Every Week",every_other:"Every Other",frequency:"Frequency",max_per_week:"Max/Week",min_per_week:"Min/Week",never_on:"Never On",always_pair:"Pair Side",rotate:"Rotate"};
                  const kindColors = {day_meal:"#2d6a4f",every_other:"#6a0572",frequency:"#1d3557",max_per_week:"#e76f51",min_per_week:"#0d7377",never_on:"#b5179e",always_pair:"#f4a261",rotate:"#1d3557"};

                  return (
                    <div key={i} style={{display:"flex",alignItems:"center",gap:"10px",padding:"10px 14px",background:"white",borderRadius:"8px",marginBottom:"6px",boxShadow:"0 1px 2px rgba(0,0,0,0.05)",borderLeft:`3px solid ${kindColors[r.kind]||"#ccc"}`}}>
                      <span style={{background:kindColors[r.kind]+"20",color:kindColors[r.kind],padding:"2px 8px",borderRadius:"10px",fontSize:"10px",fontWeight:"700",whiteSpace:"nowrap",textTransform:"uppercase"}}>{kindLabels[r.kind]||r.kind}</span>
                      <span style={{fontSize:"13px",color:"#333",flex:1}}>{desc}</span>
                      <button onClick={()=>setRules(rs=>rs.filter((_,j)=>j!==i))} style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"16px",flexShrink:0}}>x</button>
                    </div>
                  );
                })}
              </div>
            )}

            {/* ── Detected Patterns ─────────── */}
            <h3 style={{color:"#2d6a4f",marginBottom:"12px",fontSize:"16px",marginTop:"20px"}}>Detected Patterns</h3>
            <p style={{fontSize:"12px",color:"#888",marginBottom:"10px"}}>Auto-detected from your meal plan history. Promote to a rule to lock it in, or dismiss to hide it.</p>
            {patterns.length === 0 ? (
              <p style={{fontSize:"13px",color:"#888"}}>Finalize at least 2 plans to start detecting patterns.</p>
            ) : (
              <div style={{display:"grid",gap:"8px"}}>
                {patterns.map((p,i) => {
                  let desc = "";
                  let kindLabel = "";
                  let kindColor = "#2d6a4f";
                  let promoteRule = null;

                  if (p.kind === "day_type") {
                    const [day,mt,type] = p.pattern.split("_");
                    desc = `${day} ${mt} is usually ${type}`;
                    kindLabel = "Day Pattern";
                    kindColor = PREP_TYPES[type]?.color || "#2d6a4f";
                    promoteRule = { kind:"day_meal", day, mealTime:mt, type, meal:"" };
                  } else if (p.kind === "meal_freq") {
                    desc = `${p.mealName} ~${p.avgPerPlan}x per plan for ${p.mealTime}`;
                    kindLabel = "Frequency";
                    kindColor = "#1d3557";
                    promoteRule = { kind:"frequency", mealTime:p.mealTime, meal:p.mealId, count:Math.round(p.avgPerPlan), varySides:false, preferDays:[] };
                  } else if (p.kind === "side_pair") {
                    desc = `${p.mealName} usually paired with ${p.sideName}`;
                    kindLabel = "Side Pairing";
                    kindColor = "#f4a261";
                    promoteRule = { kind:"always_pair", meal:p.mealId, side:p.sideId, side2:"", side3:"" };
                  } else if (p.kind === "serving_style") {
                    desc = `${p.mealName} usually served as ${p.style}`;
                    kindLabel = "Serving Style";
                    kindColor = "#b45309";
                  }

                  return (
                    <div key={p.id} style={{display:"flex",alignItems:"center",gap:"10px",padding:"10px 14px",background:"white",borderRadius:"8px",boxShadow:"0 1px 2px rgba(0,0,0,0.05)",borderLeft:`3px solid ${kindColor}`}}>
                      <span style={{background:kindColor+"20",color:kindColor,padding:"2px 8px",borderRadius:"10px",fontSize:"10px",fontWeight:"700",whiteSpace:"nowrap",textTransform:"uppercase"}}>{kindLabel}</span>
                      <span style={{fontSize:"13px",color:"#333",flex:1}}>{desc}</span>
                      <div style={{background:"#d8f3dc",color:"#2d6a4f",padding:"2px 8px",borderRadius:"10px",fontSize:"11px",fontWeight:"600",whiteSpace:"nowrap"}}>{p.confidence}%</div>
                      {promoteRule && (
                        <button onClick={()=>{setRules(rs=>[...rs,promoteRule]); setDismissedPatterns(d=>[...d,p.id]);}}
                          title="Promote to rule" style={{background:"#d8f3dc",border:"none",color:"#2d6a4f",cursor:"pointer",fontSize:"12px",padding:"3px 8px",borderRadius:"6px",fontWeight:"600",whiteSpace:"nowrap"}}>
                          + Rule
                        </button>
                      )}
                      <button onClick={()=>setDismissedPatterns(d=>[...d,p.id])}
                        title="Dismiss pattern" style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"16px",flexShrink:0}}>
                        x
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            <div style={{marginTop:"20px",padding:"12px",background:"white",borderRadius:"10px",boxShadow:"0 1px 3px rgba(0,0,0,0.06)"}}>
              <h4 style={{color:"#555",fontSize:"14px",marginBottom:"6px"}}>Learning Stats</h4>
              <div style={{fontSize:"13px",color:"#666"}}>
                Plans finalized: {history.length} · Rules active: {rules.length} · Patterns detected: {patterns.length}
              </div>
            </div>
          </div>
        )}

        {/* ════════════════════════════════════ */}
        {/*  TAB: PANTRY                        */}
        {/* ════════════════════════════════════ */}
        {tab === "pantry" && (
          <div>
            <div style={{display:"flex",gap:"8px",marginBottom:"16px"}}>
              <button onClick={()=>setPantryTab("freezer")} style={{padding:"8px 16px",borderRadius:"8px",border:"none",cursor:"pointer",fontWeight:"600",fontSize:"13px",
                background:pantryTab==="freezer"?"#2d6a4f":"#e5e7eb",color:pantryTab==="freezer"?"white":"#555"}}>Cooked Freezer Stash</button>
              <button onClick={()=>setPantryTab("pantry")} style={{padding:"8px 16px",borderRadius:"8px",border:"none",cursor:"pointer",fontWeight:"600",fontSize:"13px",
                background:pantryTab==="pantry"?"#2d6a4f":"#e5e7eb",color:pantryTab==="pantry"?"white":"#555"}}>Pantry Inventory</button>
              <button onClick={()=>setPantryTab("scan")} style={{padding:"8px 16px",borderRadius:"8px",border:"none",cursor:"pointer",fontWeight:"600",fontSize:"13px",
                background:pantryTab==="scan"?"#f4a261":"#e5e7eb",color:pantryTab==="scan"?"white":"#555"}}>{"\uD83D\uDCF7"} Snap Pantry</button>
            </div>

            {pantryTab === "freezer" && (
              <div>
                <p style={{fontSize:"13px",color:"#666",marginBottom:"4px"}}>
                  <strong>Cooked meals you've batched and frozen</strong> — these are used when scheduling <em>Defrost</em> meals.
                </p>
                <p style={{fontSize:"11px",color:"#999",marginBottom:"12px",fontStyle:"italic"}}>
                  Note: ready-to-cook frozen items (Fish Sticks, Frozen Pizza, Chicken Nuggets) live in the meal catalog, not here. Pick those from the meal dropdown when filling a slot.
                </p>

                {/* ── Snap Photo shortcut: jumps to Scan tab with Freezer mode pre-selected ── */}
                <div style={{display:"flex",gap:"10px",marginBottom:"14px",alignItems:"center",flexWrap:"wrap"}}>
                  <button
                    onClick={() => { setScanMode("freezer"); setAiResult(null); setAiError(null); setPantryTab("scan"); }}
                    style={{padding:"10px 18px",background:"#6a0572",color:"white",border:"none",borderRadius:"10px",fontWeight:"700",fontSize:"13px",cursor:"pointer",boxShadow:"0 2px 6px rgba(106,5,114,0.25)",display:"inline-flex",alignItems:"center",gap:"8px"}}>
                    {"📷"} Snap a Photo of Your Freezer
                  </button>
                  <span style={{fontSize:"12px",color:"#666"}}>
                    AI will identify cooked meals and add them here automatically.
                  </span>
                </div>

                <div style={{display:"flex",gap:"8px",marginBottom:"16px",flexWrap:"wrap",alignItems:"center"}}>
                  <select id="fz-meal" style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                    <option value="">Select meal...</option>
                    {MEALS_DATA.filter(m=>m.time.some(t=>["Dinner","Lunch"].includes(t))).sort((a,b)=>a.name.localeCompare(b.name)).map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                  </select>
                  <input id="fz-portions" type="number" min={1} defaultValue={2} placeholder="Portions" style={{width:"80px",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}} />
                  <select id="fz-time" style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                    <option value="Both">Both (Lunch/Dinner)</option>
                    <option value="Lunch">Lunch</option>
                    <option value="Dinner">Dinner</option>
                  </select>
                  <button onClick={()=>{
                    const mealId=document.getElementById("fz-meal").value;
                    const portions=+document.getElementById("fz-portions").value;
                    const time=document.getElementById("fz-time").value;
                    const meal=MEALS_DATA.find(m=>m.id===mealId);
                    if(meal&&portions>0) setFreezerMeals(f=>[...f,{mealId,name:meal.name,portions,mealTime:time}]);
                  }} style={{padding:"6px 16px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"6px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                    Add to Freezer
                  </button>
                </div>
                {freezerMeals.length===0 ? <p style={{color:"#888",fontSize:"13px"}}>No freezer meals yet. Snap a photo above or add one manually.</p> : (
                  <div style={{display:"grid",gap:"8px"}}>
                    {freezerMeals.map((fm,i)=>(
                      <div key={i} style={{display:"flex",alignItems:"center",gap:"12px",padding:"10px 14px",background:"white",borderRadius:"8px",boxShadow:"0 1px 2px rgba(0,0,0,0.05)",borderLeft:"3px solid #6a0572"}}>
                        <div style={{flex:1}}>
                          <div style={{fontWeight:"600",fontSize:"14px"}}>{fm.name}</div>
                          <div style={{fontSize:"12px",color:"#666"}}>{fm.portions} portions · {fm.mealTime}</div>
                        </div>
                        <button onClick={()=>setFreezerMeals(f=>f.filter((_,j)=>j!==i))}
                          style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"18px"}}>x</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {pantryTab === "pantry" && (
              <div>
                <p style={{fontSize:"13px",color:"#666",marginBottom:"12px"}}>Track raw ingredients on hand. The grocery list will subtract these automatically.</p>
                <div style={{display:"flex",gap:"8px",marginBottom:"16px",flexWrap:"wrap",alignItems:"center"}}>
                  <input id="pi-name" placeholder="Ingredient name" style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",flex:"1",minWidth:"150px"}} />
                  <input id="pi-qty" type="number" min={0} step="0.5" defaultValue={1} style={{width:"70px",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}} />
                  <input id="pi-unit" placeholder="Unit" style={{width:"80px",padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}} />
                  <select id="pi-loc" style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                    <option value="Pantry">Pantry</option>
                    <option value="Fridge">Fridge</option>
                    <option value="Freezer">Freezer</option>
                  </select>
                  <input id="pi-exp" type="date" title="Expiration / use-by date (optional)" style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"12px"}} />
                  <button onClick={()=>{
                    const name=document.getElementById("pi-name").value;
                    const qty=+document.getElementById("pi-qty").value;
                    const unit=document.getElementById("pi-unit").value;
                    const loc=document.getElementById("pi-loc").value;
                    const exp=document.getElementById("pi-exp").value || null;
                    if(name&&qty>0) {
                      setPantryItems(p=>[...p,{name,qty,unit,location:loc,expiresAt:exp}]);
                      document.getElementById("pi-name").value="";
                      document.getElementById("pi-exp").value="";
                    }
                  }} style={{padding:"6px 16px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"6px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                    Add Item
                  </button>
                </div>

                <div style={{display:"flex",gap:"8px",marginBottom:"12px",alignItems:"center"}}>
                  <input value={pantrySearch} onChange={e=>setPantrySearch(e.target.value)} placeholder="Search pantry..."
                    style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px",flex:"1"}} />
                  <select value={pantryLocFilter} onChange={e=>setPantryLocFilter(e.target.value)} style={{padding:"6px 10px",borderRadius:"6px",border:"1px solid #ccc",fontSize:"13px"}}>
                    <option value="All">All Locations</option>
                    <option value="Pantry">Pantry</option>
                    <option value="Fridge">Fridge</option>
                    <option value="Freezer">Freezer</option>
                  </select>
                </div>

                {pantryItems.filter(p=>{
                  const sm=pantrySearch.toLowerCase();
                  return (!sm||p.name.toLowerCase().includes(sm))&&(pantryLocFilter==="All"||p.location===pantryLocFilter);
                }).length===0 ? <p style={{color:"#888",fontSize:"13px"}}>No pantry items yet.</p> : (
                  <div style={{display:"grid",gap:"6px"}}>
                    {pantryItems.filter(p=>{
                      const sm=pantrySearch.toLowerCase();
                      return (!sm||p.name.toLowerCase().includes(sm))&&(pantryLocFilter==="All"||p.location===pantryLocFilter);
                    }).sort((a,b)=>{
                      // Items with expiration sorted soonest-first (so you see what's about to go bad).
                      // Items without expiration drop to the bottom.
                      const ae = a.expiresAt ? new Date(a.expiresAt).getTime() : Infinity;
                      const be = b.expiresAt ? new Date(b.expiresAt).getTime() : Infinity;
                      return ae - be;
                    }).map((p,i)=>{
                      const expBadge = (() => {
                        if (!p.expiresAt) return null;
                        const days = Math.round((new Date(p.expiresAt).getTime() - Date.now()) / 86400000);
                        const bg = days < 0 ? "#fecaca" : days <= 3 ? "#fde68a" : "#dcfce7";
                        const fg = days < 0 ? "#991b1b" : days <= 3 ? "#92400e" : "#166534";
                        const label = days < 0 ? `EXPIRED ${-days}d ago` : days === 0 ? "Today" : `${days}d`;
                        return <span style={{fontSize:"10px",padding:"2px 6px",borderRadius:"8px",background:bg,color:fg,fontWeight:"600"}}>{label}</span>;
                      })();
                      return (
                        <div key={i} style={{display:"flex",alignItems:"center",gap:"10px",padding:"8px 12px",background:"white",borderRadius:"8px",boxShadow:"0 1px 2px rgba(0,0,0,0.04)"}}>
                          <div style={{flex:1}}>
                            <span style={{fontWeight:"500",fontSize:"13px"}}>{p.name}</span>
                            <span style={{fontSize:"12px",color:"#666",marginLeft:"8px"}}>{p.qty} {p.unit}</span>
                          </div>
                          {expBadge}
                          <span style={{fontSize:"11px",padding:"2px 8px",borderRadius:"10px",
                            background:p.location==="Fridge"?"#dbeafe":p.location==="Freezer"?"#e0e7ff":"#fef3c7",
                            color:p.location==="Fridge"?"#1d4ed8":p.location==="Freezer"?"#4338ca":"#92400e"}}>{p.location}</span>
                          <button onClick={()=>setPantryItems(ps=>ps.filter((_,j)=>j!==i))}
                            style={{background:"none",border:"none",color:"#e76f51",cursor:"pointer",fontSize:"16px"}}>x</button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {pantryTab === "scan" && (
              <div>
                {/* Scan mode toggle */}
                <div style={{display:"flex",gap:"8px",marginBottom:"14px"}}>
                  <button onClick={() => { setScanMode("receipt"); setAiResult(null); setAiError(null); }}
                    style={{padding:"6px 14px",borderRadius:"6px",border: scanMode === "receipt" ? "2px solid #0d6efd" : "1px solid #ccc",
                      background: scanMode === "receipt" ? "#e7f1ff" : "white",
                      fontWeight: scanMode === "receipt" ? "600" : "400",fontSize:"13px",cursor:"pointer",color:"#333"}}>
                    {"\uD83E\uDDFE"} Scan Receipt
                  </button>
                  <button onClick={() => { setScanMode && setScanMode("pantry"); setAiResult(null); setAiError(null); }}
                    style={{padding:"6px 14px",borderRadius:"6px",border: (scanMode === "pantry") ? "2px solid #2d6a4f" : "1px solid #ccc",
                      background: (scanMode === "pantry") ? "#e8f5e9" : "white",
                      fontWeight: (scanMode === "pantry") ? "600" : "400",fontSize:"13px",cursor:"pointer",color:"#333"}}>
                    Scan Pantry / Fridge
                  </button>
                  <button onClick={() => { setScanMode("freezer"); setAiResult(null); setAiError(null); }}
                    style={{padding:"6px 14px",borderRadius:"6px",border: scanMode === "freezer" ? "2px solid #6a0572" : "1px solid #ccc",
                      background: scanMode === "freezer" ? "#f3e5f5" : "white",
                      fontWeight: scanMode === "freezer" ? "600" : "400",fontSize:"13px",cursor:"pointer",color:"#333"}}>
                    Scan Freezer Meals
                  </button>
                </div>

                <p style={{fontSize:"13px",color:"#666",marginBottom:"12px"}}>
                  {scanMode === "freezer"
                    ? "Snap photos of your freezer containers/labels, or a handwritten/typed list of what's in your freezer. AI will match items to your meal catalog."
                    : "Take photos of your pantry shelves, fridge, or counters. AI will identify items and add them to your inventory."
                  }
                </p>

                {/* File/Camera input */}
                <div style={{marginBottom:"16px"}}>
                  <label style={{
                    display:"inline-flex",alignItems:"center",gap:"8px",padding:"12px 24px",
                    background: scanMode === "freezer" ? "#6a0572" : "#f4a261",color:"white",borderRadius:"10px",cursor:"pointer",
                    fontWeight:"600",fontSize:"14px",boxShadow:"0 2px 4px rgba(0,0,0,0.1)",
                  }}>
                    {"\uD83D\uDCF7"} {scanMode === "freezer" ? "Snap Freezer Contents" : scanMode === "receipt" ? "Snap Receipt" : "Take Photo or Choose Images"}
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      capture="environment"
                      style={{display:"none"}}
                      onChange={async (e) => {
                        const files = Array.from(e.target.files || []);
                        if (files.length === 0) return;

                        const toBase64 = (file) => new Promise((resolve, reject) => {
                          const reader = new FileReader();
                          reader.onload = () => resolve(reader.result);
                          reader.onerror = reject;
                          reader.readAsDataURL(file);
                        });

                        setAiLoading(true);
                        setAiError(null);
                        setAiResult(null);

                        try {
                          const base64Images = await Promise.all(files.map(f => toBase64(f)));
                          const isFreezer = scanMode === "freezer";
                          const isReceipt = scanMode === "receipt";

                          // Build request body
                          const reqBody = {
                            taskType: isReceipt ? "scan_receipt" : isFreezer ? "scan_freezer" : "scan_pantry",
                            mealCatalog: isFreezer ? MEALS_DATA.filter(m => m.time.some(t => ["Lunch","Dinner"].includes(t))).map(m => ({ id: m.id, name: m.name, time: m.time, cuisine: m.cuisine })) : [],
                            images: base64Images,
                            userMessage: isFreezer
                              ? `I'm uploading ${files.length} photo(s) of my freezer contents. Please identify all cooked meals and match them to my meal catalog.`
                              : `I'm uploading ${files.length} photo(s) of my kitchen storage. Please identify all food items you can see.`,
                          };

                          const res = await fetch(MEAL_AI_URL, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${await getEdgeFnToken()}`,
                              "apikey": SUPABASE_ANON_KEY,
                            },
                            body: JSON.stringify(reqBody),
                          });

                          const json = await res.json();

                          if (json.fallback || json.error) {
                            setAiError(json.error || "AI scan unavailable");
                          } else {
                            setAiResult({ data: json.data, taskType: isFreezer ? "scan_freezer" : "scan_pantry", model: json.model, usage: json.usage });
                          }
                        } catch (err) {
                          console.error("Scan failed:", err);
                          setAiError("Failed to scan photos — " + (err.message || "connection error"));
                        }
                        setAiLoading(false);
                        e.target.value = "";
                      }}
                    />
                  </label>
                  <span style={{fontSize:"12px",color:"#888",marginLeft:"12px"}}>Supports multiple photos at once</span>
                </div>

                {/* Loading */}
                {aiLoading && (
                  <div style={{textAlign:"center",padding:"40px",color:"#f4a261"}}>
                    <div style={{fontSize:"28px",marginBottom:"8px"}}>{"\uD83D\uDCF7"}</div>
                    <p style={{fontSize:"14px",color:"#333"}}>AI is scanning your photos...</p>
                    <p style={{fontSize:"11px",color:"#999"}}>Identifying items — this takes 5-15 seconds</p>
                  </div>
                )}

                {/* Error */}
                {aiError && (
                  <div style={{background:"#fff3cd",border:"1px solid #ffc107",borderRadius:"8px",padding:"12px",marginBottom:"16px",fontSize:"13px",color:"#856404"}}>
                    {"\u26A0\uFE0F"} {aiError}
                  </div>
                )}

                {/* Scan Results */}
                {aiResult && aiResult.taskType === "scan_pantry" && aiResult.data?.items && (
                  <div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"10px"}}>
                      <h4 style={{color:"#2d6a4f",margin:0}}>Found {aiResult.data.items.length} Items</h4>
                      <button
                        onClick={() => {
                          // Merge scanned items into pantryItems
                          const newItems = aiResult.data.items
                            .filter(item => item.confidence !== "low")
                            .map(item => ({
                              name: item.name,
                              qty: item.quantity,
                              unit: item.unit,
                              location: item.location === "fridge" ? "Fridge" : item.location === "freezer" ? "Freezer" : "Pantry",
                            }));

                          // Deduplicate: skip items already in pantry (case-insensitive name match)
                          const existingNames = new Set((pantryItems || []).map(p => p.name.toLowerCase()));
                          const uniqueNew = newItems.filter(item => !existingNames.has(item.name.toLowerCase()));

                          if (uniqueNew.length > 0) {
                            setPantryItems(prev => [...(prev || []), ...uniqueNew]);
                            setAiResult(prev => ({
                              ...prev,
                              _mergedCount: uniqueNew.length,
                              _skippedCount: newItems.length - uniqueNew.length,
                            }));
                          }
                        }}
                        style={{padding:"8px 20px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                        Add All to Pantry ({aiResult.data.items.filter(i => i.confidence !== "low").length} items)
                      </button>
                    </div>

                    {aiResult._mergedCount != null && (
                      <div style={{background:"#d4edda",borderRadius:"8px",padding:"10px 14px",marginBottom:"12px",fontSize:"13px",color:"#155724"}}>
                        {"\u2705"} Added {aiResult._mergedCount} new items to your pantry!
                        {aiResult._skippedCount > 0 && ` (${aiResult._skippedCount} already existed)`}
                      </div>
                    )}

                    {aiResult.data.summary && (
                      <p style={{fontSize:"12px",color:"#555",marginBottom:"12px",fontStyle:"italic"}}>{aiResult.data.summary}</p>
                    )}

                    <div style={{display:"grid",gap:"6px"}}>
                      {aiResult.data.items.map((item, i) => (
                        <div key={i} style={{
                          display:"flex",alignItems:"center",gap:"10px",padding:"8px 12px",
                          background:"white",borderRadius:"8px",boxShadow:"0 1px 2px rgba(0,0,0,0.04)",
                          borderLeft:`3px solid ${item.confidence === "high" ? "#2d6a4f" : item.confidence === "medium" ? "#f4a261" : "#e76f51"}`,
                          opacity: item.confidence === "low" ? 0.6 : 1,
                        }}>
                          <div style={{flex:1}}>
                            <span style={{fontWeight:"600",fontSize:"13px"}}>{item.name}</span>
                            <span style={{fontSize:"12px",color:"#666",marginLeft:"8px"}}>{item.quantity} {item.unit}</span>
                          </div>
                          <span style={{fontSize:"10px",padding:"2px 8px",borderRadius:"10px",fontWeight:"600",
                            background: item.location === "fridge" ? "#dbeafe" : item.location === "freezer" ? "#e0e7ff" : item.location === "counter" ? "#fef3c7" : "#d8f3dc",
                            color: item.location === "fridge" ? "#1d4ed8" : item.location === "freezer" ? "#4338ca" : item.location === "counter" ? "#92400e" : "#2d6a4f",
                          }}>{item.location}</span>
                          <span style={{fontSize:"10px",padding:"2px 6px",borderRadius:"8px",
                            background: item.confidence === "high" ? "#d4edda" : item.confidence === "medium" ? "#fff3cd" : "#f8d7da",
                            color: item.confidence === "high" ? "#155724" : item.confidence === "medium" ? "#856404" : "#721c24",
                          }}>{item.confidence}</span>
                        </div>
                      ))}
                    </div>

                    <p style={{fontSize:"11px",color:"#aaa",marginTop:"10px"}}>Model: {aiResult.model} · Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
                  </div>
                )}

                {/* Freezer Scan Results */}
                {aiResult && aiResult.taskType === "scan_freezer" && aiResult.data?.items && (
                  <div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"10px"}}>
                      <h4 style={{color:"#6a0572",margin:0}}>Found {aiResult.data.items.length} Freezer Meals</h4>
                      <button
                        onClick={() => {
                          const newMeals = aiResult.data.items
                            .filter(item => item.confidence !== "low" && item.matchedMealId)
                            .map(item => ({
                              mealId: item.matchedMealId,
                              name: item.name,
                              portions: item.portions || 2,
                              mealTime: item.mealTime || "Both",
                            }));

                          if (newMeals.length > 0) {
                            setFreezerMeals(prev => {
                              // Merge: if same mealId exists, add portions; otherwise add new
                              const merged = [...prev];
                              newMeals.forEach(nm => {
                                const existing = merged.find(m => m.mealId === nm.mealId);
                                if (existing) {
                                  existing.portions += nm.portions;
                                } else {
                                  merged.push(nm);
                                }
                              });
                              return merged;
                            });
                            setAiResult(prev => ({ ...prev, _mergedCount: newMeals.length }));
                          }
                        }}
                        style={{padding:"8px 20px",background:"#6a0572",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                        Add All to Freezer ({aiResult.data.items.filter(i => i.confidence !== "low").length} meals)
                      </button>
                    </div>

                    {aiResult._mergedCount != null && (
                      <div style={{background:"#f3e5f5",borderRadius:"8px",padding:"10px 14px",marginBottom:"12px",fontSize:"13px",color:"#6a0572"}}>
                        {"\u2705"} Added {aiResult._mergedCount} meals to your freezer inventory!
                      </div>
                    )}

                    {aiResult.data.summary && (
                      <p style={{fontSize:"12px",color:"#555",marginBottom:"12px",fontStyle:"italic"}}>{aiResult.data.summary}</p>
                    )}

                    <div style={{display:"grid",gap:"6px"}}>
                      {aiResult.data.items.map((item, i) => (
                        <div key={i} style={{
                          display:"flex",alignItems:"center",gap:"10px",padding:"8px 12px",
                          background:"white",borderRadius:"8px",boxShadow:"0 1px 2px rgba(0,0,0,0.04)",
                          borderLeft:`3px solid ${item.confidence === "high" ? "#6a0572" : item.confidence === "medium" ? "#f4a261" : "#e76f51"}`,
                          opacity: item.confidence === "low" ? 0.6 : 1,
                        }}>
                          <div style={{flex:1}}>
                            <span style={{fontWeight:"600",fontSize:"13px"}}>{item.name}</span>
                            <span style={{fontSize:"12px",color:"#666",marginLeft:"8px"}}>{item.portions} portions · {item.mealTime}</span>
                            {item.notes && <span style={{fontSize:"11px",color:"#999",marginLeft:"6px"}}>({item.notes})</span>}
                          </div>
                          <span style={{fontSize:"10px",padding:"2px 8px",borderRadius:"10px",fontWeight:"600",
                            background: item.matchedMealId ? "#e8f5e9" : "#fff3cd",
                            color: item.matchedMealId ? "#2d6a4f" : "#856404",
                          }}>{item.matchedMealId || "unmatched"}</span>
                          <span style={{fontSize:"10px",padding:"2px 6px",borderRadius:"8px",
                            background: item.confidence === "high" ? "#d4edda" : item.confidence === "medium" ? "#fff3cd" : "#f8d7da",
                            color: item.confidence === "high" ? "#155724" : item.confidence === "medium" ? "#856404" : "#721c24",
                          }}>{item.confidence}</span>
                        </div>
                      ))}
                    </div>

                    {aiResult.data.unmatched?.length > 0 && (
                      <div style={{marginTop:"12px"}}>
                        <h5 style={{color:"#856404",marginBottom:"6px",fontSize:"13px"}}>Unmatched Items</h5>
                        {aiResult.data.unmatched.map((u, i) => (
                          <div key={i} style={{fontSize:"12px",color:"#666",padding:"4px 0"}}>
                            <strong>{u.description}</strong> — {u.suggestion}
                          </div>
                        ))}
                      </div>
                    )}

                    <p style={{fontSize:"11px",color:"#aaa",marginTop:"10px"}}>Model: {aiResult.model} · Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* ════════════════════════════════════ */}
        {/*  TAB: GROCERY LIST                  */}
        {/* ════════════════════════════════════ */}
        {tab === "grocery" && (
          <div>
            {!finalized ? (
              <div style={{padding:"40px",textAlign:"center",color:"#888"}}>
                <p style={{fontSize:"16px",marginBottom:"8px"}}>No grocery list yet</p>
                <p style={{fontSize:"13px"}}>Go to Plan Meals and click "Finalize Plan" to generate your grocery list.</p>
              </div>
            ) : (
              <div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px",flexWrap:"wrap",gap:"8px"}}>
                  <h3 style={{color:"#2d6a4f",margin:0,fontSize:"16px"}}>Grocery List — Family of {familySize}</h3>
                  <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                    <button onClick={()=>handlePrint("grocery")}
                      style={{padding:"8px 16px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                      Print Grocery List
                    </button>
                    <button onClick={() => {
                      // CSV export — handy for sharing grocery lists with the family,
                      // pasting into a notes app, or importing into Instacart/Walmart.
                      const rows = [["Week","Category","Item","Quantity","Unit"]];
                      weeklyGroceryLists.forEach((weekList, wIdx) => {
                        const weekLabel = weeks > 1 ? `Week ${wIdx + 1}` : "";
                        Object.entries(weekList).sort(([a],[b])=>a.localeCompare(b)).forEach(([cat, items]) => {
                          items.filter(it => it.qty > 0).forEach(it => {
                            rows.push([weekLabel, cat, it.name, Math.round(it.qty * 10) / 10, it.unit]);
                          });
                        });
                      });
                      const csv = rows.map(r => r.map(c => {
                        const s = String(c);
                        return /[",\n]/.test(s) ? `"${s.replace(/"/g,'""')}"` : s;
                      }).join(",")).join("\n");
                      const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `grocery-${startDate}.csv`;
                      a.click();
                      setTimeout(() => URL.revokeObjectURL(url), 1000);
                    }}
                      style={{padding:"8px 16px",background:"#1d3557",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                      Export CSV
                    </button>
                  </div>
                </div>
                {weeklyGroceryLists.length === 0 ? (
                  <p style={{color:"#888",fontSize:"13px"}}>No ingredients needed (meals may not have ingredient data yet).</p>
                ) : (
                  weeklyGroceryLists.map((weekList, wIdx) => {
                    const weekStart = addDays(new Date(startDate + "T00:00:00"), wIdx * 7);
                    const weekEnd = addDays(weekStart, 6);
                    const hasItems = Object.values(weekList).some(items => items.some(it => it.qty > 0));
                    return (
                      <div key={wIdx} style={{marginBottom:"24px"}}>
                        {weeks > 1 && (
                          <div style={{background:"#2d6a4f",color:"white",padding:"10px 16px",borderRadius:"10px 10px 0 0",fontWeight:"600",fontSize:"14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                            <span>Week {wIdx + 1}</span>
                            <span style={{fontSize:"12px",fontWeight:"400",opacity:0.8}}>{fmtShort(weekStart)} – {fmtShort(weekEnd)}</span>
                          </div>
                        )}
                        <div style={weeks > 1 ? {border:"1px solid #e5e7eb",borderTop:"none",borderRadius:"0 0 10px 10px",padding:"12px"} : {}}>
                          {!hasItems ? (
                            <p style={{color:"#888",fontSize:"13px",padding:"8px 0"}}>No ingredients needed this week.</p>
                          ) : (
                            Object.entries(weekList).sort(([a],[b])=>a.localeCompare(b)).map(([cat, items]) => {
                              const visibleItems = items.filter(it => it.qty > 0);
                              if (visibleItems.length === 0) return null;
                              return (
                                <div key={cat} style={{marginBottom:"14px"}}>
                                  <h4 style={{color:"#f4a261",fontSize:"13px",marginBottom:"6px",textTransform:"uppercase",letterSpacing:"0.5px"}}>{cat}</h4>
                                  <div style={{background:"white",borderRadius:"8px",boxShadow:"0 1px 3px rgba(0,0,0,0.06)",overflow:"hidden"}}>
                                    {visibleItems.sort((a,b)=>a.name.localeCompare(b.name)).map((item,i) => {
                                      const gKey = `w${wIdx}_${cat}_${item.name}`;
                                      return (
                                        <div key={i} style={{display:"flex",alignItems:"center",gap:"10px",padding:"8px 12px",borderBottom:"1px solid #f0f0f0"}}>
                                          <input type="checkbox" checked={!!groceryChecked[gKey]} onChange={()=>setGroceryChecked(c=>({...c,[gKey]:!c[gKey]}))}
                                            style={{width:"16px",height:"16px",accentColor:"#2d6a4f"}} />
                                          <span style={{flex:1,fontSize:"13px",textDecoration:groceryChecked[gKey]?"line-through":"none",color:groceryChecked[gKey]?"#aaa":"#333"}}>
                                            {item.name} {item.tag && <span style={{color:"#f4a261",fontSize:"11px"}}>{item.tag}</span>}
                                          </span>
                                          <span style={{fontSize:"12px",color:"#666",whiteSpace:"nowrap"}}>{Math.round(item.qty*100)/100} {item.unit}</span>
                                          {item.onHand > 0 && (
                                            <span style={{fontSize:"10px",padding:"2px 6px",borderRadius:"8px",background:"#d8f3dc",color:"#2d6a4f",fontWeight:"600"}}>
                                              {item.onHand} on hand
                                            </span>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </div>
        )}

      </div>

      {/* ════════════════════════════════════════ */}
      {/*  PRINT VIEW MODAL                        */}
      {/* ════════════════════════════════════════ */}
      {showPrintView && finalized && (
        <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
          <div style={{background:"white",borderRadius:"16px",maxWidth:"900px",width:"100%",maxHeight:"90vh",overflow:"auto",padding:"24px",position:"relative"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"16px"}}>
              <h2 style={{color:"#2d6a4f",fontSize:"20px",margin:0}}>Your Meal Plan is Ready!</h2>
              <button onClick={()=>setShowPrintView(false)} style={{background:"none",border:"none",fontSize:"24px",cursor:"pointer",color:"#888"}}>x</button>
            </div>

            <p style={{fontSize:"14px",color:"#555",marginBottom:"16px"}}>Your plan has been finalized. Print this page to put on the fridge, or save as PDF.</p>

            <div style={{display:"flex",gap:"10px",marginBottom:"20px",flexWrap:"wrap"}}>
              <button onClick={()=>handlePrint("both")} style={{padding:"10px 24px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"14px",cursor:"pointer"}}>
                Print Plan + Grocery List
              </button>
              <button onClick={()=>handlePrint("plan")} style={{padding:"10px 24px",background:"#1e40af",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"14px",cursor:"pointer"}}>
                Print Meal Plan Only
              </button>
              <button onClick={()=>handlePrint("grocery")} style={{padding:"10px 24px",background:"#f4a261",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"14px",cursor:"pointer"}}>
                Print Grocery List Only
              </button>
              <button onClick={()=>handlePrint("fridge")} style={{padding:"10px 24px",background:"#7c2d12",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"14px",cursor:"pointer"}}>
                Fridge Calendar
              </button>
              <button onClick={()=>setShowPrintView(false)} style={{padding:"10px 24px",background:"#e5e7eb",color:"#555",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"14px",cursor:"pointer"}}>
                Close
              </button>
            </div>

            {/* ── Printable Plan Summary ────── */}
            <div id="printable-plan" style={{border:"1px solid #ddd",borderRadius:"10px",padding:"16px"}}>
              <div style={{textAlign:"center",marginBottom:"16px",borderBottom:"2px solid #2d6a4f",paddingBottom:"12px"}}>
                <h3 style={{color:"#2d6a4f",margin:"0 0 4px 0",fontSize:"18px"}}>Rogers Family Meal Plan</h3>
                <p style={{color:"#666",fontSize:"12px",margin:0}}>Family of {familySize} · Week of {new Date(startDate+"T00:00:00").toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})}</p>
              </div>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px"}}>
                <thead>
                  <tr style={{background:"#2d6a4f",color:"white"}}>
                    <th style={{padding:"8px",textAlign:"left",borderRadius:"6px 0 0 0"}}>Day</th>
                    {MEAL_TIMES.map(mt => <th key={mt} style={{padding:"8px",textAlign:"left"}}>{mt}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const totalDays = weeks * 7;
                    const sd = new Date(startDate + "T00:00:00");
                    return Array.from({length:totalDays}, (_,i) => {
                      const day = addDays(sd, i);
                      const dateKey = day.toISOString().slice(0,10);
                      const dayName = DAYS[day.getDay()];
                      return (
                        <tr key={dateKey} style={{borderBottom:"1px solid #eee",background:i%2===0?"#faf9f6":"white"}}>
                          <td style={{padding:"8px",fontWeight:"600",whiteSpace:"nowrap"}}>{dayName} {fmtShort(day)}</td>
                          {MEAL_TIMES.map(mt => {
                            const k = `${dateKey}_${mt}`;
                            const slot = plan[k];
                            if (!slot) return <td key={mt} style={{padding:"8px"}}>—</td>;
                            const meal = MEALS_DATA.find(m => m.id === slot.mealId);
                            const side = SIDES_DATA.find(s => s.id === slot.side);
                            const side2 = SIDES_DATA.find(s => s.id === slot.side2);
                            const side3 = SIDES_DATA.find(s => s.id === slot.side3);
                            const pt = PREP_TYPES[slot.prepType];
                            return (
                              <td key={mt} style={{padding:"8px",verticalAlign:"top"}}>
                                <span style={{color:pt?.color,fontWeight:"500"}}>{slot.prepType}</span>
                                {meal && <div>{meal.name}{slot.isLeftover ? " (L)" : ""}{slot.servingStyle ? ` [${slot.servingStyle}]` : ""}</div>}
                                {side && <div style={{color:"#f4a261",fontSize:"11px"}}>+ {side.name}</div>}
                                {side2 && <div style={{color:"#0d7377",fontSize:"11px"}}>+ {side2.name}</div>}
                                {side3 && <div style={{color:"#6a0572",fontSize:"11px"}}>+ {side3.name}</div>}
                                {slot.notes && slot.notes.trim() && <div style={{color:"#888",fontSize:"10px",fontStyle:"italic"}}>{"✎ "}{slot.notes}</div>}
                                {Array.isArray(slot.customItems) && slot.customItems.length > 0 && (
                                  <div style={{color:"#7c2d12",fontSize:"10px",marginTop:"2px"}}>+ {slot.customItems.join(", ")}</div>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    });
                  })()}
                </tbody>
              </table>

              {/* Grocery summary in print view */}
              {Object.keys(groceryList).length > 0 && (
                <div style={{marginTop:"20px",borderTop:"2px solid #f4a261",paddingTop:"12px"}}>
                  <h4 style={{color:"#f4a261",marginBottom:"8px",fontSize:"14px"}}>Grocery List</h4>
                  {Object.entries(groceryList).sort(([a],[b])=>a.localeCompare(b)).map(([cat, items]) => (
                    <div key={cat} style={{marginBottom:"8px"}}>
                      <strong style={{fontSize:"12px",color:"#555",textTransform:"uppercase"}}>{cat}:</strong>{" "}
                      <span style={{fontSize:"12px",color:"#333"}}>
                        {items.filter(it=>it.qty>0).sort((a,b)=>a.name.localeCompare(b.name)).map((it,i) =>
                          <span key={i}>{it.name} ({Math.round(it.qty*10)/10} {it.unit}){i < items.filter(x=>x.qty>0).length - 1 ? ", " : ""}</span>
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════════════════════ */}
      {/*  TAB: AI ASSISTANT                  */}
      {/* ════════════════════════════════════ */}
      {tab === "ai" && (
        <div style={{padding:"16px 20px", maxWidth:"900px", margin:"0 auto"}}>
          <h3 style={{color:"#2d6a4f",marginBottom:"12px",display:"flex",alignItems:"center",gap:"8px"}}>
            {"\u2728"} AI Meal Assistant
          </h3>
          <p style={{color:"#666",fontSize:"13px",marginBottom:"16px"}}>
            Ask the AI to suggest meals from your pantry, interpret your food preferences, adapt recipes, or discover new meal ideas for your family.
          </p>

          {/* Task Type Selector */}
          <div style={{display:"flex",gap:"8px",marginBottom:"16px",flexWrap:"wrap"}}>
            {[
              ["suggest_from_pantry", "What Can I Cook?"],
              ["natural_language_preference", "Set Preferences"],
              ["adapt_recipe", "Adapt a Recipe"],
              ["new_meal_suggestions", "Discover New Meals"],
              ["use_first", "\uD83E\uDD6C Use First"],
              ["nutrition_score", "\uD83E\uDD57 Nutrition Score"],
              ["costco_optimize", "\uD83D\uDED2 Costco Optimizer"],
              ["holiday_plan", "\uD83C\uDF89 Holiday/Potluck"],
            ].map(([key, label]) => (
              <button key={key} onClick={() => { setAiTaskType(key); setAiResult(null); setAiError(null); }}
                style={{
                  padding:"8px 16px", borderRadius:"8px", border: aiTaskType === key ? "2px solid #2d6a4f" : "1px solid #ccc",
                  background: aiTaskType === key ? "#e8f5e9" : "white", cursor:"pointer",
                  fontWeight: aiTaskType === key ? "600" : "400", fontSize:"13px", color: aiTaskType === key ? "#2d6a4f" : "#555",
                }}>
                {label}
              </button>
            ))}
          </div>

          {/* Contextual hint */}
          <div style={{background:"#f0f7f4",borderRadius:"8px",padding:"10px 14px",marginBottom:"12px",fontSize:"12px",color:"#555"}}>
            {aiTaskType === "suggest_from_pantry" && "Tell the AI what you have on hand, or just say \"what can I cook tonight?\" and it will match your pantry to meals in your catalog."}
            {aiTaskType === "natural_language_preference" && "Say things like \"more Mexican food\", \"tired of chicken\", \"kids don't like fish\", \"make Wednesdays easier\". The AI translates these into preference adjustments."}
            {aiTaskType === "adapt_recipe" && "Name a meal and what you want changed: \"make Shakshuka kid-friendly\", \"scale Chicken Curry for 12\", \"make Pasta Carbonara dairy-free\"."}
            {aiTaskType === "new_meal_suggestions" && "Ask for new meal ideas: \"suggest 3 quick weeknight dinners\", \"new breakfast ideas the kids will love\", \"something Asian we haven't tried\"."}
            {aiTaskType === "use_first" && "Analyzes your pantry for items nearing expiration and suggests meals to use them first. Just click Ask AI!"}
            {aiTaskType === "nutrition_score" && "Scores your current meal plan on protein variety, vegetable intake, grain balance, calcium, fruit, and cuisine variety. Plan must be filled first."}
            {aiTaskType === "costco_optimize" && "Cross-references your meal plan with pantry/freezer to recommend what to buy at Costco and what to skip. Estimates cost per serving."}
            {aiTaskType === "holiday_plan" && "Plan a holiday meal, potluck, or gathering. Say: \"Thanksgiving for 15\", \"Church potluck dish for 20\", \"Birthday party for 10 kids\"."}
          </div>

          {/* Input area */}
          <div style={{display:"flex",gap:"8px",marginBottom:"16px"}}>
            <input
              value={aiQuery}
              onChange={e => setAiQuery(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter" && aiQuery.trim() && !aiLoading) callMealAI(aiTaskType, aiQuery.trim()); }}
              placeholder={
                aiTaskType === "suggest_from_pantry" ? "What can I cook with what's in my pantry?" :
                aiTaskType === "natural_language_preference" ? "e.g., More Mediterranean, less beef..." :
                aiTaskType === "adapt_recipe" ? "e.g., Make Shakshuka kid-friendly..." :
                aiTaskType === "use_first" ? "Check my pantry for items to use first (or just press Ask AI)" :
                aiTaskType === "nutrition_score" ? "Score my current meal plan (just press Ask AI)" :
                aiTaskType === "costco_optimize" ? "What should I buy at Costco this trip?" :
                aiTaskType === "holiday_plan" ? "e.g., Thanksgiving dinner for 15 people..." :
                "e.g., Suggest 3 new easy weeknight dinners..."
              }
              style={{flex:1, padding:"10px 14px", border:"1px solid #ccc", borderRadius:"8px", fontSize:"14px"}}
              disabled={aiLoading}
            />
            <button
              onClick={() => { if (aiQuery.trim() && !aiLoading) callMealAI(aiTaskType, aiQuery.trim()); }}
              disabled={aiLoading || !aiQuery.trim()}
              style={{
                padding:"10px 20px", background: aiLoading ? "#aaa" : "#2d6a4f", color:"white",
                border:"none", borderRadius:"8px", fontWeight:"600", fontSize:"14px", cursor: aiLoading ? "wait" : "pointer",
                minWidth:"100px",
              }}>
              {aiLoading ? "Thinking..." : "Ask AI"}
            </button>
          </div>

          {/* Error display */}
          {aiError && (
            <div style={{background:"#fff3cd",border:"1px solid #ffc107",borderRadius:"8px",padding:"12px",marginBottom:"16px",fontSize:"13px",color:"#856404"}}>
              {"\u26A0\uFE0F"} {aiError}
            </div>
          )}

          {/* Loading spinner */}
          {aiLoading && (
            <div style={{textAlign:"center",padding:"40px",color:"#2d6a4f"}}>
              <div style={{fontSize:"24px",marginBottom:"8px"}}>{"\u2728"}</div>
              <p style={{fontSize:"14px"}}>AI is analyzing your meals and preferences...</p>
              <p style={{fontSize:"11px",color:"#999"}}>This usually takes 3-8 seconds</p>
            </div>
          )}

          {/* Results: Pantry Suggestions */}
          {aiResult && aiResult.taskType === "suggest_from_pantry" && aiResult.data?.suggestions && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"10px"}}>Meals You Can Make</h4>
              {aiResult.data.suggestions.map((s, i) => (
                <div key={i} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"10px",padding:"14px",marginBottom:"10px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
                    <strong style={{fontSize:"14px",color:"#1a1a1a"}}>{s.mealName}</strong>
                    <span style={{
                      padding:"2px 10px",borderRadius:"12px",fontSize:"12px",fontWeight:"600",
                      background: s.matchType === "exact" ? "#d4edda" : s.matchType === "near" ? "#fff3cd" : "#f8d7da",
                      color: s.matchType === "exact" ? "#155724" : s.matchType === "near" ? "#856404" : "#721c24",
                    }}>
                      {s.matchPercentage}% match
                    </span>
                  </div>
                  {s.missingIngredients.length > 0 && (
                    <p style={{fontSize:"12px",color:"#dc3545",margin:"4px 0"}}>Missing: {s.missingIngredients.join(", ")}</p>
                  )}
                  {s.substitutions.length > 0 && (
                    <div style={{fontSize:"12px",color:"#6c757d",margin:"4px 0"}}>
                      {s.substitutions.map((sub, j) => (
                        <span key={j}>{sub.original} {"\u2192"} {sub.substitute}{j < s.substitutions.length - 1 ? " · " : ""}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"8px"}}>Model: {aiResult.model} · Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: Natural Language Preferences */}
          {aiResult && aiResult.taskType === "natural_language_preference" && aiResult.data && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"10px"}}>Preference Adjustments</h4>
              <div style={{background:"#f0f7f4",borderRadius:"8px",padding:"12px",marginBottom:"12px",fontSize:"13px",color:"#333"}}>
                <strong>Interpretation:</strong> {aiResult.data.interpretation}
              </div>
              {(aiResult.data.adjustments || []).map((adj, i) => (
                <div key={i} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"8px",padding:"10px 14px",marginBottom:"8px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <span style={{fontSize:"13px",fontWeight:"600"}}>{adj.parameterType}</span>
                    <span style={{fontSize:"13px",color:"#555"}}> {"\u2192"} {adj.action} {adj.target}</span>
                    {adj.value != null && <span style={{fontSize:"12px",color:"#2d6a4f",fontWeight:"600"}}> ({adj.value > 0 ? "+" : ""}{adj.value})</span>}
                  </div>
                  <span style={{
                    padding:"2px 8px",borderRadius:"10px",fontSize:"11px",fontWeight:"500",
                    background: adj.confidence === "high" ? "#d4edda" : adj.confidence === "medium" ? "#fff3cd" : "#f8d7da",
                    color: adj.confidence === "high" ? "#155724" : adj.confidence === "medium" ? "#856404" : "#721c24",
                  }}>{adj.confidence}</span>
                </div>
              ))}
              <p style={{fontSize:"12px",color:"#666",marginTop:"8px"}}>{aiResult.data.reasoning || ""}</p>
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"4px"}}>Model: {aiResult.model} · Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: Recipe Adaptation */}
          {aiResult && aiResult.taskType === "adapt_recipe" && aiResult.data && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"10px"}}>Adapted Recipe</h4>
              <div style={{background:"#f0f7f4",borderRadius:"8px",padding:"12px",marginBottom:"12px"}}>
                <p style={{fontSize:"13px",margin:"0 0 6px 0"}}><strong>Adaptation:</strong> {aiResult.data.adaptationType}</p>
                <p style={{fontSize:"13px",margin:"0 0 6px 0"}}><strong>Servings:</strong> {aiResult.data.servings} · <strong>Prep:</strong> {aiResult.data.prepTime}</p>
              </div>
              {aiResult.data.changes && aiResult.data.changes.length > 0 && (
                <div style={{marginBottom:"12px"}}>
                  <strong style={{fontSize:"13px",color:"#333"}}>Changes Made:</strong>
                  {aiResult.data.changes.map((ch, i) => (
                    <div key={i} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"6px",padding:"8px 12px",marginTop:"6px",fontSize:"12px"}}>
                      <strong>{ch.what}</strong> — {ch.why}
                    </div>
                  ))}
                </div>
              )}
              {aiResult.data.modifiedIngredients && (
                <div>
                  <strong style={{fontSize:"13px",color:"#333"}}>Modified Ingredients:</strong>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"4px",marginTop:"6px"}}>
                    {aiResult.data.modifiedIngredients.map((ing, i) => (
                      <div key={i} style={{fontSize:"12px",padding:"4px 8px",background:"#f8f9fa",borderRadius:"4px"}}>
                        {ing.q} {ing.u} {ing.n}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {aiResult.data.modifiedInstructions && (
                <div style={{marginTop:"12px",background:"white",border:"1px solid #e5e7eb",borderRadius:"8px",padding:"12px",fontSize:"13px",whiteSpace:"pre-wrap"}}>
                  <strong>Instructions:</strong><br/>{aiResult.data.modifiedInstructions}
                </div>
              )}
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"8px"}}>Model: {aiResult.model} · Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: New Meal Suggestions */}
          {aiResult && aiResult.taskType === "new_meal_suggestions" && aiResult.data?.suggestions && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"10px"}}>New Meal Ideas</h4>
              {aiResult.data.analysisOfPreferences && (
                <div style={{background:"#f0f7f4",borderRadius:"8px",padding:"10px 14px",marginBottom:"12px",fontSize:"12px",color:"#555"}}>
                  {aiResult.data.analysisOfPreferences}
                </div>
              )}
              {aiResult.data.suggestions.map((s, i) => (
                <div key={i} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"10px",padding:"14px",marginBottom:"10px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
                    <strong style={{fontSize:"14px",color:"#1a1a1a"}}>{s.meal.name}</strong>
                    <span style={{padding:"2px 10px",borderRadius:"12px",fontSize:"11px",background:"#e8f5e9",color:"#2d6a4f",fontWeight:"500"}}>
                      {(s.meal.cuisine || "").charAt(0).toUpperCase() + (s.meal.cuisine || "").slice(1)} · {s.meal.cook}
                    </span>
                  </div>
                  <p style={{fontSize:"12px",color:"#555",margin:"4px 0"}}>{s.meal.notes}</p>
                  <p style={{fontSize:"12px",color:"#2d6a4f",margin:"4px 0",fontStyle:"italic"}}>{s.whyTheyWillLikeIt}</p>
                  {s.ingredients && (
                    <details style={{marginTop:"6px"}}>
                      <summary style={{fontSize:"12px",color:"#888",cursor:"pointer"}}>View ingredients ({s.ingredients.length})</summary>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"2px",marginTop:"4px"}}>
                        {s.ingredients.map((ing, j) => (
                          <span key={j} style={{fontSize:"11px",color:"#666"}}>{ing.q} {ing.u} {ing.n}</span>
                        ))}
                      </div>
                    </details>
                  )}
                </div>
              ))}
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"8px"}}>Model: {aiResult.model} · Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: Use First (Waste Reduction) */}
          {aiResult && aiResult.taskType === "use_first" && aiResult.data && (
            <div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px"}}>
                <h4 style={{color:"#dc3545",margin:0}}>{"\uD83E\uDD6C"} Use These First!</h4>
                <span style={{padding:"4px 12px",borderRadius:"12px",fontSize:"12px",fontWeight:"700",
                  background: aiResult.data.wasteRiskScore > 60 ? "#f8d7da" : aiResult.data.wasteRiskScore > 30 ? "#fff3cd" : "#d4edda",
                  color: aiResult.data.wasteRiskScore > 60 ? "#721c24" : aiResult.data.wasteRiskScore > 30 ? "#856404" : "#155724",
                }}>Waste Risk: {aiResult.data.wasteRiskScore}/100</span>
              </div>
              {aiResult.data.urgentItems?.length > 0 && (
                <div style={{marginBottom:"12px"}}>
                  <strong style={{fontSize:"13px",color:"#333"}}>Items at Risk:</strong>
                  <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginTop:"6px"}}>
                    {aiResult.data.urgentItems.map((item, i) => (
                      <span key={i} style={{padding:"4px 10px",borderRadius:"8px",fontSize:"12px",fontWeight:"600",
                        background: item.urgency === "critical" ? "#f8d7da" : item.urgency === "soon" ? "#fff3cd" : "#e8f5e9",
                        color: item.urgency === "critical" ? "#721c24" : item.urgency === "soon" ? "#856404" : "#155724",
                      }}>{item.name} ({item.daysLeft}d)</span>
                    ))}
                  </div>
                </div>
              )}
              {aiResult.data.suggestedMeals?.map((m, i) => (
                <div key={i} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"10px",padding:"12px",marginBottom:"8px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                    <strong style={{fontSize:"14px"}}>{m.mealName}</strong>
                    <span style={{fontSize:"12px",color:"#2d6a4f",fontWeight:"600"}}>{m.suggestedDay}</span>
                  </div>
                  <p style={{fontSize:"12px",color:"#555",margin:"4px 0"}}>Uses: {m.usesItems.join(", ")}</p>
                  <p style={{fontSize:"12px",color:"#888",margin:0}}>{m.reasoning}</p>
                </div>
              ))}
              <p style={{fontSize:"12px",color:"#666",marginTop:"8px"}}>{aiResult.data.summary}</p>
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"4px"}}>Model: {aiResult.model} {"\u00B7"} Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: Nutrition Scorecard */}
          {aiResult && aiResult.taskType === "nutrition_score" && aiResult.data && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"12px"}}>{"\uD83E\uDD57"} Nutrition Scorecard</h4>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:"8px",marginBottom:"14px"}}>
                <div style={{background:"linear-gradient(135deg,#e8f5e9,#c8e6c9)",borderRadius:"10px",padding:"14px",textAlign:"center"}}>
                  <div style={{fontSize:"28px",fontWeight:"800",color:"#2d6a4f"}}>{aiResult.data.overallScore}</div>
                  <div style={{fontSize:"11px",color:"#555"}}>Overall</div>
                </div>
                <div style={{background:"linear-gradient(135deg,#e3f2fd,#bbdefb)",borderRadius:"10px",padding:"14px",textAlign:"center"}}>
                  <div style={{fontSize:"28px",fontWeight:"800",color:"#1565c0"}}>{aiResult.data.kidFriendlinessScore}</div>
                  <div style={{fontSize:"11px",color:"#555"}}>Kid Score</div>
                </div>
                {Object.entries(aiResult.data.categoryScores || {}).map(([cat, score]) => (
                  <div key={cat} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"10px",padding:"10px",textAlign:"center"}}>
                    <div style={{fontSize:"20px",fontWeight:"700",color: score >= 70 ? "#2d6a4f" : score >= 50 ? "#f59e0b" : "#dc2626"}}>{score}</div>
                    <div style={{fontSize:"10px",color:"#888",textTransform:"capitalize"}}>{cat.replace(/([A-Z])/g," $1").trim()}</div>
                  </div>
                ))}
              </div>
              {aiResult.data.gaps?.length > 0 && (
                <div style={{marginBottom:"12px"}}>
                  <strong style={{fontSize:"13px"}}>Nutritional Gaps:</strong>
                  {aiResult.data.gaps.map((g, i) => (
                    <div key={i} style={{display:"flex",gap:"8px",alignItems:"center",padding:"6px 0",borderBottom:"1px solid #f3f4f6",fontSize:"12px"}}>
                      <span style={{padding:"2px 8px",borderRadius:"6px",fontSize:"11px",fontWeight:"600",
                        background: g.severity === "high" ? "#fecaca" : g.severity === "medium" ? "#fef3c7" : "#d1fae5",
                        color: g.severity === "high" ? "#991b1b" : g.severity === "medium" ? "#92400e" : "#065f46"
                      }}>{g.severity}</span>
                      <span style={{fontWeight:"600"}}>{g.nutrient}:</span>
                      <span style={{color:"#555"}}>{g.suggestion}</span>
                    </div>
                  ))}
                </div>
              )}
              <p style={{fontSize:"12px",color:"#666"}}>{aiResult.data.summary}</p>
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"4px"}}>Model: {aiResult.model} {"\u00B7"} Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: Costco Optimizer */}
          {aiResult && aiResult.taskType === "costco_optimize" && aiResult.data && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"12px"}}>{"\uD83D\uDED2"} Costco Shopping Plan</h4>
              {aiResult.data.recommendations?.map((r, i) => (
                <div key={i} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"10px",padding:"12px",marginBottom:"8px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"4px"}}>
                    <strong style={{fontSize:"14px"}}>{r.item}</strong>
                    <span style={{padding:"3px 10px",borderRadius:"8px",fontSize:"11px",fontWeight:"600",
                      background: r.priority === "must_buy" ? "#d4edda" : r.priority === "recommended" ? "#cce5ff" : "#f8f9fa",
                      color: r.priority === "must_buy" ? "#155724" : r.priority === "recommended" ? "#004085" : "#6c757d"
                    }}>{r.priority.replace(/_/g," ")}</span>
                  </div>
                  <div style={{fontSize:"12px",color:"#555",display:"flex",gap:"12px",marginBottom:"4px"}}>
                    <span>{"\uD83D\uDCB0"} {r.estimatedPrice}</span>
                    <span>{"\uD83C\uDF7D\uFE0F"} Enables {r.mealsEnabled} meals</span>
                    <span>Per serving: {r.costPerServing}</span>
                  </div>
                  <p style={{fontSize:"12px",color:"#888",margin:0}}>{r.reasoning}</p>
                </div>
              ))}
              {aiResult.data.skipThisTrip?.length > 0 && (
                <div style={{marginTop:"12px",marginBottom:"12px"}}>
                  <strong style={{fontSize:"13px",color:"#dc3545"}}>Skip This Trip:</strong>
                  {aiResult.data.skipThisTrip.map((s, i) => (
                    <div key={i} style={{fontSize:"12px",color:"#666",padding:"4px 0"}}>{"\u274C"} {s.item} — {s.reason}</div>
                  ))}
                </div>
              )}
              {aiResult.data.estimatedTotalSavings && (
                <div style={{background:"#d4edda",borderRadius:"8px",padding:"10px 14px",marginBottom:"12px",fontSize:"14px",fontWeight:"600",color:"#155724"}}>
                  Estimated savings this trip: {aiResult.data.estimatedTotalSavings}
                </div>
              )}
              <p style={{fontSize:"12px",color:"#666"}}>{aiResult.data.summary}</p>
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"4px"}}>Model: {aiResult.model} {"\u00B7"} Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: Holiday/Potluck Planner */}
          {aiResult && aiResult.taskType === "holiday_plan" && aiResult.data && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"6px"}}>{"\uD83C\uDF89"} {aiResult.data.eventName || "Event"} Plan</h4>
              <p style={{fontSize:"13px",color:"#555",marginBottom:"12px"}}>Guest count: {aiResult.data.guestCount}</p>

              {/* Menu */}
              <div style={{marginBottom:"14px"}}>
                <strong style={{fontSize:"14px",color:"#333"}}>Menu</strong>
                {aiResult.data.menu?.map((item, i) => (
                  <div key={i} style={{background:"white",border:"1px solid #e5e7eb",borderRadius:"8px",padding:"10px 14px",marginTop:"6px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <span style={{fontSize:"11px",color:"#2d6a4f",fontWeight:"600",textTransform:"uppercase"}}>{item.course}</span>
                      <div style={{fontSize:"14px",fontWeight:"600"}}>{item.dishName}</div>
                      <div style={{fontSize:"11px",color:"#888"}}>{item.prepTime} prep {item.canPrepAhead ? " \u00B7 Can prep ahead!" : ""}</div>
                    </div>
                    <span style={{fontSize:"12px",color:"#555"}}>Serves {item.servings}</span>
                  </div>
                ))}
              </div>

              {/* Timeline */}
              <div style={{marginBottom:"14px"}}>
                <strong style={{fontSize:"14px",color:"#333"}}>Cooking Timeline</strong>
                <div style={{background:"#f0f7f4",borderRadius:"10px",padding:"12px",marginTop:"6px"}}>
                  {aiResult.data.timeline?.map((step, i) => (
                    <div key={i} style={{display:"flex",gap:"10px",padding:"6px 0",borderBottom: i < aiResult.data.timeline.length - 1 ? "1px solid #e5e7eb" : "none",fontSize:"12px"}}>
                      <span style={{fontWeight:"700",color:"#2d6a4f",minWidth:"120px"}}>{step.when}</span>
                      <span style={{color:"#333",flex:1}}>{step.task}</span>
                      <span style={{color:"#888",minWidth:"60px",textAlign:"right"}}>{step.duration}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Grocery list */}
              <div style={{marginBottom:"14px"}}>
                <strong style={{fontSize:"14px",color:"#333"}}>Grocery List ({aiResult.data.groceryList?.length || 0} items)</strong>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"4px",marginTop:"6px"}}>
                  {aiResult.data.groceryList?.map((g, i) => (
                    <div key={i} style={{fontSize:"12px",padding:"3px 0",color:"#555"}}>{g.quantity} {g.item}</div>
                  ))}
                </div>
              </div>

              {/* Tips */}
              {aiResult.data.tips?.length > 0 && (
                <div style={{background:"#fff3cd",borderRadius:"8px",padding:"10px 14px",marginBottom:"12px",fontSize:"12px",color:"#856404"}}>
                  <strong>Tips:</strong>
                  {aiResult.data.tips.map((t, i) => (
                    <div key={i} style={{marginTop:"4px"}}>{"\u2022"} {t}</div>
                  ))}
                </div>
              )}

              <p style={{fontSize:"12px",color:"#666"}}>{aiResult.data.summary}</p>
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"4px"}}>Model: {aiResult.model} {"\u00B7"} Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}

          {/* Results: Receipt Scanner */}
          {aiResult && aiResult.taskType === "scan_receipt" && aiResult.data && (
            <div>
              <h4 style={{color:"#2d6a4f",marginBottom:"8px"}}>{"\uD83E\uDDFE"} Receipt: {aiResult.data.store || "Store"} ({aiResult.data.date || ""})</h4>
              <div style={{background:"#d4edda",borderRadius:"8px",padding:"10px 14px",marginBottom:"12px",fontSize:"14px",fontWeight:"600",color:"#155724"}}>
                Total: ${aiResult.data.totalSpent?.toFixed(2) || "?"} {"\u00B7"} {aiResult.data.items?.length || 0} items
              </div>
              {aiResult.data.items?.map((item, i) => (
                <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #f3f4f6",fontSize:"12px"}}>
                  <div>
                    <span style={{fontWeight:"600"}}>{item.name}</span>
                    <span style={{color:"#888"}}> {"\u00B7"} {item.quantity} {item.unit} {"\u00B7"} {item.category}</span>
                  </div>
                  <span style={{fontWeight:"600",color:"#2d6a4f"}}>${item.price.toFixed(2)}</span>
                </div>
              ))}
              <div style={{marginTop:"12px",display:"flex",gap:"8px"}}>
                <button onClick={() => {
                  const newItems = (aiResult.data.items || [])
                    .filter(it => !["household","other"].includes(it.category))
                    .map(it => ({ name: it.name, qty: parseFloat(it.quantity) || 1, unit: it.unit, category: it.category, location: it.location }));
                  setPantryItems(prev => {
                    const merged = [...prev];
                    newItems.forEach(ni => {
                      const existing = merged.findIndex(p => p.name.toLowerCase() === ni.name.toLowerCase());
                      if (existing >= 0) { merged[existing].qty = (merged[existing].qty || 0) + ni.qty; }
                      else { merged.push(ni); }
                    });
                    return merged;
                  });
                  alert("Added " + newItems.length + " items to pantry!");
                }}
                  style={{padding:"8px 16px",background:"#2d6a4f",color:"white",border:"none",borderRadius:"8px",fontWeight:"600",fontSize:"13px",cursor:"pointer"}}>
                  Add All to Pantry
                </button>
              </div>
              <p style={{fontSize:"12px",color:"#666",marginTop:"8px"}}>{aiResult.data.summary}</p>
              <p style={{fontSize:"11px",color:"#aaa",marginTop:"4px"}}>Model: {aiResult.model} {"\u00B7"} Tokens: {aiResult.usage?.input_tokens || "?"} in / {aiResult.usage?.output_tokens || "?"} out</p>
            </div>
          )}
        </div>
      )}

      {/* ── Footer ────────────────────────────── */}
      <div style={{textAlign:"center",padding:"20px",color:"#aaa",fontSize:"11px",borderTop:"1px solid #eee",marginTop:"20px"}}>
        Rogers Family Meal Planner · Built with love for the Rogers family
      </div>
    </div>{/* end #app-content */}

      {/* ── Printable Content (always rendered, hidden on screen, shown when printing) ── */}
      <div id="printable-content">
        {(printMode === "plan" || printMode === "both") && finalized && (
          <div className="print-plan-section" style={{padding:"8px"}}>
            <div className="print-plan-header" style={{textAlign:"center",marginBottom:"8px",borderBottom:"2px solid #2d6a4f",paddingBottom:"6px"}}>
              <h3 style={{color:"#2d6a4f",margin:"0 0 2px 0",fontSize:"14px"}}>Rogers Family Meal Plan</h3>
              <p style={{color:"#666",fontSize:"10px",margin:0}}>Family of {familySize} · {weeks > 1 ? `${weeks} Weeks starting` : "Week of"} {new Date(startDate+"T00:00:00").toLocaleDateString("en-US",{month:"long",day:"numeric",year:"numeric"})}</p>
            </div>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:"13px",tableLayout:"fixed"}}>
              <thead>
                <tr style={{background:"#2d6a4f",color:"white"}}>
                  <th style={{padding:"8px",textAlign:"left",width:"70px"}}>Day</th>
                  {MEAL_TIMES.map(mt => <th key={mt} style={{padding:"8px",textAlign:"left"}}>{mt}</th>)}
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const totalDays = weeks * 7;
                  const sd = new Date(startDate + "T00:00:00");
                  return Array.from({length:totalDays}, (_,i) => {
                    const day = addDays(sd, i);
                    const dateKey = day.toISOString().slice(0,10);
                    const dayName = DAYS[day.getDay()];
                    return (
                      <tr key={dateKey} style={{borderBottom:"1px solid #ddd",background:i%2===0?"#faf9f6":"white"}}>
                        <td style={{padding:"8px",fontWeight:"700",whiteSpace:"nowrap",fontSize:"13px"}}>{dayName} {fmtShort(day)}</td>
                        {MEAL_TIMES.map(mt => {
                          const k = `${dateKey}_${mt}`;
                          const slot = plan[k];
                          if (!slot) return <td key={mt} style={{padding:"8px",fontSize:"13px"}}>—</td>;
                          const meal = MEALS_DATA.find(m => m.id === slot.mealId);
                          const side = SIDES_DATA.find(s => s.id === slot.side);
                          const side2 = SIDES_DATA.find(s => s.id === slot.side2);
                          const side3 = SIDES_DATA.find(s => s.id === slot.side3);
                          const pt = PREP_TYPES[slot.prepType];
                          return (
                            <td key={mt} style={{padding:"8px",fontSize:"13px",lineHeight:"1.4",verticalAlign:"top"}}>
                              <span style={{color:pt?.color,fontWeight:"600",fontSize:"11px",textTransform:"uppercase"}}>{slot.prepType}</span>
                              {meal && <div style={{fontSize:"13px",fontWeight:"500",marginTop:"2px"}}>{meal.name}{slot.isLeftover ? " (L)" : ""}{slot.servingStyle ? ` [${slot.servingStyle}]` : ""}</div>}
                              {side && <div style={{color:"#f4a261",fontSize:"11px",marginTop:"1px"}}>+ {side.name}</div>}
                              {side2 && <div style={{color:"#0d7377",fontSize:"11px"}}>+ {side2.name}</div>}
                              {side3 && <div style={{color:"#6a0572",fontSize:"11px"}}>+ {side3.name}</div>}
                              {slot.notes && slot.notes.trim() && (
                                <div className="print-slot-notes" style={{color:"#444",fontSize:"10px",marginTop:"3px",fontStyle:"italic",lineHeight:"1.25"}}>
                                  {"✎ "}{slot.notes}
                                </div>
                              )}
                              {Array.isArray(slot.customItems) && slot.customItems.length > 0 && (
                                <div className="print-slot-extras" style={{color:"#7c2d12",fontSize:"10px",marginTop:"2px",lineHeight:"1.25"}}>
                                  + {slot.customItems.join(", ")}
                                </div>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        )}

        {(printMode === "grocery" || printMode === "both") && weeklyGroceryLists.length > 0 && (
          <div style={{padding:"8px",pageBreakBefore: printMode === "both" ? "always" : "auto"}}>
            <h3 style={{color:"#f4a261",margin:"0 0 8px 0",fontSize:"14px",borderBottom:"2px solid #f4a261",paddingBottom:"4px"}}>Grocery List</h3>
            <div className="print-grocery-section">
              {weeklyGroceryLists.map((weekList, wIdx) => {
                const weekStart = addDays(new Date(startDate + "T00:00:00"), wIdx * 7);
                const weekEnd = addDays(weekStart, 6);
                const hasItems = Object.values(weekList).some(items => items.some(it => it.qty > 0));
                if (!hasItems) return null;
                return (
                  <div key={wIdx} className="grocery-week-block" style={{marginBottom:"12px"}}>
                    {weeks > 1 && (
                      <div style={{fontWeight:"700",fontSize:"11px",color:"#2d6a4f",marginBottom:"4px",borderBottom:"1px solid #2d6a4f",paddingBottom:"2px"}}>
                        Week {wIdx + 1} — {fmtShort(weekStart)} – {fmtShort(weekEnd)}
                      </div>
                    )}
                    {Object.entries(weekList).sort(([a],[b])=>a.localeCompare(b)).map(([cat, items]) => {
                      const visibleItems = items.filter(it => it.qty > 0);
                      if (visibleItems.length === 0) return null;
                      return (
                        <div key={cat} className="grocery-cat-block" style={{marginBottom:"6px"}}>
                          <strong style={{fontSize:"9px",color:"#2d6a4f",textTransform:"uppercase",display:"block",marginBottom:"2px",borderBottom:"1px solid #eee",paddingBottom:"1px"}}>{cat}</strong>
                          {visibleItems.sort((a,b)=>a.name.localeCompare(b.name)).map((it,i) =>
                            <div key={i} style={{fontSize:"9px",color:"#333",padding:"1px 0",display:"flex",gap:"4px"}}>
                              <span style={{width:"10px",height:"10px",border:"1px solid #999",borderRadius:"1px",display:"inline-block",flexShrink:0,marginTop:"1px"}}></span>
                              <span>{it.name} — {Math.round(it.qty*10)/10} {it.unit}</span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ── Fridge Calendar (kid-friendly weekly view) ── */}
        {printMode === "fridge" && (() => {
          const sd = new Date(startDate + "T00:00:00");
          const totalDays = weeks * 7;
          const days = Array.from({length: totalDays}, (_, i) => {
            const d = new Date(sd);
            d.setDate(sd.getDate() + i);
            return d;
          });
          return (
            <div style={{padding:"20px"}}>
              <h2 style={{textAlign:"center",color:"#2d6a4f",marginBottom:"20px",fontSize:"28px"}}>
                {"\uD83C\uDF7D\uFE0F"} What Are We Eating This Week? {"\uD83C\uDF7D\uFE0F"}
              </h2>
              <div style={{display:"grid",gridTemplateColumns: totalDays <= 7 ? "repeat(7,1fr)" : "repeat(7,1fr)",gap:"8px"}}>
                {days.map((day, i) => {
                  const dateKey = day.toISOString().slice(0,10);
                  const dayName = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][day.getDay()];
                  const breakfast = plan[`${dateKey}_Breakfast`];
                  const lunch = plan[`${dateKey}_Lunch`];
                  const dinner = plan[`${dateKey}_Dinner`];
                  const getMealName = (slot) => {
                    if (!slot?.mealId) return slot?.prepType === "Eat Out" ? "Eating Out!" : slot?.prepType === "Skip" ? "-" : "?";
                    const m = MEALS_DATA.find(x => x.id === slot.mealId);
                    return m ? m.name.replace(/\s*\(2x\)/g,"") : slot.mealId;
                  };
                  const getSides = (slot) => {
                    if (!slot) return [];
                    return [slot.side, slot.side2, slot.side3]
                      .map(id => id ? SIDES_DATA.find(s => s.id === id) : null)
                      .filter(Boolean)
                      .map(s => s.name);
                  };
                  const renderSides = (slot) => {
                    const names = getSides(slot);
                    if (names.length === 0) return null;
                    return <div style={{fontSize:"9px",color:"#777",fontWeight:"500",marginLeft:"28px",marginTop:"-2px",marginBottom:"3px",lineHeight:"1.15"}}>+ {names.join(", ")}</div>;
                  };
                  return (
                    <div key={i} style={{border:"2px solid #2d6a4f",borderRadius:"12px",padding:"8px",minHeight:"120px",background: day.getDay() === 0 || day.getDay() === 6 ? "#f0f7f4" : "white"}}>
                      <div style={{textAlign:"center",fontWeight:"800",fontSize:"16px",color:"#2d6a4f",marginBottom:"6px"}}>{dayName}</div>
                      <div style={{textAlign:"center",fontSize:"11px",color:"#888",marginBottom:"8px"}}>{day.toLocaleDateString("en-US",{month:"short",day:"numeric"})}</div>
                      <div style={{fontSize:"11px",marginBottom:"2px"}}><span style={{fontWeight:"700",color:"#f59e0b"}}>AM</span> {getMealName(breakfast)}</div>
                      {renderSides(breakfast)}
                      <div style={{fontSize:"11px",marginBottom:"2px"}}><span style={{fontWeight:"700",color:"#3b82f6"}}>Lunch</span> {getMealName(lunch)}</div>
                      {renderSides(lunch)}
                      <div style={{fontSize:"12px",fontWeight:"700"}}><span style={{color:"#dc2626"}}>Dinner</span> {getMealName(dinner)}</div>
                      {renderSides(dinner)}
                    </div>
                  );
                })}
              </div>
              {totalDays > 7 && (
                <div style={{marginTop:"8px",fontSize:"10px",color:"#888",textAlign:"center"}}>Week 1 (top) {"\u00B7"} Week 2 (bottom)</div>
              )}
            </div>
          );
        })()}
      </div>

      {/* ── Print Styles (injected) ──────────── */}
      <style>{`
        /* On screen: hide the printable content */
        #printable-content { display: none; }

        @media print {
          /* Hide the app UI */
          #app-content { display: none !important; }
          /* Show the printable content */
          #printable-content { display: block !important; }
          /* Portrait with minimal margins to maximize space */
          @page { margin: 0.3in; size: portrait; }

          /* ── Meal Plan Table: auto-fill ONE page ──
             All sizes use vh so the font scales with the page.
             Font will be determined by a JS scaler too — see setPrintScale. */
          #printable-content .print-plan-section {
            page-break-after: always;
            page-break-inside: avoid;
            height: 100vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            /* Base size driven by JS auto-fit; falls back to 2vh if unset */
            font-size: var(--print-font, 2vh);
          }
          #printable-content .print-plan-section .print-plan-header {
            margin-bottom: 0.8vh !important;
            padding-bottom: 0.6vh !important;
            flex-shrink: 0;
          }
          #printable-content .print-plan-section h3 {
            font-size: 3.2vh !important;
            margin: 0 0 0.3vh 0 !important;
          }
          #printable-content .print-plan-section p {
            font-size: 1.6vh !important;
            margin: 0 !important;
          }
          #printable-content .print-plan-section table {
            font-size: var(--print-font, 2vh) !important;
            width: 100% !important;
            flex: 1;
            height: 100%;
            border-collapse: collapse;
          }
          #printable-content .print-plan-section table th {
            padding: 0.4vh 0.5vh !important;
            font-size: var(--print-font-header, 2.2vh) !important;
            line-height: 1.2 !important;
            font-weight: 700 !important;
          }
          #printable-content .print-plan-section table td {
            padding: 0.35vh 0.5vh !important;
            font-size: var(--print-font, 2vh) !important;
            line-height: 1.25 !important;
            vertical-align: top !important;
            overflow: hidden !important;
            height: var(--print-row-vh, 10vh) !important;
            max-height: var(--print-row-vh, 10vh) !important;
          }
          /* Each body row gets equal height so a heavy day can't squeeze
             the last day (Saturday) off the bottom of the page. */
          #printable-content .print-plan-section table tbody tr {
            height: var(--print-row-vh, 10vh) !important;
            page-break-inside: avoid;
          }
          /* Notes line in print: keep small, allow wrapping */
          #printable-content .print-plan-section .print-slot-notes,
          #printable-content .print-plan-section .print-slot-extras {
            font-size: 0.78em !important;
            line-height: 1.2 !important;
          }
          #printable-content .print-plan-section table td div {
            font-size: 0.92em !important;
            line-height: 1.2 !important;
          }
          #printable-content .print-plan-section table td span {
            font-size: 0.8em !important;
          }
          /* Day column wider for readability */
          #printable-content .print-plan-section table td:first-child,
          #printable-content .print-plan-section table th:first-child {
            font-size: var(--print-font, 2vh) !important;
            font-weight: 700 !important;
            white-space: nowrap !important;
            width: 9% !important;
          }

          /* ── Grocery List: 2 columns, fill page ── */
          #printable-content .print-grocery-section {
            page-break-before: always;
            columns: 2;
            column-gap: 30px;
          }
          #printable-content .print-grocery-section .grocery-week-block {
            break-inside: avoid-column;
          }
          #printable-content .print-grocery-section .grocery-cat-block {
            break-inside: avoid-column;
            margin-bottom: 10px !important;
          }
          #printable-content .print-grocery-section strong {
            font-size: 12px !important;
          }
          #printable-content .print-grocery-section div {
            font-size: 12px !important;
          }
          table { page-break-inside: auto; }
          tr { page-break-inside: avoid; }
        }
      `}</style>
    </div>
  );
}
